// @ts-ignore - gql imported for potential future use in generated document nodes
import { gql } from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  JSON: { input: any; output: any };
};

/** Current alert severity based on remaining balance vs. thresholds. */
export enum AIBillingAlertLevel {
  /** Balance is at or below the critical threshold. */
  Critical = 'CRITICAL',
  /** Balance is zero or negative. */
  Depleted = 'DEPLETED',
  /** Balance is above the warning threshold. */
  Ok = 'OK',
  /** Balance is at or below the warning threshold. */
  Warning = 'WARNING',
}

/** Current state of the AI billing ledger (singleton). */
export type AIBillingBalance = {
  __typename?: 'AIBillingBalance';
  /** Current alert level derived from balance and thresholds. */
  alertLevel: AIBillingAlertLevel;
  /** Current remaining balance in USD. */
  balanceUsd: Scalars['Float']['output'];
  /** Critical threshold in USD. Balance at/below this triggers CRITICAL alert. */
  criticalThresholdUsd: Scalars['Float']['output'];
  /** Lifetime total of manual adjustments in USD (signed). */
  totalAdjustmentsUsd: Scalars['Float']['output'];
  /** Lifetime total credits added in USD. */
  totalCreditsUsd: Scalars['Float']['output'];
  /** Lifetime total usage spent in USD. */
  totalUsageUsd: Scalars['Float']['output'];
  /** Timestamp of the last state update. */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Warning threshold in USD. Balance at/below this triggers WARNING alert. */
  warningThresholdUsd: Scalars['Float']['output'];
};

/** A single entry in the append-only AI billing ledger. */
export type AIBillingTransaction = {
  __typename?: 'AIBillingTransaction';
  /** Admin user who recorded this entry (null for USAGE). */
  admin_user_id?: Maybe<Scalars['ID']['output']>;
  /** Signed USD amount. Credits positive, usage negative. */
  amountUsd: Scalars['Float']['output'];
  /** Running balance immediately after this transaction. */
  balanceAfterUsd: Scalars['Float']['output'];
  cacheCreationTokens?: Maybe<Scalars['Int']['output']>;
  cacheReadTokens?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  /** Arbitrary context data (e.g. conversation_id for USAGE). */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Anthropic model ID for USAGE transactions. */
  model?: Maybe<Scalars['String']['output']>;
  /** Free-text note entered by the admin. */
  note?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  type: AIBillingTransactionType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Transaction type in the AI billing ledger. */
export enum AIBillingTransactionType {
  /** Manual correction entered by an admin (positive or negative). */
  Adjustment = 'ADJUSTMENT',
  /** Top-up added by an admin (positive amount). */
  Credit = 'CREDIT',
  /** API call cost (always negative amount). */
  Usage = 'USAGE',
}

/** Device/source that initiated the AI query — used for tracking, behavior customization, and link generation */
export enum AIDevice {
  /** Direct API call */
  Api = 'API',
  /** Client mobile app */
  ClientMobile = 'CLIENT_MOBILE',
  /** Client web application */
  ClientWeb = 'CLIENT_WEB',
  /** Service Provider mobile app (Flutter) */
  SpMobile = 'SP_MOBILE',
  /** Service Provider web application */
  SpWeb = 'SP_WEB',
  /** WhatsApp chat interface via Twilio */
  Whatsapp = 'WHATSAPP',
}

export type AIError = {
  __typename?: 'AIError';
  details?: Maybe<Scalars['JSON']['output']>;
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type AIQueryResponse = {
  __typename?: 'AIQueryResponse';
  /** Whether AI enhancement is allowed for this response */
  allowAIEnhancement: Scalars['Boolean']['output'];
  /** Structured data from the query */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Enhancement guidelines for Claude */
  enhancementGuidelines?: Maybe<Array<Scalars['String']['output']>>;
  /** Image transcription results if images were provided */
  imageResults?: Maybe<Array<ImageTranscriptionResult>>;
  /** Natural language response message */
  message: Scalars['String']['output'];
  /** Suggested follow-up actions */
  suggestedActions?: Maybe<Array<SuggestedAction>>;
  /** Response type for categorization */
  type?: Maybe<Scalars['String']['output']>;
};

export type AIQueryResult = AIError | AIQueryResponse;

export type AIToolInfo = {
  __typename?: 'AIToolInfo';
  /** Whether Claude can enhance responses from this tool */
  allowAIEnhancement: Scalars['Boolean']['output'];
  /** Description of what the tool does */
  description: Scalars['String']['output'];
  /** Example queries that this tool can handle */
  exampleQueries: Array<Scalars['String']['output']>;
  /** Name of the AI tool */
  name: Scalars['String']['output'];
  /** Required role to use this tool (null means available to all) */
  requiredRole?: Maybe<Scalars['String']['output']>;
};

export type AIToolsResponse = {
  __typename?: 'AIToolsResponse';
  /** List of available AI tools */
  tools: Array<AIToolInfo>;
  /** Framework version */
  version: Scalars['String']['output'];
};

/** Absentee metrics for attendance monitoring */
export type AbsenteeMetrics = {
  __typename?: 'AbsenteeMetrics';
  /** Attendance rate as percentage */
  attendanceRate: Scalars['Float']['output'];
  /** Number of days with timesheet entries */
  daysWithTimeEntries: Scalars['Int']['output'];
  /** Number of days without timesheet entries */
  daysWithoutEntries: Scalars['Int']['output'];
  /** Total duration of job in days */
  jobDurationDays: Scalars['Int']['output'];
  /** Total expected job hours */
  totalJobHours: Scalars['Float']['output'];
  /** Total logged hours */
  totalLoggedHours: Scalars['Float']['output'];
};

/** Absentee report item for individual users */
export type AbsenteeReportItem = {
  __typename?: 'AbsenteeReportItem';
  /** Absentee metrics */
  absenteeMetrics: AbsenteeMetrics;
  /** List of attendance gaps */
  attendanceGaps: Array<AttendanceGap>;
  /** Job associated with this absentee record */
  job: Job;
  /** User object */
  user: User;
  /** User's full name */
  userFullName: Scalars['String']['output'];
  /** User ID */
  user_id: Scalars['ID']['output'];
};

export type AcceptClientInvite = {
  __typename?: 'AcceptClientInvite';
  accessToken?: Maybe<Scalars['String']['output']>;
  clientAccountId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  recordId?: Maybe<Scalars['ID']['output']>;
  recordSummary?: Maybe<ClientInviteRecordSummary>;
  recordType?: Maybe<ClientInviteRecordType>;
  redirectPath: Scalars['String']['output'];
  refreshToken?: Maybe<Scalars['String']['output']>;
  serviceProviderAccountId?: Maybe<Scalars['ID']['output']>;
  serviceProviderName?: Maybe<Scalars['String']['output']>;
  variant: ClientInviteMode;
};

export type AcceptClientInviteResponse = AcceptClientInvite | Error;

export type Account = {
  availability: Availability;
  billingInfo?: Maybe<BillingInfo>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** IANA timezone (e.g. America/Los_Angeles). Nullable because Quick Add / draft client accounts are created without a timezone. */
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type AccountCacheDetails = {
  __typename?: 'AccountCacheDetails';
  accountId: Scalars['String']['output'];
  cacheEntries: Array<CacheEntryDetail>;
  companyName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  environment?: Maybe<Scalars['String']['output']>;
  hitRate: Scalars['Float']['output'];
  isBlacklisted: Scalars['Boolean']['output'];
  isWhitelisted: Scalars['Boolean']['output'];
  queryHistory: Array<QueryHistoryDetail>;
  reason: Scalars['String']['output'];
  totalCacheEntries: Scalars['Int']['output'];
  totalQueries: Scalars['Int']['output'];
  totalSize: Scalars['Int']['output'];
  totalSizeMB: Scalars['Float']['output'];
};

export type AccountCacheInfo = {
  __typename?: 'AccountCacheInfo';
  accountId: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  keyCount: Scalars['Int']['output'];
  totalHits: Scalars['Int']['output'];
  totalSize: Scalars['Int']['output'];
};

export type AccountDataDeletionSummary = {
  __typename?: 'AccountDataDeletionSummary';
  /** Whether account settings were preserved */
  accountSettingsPreserved: Scalars['Boolean']['output'];
  /** Number of attachments deleted */
  attachmentsDeleted: Scalars['Int']['output'];
  /** Whether billing information was preserved */
  billingInfoPreserved: Scalars['Boolean']['output'];
  /** Number of chats deleted */
  chatsDeleted: Scalars['Int']['output'];
  /** Number of checklist entries deleted */
  checklistEntriesDeleted: Scalars['Int']['output'];
  /** Number of checklists deleted */
  checklistsDeleted: Scalars['Int']['output'];
  /** Timestamp when deletion was completed */
  completedAt: Scalars['Date']['output'];
  /** Number of crews deleted */
  crewsDeleted: Scalars['Int']['output'];
  /** Total deletion time in milliseconds */
  deletionTimeMs: Scalars['Int']['output'];
  /** Number of estimates deleted */
  estimatesDeleted: Scalars['Int']['output'];
  /** Number of feedback entries deleted */
  feedbackEntriesDeleted: Scalars['Int']['output'];
  /** Number of groups deleted */
  groupsDeleted: Scalars['Int']['output'];
  /** Number of invoices deleted */
  invoicesDeleted: Scalars['Int']['output'];
  /** Number of jobs deleted */
  jobsDeleted: Scalars['Int']['output'];
  /** Number of manufacturers deleted */
  manufacturersDeleted: Scalars['Int']['output'];
  /** Number of messages deleted */
  messagesDeleted: Scalars['Int']['output'];
  /** Number of notes deleted */
  notesDeleted: Scalars['Int']['output'];
  /** Number of payments deleted */
  paymentsDeleted: Scalars['Int']['output'];
  /** Number of properties deleted */
  propertiesDeleted: Scalars['Int']['output'];
  /** Number of service items deleted */
  serviceItemsDeleted: Scalars['Int']['output'];
  /** Whether subscription data was preserved */
  subscriptionDataPreserved: Scalars['Boolean']['output'];
  /** Number of tax rates deleted */
  taxRatesDeleted: Scalars['Int']['output'];
  /** Number of timesheet entries deleted */
  timesheetEntriesDeleted: Scalars['Int']['output'];
  /** Number of timesheets deleted */
  timesheetsDeleted: Scalars['Int']['output'];
  /** Number of users deleted */
  usersDeleted: Scalars['Int']['output'];
  /** Number of vendors deleted */
  vendorsDeleted: Scalars['Int']['output'];
};

/** ENUM for available Account types */
export enum AccountType {
  Client = 'CLIENT',
  ServiceProvider = 'SERVICE_PROVIDER',
}

export enum AccountsSortBy {
  AccountType = 'ACCOUNT_TYPE',
  CompanyName = 'COMPANY_NAME',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/** List of active devices for the user */
export type ActiveDevicesResult = {
  __typename?: 'ActiveDevicesResult';
  devices: Array<Device>;
  message: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Successful response from addAIBillingCredit. */
export type AddAIBillingCredit = {
  __typename?: 'AddAIBillingCredit';
  /** The updated ledger balance after applying the credit. */
  balance: AIBillingBalance;
  message: Scalars['String']['output'];
  /** The newly recorded CREDIT transaction. */
  transaction: AIBillingTransaction;
  version: Scalars['String']['output'];
};

/** Input for recording a new credit (top-up) against the AI billing ledger. */
export type AddAIBillingCreditInput = {
  /** Amount to credit in USD. Must be greater than zero. */
  amountUsd: Scalars['Float']['input'];
  /** Optional free-text note, e.g. the external receipt number. */
  note?: InputMaybe<Scalars['String']['input']>;
};

export type AddAIBillingCreditResponse = AddAIBillingCredit | Error;

/** Admin activity log entry */
export type AdminActivityLog = Timestamps & {
  __typename?: 'AdminActivityLog';
  /** Action performed */
  action: Scalars['String']['output'];
  adminUser: AdminUser;
  createdAt: Scalars['Date']['output'];
  /** Description of the activity */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** IP address of the request */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Additional metadata about the activity */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Resource ID affected */
  resourceId?: Maybe<Scalars['String']['output']>;
  /** Resource type affected */
  resourceType: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User agent of the request */
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type AdminApproveConnectApplication = {
  __typename?: 'AdminApproveConnectApplication';
  application: ConnectApplicationDetails;
  message: Scalars['String']['output'];
  /** Stripe account link URL for SP to complete onboarding */
  onboardingUrl?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

/** Input for admin application approval */
export type AdminApproveConnectApplicationInput = {
  account_id: Scalars['ID']['input'];
  /** Admin notes about the approval */
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  /** Application fee configuration (optional - defaults to account settings) */
  applicationFee?: InputMaybe<AdminFeeConfigurationInput>;
};

export type AdminApproveConnectApplicationResponse = AdminApproveConnectApplication | Error;

/** Admin audit action enum */
export enum AdminAuditAction {
  /** Account access by admin */
  AccountAccess = 'ACCOUNT_ACCESS',
  /** Switching between accounts */
  AccountSwitch = 'ACCOUNT_SWITCH',
  /** Admin permission update */
  AdminPermissionUpdate = 'ADMIN_PERMISSION_UPDATE',
  /** Admin user activation */
  AdminUserActivate = 'ADMIN_USER_ACTIVATE',
  /** Admin user creation */
  AdminUserCreate = 'ADMIN_USER_CREATE',
  /** Admin user deactivation */
  AdminUserDeactivate = 'ADMIN_USER_DEACTIVATE',
  /** Admin user deletion */
  AdminUserDelete = 'ADMIN_USER_DELETE',
  /** Admin user lock */
  AdminUserLock = 'ADMIN_USER_LOCK',
  /** Admin user unlock */
  AdminUserUnlock = 'ADMIN_USER_UNLOCK',
  /** Admin user update */
  AdminUserUpdate = 'ADMIN_USER_UPDATE',
  /** Custom action */
  Custom = 'CUSTOM',
  /** Data export */
  DataExport = 'DATA_EXPORT',
  /** Invoice deletion */
  InvoiceDelete = 'INVOICE_DELETE',
  /** Invoice update */
  InvoiceUpdate = 'INVOICE_UPDATE',
  /** Invoice view */
  InvoiceView = 'INVOICE_VIEW',
  /** Job deletion */
  JobDelete = 'JOB_DELETE',
  /** Job update */
  JobUpdate = 'JOB_UPDATE',
  /** Job view */
  JobView = 'JOB_VIEW',
  /** Login failure */
  LoginFailure = 'LOGIN_FAILURE',
  /** Login success */
  LoginSuccess = 'LOGIN_SUCCESS',
  /** Logout */
  Logout = 'LOGOUT',
  /** Session expired */
  SessionExpired = 'SESSION_EXPIRED',
  /** Settings update */
  SettingsUpdate = 'SETTINGS_UPDATE',
  /** Settings view */
  SettingsView = 'SETTINGS_VIEW',
  /** User activation */
  UserActivate = 'USER_ACTIVATE',
  /** User creation */
  UserCreate = 'USER_CREATE',
  /** User deactivation */
  UserDeactivate = 'USER_DEACTIVATE',
  /** User deletion */
  UserDelete = 'USER_DELETE',
  /** User password reset */
  UserPasswordReset = 'USER_PASSWORD_RESET',
  /** User update */
  UserUpdate = 'USER_UPDATE',
}

/** Admin audit log type */
export type AdminAuditLog = Timestamps & {
  __typename?: 'AdminAuditLog';
  /** Action performed */
  action: AdminAuditAction;
  /** Admin user who performed the action */
  adminUser: AdminUser;
  createdAt: Scalars['Date']['output'];
  /** Optional description */
  description?: Maybe<Scalars['String']['output']>;
  /** Error message if action failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** IP address of the request */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Additional metadata as JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  /** Resource ID affected */
  resourceId?: Maybe<Scalars['String']['output']>;
  /** Resource type affected */
  resourceType: AdminAuditResourceType;
  /** Status of the action */
  status: AdminAuditStatus;
  /** Target client account for cross-account access */
  targetClientAccount?: Maybe<ClientAccount>;
  /** Target service provider account for cross-account access */
  targetServiceProviderAccount?: Maybe<ServiceProviderAccount>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User agent of the request */
  userAgent?: Maybe<Scalars['String']['output']>;
};

/** Admin audit log filter input */
export type AdminAuditLogFilter = {
  /** Filter by action(s) */
  action?: InputMaybe<Array<AdminAuditAction>>;
  /** Filter by admin user ID */
  adminUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by date from */
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by date to */
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by resource ID */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by resource type */
  resourceType?: InputMaybe<AdminAuditResourceType>;
  /** Search in descriptions */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Filter by status */
  status?: InputMaybe<AdminAuditStatus>;
  /** Filter by target account ID */
  targetAccountId?: InputMaybe<Scalars['ID']['input']>;
};

/** Admin audit log list with pagination */
export type AdminAuditLogList = {
  __typename?: 'AdminAuditLogList';
  /** List of audit logs */
  logs: Array<AdminAuditLog>;
  /** Pagination information */
  pagination: PaginationInfo;
};

/** Admin audit log sort options */
export enum AdminAuditLogSortBy {
  Action = 'ACTION',
  CreatedAt = 'CREATED_AT',
  ResourceType = 'RESOURCE_TYPE',
  Status = 'STATUS',
}

/** Admin audit resource type enum */
export enum AdminAuditResourceType {
  Account = 'account',
  AdminUser = 'admin_user',
  Attachment = 'attachment',
  Crew = 'crew',
  Estimate = 'estimate',
  Invoice = 'invoice',
  Job = 'job',
  Message = 'message',
  Other = 'other',
  Property = 'property',
  Report = 'report',
  Settings = 'settings',
  System = 'system',
  User = 'user',
}

/** Admin audit status enum */
export enum AdminAuditStatus {
  Failure = 'failure',
  Partial = 'partial',
  Success = 'success',
}

export type AdminDeclineConnectApplication = {
  __typename?: 'AdminDeclineConnectApplication';
  /** Alert sent to notify service provider of decline */
  alertSent: Scalars['Boolean']['output'];
  application: ConnectApplicationDetails;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Input for admin application decline */
export type AdminDeclineConnectApplicationInput = {
  account_id: Scalars['ID']['input'];
  /** Admin notes about the decline */
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  /** Reason for decline */
  declineReason: Scalars['String']['input'];
  /** Whether to send detailed decline notification */
  sendDetailedNotification?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdminDeclineConnectApplicationResponse = AdminDeclineConnectApplication | Error;

/** Input for custom fee configuration during approval */
export type AdminFeeConfigurationInput = {
  /** Fee percentage (0.1 to 10.0) */
  feePercentage: Scalars['Float']['input'];
  /** Fixed fee amount in cents */
  fixedFeeAmount: Scalars['Float']['input'];
};

export type AdminLogin = {
  __typename?: 'AdminLogin';
  accessToken: Scalars['String']['output'];
  adminUser: AdminUser;
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input for admin login */
export type AdminLoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type AdminLoginResponse = AdminLogin | Error;

export type AdminLogout = {
  __typename?: 'AdminLogout';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AdminLogoutResponse = AdminLogout | Error;

export enum AdminPlanDowngradeAction {
  CreditNextInvoice = 'CREDIT_NEXT_INVOICE',
  Refund = 'REFUND',
}

export type AdminProvisionDedicatedNumber = {
  __typename?: 'AdminProvisionDedicatedNumber';
  accountId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AdminProvisionDedicatedNumberResponse = AdminProvisionDedicatedNumber | Error;

export type AdminRefreshToken = {
  __typename?: 'AdminRefreshToken';
  accessToken: Scalars['String']['output'];
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input for admin refresh token */
export type AdminRefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type AdminRefreshTokenResponse = AdminRefreshToken | Error;

export type AdminReleaseDedicatedNumber = {
  __typename?: 'AdminReleaseDedicatedNumber';
  accountId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AdminReleaseDedicatedNumberResponse = AdminReleaseDedicatedNumber | Error;

export type AdminResetIvrGreeting = {
  __typename?: 'AdminResetIvrGreeting';
  accountId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type AdminResetIvrGreetingResponse = AdminResetIvrGreeting | Error;

/** Admin user roles enum */
export enum AdminRole {
  /** Administrator with account management permissions */
  Admin = 'ADMIN',
  /** Developer with access only to global settings CRUD operations */
  Developer = 'DEVELOPER',
  /** Super administrator with full system access */
  SuperAdmin = 'SUPER_ADMIN',
  /** Support staff with limited administrative access */
  Support = 'SUPPORT',
  /** Read-only viewer role */
  Viewer = 'VIEWER',
}

/** Search filter for admin account queries */
export type AdminSearchAccountsFilter = {
  /** Filter by service provider availability for a date range */
  availabilityDateRange?: InputMaybe<DateRangeInput>;
  /** Filter by billing info cities */
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by billing info city (deprecated: use cities array instead) */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Search by account IDs */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter by archived status */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter client/service-provider relationships by explicit link state */
  linkStates?: InputMaybe<Array<ClientServiceProviderLinkState>>;
  /** Filter by property type */
  propertyType?: InputMaybe<propertyTypeEnum>;
  /** Filter by one or more service categories */
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  /** Filter by billing info state (deprecated: use states array instead) */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Filter by billing info states */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Parameters for admin users to search accounts (supports cross-account filtering) */
export type AdminSearchAccountsInput = {
  /** Service provider account ID to filter clients linked to this SP */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filter options */
  filter?: InputMaybe<AdminSearchAccountsFilter>;
  /** Search by keyword to match company name, email, etc. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Results per page */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by property type */
  propertyType?: InputMaybe<propertyTypeEnum>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<AccountsSortBy>;
};

/** Admin session token type */
export type AdminSessionToken = {
  __typename?: 'AdminSessionToken';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
};

export type AdminSubscriptionPlanChangePreview = {
  __typename?: 'AdminSubscriptionPlanChangePreview';
  amountDueNow: Scalars['Int']['output'];
  changeType: Scalars['String']['output'];
  confirmationLabel: Scalars['String']['output'];
  creditAmount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  currentPlanCode?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  newPlanCode: Scalars['String']['output'];
  nextInvoiceImpact?: Maybe<Scalars['String']['output']>;
  refundAmount: Scalars['Int']['output'];
  requiresPaymentSuccess: Scalars['Boolean']['output'];
  seats: Scalars['Int']['output'];
  unpaidInvoiceBlocked: Scalars['Boolean']['output'];
};

/** Admin user type */
export type AdminUser = Timestamps & {
  __typename?: 'AdminUser';
  /** URL to admin user avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Admin user who created this user */
  createdBy?: Maybe<AdminUser>;
  email: Scalars['String']['output'];
  /** Number of failed login attempts */
  failedLoginAttempts: Scalars['Int']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Check if admin user is active */
  isActive: Scalars['Boolean']['output'];
  /** Check if email is confirmed */
  isEmailConfirmed: Scalars['Boolean']['output'];
  /** Check if admin user is locked */
  isLocked: Scalars['Boolean']['output'];
  /** Last login timestamp */
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  lastName: Scalars['String']['output'];
  /** Last password change timestamp */
  lastPasswordChangeAt?: Maybe<Scalars['Date']['output']>;
  /** Password expiry date */
  passwordExpiresAt?: Maybe<Scalars['Date']['output']>;
  /** Specific permissions granted to this admin */
  permissions: Array<Permission>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Admin role */
  role: AdminRole;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Admin user who last updated this user */
  updatedBy?: Maybe<AdminUser>;
};

/** Admin user session type */
export type AdminUserSession = Timestamps & {
  __typename?: 'AdminUserSession';
  /** URL to admin user avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Check if admin user is active */
  isActive: Scalars['Boolean']['output'];
  /** Check if email is confirmed */
  isEmailConfirmed: Scalars['Boolean']['output'];
  /** Last login timestamp */
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  lastName: Scalars['String']['output'];
  /** Specific permissions granted to this admin */
  permissions: Array<Permission>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Admin role */
  role: AdminRole;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** ENUM for sortBy field for admin users */
export enum AdminUsersSortBy {
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastLoginAt = 'LAST_LOGIN_AT',
  LastName = 'LAST_NAME',
  Role = 'ROLE',
}

/** Aggregated data for all entity types */
export type AggregatesData = {
  __typename?: 'AggregatesData';
  /** Crew metrics */
  crews?: Maybe<CrewMetrics>;
  /** Estimate metrics */
  estimates?: Maybe<EstimateMetrics>;
  /** Feedback metrics */
  feedbackEntries?: Maybe<FeedbackMetrics>;
  /** Invoice metrics */
  invoices?: Maybe<InvoiceMetrics>;
  /** Job metrics */
  jobs?: Maybe<JobMetrics>;
  /** Payment metrics */
  payments?: Maybe<PaymentMetrics>;
  /** Property metrics */
  properties?: Maybe<PropertyMetrics>;
  /** Service item metrics */
  serviceItems?: Maybe<ServiceItemMetrics>;
  /** Timesheet metrics */
  timesheets?: Maybe<TimesheetMetrics>;
  /** User metrics */
  users?: Maybe<UserMetrics>;
};

export type AnnouncementJobResult = {
  __typename?: 'AnnouncementJobResult';
  clientAccountsNotified: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  spAccountsNotified: Scalars['Int']['output'];
  totalAccounts: Scalars['Int']['output'];
  totalNotified: Scalars['Int']['output'];
};

export type AnnouncementJobStatus = {
  __typename?: 'AnnouncementJobStatus';
  completedAt?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  progress: Scalars['Int']['output'];
  progressMessage?: Maybe<Scalars['String']['output']>;
  result?: Maybe<AnnouncementJobResult>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ApplicationFeeCalculation = {
  __typename?: 'ApplicationFeeCalculation';
  baseFeeFixed: Scalars['Int']['output'];
  baseFeePercentage: Scalars['Float']['output'];
  finalFeeAmount: Scalars['Int']['output'];
  paymentAmount: Scalars['Int']['output'];
};

export type ApplicationFeeConfig = {
  __typename?: 'ApplicationFeeConfig';
  feePercentage?: Maybe<Scalars['Float']['output']>;
  fixedFeeAmount?: Maybe<Scalars['Float']['output']>;
  lastUpdated?: Maybe<Scalars['Date']['output']>;
};

export type ApplicationFeeHistory = {
  __typename?: 'ApplicationFeeHistory';
  account_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  feeCalculation: ApplicationFeeCalculation;
  id: Scalars['ID']['output'];
  invoice_id: Scalars['ID']['output'];
  payment_id: Scalars['ID']['output'];
  stripePaymentIntentId: Scalars['String']['output'];
  timestamp: Scalars['Date']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ApplicationFeeHistoryConnection = {
  __typename?: 'ApplicationFeeHistoryConnection';
  items: Array<ApplicationFeeHistory>;
  paginationInfo: PaginationInfo;
};

export type ApplicationFeeHistoryFilter = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  invoiceId?: InputMaybe<Scalars['ID']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type Appointment = Timestamps & {
  __typename?: 'Appointment';
  account_id: Scalars['ID']['output'];
  alternateBillingInfo?: Maybe<BillingInfo>;
  attachments?: Maybe<Array<Attachment>>;
  billToClient?: Maybe<ClientAccount>;
  bill_to_client_account_id?: Maybe<Scalars['ID']['output']>;
  callback?: Maybe<Scalars['Boolean']['output']>;
  chat?: Maybe<Chat>;
  chat_id?: Maybe<Scalars['ID']['output']>;
  client?: Maybe<ClientAccount>;
  client_account_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  crew?: Maybe<Crew>;
  crew_id?: Maybe<Scalars['ID']['output']>;
  depositRequired?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  estimate_id?: Maybe<Scalars['ID']['output']>;
  geoCoordinates?: Maybe<GeoLatLng>;
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['ID']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  job_id?: Maybe<Scalars['ID']['output']>;
  job_id_converted?: Maybe<Scalars['ID']['output']>;
  messages?: Maybe<Array<Message>>;
  name: Scalars['String']['output'];
  notes?: Maybe<Array<Note>>;
  overrideAvailability?: Maybe<Scalars['Boolean']['output']>;
  priority?: Maybe<Scalars['Boolean']['output']>;
  property?: Maybe<Property>;
  property_id?: Maybe<Scalars['ID']['output']>;
  scheduledStartDatetime?: Maybe<Scalars['Date']['output']>;
  scheduledStopDatetime?: Maybe<Scalars['Date']['output']>;
  /** Whether this appointment has been sent to the client */
  sent?: Maybe<Scalars['Boolean']['output']>;
  serviceItems?: Maybe<Array<AppointmentServiceItem>>;
  serviceProvider?: Maybe<ServiceProviderPublicProfile>;
  status: AppointmentStatus;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  taxRate?: Maybe<Scalars['Float']['output']>;
  taxRateName?: Maybe<Scalars['String']['output']>;
  taxableTotal?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AppointmentServiceItem = IServiceItem &
  Timestamps & {
    __typename?: 'AppointmentServiceItem';
    account_id: Scalars['ID']['output'];
    adt?: Maybe<Scalars['String']['output']>;
    appointmentDescription?: Maybe<Scalars['String']['output']>;
    appointmentName?: Maybe<Scalars['String']['output']>;
    appointmentUnitRetailPrice?: Maybe<Scalars['Int']['output']>;
    attachments?: Maybe<Array<Attachment>>;
    availableQty: Scalars['Int']['output'];
    checklist_id?: Maybe<Scalars['ID']['output']>;
    color?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['Date']['output'];
    description?: Maybe<Scalars['String']['output']>;
    groups?: Maybe<Array<GroupMinimum>>;
    id: Scalars['ID']['output'];
    isArchived: Scalars['Boolean']['output'];
    isInUse: Scalars['Boolean']['output'];
    isInventoryDisabled: Scalars['Boolean']['output'];
    /** Indicates if the record was created via Quick Add */
    isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
    isShowNewService: Scalars['Boolean']['output'];
    isShowOnlineBooking: Scalars['Boolean']['output'];
    isTaxable: Scalars['Boolean']['output'];
    location?: Maybe<Scalars['String']['output']>;
    manufacturer?: Maybe<Manufacturer>;
    manufacturerModelNumber?: Maybe<Scalars['String']['output']>;
    manufacturer_id?: Maybe<Scalars['ID']['output']>;
    name: Scalars['String']['output'];
    order?: Maybe<Scalars['Int']['output']>;
    /** URL of the service item image. */
    photoUrl?: Maybe<Scalars['String']['output']>;
    quantityLaborHours?: Maybe<Scalars['Int']['output']>;
    quantityLaborMinutes?: Maybe<Scalars['Int']['output']>;
    quantityMaterial?: Maybe<Scalars['Int']['output']>;
    quantityOnHand: Scalars['Int']['output'];
    reorderLevel: Scalars['Int']['output'];
    reservedInEstimates: Scalars['Int']['output'];
    reservedInJobs: Scalars['Int']['output'];
    service_item_id: Scalars['ID']['output'];
    size?: Maybe<Scalars['String']['output']>;
    sku: Scalars['String']['output'];
    tags?: Maybe<Array<Scalars['String']['output']>>;
    type: ServiceItemType;
    unitCost: Scalars['Float']['output'];
    unitOfMeasure?: Maybe<UnitOfMeasure>;
    unitRetailPrice: Scalars['Float']['output'];
    upc?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['Date']['output']>;
    vendor?: Maybe<Vendor>;
    vendorSku?: Maybe<Scalars['String']['output']>;
    vendor_id?: Maybe<Scalars['ID']['output']>;
  };

/** Expected input for an appointment service item */
export type AppointmentServiceItemInput = {
  appointmentDescription?: InputMaybe<Scalars['String']['input']>;
  appointmentName?: InputMaybe<Scalars['String']['input']>;
  appointmentUnitRetailPrice?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  quantityLaborHours?: InputMaybe<Scalars['Int']['input']>;
  quantityLaborMinutes?: InputMaybe<Scalars['Int']['input']>;
  quantityMaterial?: InputMaybe<Scalars['Int']['input']>;
  service_item_id: Scalars['ID']['input'];
};

export enum AppointmentStatus {
  /** Crew has arrived at the appointment location */
  Arrived = 'ARRIVED',
  /** Appointment has been cancelled */
  Canceled = 'CANCELED',
  /** Appointment has been completed */
  Completed = 'COMPLETED',
  /** Appointment has been confirmed by client */
  Confirmed = 'CONFIRMED',
  /** Appointment is in draft state and being created */
  Draft = 'DRAFT',
  /** Crew is traveling to the appointment location */
  EnRoute = 'EN_ROUTE',
  /** Client did not show up for the appointment */
  NoShow = 'NO_SHOW',
  /** Appointment has been sent and is awaiting client confirmation */
  Pending = 'PENDING',
  /** Appointment is scheduled with a crew */
  Scheduled = 'SCHEDULED',
  /** Appointment has started and work is in progress */
  Started = 'STARTED',
}

/** Sort options for appointments */
export enum AppointmentsSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Priority = 'PRIORITY',
  ScheduledStart = 'SCHEDULED_START',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT',
}

export type ArchiveNotification = {
  __typename?: 'ArchiveNotification';
  message: Scalars['String']['output'];
  notification: Notification;
  version: Scalars['String']['output'];
};

export type ArchiveNotificationInput = {
  /** Notification ID to archive */
  notificationId: Scalars['ID']['input'];
};

export type ArchiveNotificationResponse = ArchiveNotification | Error;

export type Attachment = Timestamps & {
  __typename?: 'Attachment';
  account_id: Scalars['ID']['output'];
  appointment_id?: Maybe<Scalars['ID']['output']>;
  base64?: Maybe<Scalars['String']['output']>;
  client_account_id?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  creatorFullName: Scalars['String']['output'];
  creator_user_id: Scalars['ID']['output'];
  estimate_id?: Maybe<Scalars['ID']['output']>;
  fileName: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['ID']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  job_id?: Maybe<Scalars['ID']['output']>;
  message_id?: Maybe<Scalars['ID']['output']>;
  mimeType: Scalars['String']['output'];
  note_id?: Maybe<Scalars['ID']['output']>;
  property_id?: Maybe<Scalars['ID']['output']>;
  service_item_id?: Maybe<Scalars['ID']['output']>;
  type: AttachmentType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/**
 * Types of attachments that can be uploaded and associated with various entities.
 * Helps categorize documents and files for better organization and searchability.
 */
export enum AttachmentType {
  /** Installation guides, setup instructions, or assembly documentation. */
  Installation = 'INSTALLATION',
  /** User manuals, instruction guides, or how-to documentation. */
  Manual = 'MANUAL',
  /** General files that don't fit into specific categories (photos, contracts, misc documents). */
  Other = 'OTHER',
  /** Safety data sheets, warnings, precautions, or compliance documentation. */
  Safety = 'SAFETY',
  /** Technical specifications, product sheets, or detailed requirements documents. */
  Specifications = 'SPECIFICATIONS',
}

export enum AttachmentsSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

/** Attendance gap for a specific day */
export type AttendanceGap = {
  __typename?: 'AttendanceGap';
  /** Actual logged hours for this day */
  actualHours: Scalars['Float']['output'];
  /** Date of the gap */
  date: Scalars['Date']['output'];
  /** Day of the week */
  dayOfWeek: Scalars['String']['output'];
  /** Expected hours for this day */
  expectedHours?: Maybe<Scalars['Float']['output']>;
  /** Whether this is a weekend */
  isWeekend: Scalars['Boolean']['output'];
};

/** Availability data. Used for both Crew and Account. */
export type Availability = {
  __typename?: 'Availability';
  dayTimeSlots?: Maybe<Array<Maybe<DayTime>>>;
  exceptionDates?: Maybe<Array<Maybe<DateRange>>>;
  exceptionFall?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthApr?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthAug?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthDec?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthFeb?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthJan?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthJul?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthJun?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthMar?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthMay?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthNov?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthOct?: Maybe<Scalars['Boolean']['output']>;
  exceptionMonthSep?: Maybe<Scalars['Boolean']['output']>;
  exceptionSpring?: Maybe<Scalars['Boolean']['output']>;
  exceptionSummer?: Maybe<Scalars['Boolean']['output']>;
  exceptionWinter?: Maybe<Scalars['Boolean']['output']>;
};

/** Availability data. Used for both Crew and Account. All fields are optional, however, if present will update value in database. If `timeSlot` or `exceptionDates` field is provided, a list should be provided of the list of records that are the entire list of records to store in the database. */
export type AvailabilityInput = {
  dayTimeSlots?: InputMaybe<Array<InputMaybe<DayTimeInput>>>;
  exceptionDates?: InputMaybe<Array<InputMaybe<DateRangeInput>>>;
  exceptionFall?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthApr?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthAug?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthDec?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthFeb?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthJan?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthJul?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthJun?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthMar?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthMay?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthNov?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthOct?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionMonthSep?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionSpring?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionSummer?: InputMaybe<Scalars['Boolean']['input']>;
  exceptionWinter?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A single available (free) time slot for a crew */
export type AvailableTimeSlot = {
  __typename?: 'AvailableTimeSlot';
  /** Duration of this free slot in minutes */
  durationMinutes: Scalars['Int']['output'];
  endTime: Scalars['Date']['output'];
  startTime: Scalars['Date']['output'];
};

/** Parameters to filter average job duration report data */
export type AverageJobDurationReportFilter = {
  /** Filter by specific crew IDs */
  crew_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date for jobs */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by priority status */
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start date for jobs */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by job statuses */
  statuses?: InputMaybe<Array<JobStatus>>;
};

/** Average job duration metrics for crew efficiency analysis */
export type AverageJobDurationReportItem = {
  __typename?: 'AverageJobDurationReportItem';
  /** Average duration in hours */
  averageDurationHours: Scalars['Int']['output'];
  /** Average duration in minutes (remainder) */
  averageDurationMinutes: Scalars['Int']['output'];
  /** Crew name or 'All Crews' for overall */
  crewName: Scalars['String']['output'];
  /** Crew ID (null for overall report) */
  crew_id?: Maybe<Scalars['ID']['output']>;
  /** Total duration across all jobs in hours */
  totalDurationHours: Scalars['Int']['output'];
  /** Total duration across all jobs in minutes (remainder) */
  totalDurationMinutes: Scalars['Int']['output'];
  /** Total number of jobs analyzed */
  totalJobs: Scalars['Int']['output'];
};

/**
 * Status of a background job throughout its lifecycle.
 * Indicates the current state of job execution.
 */
export enum BackgroundJobStatus {
  /** Job was manually cancelled before completion. */
  Cancelled = 'cancelled',
  /** Job has finished successfully. */
  Completed = 'completed',
  /** Job encountered an error and could not complete. */
  Failed = 'failed',
  /** Job has been queued but not yet started. */
  Pending = 'pending',
  /** Job is currently being processed. */
  Processing = 'processing',
}

/**
 * Types of background jobs that can be executed in the system.
 * These jobs run asynchronously to avoid blocking the main application.
 */
export enum BackgroundJobType {
  /** Job that imports large amounts of data from external sources (CSV, API, etc.). */
  BulkImport = 'BULK_IMPORT',
  /** Job that imports client accounts from CSV with billing info and properties. */
  ClientImport = 'CLIENT_IMPORT',
  /** Job that exports data to external formats for reporting or backup. */
  DataExport = 'DATA_EXPORT',
  /** Job that creates sample data for new accounts or testing purposes. */
  SampleDataCreation = 'SAMPLE_DATA_CREATION',
  /** Job that deletes sample data from accounts. */
  SampleDataDeletion = 'SAMPLE_DATA_DELETION',
}

export type BackgroundJobs = Timestamps & {
  __typename?: 'BackgroundJobs';
  account_id: Scalars['ID']['output'];
  backgroundJobType: BackgroundJobType;
  completedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  progress: Scalars['Int']['output'];
  progressMessage?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['JSON']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: BackgroundJobStatus;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type BackgroundJobsResponse = Error | GetBackgroundJob;

/** Basic aggregate data for non-financial entities */
export type BasicAggregate = {
  __typename?: 'BasicAggregate';
  /** Total count of entities */
  count: Scalars['Int']['output'];
};

export type BetaLifecycleConfiguration = {
  __typename?: 'BetaLifecycleConfiguration';
  appLink: Scalars['String']['output'];
  calendarLink: Scalars['String']['output'];
  conversionLink: Scalars['String']['output'];
  exitSurveyLink: Scalars['String']['output'];
  feedbackChannel: Scalars['String']['output'];
  foundingPrice: Scalars['String']['output'];
  privacyPolicyUrl: Scalars['String']['output'];
  teamMemberName: Scalars['String']['output'];
  thankyouPageLink: Scalars['String']['output'];
  week4SurveyLink: Scalars['String']['output'];
};

export type BetaLifecycleConfigurationInput = {
  appLink: Scalars['String']['input'];
  calendarLink: Scalars['String']['input'];
  conversionLink: Scalars['String']['input'];
  exitSurveyLink: Scalars['String']['input'];
  feedbackChannel: Scalars['String']['input'];
  foundingPrice: Scalars['String']['input'];
  privacyPolicyUrl: Scalars['String']['input'];
  teamMemberName: Scalars['String']['input'];
  thankyouPageLink: Scalars['String']['input'];
  week4SurveyLink: Scalars['String']['input'];
};

export type BetaLifecycleDeliveryEvidence = {
  __typename?: 'BetaLifecycleDeliveryEvidence';
  channels: Array<Scalars['String']['output']>;
  eventKey: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BetaLifecycleEnrollment = {
  __typename?: 'BetaLifecycleEnrollment';
  accountId: Scalars['ID']['output'];
  agreementSignedAt: Scalars['Date']['output'];
  checklistCompletedCount: Scalars['Int']['output'];
  configuration: BetaLifecycleConfiguration;
  conversionDate: Scalars['Date']['output'];
  convertedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  lastActiveAt?: Maybe<Scalars['Date']['output']>;
  launchDate: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

export type BetaLifecycleEnrollmentPayload = {
  __typename?: 'BetaLifecycleEnrollmentPayload';
  betaLifecycleEnrollment: BetaLifecycleEnrollment;
};

export type BetaLifecycleEnrollmentResponse = BetaLifecycleEnrollmentPayload | Error;

export type BetaLifecycleRun = {
  __typename?: 'BetaLifecycleRun';
  alreadyQueued: Scalars['Int']['output'];
  deliveryEvidence: Array<BetaLifecycleDeliveryEvidence>;
  deliveryLogCount: Scalars['Int']['output'];
  deliveryLogKeys: Array<Scalars['String']['output']>;
  enrollmentsEvaluated: Scalars['Int']['output'];
  eventsQueued: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
};

export type BetaLifecycleRunResponse = BetaLifecycleRun | Error;

export type BetaProgram = {
  __typename?: 'BetaProgram';
  acceptedAt?: Maybe<Scalars['Date']['output']>;
  accountStatus?: Maybe<Scalars['String']['output']>;
  activeWeek?: Maybe<Scalars['Int']['output']>;
  checklistCompletedAt?: Maybe<Scalars['Date']['output']>;
  consentLink?: Maybe<Scalars['String']['output']>;
  conversionCloseAt?: Maybe<Scalars['Date']['output']>;
  conversionOpenAt?: Maybe<Scalars['Date']['output']>;
  dataDisposition?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  foundingDiscountPercent?: Maybe<Scalars['Float']['output']>;
  launchDate?: Maybe<Scalars['Date']['output']>;
  mockSessionAt?: Maybe<Scalars['Date']['output']>;
  mockSessionAttendedAt?: Maybe<Scalars['Date']['output']>;
  mockSessionLink?: Maybe<Scalars['String']['output']>;
  mockSessionNoShowAt?: Maybe<Scalars['Date']['output']>;
  onboardingAttendedAt?: Maybe<Scalars['Date']['output']>;
  onboardingCallAt?: Maybe<Scalars['Date']['output']>;
  onboardingCallLink?: Maybe<Scalars['String']['output']>;
  onboardingNoShowAt?: Maybe<Scalars['Date']['output']>;
  platform?: Maybe<Scalars['String']['output']>;
  playStoreUrl?: Maybe<Scalars['String']['output']>;
  returnLink?: Maybe<Scalars['String']['output']>;
  testFlightUrl?: Maybe<Scalars['String']['output']>;
};

export type BetaProgramInput = {
  acceptedAt?: InputMaybe<Scalars['Date']['input']>;
  accountStatus?: InputMaybe<Scalars['String']['input']>;
  activeWeek?: InputMaybe<Scalars['Int']['input']>;
  checklistCompletedAt?: InputMaybe<Scalars['Date']['input']>;
  consentLink?: InputMaybe<Scalars['String']['input']>;
  conversionCloseAt?: InputMaybe<Scalars['Date']['input']>;
  conversionOpenAt?: InputMaybe<Scalars['Date']['input']>;
  dataDisposition?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  foundingDiscountPercent?: InputMaybe<Scalars['Float']['input']>;
  launchDate?: InputMaybe<Scalars['Date']['input']>;
  mockSessionAt?: InputMaybe<Scalars['Date']['input']>;
  mockSessionAttendedAt?: InputMaybe<Scalars['Date']['input']>;
  mockSessionLink?: InputMaybe<Scalars['String']['input']>;
  mockSessionNoShowAt?: InputMaybe<Scalars['Date']['input']>;
  onboardingAttendedAt?: InputMaybe<Scalars['Date']['input']>;
  onboardingCallAt?: InputMaybe<Scalars['Date']['input']>;
  onboardingCallLink?: InputMaybe<Scalars['String']['input']>;
  onboardingNoShowAt?: InputMaybe<Scalars['Date']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  playStoreUrl?: InputMaybe<Scalars['String']['input']>;
  returnLink?: InputMaybe<Scalars['String']['input']>;
  testFlightUrl?: InputMaybe<Scalars['String']['input']>;
};

export enum BetaUpdatesMailingListInterest {
  Consumer = 'CONSUMER',
  Serviceprovider = 'SERVICEPROVIDER',
}

export type BetaUpdatesMailingListSubscription = {
  __typename?: 'BetaUpdatesMailingListSubscription';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  interest: BetaUpdatesMailingListInterest;
  lastName: Scalars['String']['output'];
  listId: Scalars['String']['output'];
  subscribedAt: Scalars['Date']['output'];
};

/**
 * Represents different types of billing events that can occur within the system.
 * Used for tracking billing history and categorizing financial activities.
 */
export enum BillingEventType {
  /** Billing has been disabled for the account (manual override). */
  BillingDisabled = 'BILLING_DISABLED',
  /** Billing has been enabled or re-enabled for the account. */
  BillingEnabled = 'BILLING_ENABLED',
  /** New invoice has been generated for subscription or usage. */
  InvoiceCreated = 'INVOICE_CREATED',
  /** Invoice has been successfully paid by the customer. */
  InvoicePaid = 'INVOICE_PAID',
  /** Payment for invoice failed after all retry attempts. */
  InvoicePaymentFailed = 'INVOICE_PAYMENT_FAILED',
  /** Invoice has been voided and will not be collected. */
  InvoiceVoided = 'INVOICE_VOIDED',
  /** Payment attempt failed due to card issues, insufficient funds, etc. */
  PaymentFailed = 'PAYMENT_FAILED',
  /** User has updated their payment method (new card, bank account, etc.). */
  PaymentMethodUpdated = 'PAYMENT_METHOD_UPDATED',
  /** System is retrying a failed payment automatically. */
  PaymentRetry = 'PAYMENT_RETRY',
  /** Payment has been successfully processed by Stripe. */
  PaymentSucceeded = 'PAYMENT_SUCCEEDED',
  /** User has changed from one subscription plan to another. */
  PlanChanged = 'PLAN_CHANGED',
  /** Proration charge created for mid-cycle plan changes. */
  ProrationCreated = 'PRORATION_CREATED',
  /** Refund has been issued to customer for overpayment or cancellation. */
  RefundIssued = 'REFUND_ISSUED',
  /** Number of seats in team subscription has been modified. */
  SeatsChanged = 'SEATS_CHANGED',
  /** Subscription has been cancelled by user or system. */
  SubscriptionCanceled = 'SUBSCRIPTION_CANCELED',
  /** New subscription has been created for an account. */
  SubscriptionCreated = 'SUBSCRIPTION_CREATED',
  /** Previously cancelled subscription has been reactivated. */
  SubscriptionReactivated = 'SUBSCRIPTION_REACTIVATED',
  /** Existing subscription has been modified (seats, payment method, etc.). */
  SubscriptionUpdated = 'SUBSCRIPTION_UPDATED',
  /** Trial period has expired and account needs to subscribe. */
  TrialEnded = 'TRIAL_ENDED',
  /** Trial period is approaching expiration (warning notification). */
  TrialEndingSoon = 'TRIAL_ENDING_SOON',
  /** Trial period has begun for a new account. */
  TrialStarted = 'TRIAL_STARTED',
}

export type BillingHistoryEvent = {
  __typename?: 'BillingHistoryEvent';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  eventData?: Maybe<Scalars['String']['output']>;
  eventType: BillingEventType;
  id: Scalars['ID']['output'];
  stripeEventId?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
};

export type BillingHistoryFilter = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<BillingEventType>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type BillingHistoryInput = {
  filter?: InputMaybe<BillingHistoryFilter>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingHistoryResponse = {
  __typename?: 'BillingHistoryResponse';
  events: Array<BillingHistoryEvent>;
  paginationInfo: PaginationInfo;
};

/** Billing information for a client account */
export type BillingInfo = {
  __typename?: 'BillingInfo';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Use drop down list of states. Send 2 character data, display full text. Ex: Send 'AL', display 'Alabama' https://www.drupal.org/node/332575 */
  state?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type BillingInfoInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** Use drop down list of states. Send 2 character data, display full text. Ex: Send 'AL', display 'Alabama' https://www.drupal.org/node/332575 */
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type BulkDeleteError = {
  __typename?: 'BulkDeleteError';
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  reason: BulkDeleteErrorReason;
  sku?: Maybe<Scalars['String']['output']>;
};

/**
 * Reasons why a service item could not be deleted during bulk delete operations.
 * Provides specific error categorization for troubleshooting and user feedback.
 */
export enum BulkDeleteErrorReason {
  /** Service item is currently referenced by estimates, jobs, or invoices and cannot be deleted. */
  InUse = 'IN_USE',
  /** Service item with the specified ID does not exist in the database. */
  NotFound = 'NOT_FOUND',
  /** User does not have permission to delete this service item (requires SP_ADMIN or SP_SUPPORT role). */
  Unauthorized = 'UNAUTHORIZED',
  /** Service item data failed validation checks before deletion could be processed. */
  ValidationError = 'VALIDATION_ERROR',
}

export type BulkDeleteServiceItems = {
  __typename?: 'BulkDeleteServiceItems';
  errors: Array<BulkDeleteError>;
  message: Scalars['String']['output'];
  skippedItems: Array<SkippedItem>;
  successfulDeletes: Array<SuccessfulDelete>;
  totalItems: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for bulk deleting service items */
export type BulkDeleteServiceItemsInput = {
  /** Optional: Force delete even if items are in use (admin only) */
  forceDelete?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of service item IDs to delete */
  serviceItemIds: Array<Scalars['ID']['input']>;
};

export type BulkDeleteServiceItemsResponse = BulkDeleteServiceItems | Error;

export type BulkFeeUpdateError = {
  __typename?: 'BulkFeeUpdateError';
  account_id: Scalars['ID']['output'];
  businessName: Scalars['String']['output'];
  errorCode: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
};

/** Input for bulk updating service provider fees */
export type BulkFeeUpdateInput = {
  /** Account IDs to update (empty means all Connect-enabled accounts) */
  accountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** New fee percentage to apply */
  feePercentage?: InputMaybe<Scalars['Float']['input']>;
  /** New fixed fee amount to apply (in cents) */
  fixedFeeAmount?: InputMaybe<Scalars['Float']['input']>;
  /** Only update accounts with current default fees */
  onlyUpdateDefaults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reason for the bulk update (for audit trail) */
  updateReason: Scalars['String']['input'];
};

export type BulkFeeUpdateResult = {
  __typename?: 'BulkFeeUpdateResult';
  account_id: Scalars['ID']['output'];
  businessName: Scalars['String']['output'];
  newFeePercentage: Scalars['Float']['output'];
  newFixedFee: Scalars['Float']['output'];
  oldFeePercentage: Scalars['Float']['output'];
  oldFixedFee: Scalars['Float']['output'];
};

export type BulkUpdateSPFees = {
  __typename?: 'BulkUpdateSPFees';
  /** Details of failed updates */
  errors: Array<BulkFeeUpdateError>;
  message: Scalars['String']['output'];
  /** Details of successful updates */
  successfulUpdates: Array<BulkFeeUpdateResult>;
  /** Number of accounts successfully updated */
  updatedCount: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type BulkUpdateSPFeesResponse = BulkUpdateSPFees | Error;

/** Mapping of CSV columns to service item fields for bulk update */
export type BulkUpdateServiceItemCSVColumnMapping = {
  /** Column name or index for ADT */
  adt?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Is Archived */
  isArchived?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for isShowNewService */
  isShowNewService?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for isShowOnlineBooking */
  isShowOnlineBooking?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for isTaxable */
  isTaxable?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for location */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for manufacturer model number */
  manufacturerModelNumber?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for quantity on hand */
  quantityOnHand?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for reorder level */
  reorderLevel?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for size */
  size?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for SKU */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for tags (comma-separated) */
  tags?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for type (LABOR/MATERIAL) */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for unit cost */
  unitCost?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for unit of measure */
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for unit retail price */
  unitRetailPrice?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for vendor SKU */
  vendorSku?: InputMaybe<Scalars['String']['input']>;
};

export type BulkUpdateServiceItemsCSV = {
  __typename?: 'BulkUpdateServiceItemsCSV';
  errors?: Maybe<Array<ImportError>>;
  message: Scalars['String']['output'];
  successfulUpdates: Array<SuccessfulImport>;
  totalItems: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for bulk updating service items via CSV */
export type BulkUpdateServiceItemsCSVInput = {
  /** Optional mapping of CSV columns to service item fields */
  columnMapping?: InputMaybe<BulkUpdateServiceItemCSVColumnMapping>;
  /** CSV file content */
  csvContent: Scalars['String']['input'];
};

export type BulkUpdateServiceItemsCSVResponse = BulkUpdateServiceItemsCSV | Error;

export type CacheConfiguration = {
  __typename?: 'CacheConfiguration';
  backend: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  monitoringEnabled: Scalars['Boolean']['output'];
  prefetchEnabled: Scalars['Boolean']['output'];
  /** Indicates whether cache prerefreshing is enabled */
  prefreshEnabled: Scalars['Boolean']['output'];
  rolloutPercentage: Scalars['Int']['output'];
  ttl: Scalars['Int']['output'];
};

export type CacheEntity = {
  __typename?: 'CacheEntity';
  ids: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type CacheEntryDetail = {
  __typename?: 'CacheEntryDetail';
  cachedPages: Array<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  entities: Array<CacheEntity>;
  expiresAt: Scalars['String']['output'];
  key: Scalars['String']['output'];
  operationName: Scalars['String']['output'];
};

export type CachePrefreshState = {
  __typename?: 'CachePrefreshState';
  /** Indicates whether cache prerefreshing is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Indicates whether cache is currently being prerefreshed */
  isPrerefreshing: Scalars['Boolean']['output'];
  /** Timestamp of the last cache prerefreshing operation */
  lastPrefreshAt?: Maybe<Scalars['String']['output']>;
  /** Duration of the prerefreshing operation in milliseconds */
  prefreshDuration?: Maybe<Scalars['Int']['output']>;
  /** List of accounts for which queries were prerefreshed */
  prefreshedAccounts?: Maybe<Array<PrefreshAccountInfo>>;
  /** Number of queries that were prerefreshed */
  queriesPrerefreshed: Scalars['Int']['output'];
  /** List of accounts that were skipped during prerefreshing */
  skippedAccounts?: Maybe<Array<SkippedAccountInfo>>;
  /** Total number of queries to prefresh */
  totalQueriesToPrefresh: Scalars['Int']['output'];
};

export type CacheThresholds = {
  __typename?: 'CacheThresholds';
  evictionPolicy: Scalars['String']['output'];
  maxMemoryMB?: Maybe<Scalars['Int']['output']>;
  maxResultSizeKB: Scalars['Int']['output'];
  prefetchDelayMs: Scalars['Int']['output'];
  prefetchPages: Scalars['Int']['output'];
};

export type CalculateApplicationFee = {
  __typename?: 'CalculateApplicationFee';
  feeCalculation: FeeCalculation;
  message: Scalars['String']['output'];
};

export type CalculateApplicationFeeResponse = CalculateApplicationFee | Error;

export type CalculateFeePreview = {
  __typename?: 'CalculateFeePreview';
  message: Scalars['String']['output'];
  preview: FeePreview;
  version: Scalars['String']['output'];
};

export type CalculateFeePreviewInput = {
  amount: Scalars['Float']['input'];
};

export type CalculateFeePreviewResponse = CalculateFeePreview | Error;

export type CancelQuickBooksImport = {
  __typename?: 'CancelQuickBooksImport';
  importJob?: Maybe<QuickBooksImportJob>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CancelQuickBooksImportResponse = CancelQuickBooksImport | Error;

export type CancelQuickBooksSetup = {
  __typename?: 'CancelQuickBooksSetup';
  entitiesDeleted: CancelQuickBooksSetupCounts;
  message: Scalars['String']['output'];
  skippedEntities: CancelQuickBooksSetupCounts;
  version: Scalars['String']['output'];
};

export type CancelQuickBooksSetupCounts = {
  __typename?: 'CancelQuickBooksSetupCounts';
  clients: Scalars['Int']['output'];
  serviceItems: Scalars['Int']['output'];
};

export type CancelQuickBooksSetupResponse = CancelQuickBooksSetup | Error;

export type CategoryChannelSettings = {
  __typename?: 'CategoryChannelSettings';
  /** Notification category */
  category: NotificationCategory;
  /** Channels for this category */
  channels: Array<NotificationChannel>;
};

export type CategoryChannelSettingsInput = {
  /** Notification category */
  category: NotificationCategory;
  /** Channels (empty array to remove override and use global/role defaults) */
  channels: Array<NotificationChannel>;
};

export type Chat = Timestamps & {
  __typename?: 'Chat';
  account_id?: Maybe<Scalars['ID']['output']>;
  appointment_id?: Maybe<Scalars['ID']['output']>;
  chatType: ChatType;
  clientAccount?: Maybe<ClientAccount>;
  clientAccountName?: Maybe<Scalars['String']['output']>;
  clientHasUnreadMessages?: Maybe<Scalars['Boolean']['output']>;
  clientLastReadDateTime?: Maybe<Scalars['Date']['output']>;
  clientUnreadMessageCount?: Maybe<Scalars['Int']['output']>;
  clientUserFullName?: Maybe<Scalars['String']['output']>;
  client_account_id?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  estimate_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['ID']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isArchivedClientAccount?: Maybe<Scalars['Boolean']['output']>;
  isArchivedServiceProviderAccount?: Maybe<Scalars['Boolean']['output']>;
  job?: Maybe<Job>;
  job_id?: Maybe<Scalars['ID']['output']>;
  lastInternalMessageDateTime?: Maybe<Scalars['Date']['output']>;
  lastInternalMessageText?: Maybe<Scalars['String']['output']>;
  lastInternalMessageUserAvatarUrl?: Maybe<Scalars['String']['output']>;
  lastInternalMessageUserId?: Maybe<Scalars['ID']['output']>;
  lastInternalMessageUserName?: Maybe<Scalars['String']['output']>;
  lastMessageDateTime?: Maybe<Scalars['Date']['output']>;
  lastMessageText?: Maybe<Scalars['String']['output']>;
  lastMessageUserAccountName?: Maybe<Scalars['String']['output']>;
  lastMessageUserAvatarUrl?: Maybe<Scalars['String']['output']>;
  lastMessageUserFirstName?: Maybe<Scalars['String']['output']>;
  lastMessageUserId?: Maybe<Scalars['ID']['output']>;
  lastMessageUserLastName?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<Array<Message>>;
  name?: Maybe<Scalars['String']['output']>;
  serviceProviderAccount?: Maybe<ServiceProviderAccount>;
  serviceProviderAccountName?: Maybe<Scalars['String']['output']>;
  serviceProviderUserFullName?: Maybe<Scalars['String']['output']>;
  spHasUnreadMessages?: Maybe<Scalars['Boolean']['output']>;
  spInternalHasUnreadMessages?: Maybe<Scalars['Boolean']['output']>;
  spInternalUnreadMessageCount?: Maybe<Scalars['Int']['output']>;
  spLastReadDateTime?: Maybe<Scalars['Date']['output']>;
  spUnreadMessageCount?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ChatMessageEvent = ChatMessageSent | Error;

export type ChatMessageSent = {
  __typename?: 'ChatMessageSent';
  /** The new message */
  chatMessage: Message;
};

/**
 * Types of chat conversations that can be created in the system.
 * Determines the context and participants of the chat.
 */
export enum ChatType {
  /** Chat conversation related to an appointment, for discussing scheduling and appointment details. */
  Appointment = 'APPOINTMENT',
  /** Chat conversation related to an estimate, for discussing scope, pricing, or modifications. */
  Estimate = 'ESTIMATE',
  /** Chat conversation related to an invoice, for discussing payment, billing questions, or disputes. */
  Invoice = 'INVOICE',
  /** Chat conversation related to a specific job, including updates, questions, and coordination. */
  Job = 'JOB',
  /** Direct conversation between service provider and client, not tied to any specific job or document. */
  SpClientDirect = 'SP_CLIENT_DIRECT',
}

export type ChatUpdateEvent = {
  __typename?: 'ChatUpdateEvent';
  chat: Chat;
};

export enum ChatsSortBy {
  ChatType = 'CHAT_TYPE',
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type CheckAdminPasswordExpiry = {
  __typename?: 'CheckAdminPasswordExpiry';
  /** Days until password expires */
  daysUntilExpiry: Scalars['Int']['output'];
  /** Password expiry date */
  expiresAt?: Maybe<Scalars['Date']['output']>;
  /** Whether password has expired */
  isExpired: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CheckAdminPasswordExpiryResponse = CheckAdminPasswordExpiry | Error;

/** Expected input to check a token for password reset */
export type CheckResetTokenInput = {
  token: Scalars['String']['input'];
};

export type Checklist = Timestamps & {
  __typename?: 'Checklist';
  account_id: Scalars['ID']['output'];
  checklistEntries?: Maybe<Array<ChecklistEntry>>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isInUse?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ChecklistEntriesSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type ChecklistEntry = Timestamps & {
  __typename?: 'ChecklistEntry';
  account_id: Scalars['ID']['output'];
  checklist_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDescriptionRequired?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ChecklistEntrySaved = {
  __typename?: 'ChecklistEntrySaved';
  description?: Maybe<Scalars['String']['output']>;
  isDescriptionRequired?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
};

export type ChecklistSaved = {
  __typename?: 'ChecklistSaved';
  checklistEntries?: Maybe<Array<ChecklistEntrySaved>>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum ChecklistsSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
}

export type CleanTestDB = {
  __typename?: 'CleanTestDB';
  message: Scalars['String']['output'];
};

export type CleanTestDBResponse = CleanTestDB | Error;

export type ClientAccount = Account &
  Timestamps & {
    __typename?: 'ClientAccount';
    accountType: AccountType;
    attachments?: Maybe<Array<Attachment>>;
    availability: Availability;
    billingInfo?: Maybe<BillingInfo>;
    chat_id?: Maybe<Scalars['ID']['output']>;
    chats?: Maybe<Array<Chat>>;
    companyEmail?: Maybe<Scalars['String']['output']>;
    companyName?: Maybe<Scalars['String']['output']>;
    companyPhone?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['Date']['output'];
    estimates?: Maybe<Array<Estimate>>;
    /** True once the client has signed into the client portal at least once */
    hasAccessedPortal: Scalars['Boolean']['output'];
    id: Scalars['ID']['output'];
    invoices?: Maybe<Array<Invoice>>;
    isArchived: Scalars['Boolean']['output'];
    /** Indicates if this is a draft client (no email or phone yet) */
    isDraft?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates if the client account was created by an IVR self-identification call */
    isIVRClientSignUp?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates if the client is in use and cannot be deleted (based on deletion rules) */
    isInUse: Scalars['Boolean']['output'];
    /** Indicates if the record was created via Quick Add or draft mode (no email/phone required) */
    isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
    jobs?: Maybe<Array<Job>>;
    linkedServiceProviders?: Maybe<Array<LinkedServiceProviderAccount>>;
    messages?: Maybe<Array<Message>>;
    notes?: Maybe<Array<Note>>;
    properties?: Maybe<Array<Property>>;
    referralInfo: ReferralInfo;
    referredBy?: Maybe<Scalars['String']['output']>;
    serviceCategories?: Maybe<Array<ServiceCategory>>;
    settings?: Maybe<ClientSettings>;
    /** Tags for organizing and searching client accounts */
    tags?: Maybe<Array<Scalars['String']['output']>>;
    /** IANA timezone (e.g. America/Los_Angeles). Nullable because Quick Add / draft clients can be created without a timezone. */
    timeZone?: Maybe<Scalars['String']['output']>;
    updatedAt: Scalars['Date']['output'];
    users?: Maybe<Array<User>>;
    website?: Maybe<Scalars['String']['output']>;
  };

/** Mapping of CSV columns to client and property fields */
export type ClientCSVColumnMapping = {
  /** Column name for billing address line 1 */
  billingAddress1?: InputMaybe<Scalars['String']['input']>;
  /** Column name for billing address line 2 */
  billingAddress2?: InputMaybe<Scalars['String']['input']>;
  /** Column name for billing city */
  billingCity?: InputMaybe<Scalars['String']['input']>;
  /** Column name for billing company name */
  billingCompanyName?: InputMaybe<Scalars['String']['input']>;
  /** Column name for billing contact name */
  billingContactName?: InputMaybe<Scalars['String']['input']>;
  /** Column name for billing country */
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  /** Column name for billing state (2-character code) */
  billingState?: InputMaybe<Scalars['String']['input']>;
  /** Column name for billing zip code */
  billingZip?: InputMaybe<Scalars['String']['input']>;
  /** Column name for company name */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Column name for client email (required) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Column name for archived status */
  isArchived?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 address line 1 */
  property1_address1?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 address line 2 */
  property1_address2?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 city */
  property1_city?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 contact email */
  property1_contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 contact name */
  property1_contactName?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 contact phone */
  property1_contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 country */
  property1_country?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 ID (for updates) */
  property1_id?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 name */
  property1_name?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 state */
  property1_state?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 time zone */
  property1_timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 type (RESIDENTIAL/COMMERCIAL/SP_LOCATION) */
  property1_type?: InputMaybe<Scalars['String']['input']>;
  /** Column name for property 1 zip code */
  property1_zip?: InputMaybe<Scalars['String']['input']>;
  property2_address1?: InputMaybe<Scalars['String']['input']>;
  property2_address2?: InputMaybe<Scalars['String']['input']>;
  property2_city?: InputMaybe<Scalars['String']['input']>;
  property2_contactEmail?: InputMaybe<Scalars['String']['input']>;
  property2_contactName?: InputMaybe<Scalars['String']['input']>;
  property2_contactPhone?: InputMaybe<Scalars['String']['input']>;
  property2_country?: InputMaybe<Scalars['String']['input']>;
  property2_id?: InputMaybe<Scalars['String']['input']>;
  property2_name?: InputMaybe<Scalars['String']['input']>;
  property2_state?: InputMaybe<Scalars['String']['input']>;
  property2_timeZone?: InputMaybe<Scalars['String']['input']>;
  property2_type?: InputMaybe<Scalars['String']['input']>;
  property2_zip?: InputMaybe<Scalars['String']['input']>;
  property3_address1?: InputMaybe<Scalars['String']['input']>;
  property3_address2?: InputMaybe<Scalars['String']['input']>;
  property3_city?: InputMaybe<Scalars['String']['input']>;
  property3_contactEmail?: InputMaybe<Scalars['String']['input']>;
  property3_contactName?: InputMaybe<Scalars['String']['input']>;
  property3_contactPhone?: InputMaybe<Scalars['String']['input']>;
  property3_country?: InputMaybe<Scalars['String']['input']>;
  property3_id?: InputMaybe<Scalars['String']['input']>;
  property3_name?: InputMaybe<Scalars['String']['input']>;
  property3_state?: InputMaybe<Scalars['String']['input']>;
  property3_timeZone?: InputMaybe<Scalars['String']['input']>;
  property3_type?: InputMaybe<Scalars['String']['input']>;
  property3_zip?: InputMaybe<Scalars['String']['input']>;
  property4_address1?: InputMaybe<Scalars['String']['input']>;
  property4_address2?: InputMaybe<Scalars['String']['input']>;
  property4_city?: InputMaybe<Scalars['String']['input']>;
  property4_contactEmail?: InputMaybe<Scalars['String']['input']>;
  property4_contactName?: InputMaybe<Scalars['String']['input']>;
  property4_contactPhone?: InputMaybe<Scalars['String']['input']>;
  property4_country?: InputMaybe<Scalars['String']['input']>;
  property4_id?: InputMaybe<Scalars['String']['input']>;
  property4_name?: InputMaybe<Scalars['String']['input']>;
  property4_state?: InputMaybe<Scalars['String']['input']>;
  property4_timeZone?: InputMaybe<Scalars['String']['input']>;
  property4_type?: InputMaybe<Scalars['String']['input']>;
  property4_zip?: InputMaybe<Scalars['String']['input']>;
  property5_address1?: InputMaybe<Scalars['String']['input']>;
  property5_address2?: InputMaybe<Scalars['String']['input']>;
  property5_city?: InputMaybe<Scalars['String']['input']>;
  property5_contactEmail?: InputMaybe<Scalars['String']['input']>;
  property5_contactName?: InputMaybe<Scalars['String']['input']>;
  property5_contactPhone?: InputMaybe<Scalars['String']['input']>;
  property5_country?: InputMaybe<Scalars['String']['input']>;
  property5_id?: InputMaybe<Scalars['String']['input']>;
  property5_name?: InputMaybe<Scalars['String']['input']>;
  property5_state?: InputMaybe<Scalars['String']['input']>;
  property5_timeZone?: InputMaybe<Scalars['String']['input']>;
  property5_type?: InputMaybe<Scalars['String']['input']>;
  property5_zip?: InputMaybe<Scalars['String']['input']>;
  /** Column name for tags (comma-separated) */
  tags?: InputMaybe<Scalars['String']['input']>;
  /** Column name for time zone */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Column name for website */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ClientImportError = {
  __typename?: 'ClientImportError';
  /** Field name that caused the error (if applicable) */
  field?: Maybe<Scalars['String']['output']>;
  /** Error message describing what went wrong */
  message: Scalars['String']['output'];
  /** Row number in CSV where error occurred */
  row: Scalars['Int']['output'];
};

/** Mode for sendClientInvite — drives which email template is rendered. INVITE_ONLY is the plain regular-create flow; INVITE_AND_VIEW also tells the client the SP already has a record on file for them (quick-add from estimate/invoice). */
export enum ClientInviteMode {
  InviteAndView = 'INVITE_AND_VIEW',
  InviteOnly = 'INVITE_ONLY',
}

export type ClientInvitePreview = {
  __typename?: 'ClientInvitePreview';
  message: Scalars['String']['output'];
  recordId?: Maybe<Scalars['ID']['output']>;
  recordSummary?: Maybe<ClientInviteRecordSummary>;
  recordType?: Maybe<ClientInviteRecordType>;
  redirectPath: Scalars['String']['output'];
  serviceProviderName?: Maybe<Scalars['String']['output']>;
  variant: ClientInviteMode;
};

export type ClientInvitePreviewResponse = ClientInvitePreview | Error;

export type ClientInviteRecordSummary = {
  __typename?: 'ClientInviteRecordSummary';
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum ClientInviteRecordType {
  Appointment = 'APPOINTMENT',
  Estimate = 'ESTIMATE',
  Job = 'JOB',
}

export type ClientServiceProviderInviteHistory = {
  __typename?: 'ClientServiceProviderInviteHistory';
  action: Scalars['String']['output'];
  actorRole?: Maybe<Scalars['String']['output']>;
  actorUserId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  nextState: ClientServiceProviderLinkState;
  note?: Maybe<Scalars['String']['output']>;
  previousState?: Maybe<ClientServiceProviderLinkState>;
};

export enum ClientServiceProviderLinkState {
  Blocked = 'BLOCKED',
  InviteAccepted = 'INVITE_ACCEPTED',
  InviteDeclined = 'INVITE_DECLINED',
  InvitePending = 'INVITE_PENDING',
  SpCreated = 'SP_CREATED',
}

export type ClientSettings = {
  __typename?: 'ClientSettings';
  dashboardAdvancedView?: Maybe<Scalars['Boolean']['output']>;
  doNotShareInformation?: Maybe<Scalars['Boolean']['output']>;
  notificationAnnoucements?: Maybe<Scalars['Boolean']['output']>;
  notificationChatMessages?: Maybe<Scalars['Boolean']['output']>;
  notificationJobReminders?: Maybe<Scalars['Boolean']['output']>;
  notificationJobStatus?: Maybe<Scalars['Boolean']['output']>;
  notificationMarketing?: Maybe<Scalars['Boolean']['output']>;
  notificationMethod?: Maybe<NotificationMethod>;
};

export type ClientUnavailableDates = {
  __typename?: 'ClientUnavailableDates';
  client_account_id: Scalars['ID']['output'];
  unavailableDates: Array<Maybe<DateRange>>;
};

/** Parameters to filter completed work orders report data */
export type CompletedWorkOrderReportFilter = {
  /** End date for work orders */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Start date for work orders */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type ComprehensiveCacheStatus = {
  __typename?: 'ComprehensiveCacheStatus';
  accountDetails?: Maybe<AccountCacheDetails>;
  configuration: CacheConfiguration;
  globalMetrics: GlobalCacheMetrics;
  prefreshState: CachePrefreshState;
  thresholds: CacheThresholds;
};

/** Stripe Connect application details for admin review */
export type ConnectApplicationDetails = {
  __typename?: 'ConnectApplicationDetails';
  account_id: Scalars['ID']['output'];
  /** Admin notes about the application */
  adminNotes?: Maybe<Scalars['String']['output']>;
  /** Current fee configuration */
  applicationFee: ApplicationFeeConfig;
  /** Stripe Connect application status */
  applicationStatus: SPStripeApplicationStatus;
  /** Application submission timestamp */
  applicationSubmittedAt?: Maybe<Scalars['Date']['output']>;
  businessName: Scalars['String']['output'];
  businessType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Last status change timestamp */
  lastStatusUpdate?: Maybe<Scalars['Date']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  /** Admin who processed the application */
  processedBy?: Maybe<AdminUser>;
  /** Approval/decline timestamp */
  statusResolvedAt?: Maybe<Scalars['Date']['output']>;
  /** Stripe Express account ID if approved */
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  /** Stripe account status if connected */
  stripeAccountStatus?: Maybe<Scalars['String']['output']>;
  /** Stripe onboarding completion status */
  stripeOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  /** Total application fees collected */
  totalFeesCollected?: Maybe<Scalars['Float']['output']>;
  /** Total payments processed through Connect */
  totalPaymentsProcessed?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Sort options for Connect applications */
export enum ConnectApplicationSortBy {
  ApplicationStatus = 'APPLICATION_STATUS',
  BusinessName = 'BUSINESS_NAME',
  CreatedAt = 'CREATED_AT',
  StatusUpdatedAt = 'STATUS_UPDATED_AT',
  SubmittedAt = 'SUBMITTED_AT',
  TotalFees = 'TOTAL_FEES',
  TotalPayments = 'TOTAL_PAYMENTS',
}

/** Summary of Connect applications by status */
export type ConnectApplicationSummary = {
  __typename?: 'ConnectApplicationSummary';
  /** Average processing time in hours */
  averageProcessingTime?: Maybe<Scalars['Float']['output']>;
  count: Scalars['Int']['output'];
  status: SPStripeApplicationStatus;
};

export type ConnectOnboardingStatus = {
  __typename?: 'ConnectOnboardingStatus';
  accountId?: Maybe<Scalars['String']['output']>;
  currentlyDue: Array<Scalars['String']['output']>;
  eventuallyDue: Array<Scalars['String']['output']>;
  onboardingUrl?: Maybe<Scalars['String']['output']>;
  requiresAction: Scalars['Boolean']['output'];
};

export type ConnectStatus = {
  __typename?: 'ConnectStatus';
  applicationFee: ApplicationFeeConfig;
  applicationStatus: SPStripeApplicationStatus;
  isOnboardingComplete: Scalars['Boolean']['output'];
  lastStatusUpdate?: Maybe<Scalars['Date']['output']>;
  requiresAction: Scalars['Boolean']['output'];
  stripeAccountId?: Maybe<Scalars['String']['output']>;
};

export enum ContactMethod {
  /** Contact via email */
  Email = 'EMAIL',
  /** Contact via phone */
  Phone = 'PHONE',
  /** Contact via SMS */
  Sms = 'SMS',
}

export type ContactRequest = {
  __typename?: 'ContactRequest';
  contact_email?: Maybe<Scalars['String']['output']>;
  contact_notes?: Maybe<Scalars['String']['output']>;
  contact_phone?: Maybe<Scalars['String']['output']>;
  contact_status: ContactRequestStatus;
  contactedByUserFullName?: Maybe<Scalars['String']['output']>;
  contacted_at?: Maybe<Scalars['Date']['output']>;
  contacted_by_user_id?: Maybe<Scalars['ID']['output']>;
  preferred_contact_method?: Maybe<ContactMethod>;
  preferred_contact_time?: Maybe<ContactTime>;
};

export enum ContactRequestStatus {
  /** Contact request has been completed */
  Completed = 'COMPLETED',
  /** Contact has been initiated */
  Contacted = 'CONTACTED',
  /** Contact request has been declined */
  Declined = 'DECLINED',
  /** Contact request is pending */
  Pending = 'PENDING',
}

export enum ContactTime {
  /** Contact in the afternoon */
  Afternoon = 'AFTERNOON',
  /** Contact at any time */
  Any = 'ANY',
  /** Contact in the evening */
  Evening = 'EVENING',
  /** Contact in the morning */
  Morning = 'MORNING',
}

/** Response for converting an IVR lead to a client account */
export type ConvertIVRLeadToClient = {
  __typename?: 'ConvertIVRLeadToClient';
  callLogId: Scalars['ID']['output'];
  clientAccountId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ConvertIVRLeadToClientInput = {
  callLogId: Scalars['ID']['input'];
  /** Override display name (defaults to callerName from call log) */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Optional email — caller may not have provided one over IVR */
  email?: InputMaybe<Scalars['String']['input']>;
};

export type ConvertIVRLeadToClientResponse = ConvertIVRLeadToClient | Error;

export type CreateAccountSampleData = {
  __typename?: 'CreateAccountSampleData';
  message: Scalars['String']['output'];
  sampleDataJobId: Scalars['ID']['output'];
};

export type CreateAccountSampleDataResponse = CreateAccountSampleData | Error;

export type CreateAdminUser = {
  __typename?: 'CreateAdminUser';
  adminUser: AdminUser;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to create an admin user */
export type CreateAdminUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  /** Specific permission IDs to grant */
  permissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  phone: Scalars['String']['input'];
  role: AdminRole;
  /** Whether to send welcome email */
  sendWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone: Scalars['String']['input'];
};

export type CreateAdminUserResponse = CreateAdminUser | Error;

/** Expected input to create an appointment */
export type CreateAppointmentInput = {
  /** Service Provider account ID - required when CLIENT user creates appointment */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  alternateBillingInfo?: InputMaybe<BillingInfoInput>;
  bill_to_client_account_id?: InputMaybe<Scalars['ID']['input']>;
  callback?: InputMaybe<Scalars['Boolean']['input']>;
  client_account_id: Scalars['ID']['input'];
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  /** Optional note text to create on the appointment after creation */
  description?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional note text alias to create on the appointment after creation */
  note?: InputMaybe<Scalars['String']['input']>;
  overrideAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Boolean']['input']>;
  property_id?: InputMaybe<Scalars['ID']['input']>;
  scheduledStartDatetime?: InputMaybe<Scalars['Date']['input']>;
  serviceItems?: InputMaybe<Array<AppointmentServiceItemInput>>;
  status?: InputMaybe<AppointmentStatus>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  taxRateName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAttachment = {
  __typename?: 'CreateAttachment';
  attachment: Attachment;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to create an attachment. */
export type CreateAttachmentInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  base64: Scalars['String']['input'];
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  estimate_id?: InputMaybe<Scalars['ID']['input']>;
  fileName: Scalars['String']['input'];
  invoice_id?: InputMaybe<Scalars['ID']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
  message_id?: InputMaybe<Scalars['ID']['input']>;
  note_id?: InputMaybe<Scalars['ID']['input']>;
  property_id?: InputMaybe<Scalars['ID']['input']>;
  service_item_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AttachmentType>;
};

export type CreateAttachmentResponse = CreateAttachment | Error;

export type CreateChat = {
  __typename?: 'CreateChat';
  chat: Chat;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to create a chat. If there is no user in the array with `isChatLead` set to true, an error will be returned. */
export type CreateChatInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  chatType: ChatType;
  client_account_id: Scalars['ID']['input'];
  estimate_id?: InputMaybe<Scalars['ID']['input']>;
  invoice_id?: InputMaybe<Scalars['ID']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateChatResponse = CreateChat | Error;

/** Expected input to create a checklistEntry. */
export type CreateChecklistEntryInput = {
  checklist_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDescriptionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

/** Expected input to create a checklist. */
export type CreateChecklistInput = {
  checklistEntries?: InputMaybe<Array<CreateChecklistEntryInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateChecklistSavedEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDescriptionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type CreateChecklistSavedInput = {
  checklistEntries?: InputMaybe<Array<CreateChecklistSavedEntryInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateClient = {
  __typename?: 'CreateClient';
  account: ClientAccount;
  message: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

export type CreateClientExternal = {
  __typename?: 'CreateClientExternal';
  accessToken: Scalars['String']['output'];
  account: ClientAccount;
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

export type CreateClientExternalResponse = CreateClientExternal | Error;

/** Expected input for sign-up of a client from the website */
export type CreateClientInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  analyticsConsent?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** Optional language preference for the client owner. Defaults to English. */
  locale?: InputMaybe<Locale>;
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  planCode: Scalars['String']['input'];
  propertyBase64Image?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<propertyTypeEnum>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  serviceProviderClientCode?: InputMaybe<Scalars['String']['input']>;
  service_provider_id?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  /** Use drop down list of states. Send 2 character data, display full text. Ex: Send 'AL', display 'Alabama' https://www.drupal.org/node/332575 */
  state: Scalars['String']['input'];
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

/** Expected input for creating a client from within the service provider admin. Either (firstName + lastName) or companyName must be provided. All other fields are optional for draft client creation. */
export type CreateClientInternalInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<InputMaybe<LinkAttachmentInput>>>;
  billingInfo?: InputMaybe<BillingInfoInput>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** At least one of firstName, lastName, or companyName required */
  firstName?: InputMaybe<Scalars['String']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  /** At least one of firstName, lastName, or companyName required */
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  propertyAttachments?: InputMaybe<Array<InputMaybe<LinkAttachmentInput>>>;
  propertyBase64Image?: InputMaybe<Scalars['String']['input']>;
  propertyNote?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<propertyTypeEnum>;
  /** Use drop down list of states. Send 2 character data, display full text. Ex: Send 'AL', display 'Alabama' https://www.drupal.org/node/332575 */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Tags for organizing and searching client accounts */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClientResponse = CreateClient | Error;

export type CreateClientUserProperty = {
  __typename?: 'CreateClientUserProperty';
  account: ClientAccount;
  message: Scalars['String']['output'];
  /** Property is null when no address data was provided (deferred validation) */
  property?: Maybe<Property>;
  user: User;
  version: Scalars['String']['output'];
};

/** Create client with user and optional property. At least one of firstName, lastName, or companyName required. */
export type CreateClientUserPropertyInput = {
  /** Primary address line (optional — property created only if provided) */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** Secondary address line */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** File attachments tied to the client account */
  attachments?: InputMaybe<Array<InputMaybe<LinkAttachmentInput>>>;
  /** Billing information for the client account */
  billingInfo?: InputMaybe<BillingInfoInput>;
  /** City (optional — property created only if address1 provided) */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Company name for the client account */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Country code (defaults to USA) */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Client email address (optional — required to send documents) */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name (at least one of firstName, lastName, or companyName required) */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Mark as quick add (incomplete record) */
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  /** User last name (at least one of firstName, lastName, or companyName required) */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number in format +15105551212 (optional) */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** File attachments tied to the property */
  propertyAttachments?: InputMaybe<Array<InputMaybe<LinkAttachmentInput>>>;
  /** Base64 encoded property image (jpg or png) */
  propertyBase64Image?: InputMaybe<Scalars['String']['input']>;
  /** Free-text note attached to the property */
  propertyNote?: InputMaybe<Scalars['String']['input']>;
  /** Property type (RESIDENTIAL, COMMERCIAL, SP_LOCATION) */
  propertyType?: InputMaybe<propertyTypeEnum>;
  /** Use drop down list of states. Send 2 character data, display full text. Ex: Send 'AL', display 'Alabama' */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Tags for organizing and searching client accounts */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** IANA timezone (optional — defaults to SP account timezone). Ex: America/Los_Angeles */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Website URL */
  website?: InputMaybe<Scalars['String']['input']>;
  /** Zip code */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClientUserPropertyResponse = CreateClientUserProperty | Error;

/** Expected input to create a crew. If there is no user in the array with `isCrewLead` set to true, an error will be returned. */
export type CreateCrewInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** IANA timezone identifier for the crew (e.g., America/Los_Angeles, America/New_York) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  users: Array<CrewUserInput>;
};

export type CreateEstimateFromAppointment = {
  __typename?: 'CreateEstimateFromAppointment';
  estimate: Estimate;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to convert an appointment to an estimate */
export type CreateEstimateFromAppointmentInput = {
  appointment_id: Scalars['ID']['input'];
};

export type CreateEstimateFromAppointmentResponse = CreateEstimateFromAppointment | Error;

/** Expected input to create a estimate. */
export type CreateEstimateInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  alternateBillingInfo?: InputMaybe<BillingInfoInput>;
  bill_to_client_account_id?: InputMaybe<Scalars['ID']['input']>;
  checklist_id?: InputMaybe<Scalars['ID']['input']>;
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  commentToClient?: InputMaybe<Scalars['String']['input']>;
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  firstMessageToClient?: InputMaybe<Scalars['String']['input']>;
  firstMessageToSP?: InputMaybe<Scalars['String']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  property_id?: InputMaybe<Scalars['ID']['input']>;
  recurringSchedule?: InputMaybe<RecurringScheduleInput>;
  serviceItems?: InputMaybe<Array<EstimateServiceItemInput>>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  taxRateName?: InputMaybe<Scalars['String']['input']>;
  /** Optional date after which a sent estimate is no longer valid */
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

/** Expected input to create a feedback entry. */
export type CreateFeedbackEntryInput = {
  complaintDescription?: InputMaybe<Scalars['String']['input']>;
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  description: Scalars['String']['input'];
  isComplaint?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
  rating: Scalars['Int']['input'];
  type: FeedbackEntryType;
};

export type CreateGroupInput = {
  /** Account ID for admin users (optional, ignored for regular users) */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupCode: Scalars['String']['input'];
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  service_item_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateInvoiceFromAppointment = {
  __typename?: 'CreateInvoiceFromAppointment';
  invoice: Invoice;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to convert an appointment to an invoice */
export type CreateInvoiceFromAppointmentInput = {
  appointment_id: Scalars['ID']['input'];
};

export type CreateInvoiceFromAppointmentResponse = CreateInvoiceFromAppointment | Error;

/** Expected input to create a invoice. */
export type CreateInvoiceInput = {
  clientMessage?: InputMaybe<Scalars['String']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDateTerms?: InputMaybe<DueDateTerms>;
  dueDateType?: InputMaybe<DueDateTerms>;
  issueDate?: InputMaybe<Scalars['Date']['input']>;
  job_id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  serviceItems: Array<InvoiceServiceItemInput>;
  status?: InputMaybe<InvoiceStatus>;
  taxRate?: InputMaybe<Scalars['Int']['input']>;
  taxRateName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoicePaymentSession = {
  __typename?: 'CreateInvoicePaymentSession';
  message: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  sessionUrl: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreateInvoicePaymentSessionResponse = CreateInvoicePaymentSession | Error;

export type CreateJobFromAppointment = {
  __typename?: 'CreateJobFromAppointment';
  job: Job;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to convert an appointment to a job */
export type CreateJobFromAppointmentInput = {
  appointment_id: Scalars['ID']['input'];
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledStartDatetime: Scalars['Date']['input'];
  scheduledStopDatetime: Scalars['Date']['input'];
};

export type CreateJobFromAppointmentResponse = CreateJobFromAppointment | Error;

/** Expected input to convert an estimate to a job */
export type CreateJobFromEstimateInput = {
  estimate_id: Scalars['ID']['input'];
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledStartDatetime: Scalars['Date']['input'];
  scheduledStopDatetime: Scalars['Date']['input'];
};

/** Expected input to create a job. */
export type CreateJobInput = {
  alternateBillingInfo?: InputMaybe<BillingInfoInput>;
  bill_to_client_account_id?: InputMaybe<Scalars['ID']['input']>;
  checklist?: InputMaybe<CreateChecklistSavedInput>;
  checklist_id?: InputMaybe<Scalars['ID']['input']>;
  client_account_id: Scalars['ID']['input'];
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  property_id?: InputMaybe<Scalars['ID']['input']>;
  recurringSchedule?: InputMaybe<RecurringScheduleInput>;
  scheduledStartDatetime?: InputMaybe<Scalars['Date']['input']>;
  scheduledStopDatetime?: InputMaybe<Scalars['Date']['input']>;
  serviceItems?: InputMaybe<Array<JobServiceItemInput>>;
  status?: InputMaybe<JobStatus>;
  taxRate?: InputMaybe<Scalars['Int']['input']>;
  taxRateName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManufacturerInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Account ID for admin users (optional, ignored for regular users) */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName: Scalars['String']['input'];
  country?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  primaryContactEmail?: InputMaybe<Scalars['String']['input']>;
  primaryContactName?: InputMaybe<Scalars['String']['input']>;
  primaryContactPhone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Expected input to create a message. */
export type CreateMessageInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<LinkAttachmentInput>>;
  chat_id?: InputMaybe<Scalars['ID']['input']>;
  estimate_id?: InputMaybe<Scalars['ID']['input']>;
  invoice_id?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
  /** sender account id / user id are embedded within resolver */
  recipient_account_id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** Expected input to create a note. */
export type CreateNoteInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<LinkAttachmentInput>>;
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  estimate_id?: InputMaybe<Scalars['ID']['input']>;
  invoice_id?: InputMaybe<Scalars['ID']['input']>;
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
  property_id?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Expected input to create a payment */
export type CreatePaymentInput = {
  amount: Scalars['Int']['input'];
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  invoice_id: Scalars['ID']['input'];
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  method: PaymentMethod;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  processorFee?: InputMaybe<Scalars['Int']['input']>;
  processorTransactionId?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  status: PaymentStatus;
  transactionDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Expected input to create a property. */
export type CreatePropertyInput = {
  /** Specify either account id or client_account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<LinkAttachmentInput>>;
  base64Image?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  propertyType: propertyTypeEnum;
  /** Use drop down list of states. Send 2 character data, display full text. Ex: Send 'AL', display 'Alabama' https://www.drupal.org/node/332575 */
  state: Scalars['String']['input'];
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

export type CreatePublicInvoicePaymentSession = {
  __typename?: 'CreatePublicInvoicePaymentSession';
  message: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  sessionUrl: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreatePublicInvoicePaymentSessionResponse = CreatePublicInvoicePaymentSession | Error;

/** Expected input to create a service item. */
export type CreateServiceItemInput = {
  adt?: InputMaybe<Scalars['String']['input']>;
  attachments?: InputMaybe<Array<CreateAttachmentInput>>;
  /** Base64 encoded image data for the service item. */
  base64Image?: InputMaybe<Scalars['String']['input']>;
  checklist_id?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isInventoryDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  isShowNewService: Scalars['Boolean']['input'];
  isShowOnlineBooking: Scalars['Boolean']['input'];
  isTaxable: Scalars['Boolean']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  manufacturerModelNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturer_id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  quantityOnHand?: InputMaybe<Scalars['Int']['input']>;
  reorderLevel?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  sku: Scalars['String']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type: ServiceItemType;
  unitCost?: Scalars['Float']['input'];
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
  unitRetailPrice?: Scalars['Float']['input'];
  upc?: InputMaybe<Scalars['String']['input']>;
  vendorSku?: InputMaybe<Scalars['String']['input']>;
  vendor_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateServiceProvider = {
  __typename?: 'CreateServiceProvider';
  accessLinkToken: Scalars['String']['output'];
  accessToken: Scalars['String']['output'];
  account: ServiceProviderAccount;
  linkToken: Scalars['String']['output'];
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

/** Expected input for sign-up of a service provider account from website */
export type CreateServiceProviderInput = {
  address1: Scalars['String']['input'];
  address2?: InputMaybe<Scalars['String']['input']>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** Optional language preference for the service provider owner. Defaults to English. */
  locale?: InputMaybe<Locale>;
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  planCode?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  /** Use drop down list of states. Send 2 character data, display full text. Ex: Send 'AL', display 'Alabama' https://www.drupal.org/node/332575 */
  state: Scalars['String']['input'];
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone: Scalars['String']['input'];
  website?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CreateServiceProviderResponse = CreateServiceProvider | Error;

/** Expected input to create a taxRate. */
export type CreateTaxRateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  rate: Scalars['Int']['input'];
};

/** Expected input to create a timesheetEntry. */
export type CreateTimesheetEntryInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
  startTime: Scalars['Date']['input'];
  timesheet_id?: InputMaybe<Scalars['ID']['input']>;
  type: TimesheetEntryType;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Expected input to create a timesheet. */
export type CreateTimesheetInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employee_id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<TimesheetStatus>;
  timesheetDate?: InputMaybe<Scalars['Date']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  weekEndDate?: InputMaybe<Scalars['String']['input']>;
  weekStartDate?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUpdateAppointment = {
  __typename?: 'CreateUpdateAppointment';
  appointment: Appointment;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreateUpdateAppointmentResponse = CreateUpdateAppointment | Error;

export type CreateUpdateChecklist = {
  __typename?: 'CreateUpdateChecklist';
  checklist: Checklist;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreateUpdateChecklistEntry = {
  __typename?: 'CreateUpdateChecklistEntry';
  checklistEntry: ChecklistEntry;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreateUpdateChecklistEntryResponse = CreateUpdateChecklistEntry | Error;

export type CreateUpdateChecklistResponse = CreateUpdateChecklist | Error;

export type CreateUpdateCrew = {
  __typename?: 'CreateUpdateCrew';
  crew: Crew;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreateUpdateCrewResponse = CreateUpdateCrew | Error;

export type CreateUpdateEstimate = {
  __typename?: 'CreateUpdateEstimate';
  estimate: Estimate;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreateUpdateEstimateResponse = CreateUpdateEstimate | Error;

export type CreateUpdateFeedbackEntry = {
  __typename?: 'CreateUpdateFeedbackEntry';
  feedbackEntry: FeedbackEntry;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreateUpdateFeedbackEntryResponse = CreateUpdateFeedbackEntry | Error;

export type CreateUpdateGroup = {
  __typename?: 'CreateUpdateGroup';
  group: Group;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreateUpdateGroupResponse = CreateUpdateGroup | Error;

export type CreateUpdateInvoice = {
  __typename?: 'CreateUpdateInvoice';
  invoice: Invoice;
  message: Scalars['String']['output'];
};

export type CreateUpdateInvoiceResponse = CreateUpdateInvoice | Error;

export type CreateUpdateJob = {
  __typename?: 'CreateUpdateJob';
  job: Job;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreateUpdateJobResponse = CreateUpdateJob | Error;

export type CreateUpdateManufacturer = {
  __typename?: 'CreateUpdateManufacturer';
  manufacturer: Manufacturer;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type CreateUpdateManufacturerResponse = CreateUpdateManufacturer | Error;

export type CreateUpdateMessage = {
  __typename?: 'CreateUpdateMessage';
  message: Scalars['String']['output'];
  messageData: Message;
  version: Scalars['String']['output'];
};

export type CreateUpdateMessageResponse = CreateUpdateMessage | Error;

export type CreateUpdateNote = {
  __typename?: 'CreateUpdateNote';
  message: Scalars['String']['output'];
  note: Note;
  version: Scalars['String']['output'];
};

export type CreateUpdateNoteResponse = CreateUpdateNote | Error;

export type CreateUpdatePayment = {
  __typename?: 'CreateUpdatePayment';
  message: Scalars['String']['output'];
  payment: Payment;
};

export type CreateUpdatePaymentResponse = CreateUpdatePayment | Error;

export type CreateUpdateProperty = {
  __typename?: 'CreateUpdateProperty';
  message: Scalars['String']['output'];
  property: Property;
  version: Scalars['String']['output'];
};

export type CreateUpdatePropertyResponse = CreateUpdateProperty | Error;

export type CreateUpdateServiceItem = {
  __typename?: 'CreateUpdateServiceItem';
  message: Scalars['String']['output'];
  serviceItem: ServiceItem;
  version: Scalars['String']['output'];
};

export type CreateUpdateServiceItemResponse = CreateUpdateServiceItem | Error;

export type CreateUpdateTaxRate = {
  __typename?: 'CreateUpdateTaxRate';
  message: Scalars['String']['output'];
  taxRate: TaxRate;
  version: Scalars['String']['output'];
};

export type CreateUpdateTaxRateResponse = CreateUpdateTaxRate | Error;

export type CreateUpdateTimesheet = {
  __typename?: 'CreateUpdateTimesheet';
  message: Scalars['String']['output'];
  timesheet: Timesheet;
  version: Scalars['String']['output'];
};

export type CreateUpdateTimesheetEntry = {
  __typename?: 'CreateUpdateTimesheetEntry';
  message: Scalars['String']['output'];
  timesheetEntry: TimesheetEntry;
  version: Scalars['String']['output'];
};

export type CreateUpdateTimesheetEntryResponse = CreateUpdateTimesheetEntry | Error;

export type CreateUpdateTimesheetResponse = CreateUpdateTimesheet | Error;

export type CreateUpdateUser = {
  __typename?: 'CreateUpdateUser';
  message: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

export type CreateUpdateUserResponse = CreateUpdateUser | Error;

export type CreateUpdateVendor = {
  __typename?: 'CreateUpdateVendor';
  message: Scalars['String']['output'];
  vendor: Vendor;
  version: Scalars['String']['output'];
};

export type CreateUpdateVendorResponse = CreateUpdateVendor | Error;

/** Expected input to create a service provider user from service provider admin */
export type CreateUserInput = {
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  locale?: InputMaybe<Locale>;
  password: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  role: Role;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone: Scalars['String']['input'];
};

export type CreateVendorInput = {
  /** Account ID for admin users (optional, ignored for regular users) */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactBusinessPhone?: InputMaybe<Scalars['String']['input']>;
  contactCellPhone?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPosition?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type Crew = Timestamps & {
  __typename?: 'Crew';
  account_id: Scalars['ID']['output'];
  availability: Availability;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** If isScheduleConflict is true, the list of jobs that are in conflict. */
  isInUse: Scalars['Boolean']['output'];
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates that the current crew schedule contains at least one conflict */
  isScheduleConflict: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Indicates that the crew is assigned to an estimate, job, or other entity and cannot be deleted */
  scheduleConflictList?: Maybe<Array<Maybe<ScheduleConflictJob>>>;
  /** IANA timezone identifier for the crew (e.g., America/Los_Angeles, America/New_York) */
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  users: Array<CrewUser>;
};

export type CrewList = {
  __typename?: 'CrewList';
  id?: Maybe<Scalars['ID']['output']>;
  isCrewLead?: Maybe<Scalars['Boolean']['output']>;
};

/** Crew metrics */
export type CrewMetrics = {
  __typename?: 'CrewMetrics';
  /** Average crew size */
  averageSize: Scalars['Float']['output'];
  /** Total count of crews */
  count: Scalars['Int']['output'];
  /** Number of crews in use */
  inUseCount: Scalars['Int']['output'];
  /** Number of crews not in use */
  notInUseCount: Scalars['Int']['output'];
  /** Status breakdown */
  statusBreakdown: Array<StatusCount>;
};

export type CrewUnavailableDates = {
  __typename?: 'CrewUnavailableDates';
  /** Unavailable dates for crew + SP account + each specific client */
  clientUnavailableDates: Array<Maybe<ClientUnavailableDates>>;
  crew_id: Scalars['ID']['output'];
  /** Unavailable dates for crew + SP account (without any clients) */
  unavailableDates: Array<Maybe<DateRange>>;
};

export type CrewUser = IUser &
  Timestamps & {
    __typename?: 'CrewUser';
    account_id: Scalars['ID']['output'];
    /** URL to user avatar */
    avatarUrl?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['Date']['output'];
    crews?: Maybe<Array<Maybe<CrewList>>>;
    /** Current GPS latitude for ETA calculations */
    currentLatitude?: Maybe<Scalars['Float']['output']>;
    /** Current GPS longitude for ETA calculations */
    currentLongitude?: Maybe<Scalars['Float']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    email: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    /** Indicates if the user is the crew lead */
    isCrewLead: Scalars['Boolean']['output'];
    /** Check if user is disabled */
    isDisabled: Scalars['Boolean']['output'];
    /** Check if email is confirmed */
    isEmailConfirmed: Scalars['Boolean']['output'];
    /** Check if user is in use within a crew or other entity and cannot be deleted. */
    isInUse: Scalars['Boolean']['output'];
    /** Indicates if all required onboarding steps are completed */
    isOnboardingComplete: Scalars['Boolean']['output'];
    /** Indicates if the record was created via Quick Add */
    isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates whether the user consented to receive SMS notifications */
    isSMSConsent?: Maybe<Scalars['Boolean']['output']>;
    /** Onboarding related fields */
    isWelcomeScreenClosed: Scalars['Boolean']['output'];
    /** Timestamp of last location update */
    lastLocationUpdate?: Maybe<Scalars['Date']['output']>;
    lastName: Scalars['String']['output'];
    lastOnboardingInteraction?: Maybe<Scalars['Date']['output']>;
    locale?: Maybe<Locale>;
    /** Indicates if the mobile tour onboarding has been completed */
    onboardingMobileTourComplete: Scalars['Boolean']['output'];
    onboardingSteps: Array<OnboardingStep>;
    onboardingWizardState: OnboardingWizardState;
    /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
    phone: Scalars['String']['output'];
    /** Per-tour Quick Tour outcomes used to suppress repeat auto-starts */
    quickTours: Array<QuickTourState>;
    /** Disable automatic Quick Tour starts for this user */
    quickToursDisabled: Scalars['Boolean']['output'];
    role: Role;
    /** User settings and preferences */
    settings?: Maybe<UserSettings>;
    timeZone: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['Date']['output']>;
    /** Verified WhatsApp number linked from the DHS app (E.164 format) */
    whatsappNumber?: Maybe<Scalars['String']['output']>;
  };

/** Expected input of a crew user */
export type CrewUserInput = {
  id: Scalars['ID']['input'];
  isCrewLead?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Parameters to filter crewUser status report data */
export type CrewUserStatusReportFilter = {
  /** End date for timesheet entries */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by user roles */
  roles?: InputMaybe<Array<Role>>;
  /** Start date for timesheet entries */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by job statuses */
  statuses?: InputMaybe<Array<JobStatus>>;
  /** Filter by user IDs */
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Represents a crewUser's job performance metrics for a specific time period. */
export type CrewUserStatusReportItem = {
  __typename?: 'CrewUserStatusReportItem';
  /** Job counts broken down by status. */
  jobStatusCounts: Array<JobStatusCount>;
  /** Total number of jobs assigned to this crew member. */
  totalJobs: Scalars['Int']['output'];
  /** Full User object for this crew member. */
  user: User;
  /** Full name of the crewUser. */
  userFullName: Scalars['String']['output'];
  /** Unique identifier for the crewUser. */
  user_id: Scalars['ID']['output'];
};

/** Filter for crew working hours report */
export type CrewUserWorkingHoursFilter = {
  /** Filter by specific crew IDs */
  crew_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date for the reporting period */
  endDate: Scalars['Date']['input'];
  /** Filter by one or more job statuses */
  jobStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Start date for the reporting period */
  startDate: Scalars['Date']['input'];
  /** Filter by specific user IDs */
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Working hours data for a crew user */
export type CrewUserWorkingHoursReportItem = {
  __typename?: 'CrewUserWorkingHoursReportItem';
  /** Available hours based on crew schedule */
  availableHours: Scalars['Float']['output'];
  /** Downtime hours (available - working) */
  downTime: Scalars['Float']['output'];
  /** Breakdown of job-related hours */
  jobHours: JobHours;
  /** User object with basic information */
  user: User;
  /** User's full name */
  userFullName: Scalars['String']['output'];
  /** User ID */
  user_id: Scalars['ID']['output'];
  /** Utilization percentage */
  utilizationPercentage: Scalars['Float']['output'];
};

/** ENUM for sortBy field */
export enum CrewsSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
}

export type CustomDateRange = {
  __typename?: 'CustomDateRange';
  endDate?: Maybe<Scalars['Date']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type CustomDateRangeInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type CustomFeeConfiguration = {
  __typename?: 'CustomFeeConfiguration';
  baseFeeFixed?: Maybe<Scalars['Float']['output']>;
  baseFeePercentage?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomFeeConfigurationInput = {
  baseFeeFixed?: InputMaybe<Scalars['Float']['input']>;
  baseFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerComplaintsReportItem = {
  __typename?: 'CustomerComplaintsReportItem';
  crewLeadId: Scalars['ID']['output'];
  crewLeadName: Scalars['String']['output'];
  feedbackEntries: Array<FeedbackEntry>;
  totalComplaints: Scalars['Int']['output'];
  totalFeedbackEntries: Scalars['Int']['output'];
};

/** Represents a summary of customer satisfaction metrics for a crew lead, including feedback statistics and ratings. */
export type CustomerSatisfactionReportItem = {
  __typename?: 'CustomerSatisfactionReportItem';
  /** Average rating from all feedback entries for this crew lead. */
  averageRating: Scalars['Float']['output'];
  /** Unique identifier for the crew lead. */
  crewLeadId: Scalars['ID']['output'];
  /** Full name of the crew lead. */
  crewLeadName: Scalars['String']['output'];
  /** List of feedback entries associated with this crew lead. */
  feedbackEntries: Array<FeedbackEntry>;
  /** Highest rating received in feedback entries for this crew lead. */
  highestRating?: Maybe<Scalars['Int']['output']>;
  /** Lowest rating received in feedback entries for this crew lead. */
  lowestRating?: Maybe<Scalars['Int']['output']>;
  /** Calculated satisfaction score for this crew lead, based on feedback ratings. */
  satisfactionScore: Scalars['Float']['output'];
  /** Total number of feedback entries received for this crew lead. */
  totalFeedbackEntries: Scalars['Int']['output'];
};

export enum DashboardInboxFilter {
  All = 'ALL',
  UniqueClient = 'UNIQUE_CLIENT',
}

export type DashboardSettings = {
  __typename?: 'DashboardSettings';
  dashboardInboxFilter?: Maybe<DashboardInboxFilter>;
  dashboardMaxListLength?: Maybe<Scalars['Int']['output']>;
  dashboardSchedulerView?: Maybe<SchedulerViewSettings>;
  dashboardShowOnlyNew?: Maybe<Scalars['Boolean']['output']>;
  showClock?: Maybe<Scalars['Boolean']['output']>;
  showDate?: Maybe<Scalars['Boolean']['output']>;
  showSeconds?: Maybe<Scalars['Boolean']['output']>;
  showTimer?: Maybe<Scalars['Boolean']['output']>;
  timeFormat?: Maybe<Scalars['String']['output']>;
  upcomingJobsWindow?: Maybe<Scalars['Int']['output']>;
};

export type DashboardSettingsInput = {
  dashboardInboxFilter?: InputMaybe<DashboardInboxFilter>;
  dashboardMaxListLength?: InputMaybe<Scalars['Int']['input']>;
  dashboardSchedulerView?: InputMaybe<SchedulerViewSettingsInput>;
  dashboardShowOnlyNew?: InputMaybe<Scalars['Boolean']['input']>;
  showClock?: InputMaybe<Scalars['Boolean']['input']>;
  showDate?: InputMaybe<Scalars['Boolean']['input']>;
  showSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  showTimer?: InputMaybe<Scalars['Boolean']['input']>;
  timeFormat?: InputMaybe<Scalars['String']['input']>;
  upcomingJobsWindow?: InputMaybe<Scalars['Int']['input']>;
};

export type DashboardSnapshotUpdated = {
  __typename?: 'DashboardSnapshotUpdated';
  accountId: Scalars['ID']['output'];
  changedAt: Scalars['Date']['output'];
  generatedAt: Scalars['Date']['output'];
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  sourceEntityType?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type DashboardSnapshotUpdatedResponse = DashboardSnapshotUpdated | Error;

/** One weekly bucket of dashboard KPI values for sparkline trend charts. */
export type DashboardTrendPoint = {
  __typename?: 'DashboardTrendPoint';
  /** Invoices with an outstanding balance that were active this week. */
  pendingInvoices: Scalars['Int']['output'];
  /** ISO week start date (YYYY-MM-DD Monday). */
  period: Scalars['String']['output'];
  /** Net payments received minus service-item costs during this week (cents). */
  realProfit: Scalars['Float']['output'];
  /** Jobs created during this week. */
  totalJobs: Scalars['Int']['output'];
  /** Potential revenue minus costs for jobs created this week (cents). */
  totalPotentialProfit: Scalars['Float']['output'];
};

/** Date range.  `start` and `end` fields are inclusive and use ISO 8601 date format.  Ex: 2020-01-01.  2020-12-31. If `annual` is true, this range recurs every year. */
export type DateRange = {
  __typename?: 'DateRange';
  annual?: Maybe<Scalars['Boolean']['output']>;
  endDate: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
};

/** Date range.  `start` and `end` fields are inclusive and use ISO 8601 date format.  Ex: 2020-01-01.  2020-12-31. If `annual` is true, this range recurs every year. */
export type DateRangeInput = {
  annual?: InputMaybe<Scalars['Boolean']['input']>;
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

/** Time slot for day and time.  `day` field is 0-indexed, where 0 is Sunday and 6 is Saturday.  `start` and `end` fields use HHMM time format. Ex: 0900, 1300.  */
export type DayTime = {
  __typename?: 'DayTime';
  day: Scalars['Int']['output'];
  endTime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

/** Time slot for day and time.  `day` field is 0-indexed, where 0 is Sunday and 6 is Saturday.  `start` and `end` fields use HHMM time format. Ex: 0900, 1300.  */
export type DayTimeInput = {
  day: Scalars['Int']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type DeleteAccountSampleData = {
  __typename?: 'DeleteAccountSampleData';
  message: Scalars['String']['output'];
  sampleDataDeletionJobId: Scalars['ID']['output'];
};

export type DeleteAccountSampleDataResponse = DeleteAccountSampleData | Error;

export type DeleteAdminUser = {
  __typename?: 'DeleteAdminUser';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteAdminUserResponse = DeleteAdminUser | Error;

export type DeleteAllAccountData = {
  __typename?: 'DeleteAllAccountData';
  deletionSummary: AccountDataDeletionSummary;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Input for force deleting all account data - DANGEROUS OPERATION */
export type DeleteAllAccountDataInput = {
  /** Optional account ID for admin users to delete other accounts */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Required confirmation text to prevent accidental deletion */
  confirmationText: Scalars['String']['input'];
};

export type DeleteAllAccountDataResponse = DeleteAllAccountData | Error;

export type DeleteAppointment = {
  __typename?: 'DeleteAppointment';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteAppointmentResponse = DeleteAppointment | Error;

export type DeleteAttachment = {
  __typename?: 'DeleteAttachment';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteAttachmentResponse = DeleteAttachment | Error;

export type DeleteChecklist = {
  __typename?: 'DeleteChecklist';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteChecklistEntriesInput = {
  id: Scalars['ID']['input'];
};

export type DeleteChecklistEntry = {
  __typename?: 'DeleteChecklistEntry';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteChecklistEntryResponse = DeleteChecklistEntry | Error;

export type DeleteChecklistResponse = DeleteChecklist | Error;

export type DeleteClientAccount = {
  __typename?: 'DeleteClientAccount';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteClientAccountResponse = DeleteClientAccount | Error;

export type DeleteCrew = {
  __typename?: 'DeleteCrew';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteCrewResponse = DeleteCrew | Error;

export type DeleteEstimate = {
  __typename?: 'DeleteEstimate';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteEstimateResponse = DeleteEstimate | Error;

export type DeleteFeedbackEntry = {
  __typename?: 'DeleteFeedbackEntry';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteFeedbackEntryResponse = DeleteFeedbackEntry | Error;

export type DeleteGroup = {
  __typename?: 'DeleteGroup';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteGroupResponse = DeleteGroup | Error;

/** Response for deleting an IVR voicemail */
export type DeleteIVRVoicemail = {
  __typename?: 'DeleteIVRVoicemail';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteIVRVoicemailInput = {
  id: Scalars['ID']['input'];
};

export type DeleteIVRVoicemailResponse = DeleteIVRVoicemail | Error;

export type DeleteInvoice = {
  __typename?: 'DeleteInvoice';
  message: Scalars['String']['output'];
};

export type DeleteInvoiceResponse = DeleteInvoice | Error;

export type DeleteJob = {
  __typename?: 'DeleteJob';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteJobResponse = DeleteJob | Error;

export type DeleteManufacturer = {
  __typename?: 'DeleteManufacturer';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteManufacturerResponse = DeleteManufacturer | Error;

export type DeleteMessage = {
  __typename?: 'DeleteMessage';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteMessageResponse = DeleteMessage | Error;

export type DeleteNote = {
  __typename?: 'DeleteNote';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteNoteResponse = DeleteNote | Error;

export type DeleteNotification = {
  __typename?: 'DeleteNotification';
  deletedId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteNotificationInput = {
  /** Notification ID to delete */
  notificationId: Scalars['ID']['input'];
};

export type DeleteNotificationResponse = DeleteNotification | Error;

export type DeletePayment = {
  __typename?: 'DeletePayment';
  message: Scalars['String']['output'];
};

export type DeletePaymentResponse = DeletePayment | Error;

export type DeleteProperty = {
  __typename?: 'DeleteProperty';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeletePropertyResponse = DeleteProperty | Error;

export type DeleteServiceItem = {
  __typename?: 'DeleteServiceItem';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteServiceItemResponse = DeleteServiceItem | Error;

export type DeleteServiceProviderAccount = {
  __typename?: 'DeleteServiceProviderAccount';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteServiceProviderAccountResponse = DeleteServiceProviderAccount | Error;

export type DeleteTaxRate = {
  __typename?: 'DeleteTaxRate';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteTaxRateResponse = DeleteTaxRate | Error;

export type DeleteTaxRatesByDate = {
  __typename?: 'DeleteTaxRatesByDate';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteTimesheet = {
  __typename?: 'DeleteTimesheet';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteTimesheetEntriesByDate = {
  __typename?: 'DeleteTimesheetEntriesByDate';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteTimesheetEntriesByDateInput = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['Date']['input'];
  job_id?: InputMaybe<Scalars['ID']['input']>;
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DeleteTimesheetEntriesByDateResponse = DeleteTimesheetEntriesByDate | Error;

export type DeleteTimesheetEntry = {
  __typename?: 'DeleteTimesheetEntry';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteTimesheetEntryResponse = DeleteTimesheetEntry | Error;

export type DeleteTimesheetResponse = DeleteTimesheet | Error;

export type DeleteVendor = {
  __typename?: 'DeleteVendor';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DeleteVendorResponse = DeleteVendor | Error;

export type DeliveryAttempt = {
  __typename?: 'DeliveryAttempt';
  /** When delivery was attempted */
  attemptedAt: Scalars['Date']['output'];
  /** Delivery channel used */
  channel: NotificationChannel;
  /** Error message (deprecated, use errorMessage) */
  error?: Maybe<Scalars['String']['output']>;
  /** Error message if failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Provider used */
  provider?: Maybe<Scalars['String']['output']>;
  /** Provider response (deprecated, use responseCode) */
  response?: Maybe<Scalars['JSON']['output']>;
  /** Provider response code */
  responseCode?: Maybe<Scalars['String']['output']>;
  /** Delivery status (deprecated, use success) */
  status: Scalars['String']['output'];
  /** Whether delivery was successful */
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type Destination = {
  __typename?: 'Destination';
  address: Scalars['String']['output'];
  coordinates?: Maybe<GeoLatLng>;
};

/** Device information for push notifications */
export type Device = {
  __typename?: 'Device';
  appVersion?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  deviceModel?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  fcmToken: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invalidatedAt?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastUsed?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  osVersion?: Maybe<Scalars['String']['output']>;
  platform: DevicePlatform;
  registeredAt: Scalars['String']['output'];
  status: DeviceTokenStatus;
  timezone?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

/** Filter for querying FCM devices */
export type DeviceFilter = {
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<DevicePlatform>;
  status?: InputMaybe<DeviceTokenStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Platform types for device tokens */
export enum DevicePlatform {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB',
}

/** Device removal response */
export type DeviceRemoval = {
  __typename?: 'DeviceRemoval';
  message: Scalars['String']['output'];
  removedDeviceId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Successful device retrieval */
export type DeviceResult = {
  __typename?: 'DeviceResult';
  device: Device;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Device status information */
export type DeviceStatus = {
  __typename?: 'DeviceStatus';
  deviceId: Scalars['String']['output'];
  fcmTokenValid: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  lastUsed?: Maybe<Scalars['String']['output']>;
  lastValidated?: Maybe<Scalars['String']['output']>;
  status: DeviceTokenStatus;
};

/** Device status information result */
export type DeviceStatusResult = {
  __typename?: 'DeviceStatusResult';
  deviceStatus: DeviceStatus;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Status of a device token */
export enum DeviceTokenStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invalid = 'INVALID',
}

/** Device token validation result */
export type DeviceTokenValidationResult = {
  __typename?: 'DeviceTokenValidationResult';
  deviceId: Scalars['String']['output'];
  isValid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Device update response */
export type DeviceUpdate = {
  __typename?: 'DeviceUpdate';
  device: Device;
  message: Scalars['String']['output'];
};

export type DisconnectQuickBooks = {
  __typename?: 'DisconnectQuickBooks';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DisconnectQuickBooksResponse = DisconnectQuickBooks | Error;

export type Distance = {
  __typename?: 'Distance';
  text: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type DoNotDisturb = {
  __typename?: 'DoNotDisturb';
  /** Whether do not disturb is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Do not disturb until this time (null means indefinite) */
  until?: Maybe<Scalars['Date']['output']>;
};

export type DoNotDisturbInput = {
  /** Whether do not disturb is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Do not disturb until this time */
  until?: InputMaybe<Scalars['Date']['input']>;
};

export enum DueDateTerms {
  /** Custom due date set manually by service provider */
  DueCustom = 'DUE_CUSTOM',
  /** Payment is due within 15 days of invoice date */
  DueNet_15 = 'DUE_NET_15',
  /** Payment is due within 30 days of invoice date */
  DueNet_30 = 'DUE_NET_30',
  /** Payment is due within 45 days of invoice date */
  DueNet_45 = 'DUE_NET_45',
  /** Payment is due immediately upon receipt of invoice */
  DueOnReceipt = 'DUE_ON_RECEIPT',
}

export type DuplicateChecklist = {
  __typename?: 'DuplicateChecklist';
  checklist: Checklist;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type DuplicateChecklistInput = {
  id: Scalars['ID']['input'];
};

export type DuplicateChecklistResponse = DuplicateChecklist | Error;

/** Expected input to duplicate a job with optional custom dates */
export type DuplicateJobInput = {
  id: Scalars['ID']['input'];
  scheduledStartDatetime?: InputMaybe<Scalars['Date']['input']>;
  scheduledStopDatetime?: InputMaybe<Scalars['Date']['input']>;
};

export type Duration = {
  __typename?: 'Duration';
  text: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type Email = {
  email: Scalars['String']['input'];
};

export type EndImpersonation = {
  __typename?: 'EndImpersonation';
  accessToken: Scalars['String']['output'];
  adminUser: AdminUser;
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type EndImpersonationResponse = EndImpersonation | Error;

export type EnrollBetaLifecycleInput = {
  accountId: Scalars['ID']['input'];
  agreementSignedAt: Scalars['Date']['input'];
  configuration: BetaLifecycleConfigurationInput;
  conversionDate: Scalars['Date']['input'];
  launchDate: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
};

/** All entity data for the account */
export type EntitiesData = {
  __typename?: 'EntitiesData';
  /** List of attachments */
  attachments: Array<Attachment>;
  /** List of checklist entries */
  checklistEntries: Array<ChecklistEntry>;
  /** List of checklists */
  checklists: Array<Checklist>;
  /** List of crews */
  crews: Array<Crew>;
  /** List of estimates */
  estimates: Array<Estimate>;
  /** List of feedback entries */
  feedbackEntries: Array<FeedbackEntry>;
  /** List of groups */
  groups: Array<Group>;
  /** List of invoices */
  invoices: Array<Invoice>;
  /** List of jobs */
  jobs: Array<Job>;
  /** List of manufacturers */
  manufacturers: Array<Manufacturer>;
  /** List of notes */
  notes: Array<Note>;
  /** List of payments */
  payments: Array<Payment>;
  /** List of properties */
  properties: Array<Property>;
  /** List of service items */
  serviceItems: Array<ServiceItem>;
  /** List of timesheet entries */
  timesheetEntries: Array<TimesheetEntry>;
  /** List of timesheets */
  timesheets: Array<Timesheet>;
  /** List of users */
  users: Array<User>;
  /** List of vendors */
  vendors: Array<Vendor>;
};

export type Error = {
  __typename?: 'Error';
  details?: Maybe<Scalars['JSON']['output']>;
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Estimate = Timestamps & {
  __typename?: 'Estimate';
  account_id: Scalars['ID']['output'];
  alternateBillingInfo?: Maybe<BillingInfo>;
  appointment_id?: Maybe<Scalars['ID']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  billToClient?: Maybe<ClientAccount>;
  chat?: Maybe<Chat>;
  chat_id?: Maybe<Scalars['ID']['output']>;
  checklist_id?: Maybe<Scalars['ID']['output']>;
  client?: Maybe<ClientAccount>;
  clientApprovedSignatureImageBase64?: Maybe<Scalars['String']['output']>;
  clientApprovedSignatureImageUrl?: Maybe<Scalars['String']['output']>;
  clientApprovedSignatureTimestamp?: Maybe<Scalars['Date']['output']>;
  client_account_id?: Maybe<Scalars['ID']['output']>;
  commentToClient?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  crew?: Maybe<Crew>;
  crew_id?: Maybe<Scalars['ID']['output']>;
  depositRequired?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  /** Whether this instance has an availability conflict */
  hasAvailabilityConflict?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this estimate is a recurring template that generates instances */
  isRecurringTemplate?: Maybe<Scalars['Boolean']['output']>;
  isViewedByClient?: Maybe<Scalars['Boolean']['output']>;
  isViewedByClientTimestamp?: Maybe<Scalars['Date']['output']>;
  job_id?: Maybe<Scalars['ID']['output']>;
  messages?: Maybe<Array<Message>>;
  /** Whether this instance has been modified from its template */
  modifiedFromTemplate?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Array<Note>>;
  /** The original date/time calculated by the RRULE before any modifications */
  originalScheduledDate?: Maybe<Scalars['Date']['output']>;
  /** Reference to parent template estimate if this is a recurring instance */
  parent_estimate_id?: Maybe<Scalars['ID']['output']>;
  property?: Maybe<Property>;
  property_id?: Maybe<Scalars['ID']['output']>;
  recurringSchedule: RecurringSchedule;
  /** RFC 5545 RRULE string defining the recurrence pattern */
  rruleString?: Maybe<Scalars['String']['output']>;
  /** Optional end date for the recurring series */
  seriesEndDate?: Maybe<Scalars['Date']['output']>;
  serviceItems?: Maybe<Array<EstimateServiceItem>>;
  serviceProvider?: Maybe<ServiceProviderPublicProfile>;
  /** Whether to skip estimates on account holidays */
  skipAccountHolidays?: Maybe<Scalars['Boolean']['output']>;
  status: EstimateStatus;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  taxRate?: Maybe<Scalars['Int']['output']>;
  taxRateName?: Maybe<Scalars['String']['output']>;
  taxableTotal?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  validUntil?: Maybe<Scalars['Date']['output']>;
};

/** Estimate metrics with financial data */
export type EstimateMetrics = {
  __typename?: 'EstimateMetrics';
  /** Average estimate value */
  averageValue?: Maybe<Scalars['Float']['output']>;
  /** Total count of estimates */
  count: Scalars['Int']['output'];
  /** Number of estimates with service items */
  estimatesWithServiceItems?: Maybe<Scalars['Int']['output']>;
  /** Status breakdown */
  statusBreakdown: Array<StatusCount>;
  /** Total value of all estimates */
  totalValue?: Maybe<Scalars['Float']['output']>;
};

export type EstimateServiceItem = IServiceItem &
  Timestamps & {
    __typename?: 'EstimateServiceItem';
    account_id: Scalars['ID']['output'];
    adt?: Maybe<Scalars['String']['output']>;
    attachments?: Maybe<Array<Attachment>>;
    availableQty: Scalars['Int']['output'];
    checklist_id?: Maybe<Scalars['ID']['output']>;
    color?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['Date']['output'];
    description?: Maybe<Scalars['String']['output']>;
    estimateDescription?: Maybe<Scalars['String']['output']>;
    estimateName?: Maybe<Scalars['String']['output']>;
    estimateUnitRetailPrice?: Maybe<Scalars['Int']['output']>;
    groups?: Maybe<Array<GroupMinimum>>;
    id: Scalars['ID']['output'];
    isArchived: Scalars['Boolean']['output'];
    isInUse: Scalars['Boolean']['output'];
    isInventoryDisabled: Scalars['Boolean']['output'];
    /** Indicates if the record was created via Quick Add */
    isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
    isShowNewService: Scalars['Boolean']['output'];
    isShowOnlineBooking: Scalars['Boolean']['output'];
    isTaxable: Scalars['Boolean']['output'];
    location?: Maybe<Scalars['String']['output']>;
    manufacturer?: Maybe<Manufacturer>;
    manufacturerModelNumber?: Maybe<Scalars['String']['output']>;
    manufacturer_id?: Maybe<Scalars['ID']['output']>;
    name: Scalars['String']['output'];
    order?: Maybe<Scalars['Int']['output']>;
    /** URL of the service item image. */
    photoUrl?: Maybe<Scalars['String']['output']>;
    quantityLaborHours?: Maybe<Scalars['Int']['output']>;
    quantityLaborMinutes?: Maybe<Scalars['Int']['output']>;
    quantityMaterial?: Maybe<Scalars['Int']['output']>;
    quantityOnHand: Scalars['Int']['output'];
    reorderLevel: Scalars['Int']['output'];
    reservedInEstimates: Scalars['Int']['output'];
    reservedInJobs: Scalars['Int']['output'];
    service_item_id: Scalars['ID']['output'];
    size?: Maybe<Scalars['String']['output']>;
    sku: Scalars['String']['output'];
    tags?: Maybe<Array<Scalars['String']['output']>>;
    type: ServiceItemType;
    unitCost: Scalars['Float']['output'];
    unitOfMeasure?: Maybe<UnitOfMeasure>;
    unitRetailPrice: Scalars['Float']['output'];
    upc?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['Date']['output']>;
    vendor?: Maybe<Vendor>;
    vendorSku?: Maybe<Scalars['String']['output']>;
    vendor_id?: Maybe<Scalars['ID']['output']>;
  };

/** Expected input for an estimate line item. */
export type EstimateServiceItemInput = {
  estimateDescription?: InputMaybe<Scalars['String']['input']>;
  estimateName?: InputMaybe<Scalars['String']['input']>;
  estimateUnitRetailPrice?: InputMaybe<Scalars['Int']['input']>;
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  quantityLaborHours?: InputMaybe<Scalars['Int']['input']>;
  quantityLaborMinutes?: InputMaybe<Scalars['Int']['input']>;
  quantityMaterial?: InputMaybe<Scalars['Int']['input']>;
  service_item_id: Scalars['ID']['input'];
};

/** Options to set an estimate status */
export enum EstimateStatus {
  /** Client has approved the estimate and work can proceed */
  Approved = 'APPROVED',
  /** Client has requested changes to the estimate */
  ChangesRequested = 'CHANGES_REQUESTED',
  /** Initial state - estimate is being created and can be modified */
  Draft = 'DRAFT',
  /** The estimate validity period has elapsed */
  Expired = 'EXPIRED',
  /** Estimate is complete and ready for client review */
  ReadyForReview = 'READY_FOR_REVIEW',
  /** Client has rejected the estimate */
  Rejected = 'REJECTED',
}

export enum EstimatesSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Status = 'STATUS',
  TotalAmount = 'TOTAL_AMOUNT',
  UpdatedAt = 'UPDATED_AT',
  ValidUntil = 'VALID_UNTIL',
}

export type ExchangeAccessLinkToken = {
  __typename?: 'ExchangeAccessLinkToken';
  accessToken: Scalars['String']['output'];
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user?: Maybe<User>;
  version: Scalars['String']['output'];
};

export type ExchangeAccessLinkTokenResponse = Error | ExchangeAccessLinkToken;

export type ExchangeClientUpdateToken = {
  __typename?: 'ExchangeClientUpdateToken';
  accessToken: Scalars['String']['output'];
  account: ClientAccount;
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

export type ExchangeClientUpdateTokenResponse = Error | ExchangeClientUpdateToken;

export type ExchangeLinkToken = {
  __typename?: 'ExchangeLinkToken';
  accessToken: Scalars['String']['output'];
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

export type ExchangeLinkTokenResponse = Error | ExchangeLinkToken;

export type ExchangeMagicLinkToken = {
  __typename?: 'ExchangeMagicLinkToken';
  accessToken: Scalars['String']['output'];
  message: Scalars['String']['output'];
  redirectPath: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ExchangeMagicLinkTokenResponse = Error | ExchangeMagicLinkToken;

/** Read-only projection of an existing client returned when an SP tries to add a client whose email/phone already belongs to another account. No billing info, no job history — just enough to recognise the person and decide whether to send a link-up invite. */
export type ExistingClientInfo = {
  __typename?: 'ExistingClientInfo';
  /** True when this client is already a confirmed (non-pending) linked client of the caller SP */
  alreadyLinkedToMe: Scalars['Boolean']['output'];
  /** True when the caller SP already has an outstanding pending invite on this client */
  alreadyPendingToMe: Scalars['Boolean']['output'];
  city?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Existing client account id */
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ExportClientsCSV = {
  __typename?: 'ExportClientsCSV';
  /** CSV content as string */
  csvContent: Scalars['String']['output'];
  message: Scalars['String']['output'];
  /** Number of clients exported */
  totalClients: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for exporting client accounts to CSV */
export type ExportClientsCSVInput = {
  /** Optional filter for which clients to export */
  filter?: InputMaybe<SearchAccountsFilter>;
};

export type ExportClientsCSVResponse = Error | ExportClientsCSV;

export type ExportServiceItemsCSV = {
  __typename?: 'ExportServiceItemsCSV';
  csvContent: Scalars['String']['output'];
  headers: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ExportServiceItemsCSVResponse = Error | ExportServiceItemsCSV;

export type FCMActiveDevicesResponse = ActiveDevicesResult | Error;

export type FCMDeviceConnection = Error | GetDevices;

export type FCMDeviceResponse = DeviceResult | Error;

export type FCMDeviceStatusResponse = DeviceStatusResult | Error;

export type FeeCalculation = {
  __typename?: 'FeeCalculation';
  baseAmount: Scalars['Int']['output'];
  feeFixed: Scalars['Int']['output'];
  feePercentage: Scalars['Float']['output'];
  netAmount: Scalars['Int']['output'];
  totalFee: Scalars['Int']['output'];
};

export type FeePreview = {
  __typename?: 'FeePreview';
  applicationFeeAmount: Scalars['Float']['output'];
  feePercentage: Scalars['Float']['output'];
  fixedFeeAmount: Scalars['Float']['output'];
  netAmount: Scalars['Float']['output'];
  paymentAmount: Scalars['Float']['output'];
};

export type FeeStatistics = {
  __typename?: 'FeeStatistics';
  averageFeePercentage: Scalars['Float']['output'];
  averageTransactionAmount: Scalars['Float']['output'];
  totalFees: Scalars['Float']['output'];
  totalPaymentAmount: Scalars['Float']['output'];
  transactionCount: Scalars['Int']['output'];
};

export type FeeValidation = {
  __typename?: 'FeeValidation';
  calculatedFee: Scalars['Float']['output'];
  difference: Scalars['Float']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  expectedFee: Scalars['Float']['output'];
  isValid: Scalars['Boolean']['output'];
};

export type FeedbackAttachment = {
  __typename?: 'FeedbackAttachment';
  filename: Scalars['String']['output'];
  mime_type: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export enum FeedbackEntriesSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type FeedbackEntry = Timestamps & {
  __typename?: 'FeedbackEntry';
  account_id: Scalars['ID']['output'];
  client_account_id?: Maybe<Scalars['ID']['output']>;
  complaintDescription?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  crew_id?: Maybe<Scalars['ID']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isComplaint: Scalars['Boolean']['output'];
  isDisabled: Scalars['Boolean']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  job_id?: Maybe<Scalars['ID']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  resolution_notes?: Maybe<Scalars['String']['output']>;
  reviewedByUserFullName?: Maybe<Scalars['String']['output']>;
  reviewed_at?: Maybe<Scalars['Date']['output']>;
  reviewed_by_user_id?: Maybe<Scalars['ID']['output']>;
  status: FeedbackEntryStatus;
  type: FeedbackEntryType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum FeedbackEntryStatus {
  /** Feedback has been archived */
  Archived = 'ARCHIVED',
  /** Feedback is pending review */
  Pending = 'PENDING',
  /** Feedback has been resolved */
  Resolved = 'RESOLVED',
  /** Feedback has been reviewed */
  Reviewed = 'REVIEWED',
}

export enum FeedbackEntryType {
  /** Feedback about a user */
  CrewFeedback = 'CREW_FEEDBACK',
  /** General feedback */
  GeneralFeedback = 'GENERAL_FEEDBACK',
  /** Feedback related to a specific job */
  JobFeedback = 'JOB_FEEDBACK',
  /** Feedback about the system */
  SystemFeedback = 'SYSTEM_FEEDBACK',
}

/** Feedback metrics */
export type FeedbackMetrics = {
  __typename?: 'FeedbackMetrics';
  /** Average rating */
  averageRating: Scalars['Float']['output'];
  /** Number of complaints */
  complaintCount: Scalars['Int']['output'];
  /** Total count of feedback entries */
  count: Scalars['Int']['output'];
  /** Number of rated entries */
  ratedEntriesCount: Scalars['Int']['output'];
  /** Rating breakdown */
  ratingBreakdown: Array<StatusCount>;
  /** Type breakdown */
  typeBreakdown: Array<StatusCount>;
};

/** Parameters to filter feedback report data */
export type FeedbackReportFilter = {
  /** Filter by crew lead user IDs */
  crew_lead_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date for feedback entries */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by isComplaint */
  isComplaint?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by job IDs */
  job_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by ratings */
  ratings?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter by reviewed by user IDs */
  reviewed_by_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date for feedback entries */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by feedback statuses */
  statuses?: InputMaybe<Array<FeedbackEntryStatus>>;
  /** Filter by feedback types */
  types?: InputMaybe<Array<FeedbackEntryType>>;
};

/** Financial aggregate data for entities with monetary values */
export type FinancialAggregate = {
  __typename?: 'FinancialAggregate';
  /** Average monetary value per entity */
  averageValue: Scalars['Float']['output'];
  /** Total count of entities */
  count: Scalars['Int']['output'];
  /** Maximum monetary value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum monetary value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Total monetary value across all entities */
  totalValue: Scalars['Float']['output'];
};

/** Result of findExistingClient; existingClient is null when no collision was found */
export type FindExistingClient = {
  __typename?: 'FindExistingClient';
  existingClient?: Maybe<ExistingClientInfo>;
  message: Scalars['String']['output'];
};

/** Input for findExistingClient lookup */
export type FindExistingClientInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type FindExistingClientResponse = Error | FindExistingClient;

export type FlushCache = {
  __typename?: 'FlushCache';
  accountIds: Array<Scalars['String']['output']>;
  flushResult: FlushCacheResult;
  includedAdmin: Scalars['Boolean']['output'];
  includedAllAccounts: Scalars['Boolean']['output'];
  includedGlobalQueries: Scalars['Boolean']['output'];
  includedHistory: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type FlushCacheResponse = Error | FlushCache;

export type FlushCacheResult = {
  __typename?: 'FlushCacheResult';
  accountsAffected: Scalars['Int']['output'];
  cacheMetadata: Scalars['Int']['output'];
  globalQueries: Scalars['Int']['output'];
  queryHistory: Scalars['Int']['output'];
  redisKeys: Scalars['Int']['output'];
  totalItems: Scalars['Int']['output'];
};

export type FlushGeocodingCache = {
  __typename?: 'FlushGeocodingCache';
  deletedCount: Scalars['Int']['output'];
  includeInvalid: Scalars['Boolean']['output'];
  includeValid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type FlushGeocodingCacheResponse = Error | FlushGeocodingCache;

export type GeoBoundary = {
  __typename?: 'GeoBoundary';
  northEast?: Maybe<GeoLatLng>;
  southWest?: Maybe<GeoLatLng>;
};

export type GeoLatLng = {
  __typename?: 'GeoLatLng';
  latitude: Scalars['String']['output'];
  longitude: Scalars['String']['output'];
};

/** Successful response from getAIBillingBalance. */
export type GetAIBillingBalance = {
  __typename?: 'GetAIBillingBalance';
  balance: AIBillingBalance;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetAIBillingBalanceResponse = Error | GetAIBillingBalance;

/** Successful response from getAIBillingLedger. */
export type GetAIBillingLedger = {
  __typename?: 'GetAIBillingLedger';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  transactions: Array<AIBillingTransaction>;
  version: Scalars['String']['output'];
};

/** Filter and pagination parameters for the AI billing ledger query. */
export type GetAIBillingLedgerInput = {
  /** Records per page (1-200). Defaults to 50. */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number (1-indexed). Defaults to 1. */
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAIBillingLedgerResponse = Error | GetAIBillingLedger;

export type GetAIToolsResult = AIError | AIToolsResponse;

export type GetAccountCacheDetails = {
  __typename?: 'GetAccountCacheDetails';
  details: AccountCacheDetails;
  message: Scalars['String']['output'];
};

export type GetAccountCacheDetailsResponse = Error | GetAccountCacheDetails;

export type GetAdminActivityLog = {
  __typename?: 'GetAdminActivityLog';
  activities: Array<AdminActivityLog>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetAdminActivityLogResponse = Error | GetAdminActivityLog;

export type GetAdminAuditLogs = {
  __typename?: 'GetAdminAuditLogs';
  auditLogs: AdminAuditLogList;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetAdminAuditLogsResponse = Error | GetAdminAuditLogs;

export type GetAdminPermissions = {
  __typename?: 'GetAdminPermissions';
  message: Scalars['String']['output'];
  permissions: Array<Permission>;
  version: Scalars['String']['output'];
};

export type GetAdminPermissionsResponse = Error | GetAdminPermissions;

export type GetAdminUser = {
  __typename?: 'GetAdminUser';
  adminUser: AdminUser;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetAdminUserResponse = Error | GetAdminUser;

export type GetAdminUserSession = {
  __typename?: 'GetAdminUserSession';
  adminUser: AdminUserSession;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetAdminUserSessionResponse = Error | GetAdminUserSession;

export type GetAdminUsers = {
  __typename?: 'GetAdminUsers';
  adminUsers: Array<AdminUser>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetAdminUsersResponse = Error | GetAdminUsers;

export type GetAnnouncementJobStatusResponse = AnnouncementJobStatus | Error;

export type GetApplicationFeeHistory = {
  __typename?: 'GetApplicationFeeHistory';
  feeHistory: ApplicationFeeHistoryConnection;
  message: Scalars['String']['output'];
};

export type GetApplicationFeeHistoryInput = {
  filter?: InputMaybe<ApplicationFeeHistoryFilter>;
  pagination?: InputMaybe<PaginationInput>;
};

export type GetApplicationFeeHistoryResponse = Error | GetApplicationFeeHistory;

export type GetAppointment = {
  __typename?: 'GetAppointment';
  appointment: Appointment;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetAppointmentResponse = Error | GetAppointment;

export type GetAppointments = {
  __typename?: 'GetAppointments';
  appointments: Array<Appointment>;
  geoBoundary?: Maybe<GeoBoundary>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetAppointmentsResponse = Error | GetAppointments;

export type GetAttachment = {
  __typename?: 'GetAttachment';
  attachment: Attachment;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetAttachmentResponse = Error | GetAttachment;

export type GetAttachments = {
  __typename?: 'GetAttachments';
  attachments: Array<Attachment>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetAttachmentsResponse = Error | GetAttachments;

export type GetAvailableSlots = {
  __typename?: 'GetAvailableSlots';
  crew_id: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  message: Scalars['String']['output'];
  /** Free time slots for this crew on the requested date, accounting for existing bookings */
  slots: Array<AvailableTimeSlot>;
  version: Scalars['String']['output'];
};

/** Input for querying available (free) time slots for a crew on a specific date */
export type GetAvailableSlotsInput = {
  crew_id: Scalars['ID']['input'];
  /** Date to check (time portion ignored; uses crew's working hours for that day) */
  date: Scalars['Date']['input'];
  /** Minimum slot duration in minutes (defaults to 30) */
  minDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type GetAvailableSlotsResponse = Error | GetAvailableSlots;

export type GetBackgroundJob = {
  __typename?: 'GetBackgroundJob';
  backgroundJob: BackgroundJobs;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetBillingHistory = {
  __typename?: 'GetBillingHistory';
  events: Array<BillingHistoryEvent>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
};

export type GetBillingHistoryResponse = Error | GetBillingHistory;

export type GetCacheStatus = {
  __typename?: 'GetCacheStatus';
  message: Scalars['String']['output'];
  status: ComprehensiveCacheStatus;
};

export type GetCacheStatusResponse = Error | GetCacheStatus;

export type GetChat = {
  __typename?: 'GetChat';
  chat: Chat;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetChatResponse = Error | GetChat;

export type GetChats = {
  __typename?: 'GetChats';
  chats: Array<Chat>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetChatsResponse = Error | GetChats;

export type GetChecklist = {
  __typename?: 'GetChecklist';
  checklist: Checklist;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetChecklistEntries = {
  __typename?: 'GetChecklistEntries';
  checklistEntries: Array<ChecklistEntry>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetChecklistEntriesResponse = Error | GetChecklistEntries;

export type GetChecklistEntry = {
  __typename?: 'GetChecklistEntry';
  checklistEntry: ChecklistEntry;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetChecklistEntryResponse = Error | GetChecklistEntry;

export type GetChecklistResponse = Error | GetChecklist;

export type GetChecklists = {
  __typename?: 'GetChecklists';
  checklists: Array<Checklist>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetChecklistsResponse = Error | GetChecklists;

export type GetClientAccount = {
  __typename?: 'GetClientAccount';
  account: ClientAccount;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetClientAccountResponse = Error | GetClientAccount;

export type GetClientAccountSettings = {
  __typename?: 'GetClientAccountSettings';
  message: Scalars['String']['output'];
  settings: ClientSettings;
  version: Scalars['String']['output'];
};

export type GetClientAccountSettingsResponse = Error | GetClientAccountSettings;

export type GetClientAccountTags = {
  __typename?: 'GetClientAccountTags';
  message: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type GetClientAccountTagsResponse = Error | GetClientAccountTags;

export type GetClientAccounts = {
  __typename?: 'GetClientAccounts';
  accounts: Array<ClientAccount>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetClientAccountsResponse = Error | GetClientAccounts;

export type GetClientSampleCSV = {
  __typename?: 'GetClientSampleCSV';
  /** CSV content as string with sample data */
  csvContent: Scalars['String']['output'];
  /** Column headers array */
  headers: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetClientSampleCSVResponse = Error | GetClientSampleCSV;

export type GetConnectApplicationDetails = {
  __typename?: 'GetConnectApplicationDetails';
  application: ConnectApplicationDetails;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetConnectApplicationDetailsResponse = Error | GetConnectApplicationDetails;

export type GetConnectApplicationSummary = {
  __typename?: 'GetConnectApplicationSummary';
  message: Scalars['String']['output'];
  summary: Array<ConnectApplicationSummary>;
  version: Scalars['String']['output'];
};

export type GetConnectApplicationSummaryResponse = Error | GetConnectApplicationSummary;

export type GetConnectOnboardingStatus = {
  __typename?: 'GetConnectOnboardingStatus';
  message: Scalars['String']['output'];
  onboardingStatus: ConnectOnboardingStatus;
};

export type GetConnectOnboardingStatusResponse = Error | GetConnectOnboardingStatus;

export type GetConnectOnboardingUrl = {
  __typename?: 'GetConnectOnboardingUrl';
  expiresAt: Scalars['Date']['output'];
  message: Scalars['String']['output'];
  onboardingUrl: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetConnectOnboardingUrlInput = {
  refreshUrl?: InputMaybe<Scalars['String']['input']>;
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};

export type GetConnectOnboardingUrlResponse = Error | GetConnectOnboardingUrl;

export type GetConnectStatus = {
  __typename?: 'GetConnectStatus';
  message: Scalars['String']['output'];
  status: ConnectStatus;
  version: Scalars['String']['output'];
};

export type GetConnectStatusResponse = Error | GetConnectStatus;

export type GetCrew = {
  __typename?: 'GetCrew';
  crew: Crew;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetCrewResponse = Error | GetCrew;

export type GetCrews = {
  __typename?: 'GetCrews';
  crews: Array<Crew>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetCrewsResponse = Error | GetCrews;

export type GetDashboard = {
  __typename?: 'GetDashboard';
  generatedAt: Scalars['Date']['output'];
  message: Scalars['String']['output'];
  payload: Scalars['JSON']['output'];
  snapshotVersion: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type GetDashboardReport = {
  __typename?: 'GetDashboardReport';
  message: Scalars['String']['output'];
  pendingInvoices: Scalars['Int']['output'];
  realProfit: Scalars['Float']['output'];
  totalJobs: Scalars['Int']['output'];
  totalPotentialProfit: Scalars['Float']['output'];
  version: Scalars['String']['output'];
};

export type GetDashboardReportResponse = Error | GetDashboardReport;

export type GetDashboardResponse = Error | GetDashboard;

export type GetDashboardTrend = {
  __typename?: 'GetDashboardTrend';
  message: Scalars['String']['output'];
  /** Ordered oldest-first weekly data points (up to 12 weeks). */
  trendPoints: Array<DashboardTrendPoint>;
  version: Scalars['String']['output'];
};

export type GetDashboardTrendResponse = Error | GetDashboardTrend;

/** List of devices with pagination */
export type GetDevices = {
  __typename?: 'GetDevices';
  devices: Array<Device>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetEmailInUse = {
  __typename?: 'GetEmailInUse';
  isInUse: Scalars['Boolean']['output'];
  isLinkedToMe: Scalars['Boolean']['output'];
  isPendingInviteFromMe: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetEmailInUsePublic = {
  __typename?: 'GetEmailInUsePublic';
  isInUse: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetEmailInUseResponse = Error | GetEmailInUse | GetEmailInUsePublic;

export type GetEstimate = {
  __typename?: 'GetEstimate';
  estimate: Estimate;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetEstimatePDF = {
  __typename?: 'GetEstimatePDF';
  estimatePDF: PDF;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetEstimatePDFResponse = Error | GetEstimatePDF;

export type GetEstimateResponse = Error | GetEstimate;

export type GetEstimates = {
  __typename?: 'GetEstimates';
  estimates: Array<Estimate>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetEstimatesResponse = Error | GetEstimates;

export type GetFeeStatistics = {
  __typename?: 'GetFeeStatistics';
  message: Scalars['String']['output'];
  statistics: FeeStatistics;
  version: Scalars['String']['output'];
};

export type GetFeeStatisticsInput = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetFeeStatisticsResponse = Error | GetFeeStatistics;

export type GetFeedbackEntries = {
  __typename?: 'GetFeedbackEntries';
  feedbackEntries: Array<FeedbackEntry>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetFeedbackEntriesResponse = Error | GetFeedbackEntries;

export type GetFeedbackEntry = {
  __typename?: 'GetFeedbackEntry';
  feedbackEntry: FeedbackEntry;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetFeedbackEntryResponse = Error | GetFeedbackEntry;

export type GetGlobalFeeStatistics = {
  __typename?: 'GetGlobalFeeStatistics';
  message: Scalars['String']['output'];
  statistics: GlobalFeeStatistics;
  version: Scalars['String']['output'];
};

export type GetGlobalFeeStatisticsResponse = Error | GetGlobalFeeStatistics;

export type GetGlobalSettings = {
  __typename?: 'GetGlobalSettings';
  message: Scalars['String']['output'];
  settings: GlobalSettings;
  version: Scalars['String']['output'];
};

export type GetGlobalSettingsResponse = Error | GetGlobalSettings;

export type GetGroup = {
  __typename?: 'GetGroup';
  group: Group;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetGroupResponse = Error | GetGroup;

export type GetGroups = {
  __typename?: 'GetGroups';
  groups: Array<Group>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetGroupsResponse = Error | GetGroups;

export type GetHealth = {
  __typename?: 'GetHealth';
  message: Scalars['String']['output'];
  status: Scalars['JSON']['output'];
  version: Scalars['String']['output'];
};

export type GetHealthResponse = Error | GetHealth;

/** Response for getting IVR call logs */
export type GetIVRCallLogs = {
  __typename?: 'GetIVRCallLogs';
  callLogs: Array<IVRCallLog>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  stats?: Maybe<IVRCallLogStats>;
  version: Scalars['String']['output'];
};

export type GetIVRCallLogsInput = {
  filter?: InputMaybe<IVRCallLogFilter>;
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type GetIVRCallLogsResponse = Error | GetIVRCallLogs;

/** Response for getting IVR voicemails */
export type GetIVRVoicemails = {
  __typename?: 'GetIVRVoicemails';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  unlistenedCount: Scalars['Int']['output'];
  version: Scalars['String']['output'];
  voicemails: Array<IVRVoicemail>;
};

export type GetIVRVoicemailsInput = {
  includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  includeListened?: InputMaybe<Scalars['Boolean']['input']>;
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type GetIVRVoicemailsResponse = Error | GetIVRVoicemails;

export type GetInvoice = {
  __typename?: 'GetInvoice';
  invoice: Invoice;
  message: Scalars['String']['output'];
};

export type GetInvoicePDF = {
  __typename?: 'GetInvoicePDF';
  invoicePDF: PDF;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetInvoicePDFResponse = Error | GetInvoicePDF;

export type GetInvoicePaymentInfo = {
  __typename?: 'GetInvoicePaymentInfo';
  invoiceInfo: InvoicePaymentInfo;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetInvoicePaymentInfoResponse = Error | GetInvoicePaymentInfo;

export type GetInvoiceResponse = Error | GetInvoice;

export type GetInvoices = {
  __typename?: 'GetInvoices';
  invoices: Array<Invoice>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
};

export type GetInvoicesResponse = Error | GetInvoices;

export type GetJob = {
  __typename?: 'GetJob';
  job: Job;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetJobEnRouteETA = {
  __typename?: 'GetJobEnRouteETA';
  destination: Destination;
  distance: Distance;
  duration: Duration;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetJobEnRouteETAResponse = Error | GetJobEnRouteETA;

export type GetJobFeedbackStatus = {
  __typename?: 'GetJobFeedbackStatus';
  /** Whether feedback was skipped for this job */
  feedbackSkipped: Scalars['Boolean']['output'];
  /** Whether feedback has already been submitted for this job */
  hasFeedback: Scalars['Boolean']['output'];
  /** The job ID */
  job_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  /** Whether the feedback prompt should be shown */
  shouldShowFeedbackPrompt: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

export type GetJobFeedbackStatusResponse = Error | GetJobFeedbackStatus;

export type GetJobPDF = {
  __typename?: 'GetJobPDF';
  jobPDF: PDF;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetJobPDFResponse = Error | GetJobPDF;

export type GetJobResponse = Error | GetJob;

export type GetJobs = {
  __typename?: 'GetJobs';
  geoBoundary?: Maybe<GeoBoundary>;
  jobs: Array<Job>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetJobsResponse = Error | GetJobs;

export type GetKnownDevices = {
  __typename?: 'GetKnownDevices';
  devices: Array<KnownDevice>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetLists = {
  __typename?: 'GetLists';
  lists?: Maybe<Array<List>>;
  message: Scalars['String']['output'];
};

export type GetListsResponse = Error | GetLists;

export type GetLocations = {
  __typename?: 'GetLocations';
  locations: Locations;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Input options for retrieving location data */
export type GetLocationsInput = {
  /** Include cities and states from billing information (default: true) */
  includeBilling?: InputMaybe<Scalars['Boolean']['input']>;
  /** Include cities and states from properties (default: true) */
  includeProperties?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetLocationsResponse = Error | GetLocations;

export type GetManufacturer = {
  __typename?: 'GetManufacturer';
  manufacturer: Manufacturer;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetManufacturerResponse = Error | GetManufacturer;

export type GetManufacturers = {
  __typename?: 'GetManufacturers';
  manufacturers: Array<Manufacturer>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetManufacturersResponse = Error | GetManufacturers;

export type GetMessages = {
  __typename?: 'GetMessages';
  message: Scalars['String']['output'];
  messages: Array<Message>;
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetMessagesResponse = Error | GetMessages;

export type GetMinimumMobileAppVersions = {
  __typename?: 'GetMinimumMobileAppVersions';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
  versions: Array<MobileAppVersion>;
};

export type GetMinimumMobileAppVersionsResponse = Error | GetMinimumMobileAppVersions;

export type GetNote = {
  __typename?: 'GetNote';
  message: Scalars['String']['output'];
  note: Note;
  version: Scalars['String']['output'];
};

export type GetNoteResponse = Error | GetNote;

export type GetNotes = {
  __typename?: 'GetNotes';
  message: Scalars['String']['output'];
  notes: Array<Note>;
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetNotesResponse = Error | GetNotes;

export type GetNotification = {
  __typename?: 'GetNotification';
  message: Scalars['String']['output'];
  notification: Notification;
  version: Scalars['String']['output'];
};

export type GetNotificationPreferences = {
  __typename?: 'GetNotificationPreferences';
  message: Scalars['String']['output'];
  preferences: NotificationPreferences;
  version: Scalars['String']['output'];
};

export type GetNotificationPreferencesResponse = Error | GetNotificationPreferences;

export type GetNotificationResponse = Error | GetNotification;

export type GetNotificationSettings = {
  __typename?: 'GetNotificationSettings';
  /** Account-level notification settings */
  accountSettings?: Maybe<Scalars['JSON']['output']>;
  /** Available notification types for this user */
  availableTypes: Array<NotificationType>;
  message: Scalars['String']['output'];
  /** User-level notification preferences */
  userPreferences?: Maybe<NotificationPreferences>;
  version: Scalars['String']['output'];
};

export type GetNotificationSettingsResponse = Error | GetNotificationSettings;

export type GetNotifications = {
  __typename?: 'GetNotifications';
  message: Scalars['String']['output'];
  notifications: Array<Notification>;
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetNotificationsInput = {
  /** Filter criteria */
  filter?: InputMaybe<NotificationFilter>;
  /** Records per page */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort field */
  sortBy?: InputMaybe<NotificationSortBy>;
};

export type GetNotificationsResponse = Error | GetNotifications;

export type GetOfflineSyncClientParents = {
  __typename?: 'GetOfflineSyncClientParents';
  accounts: Array<ClientAccount>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Exact Client parents required to persist an offline child-sync payload. */
export type GetOfflineSyncClientParentsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type GetOfflineSyncClientParentsResponse = Error | GetOfflineSyncClientParents;

export type GetOnboardingEmailTemplates = {
  __typename?: 'GetOnboardingEmailTemplates';
  message: Scalars['String']['output'];
  templates: Array<OnboardingEmailTemplate>;
  version: Scalars['String']['output'];
};

export type GetOnboardingEmailTemplatesResponse = Error | GetOnboardingEmailTemplates;

export type GetOnboardingSteps = {
  __typename?: 'GetOnboardingSteps';
  message: Scalars['String']['output'];
  steps: Array<OnboardingStep>;
};

export type GetOnboardingStepsResponse = Error | GetOnboardingSteps;

export type GetPasswordStrength = {
  __typename?: 'GetPasswordStrength';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetPasswordStrengthResponse = Error | GetPasswordStrength;

export type GetPayment = {
  __typename?: 'GetPayment';
  message: Scalars['String']['output'];
  payment: Payment;
  version: Scalars['String']['output'];
};

export type GetPaymentResponse = Error | GetPayment;

export type GetPayments = {
  __typename?: 'GetPayments';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  payments: Array<Payment>;
  version: Scalars['String']['output'];
};

export type GetPaymentsResponse = Error | GetPayments;

export type GetPendingConnectApplications = {
  __typename?: 'GetPendingConnectApplications';
  applications: Array<ConnectApplicationDetails>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetPendingConnectApplicationsResponse = Error | GetPendingConnectApplications;

export type GetPhoneInUse = {
  __typename?: 'GetPhoneInUse';
  isInUse: Scalars['Boolean']['output'];
  isLinkedToMe: Scalars['Boolean']['output'];
  isPendingInviteFromMe: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetPhoneInUsePublic = {
  __typename?: 'GetPhoneInUsePublic';
  isInUse: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetPhoneInUseResponse = Error | GetPhoneInUse | GetPhoneInUsePublic;

export type GetProperties = {
  __typename?: 'GetProperties';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  properties: Array<Property>;
  version: Scalars['String']['output'];
};

export type GetPropertiesResponse = Error | GetProperties;

export type GetProperty = {
  __typename?: 'GetProperty';
  message: Scalars['String']['output'];
  property: Property;
  version: Scalars['String']['output'];
};

export type GetPropertyResponse = Error | GetProperty;

export type GetPublicInvoice = {
  __typename?: 'GetPublicInvoice';
  invoice: PublicInvoice;
  message: Scalars['String']['output'];
};

export type GetPublicInvoicePaymentInfo = {
  __typename?: 'GetPublicInvoicePaymentInfo';
  invoiceInfo: PublicInvoicePaymentInfo;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetPublicInvoicePaymentInfoResponse = Error | GetPublicInvoicePaymentInfo;

export type GetPublicInvoiceResponse = Error | GetPublicInvoice;

export type GetPublicReferralCodeIsValid = {
  __typename?: 'GetPublicReferralCodeIsValid';
  isValid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
};

export type GetPublicReferralCodeIsValidResponse = Error | GetPublicReferralCodeIsValid;

export type GetQBOAccounts = {
  __typename?: 'GetQBOAccounts';
  accounts: Array<QuickBooksAccountInfo>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetQBOAccountsResponse = Error | GetQBOAccounts;

export type GetQuickBooksConnection = {
  __typename?: 'GetQuickBooksConnection';
  connection?: Maybe<QuickBooksConnectionInfo>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetQuickBooksConnectionResponse = Error | GetQuickBooksConnection;

export type GetQuickBooksImportConflicts = {
  __typename?: 'GetQuickBooksImportConflicts';
  conflicts: Array<QuickBooksImportConflict>;
  message: Scalars['String']['output'];
  totalConflicts: Scalars['Int']['output'];
  unresolvedCount: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type GetQuickBooksImportConflictsResponse = Error | GetQuickBooksImportConflicts;

export type GetQuickBooksImportJob = {
  __typename?: 'GetQuickBooksImportJob';
  job?: Maybe<QuickBooksImportJob>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetQuickBooksImportJobResponse = Error | GetQuickBooksImportJob;

export type GetQuickBooksImportPreview = {
  __typename?: 'GetQuickBooksImportPreview';
  message: Scalars['String']['output'];
  previews: Array<QuickBooksImportPreview>;
  version: Scalars['String']['output'];
};

export type GetQuickBooksImportPreviewResponse = Error | GetQuickBooksImportPreview;

export type GetQuickBooksSyncLogDetail = {
  __typename?: 'GetQuickBooksSyncLogDetail';
  message: Scalars['String']['output'];
  syncItem?: Maybe<QuickBooksSyncLogEntry>;
  version: Scalars['String']['output'];
};

export type GetQuickBooksSyncLogDetailResponse = Error | GetQuickBooksSyncLogDetail;

export type GetQuickBooksSyncLogs = {
  __typename?: 'GetQuickBooksSyncLogs';
  errorCount?: Maybe<Scalars['Int']['output']>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  syncLogs: Array<QuickBooksSyncLogEntry>;
  version: Scalars['String']['output'];
  warningCount?: Maybe<Scalars['Int']['output']>;
};

export type GetQuickBooksSyncLogsResponse = Error | GetQuickBooksSyncLogs;

export type GetQuickBooksSyncSettings = {
  __typename?: 'GetQuickBooksSyncSettings';
  message: Scalars['String']['output'];
  syncSettings?: Maybe<QuickBooksSyncSettingsInfo>;
  version: Scalars['String']['output'];
};

export type GetQuickBooksSyncSettingsResponse = Error | GetQuickBooksSyncSettings;

/** Absentee report response */
export type GetReportDataAbsentee = {
  __typename?: 'GetReportDataAbsentee';
  absenteeReportItems: Array<AbsenteeReportItem>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
};

export type GetReportDataAbsenteeResponse = Error | GetReportDataAbsentee;

/** Average job duration report response */
export type GetReportDataAverageJobDuration = {
  __typename?: 'GetReportDataAverageJobDuration';
  averageJobDurationReportItems: Array<AverageJobDurationReportItem>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
};

export type GetReportDataAverageJobDurationResponse = Error | GetReportDataAverageJobDuration;

export type GetReportDataCompletedWorkOrders = {
  __typename?: 'GetReportDataCompletedWorkOrders';
  completeEntriesCount: Scalars['Int']['output'];
  incompleteEntriesCount: Scalars['Int']['output'];
  jobs: Array<Job>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  totalCompletedHours: Scalars['Int']['output'];
  totalCompletedMinutes: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type GetReportDataCompletedWorkOrdersResponse = Error | GetReportDataCompletedWorkOrders;

export type GetReportDataCrewUserStatus = {
  __typename?: 'GetReportDataCrewUserStatus';
  crewUserStatusReportItems: Array<CrewUserStatusReportItem>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
};

export type GetReportDataCrewUserStatusResponse = Error | GetReportDataCrewUserStatus;

/** Working hours report response */
export type GetReportDataCrewUserWorkingHours = {
  __typename?: 'GetReportDataCrewUserWorkingHours';
  /** Working hours items for each crew user */
  crewUserWorkingHoursReportItems: Array<CrewUserWorkingHoursReportItem>;
  message: Scalars['String']['output'];
  /** Pagination information */
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
};

export type GetReportDataCrewUserWorkingHoursResponse = Error | GetReportDataCrewUserWorkingHours;

export type GetReportDataCustomerComplaints = {
  __typename?: 'GetReportDataCustomerComplaints';
  customerComplaintsReportItems: Array<CustomerComplaintsReportItem>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
};

export type GetReportDataCustomerComplaintsResponse = Error | GetReportDataCustomerComplaints;

export type GetReportDataCustomerSatisfaction = {
  __typename?: 'GetReportDataCustomerSatisfaction';
  customerSatisfactionReportItems: Array<CustomerSatisfactionReportItem>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
};

export type GetReportDataCustomerSatisfactionResponse = Error | GetReportDataCustomerSatisfaction;

/** Idle time report response */
export type GetReportDataIdleTime = {
  __typename?: 'GetReportDataIdleTime';
  idleTimeReportItems: Array<IdleTimeReportItem>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
};

export type GetReportDataIdleTimeResponse = Error | GetReportDataIdleTime;

/** Job productivity report response */
export type GetReportDataJobProductivity = {
  __typename?: 'GetReportDataJobProductivity';
  jobProductivityReportItems: Array<JobProductivityReportItem>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
};

export type GetReportDataJobProductivityResponse = Error | GetReportDataJobProductivity;

export type GetReportDataOpenWorkOrders = {
  __typename?: 'GetReportDataOpenWorkOrders';
  jobs: Array<Job>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
};

export type GetReportDataOpenWorkOrdersResponse = Error | GetReportDataOpenWorkOrders;

/** Travel time report response */
export type GetReportDataTravelTime = {
  __typename?: 'GetReportDataTravelTime';
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  travelTimeReportItems: Array<TravelTimeReportItem>;
  version: Scalars['String']['output'];
};

export type GetReportDataTravelTimeResponse = Error | GetReportDataTravelTime;

export type GetReportDataWorkOrders = {
  __typename?: 'GetReportDataWorkOrders';
  jobs: Array<Job>;
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
};

export type GetReportDataWorkOrdersResponse = Error | GetReportDataWorkOrders;

/** Working hours report response */
export type GetReportDataWorkingHoursByGroup = {
  __typename?: 'GetReportDataWorkingHoursByGroup';
  message: Scalars['String']['output'];
  paginationInfo: PaginationInfo;
  version: Scalars['String']['output'];
  workingHoursReportItems: Array<WorkingHoursReportItem>;
};

export type GetReportDataWorkingHoursByGroupResponse = Error | GetReportDataWorkingHoursByGroup;

export type GetServiceCategories = {
  __typename?: 'GetServiceCategories';
  message: Scalars['String']['output'];
  serviceCategories: Array<ServiceCategory>;
};

export type GetServiceCategoriesResponse = Error | GetServiceCategories;

export type GetServiceItem = {
  __typename?: 'GetServiceItem';
  message: Scalars['String']['output'];
  serviceItem: ServiceItem;
  version: Scalars['String']['output'];
};

export type GetServiceItemResponse = Error | GetServiceItem;

export type GetServiceItemSampleCSV = {
  __typename?: 'GetServiceItemSampleCSV';
  csvContent: Scalars['String']['output'];
  headers: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetServiceItemSampleCSVResponse = Error | GetServiceItemSampleCSV;

export type GetServiceItemTags = {
  __typename?: 'GetServiceItemTags';
  message: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type GetServiceItemTagsResponse = Error | GetServiceItemTags;

export type GetServiceItems = {
  __typename?: 'GetServiceItems';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  serviceItems: Array<ServiceItem>;
  version: Scalars['String']['output'];
};

export type GetServiceItemsResponse = Error | GetServiceItems;

export type GetServiceProviderAccount = {
  __typename?: 'GetServiceProviderAccount';
  account: ServiceProviderAccount;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetServiceProviderAccountResponse = Error | GetServiceProviderAccount;

export type GetServiceProviderAccountSettings = {
  __typename?: 'GetServiceProviderAccountSettings';
  message: Scalars['String']['output'];
  settings: ServiceProviderSettings;
  version: Scalars['String']['output'];
};

export type GetServiceProviderAccountSettingsResponse = Error | GetServiceProviderAccountSettings;

export type GetServiceProviderAccounts = {
  __typename?: 'GetServiceProviderAccounts';
  accounts?: Maybe<Array<ServiceProviderAccountClientView>>;
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  version: Scalars['String']['output'];
};

export type GetServiceProviderAccountsResponse = Error | GetServiceProviderAccounts;

export type GetServiceProviderByClientCode = {
  __typename?: 'GetServiceProviderByClientCode';
  message: Scalars['String']['output'];
  serviceProviderName: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetServiceProviderByClientCodeResponse = Error | GetServiceProviderByClientCode;

export type GetServiceProviderByExtensionCode = {
  __typename?: 'GetServiceProviderByExtensionCode';
  accountId: Scalars['ID']['output'];
  companyName: Scalars['String']['output'];
  ivrGreetingUrl?: Maybe<Scalars['String']['output']>;
  ivrMode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetServiceProviderByExtensionCodeResponse = Error | GetServiceProviderByExtensionCode;

export type GetServiceProviderByReferralCode = {
  __typename?: 'GetServiceProviderByReferralCode';
  message: Scalars['String']['output'];
  serviceProviderName: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetServiceProviderByReferralCodeResponse = Error | GetServiceProviderByReferralCode;

export type GetServiceProviderPublicProfile = {
  __typename?: 'GetServiceProviderPublicProfile';
  message: Scalars['String']['output'];
  serviceProvider: ServiceProviderPublicProfile;
  version: Scalars['String']['output'];
};

export type GetServiceProviderPublicProfileResponse = Error | GetServiceProviderPublicProfile;

export type GetServiceProviderPublicProfiles = {
  __typename?: 'GetServiceProviderPublicProfiles';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  serviceProviders: Array<ServiceProviderPublicProfile>;
  version: Scalars['String']['output'];
};

export type GetServiceProviderPublicProfilesResponse = Error | GetServiceProviderPublicProfiles;

export type GetSetupStatus = {
  __typename?: 'GetSetupStatus';
  message: Scalars['String']['output'];
  setupStatus: SetupStatus;
};

export type GetSetupStatusResponse = Error | GetSetupStatus;

export type GetSkuInUse = {
  __typename?: 'GetSkuInUse';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetSkuInUseResponse = Error | GetSkuInUse;

/** Response for getStripeClientKey query. */
export type GetStripeClientKey = {
  __typename?: 'GetStripeClientKey';
  /** The Stripe setup intent client secret for payment method collection. */
  clientSecret: Scalars['String']['output'];
  /** Status message for the operation. */
  message: Scalars['String']['output'];
};

export type GetStripeClientKeyResponse = Error | GetStripeClientKey;

export type GetSubscriptionPlan = {
  __typename?: 'GetSubscriptionPlan';
  message: Scalars['String']['output'];
  plan?: Maybe<SubscriptionPlan>;
};

export type GetSubscriptionPlanChangeLog = {
  __typename?: 'GetSubscriptionPlanChangeLog';
  history: Array<SubscriptionPlanChangeHistory>;
  message: Scalars['String']['output'];
};

export type GetSubscriptionPlanChangeLogResponse = Error | GetSubscriptionPlanChangeLog;

export type GetSubscriptionPlanResponse = Error | GetSubscriptionPlan;

export type GetSubscriptionPlans = {
  __typename?: 'GetSubscriptionPlans';
  message: Scalars['String']['output'];
  plans: Array<SubscriptionPlan>;
};

export type GetSubscriptionPlansResponse = Error | GetSubscriptionPlans;

export type GetTaxRate = {
  __typename?: 'GetTaxRate';
  message: Scalars['String']['output'];
  taxRate: TaxRate;
  version: Scalars['String']['output'];
};

export type GetTaxRateResponse = Error | GetTaxRate;

export type GetTaxRates = {
  __typename?: 'GetTaxRates';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  taxRates: Array<TaxRate>;
  version: Scalars['String']['output'];
};

export type GetTaxRatesResponse = Error | GetTaxRates;

export type GetTimesheet = {
  __typename?: 'GetTimesheet';
  message: Scalars['String']['output'];
  timesheet: Timesheet;
  version: Scalars['String']['output'];
};

export type GetTimesheetAnalytics = {
  __typename?: 'GetTimesheetAnalytics';
  message: Scalars['String']['output'];
  timesheetAnalytics: TimesheetAnalytics;
  version: Scalars['String']['output'];
};

export type GetTimesheetAnalyticsResponse = Error | GetTimesheetAnalytics;

export type GetTimesheetEntries = {
  __typename?: 'GetTimesheetEntries';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  timesheetEntries: Array<TimesheetEntry>;
  version: Scalars['String']['output'];
};

export type GetTimesheetEntriesResponse = Error | GetTimesheetEntries;

export type GetTimesheetEntry = {
  __typename?: 'GetTimesheetEntry';
  message: Scalars['String']['output'];
  timesheetEntry: TimesheetEntry;
  version: Scalars['String']['output'];
};

export type GetTimesheetEntryResponse = Error | GetTimesheetEntry;

export type GetTimesheetResponse = Error | GetTimesheet;

export type GetTimesheets = {
  __typename?: 'GetTimesheets';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  timesheets: Array<Timesheet>;
  version: Scalars['String']['output'];
};

export type GetTimesheetsResponse = Error | GetTimesheets;

export type GetUnavailableDates = {
  __typename?: 'GetUnavailableDates';
  /** Per-client unavailable dates (SP account + each client) */
  clientUnavailableDates: Array<Maybe<ClientUnavailableDates>>;
  /** Per-crew unavailable dates with nested client combinations */
  crewUnavailableDates: Array<Maybe<CrewUnavailableDates>>;
  message: Scalars['String']['output'];
  /** Base unavailable dates (SP account only) */
  unavailableDates: Array<Maybe<DateRange>>;
};

/** Get unavailable dates input */
export type GetUnavailableDatesInput = {
  /** Single client account ID (deprecated, use client_account_ids for multiple) */
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Multiple client account IDs */
  client_account_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  crew_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** End date for availability check (defaults to one year from start date if not provided) */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** If true, overlays existing job and appointment bookings onto unavailable dates */
  includeExistingBookings?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, excludes Service Provider account availability from intersection logic */
  isServiceProviderAvailabilityDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start date for availability check (defaults to now if not provided) */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type GetUnavailableDatesResponse = Error | GetUnavailableDates;

export type GetUnreadCount = {
  __typename?: 'GetUnreadCount';
  count: Scalars['Int']['output'];
  /** Unread by priority */
  countByPriority: NotificationPriorityCount;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetUnreadCountResponse = Error | GetUnreadCount;

export type GetUser = {
  __typename?: 'GetUser';
  message: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

export type GetUserAvatar = {
  __typename?: 'GetUserAvatar';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type GetUserAvatarResponse = Error | GetUserAvatar;

export type GetUserResponse = Error | GetUser;

export type GetUserSession = {
  __typename?: 'GetUserSession';
  linkToken?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  user: UserSession;
  version: Scalars['String']['output'];
};

export type GetUserSessionResponse = Error | GetUserSession;

export type GetUserSettings = {
  __typename?: 'GetUserSettings';
  message: Scalars['String']['output'];
  settings: UserSettings;
  version: Scalars['String']['output'];
};

export type GetUserSettingsResponse = Error | GetUserSettings;

export type GetUsers = {
  __typename?: 'GetUsers';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  users: Array<User>;
  version: Scalars['String']['output'];
};

export type GetUsersResponse = Error | GetUsers;

export type GetVendor = {
  __typename?: 'GetVendor';
  message: Scalars['String']['output'];
  vendor: Vendor;
  version: Scalars['String']['output'];
};

export type GetVendorResponse = Error | GetVendor;

export type GetVendors = {
  __typename?: 'GetVendors';
  message: Scalars['String']['output'];
  paginationInfo?: Maybe<PaginationInfo>;
  vendors: Array<Vendor>;
  version: Scalars['String']['output'];
};

export type GetVendorsResponse = Error | GetVendors;

export type GetWidgetHTML = {
  __typename?: 'GetWidgetHTML';
  html: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GetWidgetHTMLResponse = Error | GetWidgetHTML;

export type GlobalCacheMetrics = {
  __typename?: 'GlobalCacheMetrics';
  avgResponseTime: Scalars['Float']['output'];
  connectionStatus: Scalars['String']['output'];
  evictions: Scalars['Int']['output'];
  globalQueries: Array<GlobalQuery>;
  hitRate: Scalars['Float']['output'];
  memoryUsage: MemoryUsage;
  missRate: Scalars['Float']['output'];
  topAccounts: Array<AccountCacheInfo>;
  totalKeys: Scalars['Int']['output'];
  totalSize: Scalars['Int']['output'];
  totalSizeMB: Scalars['Float']['output'];
};

/** Global fee defaults configuration */
export type GlobalFeeDefaults = {
  __typename?: 'GlobalFeeDefaults';
  /** Default fee percentage for new accounts */
  feePercentage: Scalars['Float']['output'];
  /** Default fixed fee amount for new accounts (in cents) */
  fixedFeeAmount: Scalars['Float']['output'];
  /** Last update timestamp */
  lastUpdated?: Maybe<Scalars['Date']['output']>;
};

/** Input for updating global fee defaults */
export type GlobalFeeDefaultsInput = {
  /** Whether to apply changes to existing accounts with default fees */
  applyToExistingDefaults?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default fee percentage for new accounts */
  feePercentage: Scalars['Float']['input'];
  /** Default fixed fee amount for new accounts (in cents) */
  fixedFeeAmount: Scalars['Float']['input'];
};

/** Global fee statistics across all service providers */
export type GlobalFeeStatistics = {
  __typename?: 'GlobalFeeStatistics';
  /** Number of active Connect-enabled accounts */
  activeConnectAccounts: Scalars['Int']['output'];
  /** Total application fees collected all time */
  allTimeFees: Scalars['Float']['output'];
  /** Average fee percentage across all accounts */
  averageFeePercentage: Scalars['Float']['output'];
  /** Average fixed fee amount across all accounts */
  averageFixedFee: Scalars['Float']['output'];
  /** Total application fees collected this month */
  currentMonthFees: Scalars['Float']['output'];
  /** Total payments processed through Connect this month */
  currentMonthVolume: Scalars['Float']['output'];
  /** Total application fees collected last month */
  lastMonthFees: Scalars['Float']['output'];
  /** Growth rate compared to previous month */
  monthOverMonthGrowth: Scalars['Float']['output'];
  /** Number of pending applications */
  pendingApplications: Scalars['Int']['output'];
  /** Total application fees collected this year */
  yearToDateFees: Scalars['Float']['output'];
};

export type GlobalQuery = {
  __typename?: 'GlobalQuery';
  hitCount: Scalars['Int']['output'];
  lastAccessed: Scalars['String']['output'];
  operationName: Scalars['String']['output'];
  query?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Scalars['JSON']['output']>;
};

export type GlobalSettings = {
  __typename?: 'GlobalSettings';
  appUrl?: Maybe<Scalars['String']['output']>;
  bookingUrl?: Maybe<Scalars['String']['output']>;
  conversionCloseAt?: Maybe<Scalars['Date']['output']>;
  conversionOpenAt?: Maybe<Scalars['Date']['output']>;
  foundingDiscountPercent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  launchDate?: Maybe<Scalars['Date']['output']>;
  privacyPolicyUrl?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type GlobalSettingsInput = {
  appUrl?: InputMaybe<Scalars['String']['input']>;
  bookingUrl?: InputMaybe<Scalars['String']['input']>;
  conversionCloseAt?: InputMaybe<Scalars['Date']['input']>;
  conversionOpenAt?: InputMaybe<Scalars['Date']['input']>;
  foundingDiscountPercent?: InputMaybe<Scalars['Float']['input']>;
  launchDate?: InputMaybe<Scalars['Date']['input']>;
  privacyPolicyUrl?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
};

export type Group = Timestamps & {
  __typename?: 'Group';
  account_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  serviceItems?: Maybe<Array<ServiceItem>>;
  service_item_ids?: Maybe<Array<Scalars['ID']['output']>>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type GroupMinimum = Timestamps & {
  __typename?: 'GroupMinimum';
  account_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum GroupsSortBy {
  CreatedAt = 'CREATED_AT',
  GroupCode = 'GROUP_CODE',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
}

/** Hours breakdown by timesheet entry type */
export type HoursBreakdown = {
  __typename?: 'HoursBreakdown';
  /** Hours spent en route to jobs */
  enRouteHours: Scalars['Float']['output'];
  /** Hours spent on job preparation */
  jobPrepHours: Scalars['Float']['output'];
  /** Hours spent on actual job work */
  jobTimeHours: Scalars['Float']['output'];
  /** Hours spent on office/administrative work */
  officeHours: Scalars['Float']['output'];
  /** Total hours across all types */
  totalHours: Scalars['Float']['output'];
};

/** Represents the common fields for a service item, including inventory, vendor, and manufacturer details. */
export type IServiceItem = {
  /** ID of the account that owns this service item. */
  account_id: Scalars['ID']['output'];
  /** Additional data or notes (ADT) for the service item. */
  adt?: Maybe<Scalars['String']['output']>;
  /** Attachments related to the service item (e.g., images, documents). */
  attachments?: Maybe<Array<Attachment>>;
  /** Quantity of the service item available for use. */
  availableQty: Scalars['Int']['output'];
  /** ID of the checklist associated with this service item, if any. */
  checklist_id?: Maybe<Scalars['ID']['output']>;
  /** Color of the service item, if applicable. */
  color?: Maybe<Scalars['String']['output']>;
  /** Date when the service item was created. */
  createdAt: Scalars['Date']['output'];
  /** Description of the service item. */
  description?: Maybe<Scalars['String']['output']>;
  /** Groups this service item belongs to. */
  groups?: Maybe<Array<GroupMinimum>>;
  /** Unique identifier for the service item. */
  id: Scalars['ID']['output'];
  /** Indicates if the service item is archived. */
  isArchived: Scalars['Boolean']['output'];
  /** Indicates if the service item is currently in use. */
  isInUse: Scalars['Boolean']['output'];
  /** Indicates if inventory tracking is disabled for this MATERIAL item (e.g., for consumables like bolts, screws). */
  isInventoryDisabled: Scalars['Boolean']['output'];
  /** Indicates if the record was created via Quick Add. */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the service item is shown as a new service. */
  isShowNewService: Scalars['Boolean']['output'];
  /** Indicates if the service item is available for online booking. */
  isShowOnlineBooking: Scalars['Boolean']['output'];
  /** Indicates if the service item is taxable. */
  isTaxable: Scalars['Boolean']['output'];
  /** Location of the service item in inventory or warehouse. */
  location?: Maybe<Scalars['String']['output']>;
  /** Manufacturer entity associated with this service item. */
  manufacturer?: Maybe<Manufacturer>;
  /** Manufacturer's model number for the service item. */
  manufacturerModelNumber?: Maybe<Scalars['String']['output']>;
  /** ID of the manufacturer of this service item, if any. */
  manufacturer_id?: Maybe<Scalars['ID']['output']>;
  /** Name of the service item. */
  name: Scalars['String']['output'];
  /** URL of the service item image. */
  photoUrl?: Maybe<Scalars['String']['output']>;
  /** Current quantity of the service item on hand. */
  quantityOnHand: Scalars['Int']['output'];
  /** Reorder level for the service item. */
  reorderLevel: Scalars['Int']['output'];
  /** Quantity of the service item reserved in estimates. */
  reservedInEstimates: Scalars['Int']['output'];
  /** Quantity of the service item reserved in jobs. */
  reservedInJobs: Scalars['Int']['output'];
  /** Size of the service item, if applicable. */
  size?: Maybe<Scalars['String']['output']>;
  /** Stock keeping unit (SKU) for the service item. */
  sku: Scalars['String']['output'];
  /** Tags associated with the service item. */
  tags?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of the service item (labor or material). */
  type: ServiceItemType;
  /** Unit cost of the service item in cents. */
  unitCost: Scalars['Float']['output'];
  /** Unit of measure for the service item (e.g., EACH, BOX, GALLON). */
  unitOfMeasure?: Maybe<UnitOfMeasure>;
  /** Unit retail price of the service item in cents. */
  unitRetailPrice: Scalars['Float']['output'];
  /** Universal Product Code (UPC) for the service item. */
  upc?: Maybe<Scalars['String']['output']>;
  /** Date when the service item was last updated. */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Vendor entity associated with this service item. */
  vendor?: Maybe<Vendor>;
  /** Vendor-specific SKU for the service item. */
  vendorSku?: Maybe<Scalars['String']['output']>;
  /** ID of the vendor supplying this service item, if any. */
  vendor_id?: Maybe<Scalars['ID']['output']>;
};

export type IUser = {
  account_id: Scalars['ID']['output'];
  /** URL to user avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Current GPS latitude for ETA calculations */
  currentLatitude?: Maybe<Scalars['Float']['output']>;
  /** Current GPS longitude for ETA calculations */
  currentLongitude?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Email address (optional for draft client users created without email) */
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Check if user is disabled */
  isDisabled: Scalars['Boolean']['output'];
  /** Check if email is confirmed */
  isEmailConfirmed: Scalars['Boolean']['output'];
  /** Check if user is in use within a crew or other entity and cannot be deleted. */
  isInUse: Scalars['Boolean']['output'];
  /** Indicates if all required onboarding steps are completed */
  isOnboardingComplete: Scalars['Boolean']['output'];
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the user consented to receive SMS notifications */
  isSMSConsent?: Maybe<Scalars['Boolean']['output']>;
  /** Onboarding related fields */
  isWelcomeScreenClosed: Scalars['Boolean']['output'];
  /** Timestamp of last location update */
  lastLocationUpdate?: Maybe<Scalars['Date']['output']>;
  lastName: Scalars['String']['output'];
  lastOnboardingInteraction?: Maybe<Scalars['Date']['output']>;
  locale?: Maybe<Locale>;
  /** Indicates if the mobile tour onboarding has been completed */
  onboardingMobileTourComplete: Scalars['Boolean']['output'];
  onboardingSteps: Array<OnboardingStep>;
  onboardingWizardState: OnboardingWizardState;
  /** Phone number (optional for draft client users created without phone) */
  phone?: Maybe<Scalars['String']['output']>;
  /** Per-tour Quick Tour outcomes used to suppress repeat auto-starts */
  quickTours: Array<QuickTourState>;
  /** Disable automatic Quick Tour starts for this user */
  quickToursDisabled: Scalars['Boolean']['output'];
  role: Role;
  /** User settings and preferences */
  settings?: Maybe<UserSettings>;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Verified WhatsApp number linked from the DHS app (E.164 format) */
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};

/** IVR call log entry for appointment line analytics */
export type IVRCallLog = {
  __typename?: 'IVRCallLog';
  aiMessagesCount?: Maybe<Scalars['Int']['output']>;
  appointmentId?: Maybe<Scalars['ID']['output']>;
  callConnectionId: Scalars['String']['output'];
  callEndedAt?: Maybe<Scalars['Date']['output']>;
  callStartedAt: Scalars['Date']['output'];
  callerName?: Maybe<Scalars['String']['output']>;
  callerPhone: Scalars['String']['output'];
  clientAccountId?: Maybe<Scalars['ID']['output']>;
  clientCompanyName?: Maybe<Scalars['String']['output']>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  convertedAt?: Maybe<Scalars['Date']['output']>;
  convertedClientAccountId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  discoveryCity?: Maybe<Scalars['String']['output']>;
  discoveryServiceType?: Maybe<Scalars['String']['output']>;
  discoveryState?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isConverted?: Maybe<Scalars['Boolean']['output']>;
  isKnownClient?: Maybe<Scalars['Boolean']['output']>;
  leadScore?: Maybe<Scalars['Int']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  recordingId?: Maybe<Scalars['String']['output']>;
  recordingUrl?: Maybe<Scalars['String']['output']>;
  resolvedVia?: Maybe<Scalars['String']['output']>;
  serviceProviderId?: Maybe<Scalars['ID']['output']>;
  serviceProviderName?: Maybe<Scalars['String']['output']>;
  smsFollowUpSent?: Maybe<Scalars['Boolean']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  transcript?: Maybe<Scalars['String']['output']>;
  urgencyDetected?: Maybe<Scalars['Boolean']['output']>;
  urgencyKeywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  voicemail?: Maybe<IVRVoicemail>;
};

export type IVRCallLogFilter = {
  callerPhone?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  isConverted?: InputMaybe<Scalars['Boolean']['input']>;
  isKnownClient?: InputMaybe<Scalars['Boolean']['input']>;
  minLeadScore?: InputMaybe<Scalars['Int']['input']>;
  outcome?: InputMaybe<Scalars['String']['input']>;
  outcomes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  urgencyOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Aggregated call statistics */
export type IVRCallLogStats = {
  __typename?: 'IVRCallLogStats';
  appointmentsCreated: Scalars['Int']['output'];
  avgDurationSeconds?: Maybe<Scalars['Int']['output']>;
  avgLeadScore?: Maybe<Scalars['Float']['output']>;
  callbacksRequested: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
  urgentCalls: Scalars['Int']['output'];
  voicemails: Scalars['Int']['output'];
};

/** A voicemail left by a caller through the IVR system */
export type IVRVoicemail = {
  __typename?: 'IVRVoicemail';
  accountId: Scalars['ID']['output'];
  audioUrl: Scalars['String']['output'];
  callConnectionId: Scalars['String']['output'];
  callerAni: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  durationSec: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  listenedAt?: Maybe<Scalars['Date']['output']>;
  retentionExpiresAt: Scalars['Date']['output'];
  status: Scalars['String']['output'];
  transcript?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

/** Parameters to filter idle time report data */
export type IdleTimeReportFilter = {
  /** Filter by specific crew IDs */
  crew_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date for timesheet entries */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by job statuses */
  jobStatuses?: InputMaybe<Array<JobStatus>>;
  /** Start date for timesheet entries */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by specific user IDs */
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Idle time metrics for crew utilization analysis */
export type IdleTimeReportItem = {
  __typename?: 'IdleTimeReportItem';
  /** Available hours for the period */
  availableHours: Scalars['Float']['output'];
  /** Idle hours (available - working) */
  idleHours: Scalars['Float']['output'];
  /** Idle time as percentage of available time */
  idlePercentage: Scalars['Float']['output'];
  /** User object */
  user: User;
  /** User full name */
  userFullName: Scalars['String']['output'];
  /** User ID */
  user_id: Scalars['ID']['output'];
  /** Working hours breakdown */
  workingHours: WorkingHours;
};

export type IgnoreQuickBooksSyncItem = {
  __typename?: 'IgnoreQuickBooksSyncItem';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type IgnoreQuickBooksSyncItemResponse = Error | IgnoreQuickBooksSyncItem;

/** Image input for AI query with transcription mode */
export type ImageInput = {
  /** Base64-encoded image data */
  base64: Scalars['String']['input'];
  /** Optional filename for context and reference */
  fileName?: InputMaybe<Scalars['String']['input']>;
  /** MIME type (e.g., image/png, image/jpeg, image/jpg, image/gif, image/webp) */
  mimeType: Scalars['String']['input'];
  /** Transcription mode to use */
  mode: ImageTranscriptionMode;
};

/** Image transcription mode - SIMPLE for text extraction only, INTELLIGENT for contextual interpretation */
export enum ImageTranscriptionMode {
  /** AI interpretation with context and insights */
  Intelligent = 'INTELLIGENT',
  /** Plain text extraction only (OCR-style) */
  Simple = 'SIMPLE',
}

/** Image transcription result from AI processing */
export type ImageTranscriptionResult = {
  __typename?: 'ImageTranscriptionResult';
  /** Confidence score (0-1) for transcription accuracy */
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Extracted text or AI interpretation */
  content: Scalars['String']['output'];
  /** Filename if provided */
  fileName?: Maybe<Scalars['String']['output']>;
  /** Transcription mode used */
  mode: ImageTranscriptionMode;
  /** Any warnings or limitations detected */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type ImpersonateUser = {
  __typename?: 'ImpersonateUser';
  accessToken: Scalars['String']['output'];
  /** Original admin session token to return to admin mode */
  adminSessionToken: Scalars['String']['output'];
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

export type ImpersonateUserResponse = Error | ImpersonateUser;

export type ImportClientsCSV = {
  __typename?: 'ImportClientsCSV';
  errors: Array<ClientImportError>;
  message: Scalars['String']['output'];
  successfulImports: Array<SuccessfulClientImport>;
  totalRows: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for importing client accounts via CSV */
export type ImportClientsCSVInput = {
  /** Optional mapping of CSV columns to client/property fields */
  columnMapping?: InputMaybe<ClientCSVColumnMapping>;
  /** CSV file content with client and property data */
  csvContent: Scalars['String']['input'];
};

export type ImportClientsCSVJob = {
  __typename?: 'ImportClientsCSVJob';
  backgroundJobId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ImportClientsCSVJobResponse = Error | ImportClientsCSVJob;

export type ImportClientsCSVResponse = Error | ImportClientsCSV;

export type ImportError = {
  __typename?: 'ImportError';
  field?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  row: Scalars['Int']['output'];
};

export type ImportServiceItemsCSV = {
  __typename?: 'ImportServiceItemsCSV';
  errors?: Maybe<Array<ImportError>>;
  message: Scalars['String']['output'];
  successfulImports: Array<SuccessfulImport>;
  totalItems: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for importing service items via CSV */
export type ImportServiceItemsCSVInput = {
  /** Optional mapping of CSV columns to service item fields */
  columnMapping?: InputMaybe<ServiceItemCSVColumnMapping>;
  /** CSV file content */
  csvContent: Scalars['String']['input'];
};

export type ImportServiceItemsCSVJob = {
  __typename?: 'ImportServiceItemsCSVJob';
  backgroundJobId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ImportServiceItemsCSVJobResponse = Error | ImportServiceItemsCSVJob;

export type ImportServiceItemsCSVResponse = Error | ImportServiceItemsCSV;

export type InitiateQuickBooksOAuth = {
  __typename?: 'InitiateQuickBooksOAuth';
  authUrl: Scalars['String']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type InitiateQuickBooksOAuthResponse = Error | InitiateQuickBooksOAuth;

export type InvalidateEntityCache = {
  __typename?: 'InvalidateEntityCache';
  account_id: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  entityType: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type InvalidateEntityCacheResponse = Error | InvalidateEntityCache;

export type Invoice = Timestamps & {
  __typename?: 'Invoice';
  account_id: Scalars['ID']['output'];
  appointmentName?: Maybe<Scalars['String']['output']>;
  appointment_id?: Maybe<Scalars['ID']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  balanceDue?: Maybe<Scalars['Int']['output']>;
  billingInfo?: Maybe<BillingInfo>;
  chat?: Maybe<Chat>;
  chat_id?: Maybe<Scalars['ID']['output']>;
  client?: Maybe<ClientAccount>;
  clientMessage?: Maybe<Scalars['String']['output']>;
  client_account_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  depositRequired?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  dueDate?: Maybe<Scalars['Date']['output']>;
  dueDateTerms?: Maybe<DueDateTerms>;
  dueDateType?: Maybe<DueDateTerms>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isPastDue?: Maybe<Scalars['Boolean']['output']>;
  issueDate?: Maybe<Scalars['Date']['output']>;
  jobName?: Maybe<Scalars['String']['output']>;
  job_id?: Maybe<Scalars['ID']['output']>;
  messages?: Maybe<Array<Message>>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Note>>;
  payments?: Maybe<Array<Payment>>;
  property?: Maybe<Property>;
  property_id?: Maybe<Scalars['ID']['output']>;
  serviceItems?: Maybe<Array<InvoiceServiceItem>>;
  serviceProvider?: Maybe<ServiceProviderPublicProfile>;
  status: InvoiceStatus;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  taxRate?: Maybe<Scalars['Int']['output']>;
  taxRateName?: Maybe<Scalars['String']['output']>;
  taxableTotal?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPaid?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Invoice metrics */
export type InvoiceMetrics = {
  __typename?: 'InvoiceMetrics';
  /** Average invoice value */
  averageValue: Scalars['Float']['output'];
  /** Total count of invoices */
  count: Scalars['Int']['output'];
  /** Maximum invoice value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum invoice value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Status breakdown */
  statusBreakdown: Array<StatusCount>;
  /** Total invoice value */
  totalValue: Scalars['Float']['output'];
};

export type InvoicePaymentInfo = {
  __typename?: 'InvoicePaymentInfo';
  canAcceptPayment: Scalars['Boolean']['output'];
  clientName: Scalars['String']['output'];
  connectStatus?: Maybe<SPStripeApplicationStatus>;
  invoiceId: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  paymentMethods: Array<Scalars['String']['output']>;
  remainingBalance: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type InvoiceServiceItem = IServiceItem &
  Timestamps & {
    __typename?: 'InvoiceServiceItem';
    account_id: Scalars['ID']['output'];
    adt?: Maybe<Scalars['String']['output']>;
    attachments?: Maybe<Array<Attachment>>;
    availableQty: Scalars['Int']['output'];
    checklist_id?: Maybe<Scalars['ID']['output']>;
    color?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['Date']['output'];
    description?: Maybe<Scalars['String']['output']>;
    groups?: Maybe<Array<GroupMinimum>>;
    id: Scalars['ID']['output'];
    invoiceDescription?: Maybe<Scalars['String']['output']>;
    invoiceName?: Maybe<Scalars['String']['output']>;
    invoiceUnitRetailPrice?: Maybe<Scalars['Float']['output']>;
    /** inherited from service item - not used */
    isArchived: Scalars['Boolean']['output'];
    isInUse: Scalars['Boolean']['output'];
    isInventoryDisabled: Scalars['Boolean']['output'];
    /** Indicates if the record was created via Quick Add */
    isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
    isShowNewService: Scalars['Boolean']['output'];
    isShowOnlineBooking: Scalars['Boolean']['output'];
    isTaxable: Scalars['Boolean']['output'];
    location?: Maybe<Scalars['String']['output']>;
    manufacturer?: Maybe<Manufacturer>;
    manufacturerModelNumber?: Maybe<Scalars['String']['output']>;
    manufacturer_id?: Maybe<Scalars['ID']['output']>;
    name: Scalars['String']['output'];
    order?: Maybe<Scalars['Int']['output']>;
    /** URL of the service item image. */
    photoUrl?: Maybe<Scalars['String']['output']>;
    quantityLaborHours?: Maybe<Scalars['Int']['output']>;
    quantityLaborMinutes?: Maybe<Scalars['Int']['output']>;
    quantityMaterial?: Maybe<Scalars['Int']['output']>;
    quantityOnHand: Scalars['Int']['output'];
    reorderLevel: Scalars['Int']['output'];
    reservedInEstimates: Scalars['Int']['output'];
    reservedInJobs: Scalars['Int']['output'];
    service_item_id: Scalars['ID']['output'];
    size?: Maybe<Scalars['String']['output']>;
    sku: Scalars['String']['output'];
    tags?: Maybe<Array<Scalars['String']['output']>>;
    type: ServiceItemType;
    unitCost: Scalars['Float']['output'];
    unitOfMeasure?: Maybe<UnitOfMeasure>;
    unitRetailPrice: Scalars['Float']['output'];
    upc?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['Date']['output']>;
    vendor?: Maybe<Vendor>;
    vendorSku?: Maybe<Scalars['String']['output']>;
    vendor_id?: Maybe<Scalars['ID']['output']>;
  };

/** Expected input for an invoice line item. */
export type InvoiceServiceItemInput = {
  invoiceDescription?: InputMaybe<Scalars['String']['input']>;
  invoiceName?: InputMaybe<Scalars['String']['input']>;
  invoiceUnitRetailPrice?: InputMaybe<Scalars['Float']['input']>;
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  quantityLaborHours?: InputMaybe<Scalars['Int']['input']>;
  quantityLaborMinutes?: InputMaybe<Scalars['Int']['input']>;
  quantityMaterial?: InputMaybe<Scalars['Int']['input']>;
  service_item_id: Scalars['ID']['input'];
};

/** Options to set an invoice status */
export enum InvoiceStatus {
  /** Initial state - invoice can be edited and modified */
  Draft = 'DRAFT',
  /** Invoice is fully paid and completed */
  Paid = 'PAID',
  /** Payment is being processed through payment gateway */
  PaymentInProgress = 'PAYMENT_IN_PROGRESS',
  /** Invoice has been sent to client for review */
  Sent = 'SENT',
  /** Client has viewed the invoice */
  Viewed = 'VIEWED',
}

export enum InvoicesSortBy {
  CreatedAt = 'CREATED_AT',
  DueDate = 'DUE_DATE',
  InvoiceNumber = 'INVOICE_NUMBER',
  Status = 'STATUS',
  TotalAmount = 'TOTAL_AMOUNT',
  UpdatedAt = 'UPDATED_AT',
}

export type Job = Timestamps & {
  __typename?: 'Job';
  account_id: Scalars['ID']['output'];
  alternateBillingInfo?: Maybe<BillingInfo>;
  appointment_id?: Maybe<Scalars['ID']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  billToClient?: Maybe<ClientAccount>;
  chat?: Maybe<Chat>;
  chat_id?: Maybe<Scalars['ID']['output']>;
  checklist?: Maybe<ChecklistSaved>;
  checklist_id?: Maybe<Scalars['ID']['output']>;
  client?: Maybe<ClientAccount>;
  client_account_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  crew?: Maybe<Crew>;
  crew_id?: Maybe<Scalars['ID']['output']>;
  depositRequired?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  estimate_id?: Maybe<Scalars['ID']['output']>;
  estimatedHours?: Maybe<Scalars['Float']['output']>;
  /** Estimated time of arrival for crew to reach job location */
  eta?: Maybe<Duration>;
  /** Message explaining ETA status or why it's unavailable */
  etaMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the client has skipped leaving feedback for this job */
  feedbackSkipped?: Maybe<Scalars['Boolean']['output']>;
  geoCoordinates?: Maybe<GeoLatLng>;
  /** Whether this instance has an availability conflict */
  hasAvailabilityConflict?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invoices?: Maybe<Array<Invoice>>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isPriority?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this job is a recurring template that generates instances */
  isRecurringTemplate?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<Message>>;
  /** Whether this instance has been modified from its template */
  modifiedFromTemplate?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Note>>;
  /** The original date/time calculated by the RRULE before any modifications */
  originalScheduledDate?: Maybe<Scalars['Date']['output']>;
  overrideAvailability?: Maybe<Scalars['Boolean']['output']>;
  /** Reference to parent template job if this is a recurring instance */
  parent_job_id?: Maybe<Scalars['ID']['output']>;
  property?: Maybe<Property>;
  property_id?: Maybe<Scalars['ID']['output']>;
  recurringSchedule: RecurringSchedule;
  /** RFC 5545 RRULE string defining the recurrence pattern */
  rruleString?: Maybe<Scalars['String']['output']>;
  scheduledStartDatetime?: Maybe<Scalars['Date']['output']>;
  scheduledStopDatetime?: Maybe<Scalars['Date']['output']>;
  /** Whether this job has been sent to the client */
  sent?: Maybe<Scalars['Boolean']['output']>;
  /** Optional end date for the recurring series */
  seriesEndDate?: Maybe<Scalars['Date']['output']>;
  serviceItems?: Maybe<Array<JobServiceItem>>;
  serviceProvider?: Maybe<ServiceProviderPublicProfile>;
  /** Whether to skip jobs on account holidays */
  skipAccountHolidays?: Maybe<Scalars['Boolean']['output']>;
  status: JobStatus;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  taxRate?: Maybe<Scalars['Int']['output']>;
  taxRateName?: Maybe<Scalars['String']['output']>;
  taxableTotal?: Maybe<Scalars['Int']['output']>;
  timesheetEntries?: Maybe<Array<TimesheetEntry>>;
  timesheetStats?: Maybe<TimesheetStats>;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Job completion metrics for productivity analysis */
export type JobCompletionMetrics = {
  __typename?: 'JobCompletionMetrics';
  /** Average jobs completed per time period */
  avgJobsPerPeriod: Scalars['Float']['output'];
  /** Completion rate as a percentage */
  completionRate: Scalars['Float']['output'];
  /** Total number of assigned jobs */
  totalAssigned: Scalars['Int']['output'];
  /** Total number of completed jobs */
  totalCompleted: Scalars['Int']['output'];
};

/** Job hours breakdown for a crew user */
export type JobHours = {
  __typename?: 'JobHours';
  /** Time spent en route to jobs */
  enRouteTime: Scalars['Float']['output'];
  /** Time spent on job preparation */
  jobPrepTime: Scalars['Float']['output'];
  /** Time spent on job work */
  jobTime: Scalars['Float']['output'];
  /** Total job hours */
  total: Scalars['Float']['output'];
};

/** Job metrics with financial data */
export type JobMetrics = {
  __typename?: 'JobMetrics';
  /** Average job value */
  averageValue?: Maybe<Scalars['Float']['output']>;
  /** Completion rate as percentage */
  completionRate?: Maybe<Scalars['Float']['output']>;
  /** Total count of jobs */
  count: Scalars['Int']['output'];
  /** Number of jobs with service items */
  jobsWithServiceItems?: Maybe<Scalars['Int']['output']>;
  /** Status breakdown */
  statusBreakdown: Array<StatusCount>;
  /** Total value of all jobs */
  totalValue?: Maybe<Scalars['Float']['output']>;
};

/** Flexible response item that adapts to crew vs user grouping for job productivity */
export type JobProductivityReportItem = {
  __typename?: 'JobProductivityReportItem';
  /** Job completion metrics */
  completionMetrics: JobCompletionMetrics;
  /** Crew object - populated when type = 'CREW' */
  crew?: Maybe<Crew>;
  /** Entity ID - user_id or crew_id depending on groupBy */
  id: Scalars['ID']['output'];
  /** Member breakdown - populated when groupBy = 'CREW_USER' */
  memberBreakdown?: Maybe<Array<JobProductivityReportItem>>;
  /** Entity name - userFullName or crew name */
  name: Scalars['String']['output'];
  /** Productivity statistics */
  productivityStats: ProductivityStats;
  /** Time period breakdown for trend analysis */
  timePeriodBreakdown: Array<TimePeriodBreakdown>;
  /** Entity type - 'USER' or 'CREW' */
  type: Scalars['String']['output'];
  /** User object - populated when type = 'USER' */
  user?: Maybe<User>;
};

export type JobServiceItem = IServiceItem &
  Timestamps & {
    __typename?: 'JobServiceItem';
    account_id: Scalars['ID']['output'];
    adt?: Maybe<Scalars['String']['output']>;
    attachments?: Maybe<Array<Attachment>>;
    availableQty: Scalars['Int']['output'];
    checklist_id?: Maybe<Scalars['ID']['output']>;
    color?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['Date']['output'];
    description?: Maybe<Scalars['String']['output']>;
    groups?: Maybe<Array<GroupMinimum>>;
    id: Scalars['ID']['output'];
    isArchived: Scalars['Boolean']['output'];
    isInUse: Scalars['Boolean']['output'];
    isInventoryDisabled: Scalars['Boolean']['output'];
    /** Indicates if the record was created via Quick Add */
    isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
    isShowNewService: Scalars['Boolean']['output'];
    isShowOnlineBooking: Scalars['Boolean']['output'];
    isTaxable: Scalars['Boolean']['output'];
    jobDescription?: Maybe<Scalars['String']['output']>;
    jobName?: Maybe<Scalars['String']['output']>;
    jobUnitRetailPrice?: Maybe<Scalars['Float']['output']>;
    location?: Maybe<Scalars['String']['output']>;
    manufacturer?: Maybe<Manufacturer>;
    manufacturerModelNumber?: Maybe<Scalars['String']['output']>;
    manufacturer_id?: Maybe<Scalars['ID']['output']>;
    name: Scalars['String']['output'];
    order?: Maybe<Scalars['Int']['output']>;
    /** URL of the service item image. */
    photoUrl?: Maybe<Scalars['String']['output']>;
    quantityLaborHours?: Maybe<Scalars['Int']['output']>;
    quantityLaborMinutes?: Maybe<Scalars['Int']['output']>;
    quantityMaterial?: Maybe<Scalars['Int']['output']>;
    quantityOnHand: Scalars['Int']['output'];
    reorderLevel: Scalars['Int']['output'];
    reservedInEstimates: Scalars['Int']['output'];
    reservedInJobs: Scalars['Int']['output'];
    service_item_id: Scalars['ID']['output'];
    size?: Maybe<Scalars['String']['output']>;
    sku: Scalars['String']['output'];
    tags?: Maybe<Array<Scalars['String']['output']>>;
    type: ServiceItemType;
    unitCost: Scalars['Float']['output'];
    unitOfMeasure?: Maybe<UnitOfMeasure>;
    unitRetailPrice: Scalars['Float']['output'];
    upc?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['Date']['output']>;
    vendor?: Maybe<Vendor>;
    vendorSku?: Maybe<Scalars['String']['output']>;
    vendor_id?: Maybe<Scalars['ID']['output']>;
  };

/** Expected input for an job line item. */
export type JobServiceItemInput = {
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  jobName?: InputMaybe<Scalars['String']['input']>;
  jobUnitRetailPrice?: InputMaybe<Scalars['Float']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  quantityLaborHours?: InputMaybe<Scalars['Int']['input']>;
  quantityLaborMinutes?: InputMaybe<Scalars['Int']['input']>;
  quantityMaterial?: InputMaybe<Scalars['Int']['input']>;
  service_item_id: Scalars['ID']['input'];
};

export enum JobStatus {
  /** Crew has arrived at the job location */
  Arrived = 'ARRIVED',
  /** Job has been cancelled and will not be completed */
  Canceled = 'CANCELED',
  /** Job has been finished and all work completed */
  Completed = 'COMPLETED',
  /** Job has been confirmed by client */
  Confirmed = 'CONFIRMED',
  /** Job is in draft state and being created */
  Draft = 'DRAFT',
  /** Crew is traveling to the job location */
  EnRoute = 'EN_ROUTE',
  /** Job work has been temporarily paused */
  Paused = 'PAUSED',
  /** Job has been sent and is awaiting client confirmation */
  Pending = 'PENDING',
  /** Job is scheduled with a crew and ready to begin */
  Scheduled = 'SCHEDULED',
  /** Job has begun and work is in progress */
  Started = 'STARTED',
}

/** Represents job counts by status for reporting purposes. */
export type JobStatusCount = {
  __typename?: 'JobStatusCount';
  /** Number of jobs with this status. */
  count: Scalars['Int']['output'];
  /** The job status. */
  status: JobStatus;
};

export enum JobsSortBy {
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  ScheduledStartDate = 'SCHEDULED_START_DATE',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT',
}

/** Known login device tracked for account security. */
export type KnownDevice = {
  __typename?: 'KnownDevice';
  deviceName?: Maybe<Scalars['String']['output']>;
  fingerprint: Scalars['String']['output'];
  firstSeenAt?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  isTrusted: Scalars['Boolean']['output'];
  lastSeenAt?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type KnownDevicesResponse = Error | GetKnownDevices;

export type LegacyApplicationFee = {
  __typename?: 'LegacyApplicationFee';
  baseFeeFixed?: Maybe<Scalars['Float']['output']>;
  baseFeePercentage?: Maybe<Scalars['Float']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type LegacyApplicationFeeInput = {
  baseFeeFixed?: InputMaybe<Scalars['Float']['input']>;
  baseFeePercentage?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Expected input when linking an attachment to an entity. */
export type LinkAttachmentInput = {
  base64: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type LinkServiceProvider = {
  __typename?: 'LinkServiceProvider';
  isLinked: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Input for linking a service provider to a client account using client code */
export type LinkServiceProviderInput = {
  clientCode: Scalars['String']['input'];
};

export type LinkServiceProviderResponse = Error | LinkServiceProvider;

/** Response when a WhatsApp number is successfully linked */
export type LinkWhatsApp = {
  __typename?: 'LinkWhatsApp';
  message: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
  /** The verified WhatsApp number now linked to the user */
  whatsappNumber: Scalars['String']['output'];
};

/** Input for linking a WhatsApp number to the authenticated user's account */
export type LinkWhatsAppInput = {
  /** WhatsApp phone number in E.164 format (e.g., +15106378251) */
  whatsappNumber: Scalars['String']['input'];
};

export type LinkWhatsAppResponse = Error | LinkWhatsApp;

export type LinkedServiceProviderAccount = {
  __typename?: 'LinkedServiceProviderAccount';
  account_id: Scalars['ID']['output'];
  chat_id?: Maybe<Scalars['ID']['output']>;
  inviteHistory: Array<ClientServiceProviderInviteHistory>;
  isBlocked?: Maybe<Scalars['Boolean']['output']>;
  isPending?: Maybe<Scalars['Boolean']['output']>;
  linkState: ClientServiceProviderLinkState;
  serviceProviderAccount?: Maybe<ServiceProviderAccount>;
};

export type List = Timestamps & {
  __typename?: 'List';
  createdAt: Scalars['Date']['output'];
  data?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** ENUM for Locale */
export enum Locale {
  /** English language locale */
  En = 'EN',
  /** Spanish language locale */
  Es = 'ES',
}

/** Input for updating user location */
export type LocationInput = {
  /** GPS latitude coordinate */
  latitude: Scalars['Float']['input'];
  /** GPS longitude coordinate */
  longitude: Scalars['Float']['input'];
};

/** Represents unique cities and states from client properties and billing information */
export type Locations = {
  __typename?: 'Locations';
  /** List of unique cities across all client properties and billing addresses */
  cities: Array<Scalars['String']['output']>;
  /** List of unique states across all client properties and billing addresses */
  states: Array<Scalars['String']['output']>;
};

export type Manufacturer = Timestamps & {
  __typename?: 'Manufacturer';
  accountNumber?: Maybe<Scalars['String']['output']>;
  account_id: Scalars['ID']['output'];
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  primaryContactEmail?: Maybe<Scalars['String']['output']>;
  primaryContactName?: Maybe<Scalars['String']['output']>;
  primaryContactPhone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  supportEmail?: Maybe<Scalars['String']['output']>;
  supportPhone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum ManufacturersSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type MarkAllAsRead = {
  __typename?: 'MarkAllAsRead';
  message: Scalars['String']['output'];
  updatedCount: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type MarkAllAsReadInput = {
  /** Optional filter for which notifications to mark */
  filter?: InputMaybe<NotificationFilter>;
};

export type MarkAllAsReadResponse = Error | MarkAllAsRead;

export type MarkAsRead = {
  __typename?: 'MarkAsRead';
  message: Scalars['String']['output'];
  notification: Notification;
  version: Scalars['String']['output'];
};

export type MarkAsReadInput = {
  /** Notification ID to mark as read */
  notificationId: Scalars['ID']['input'];
};

export type MarkAsReadResponse = Error | MarkAsRead;

export type MarkEstimateAsViewed = {
  __typename?: 'MarkEstimateAsViewed';
  estimate_id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
  viewed: Scalars['Boolean']['output'];
};

/** Expected input to mark an estimate as viewed. */
export type MarkEstimateAsViewedInput = {
  id: Scalars['ID']['input'];
};

export type MarkEstimateAsViewedResponse = Error | MarkEstimateAsViewed;

/** Response for marking an IVR voicemail as listened */
export type MarkIVRVoicemailListened = {
  __typename?: 'MarkIVRVoicemailListened';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
  voicemail: IVRVoicemail;
};

export type MarkIVRVoicemailListenedInput = {
  id: Scalars['ID']['input'];
};

export type MarkIVRVoicemailListenedResponse = Error | MarkIVRVoicemailListened;

export type MemoryUsage = {
  __typename?: 'MemoryUsage';
  limit?: Maybe<Scalars['Int']['output']>;
  limitMB?: Maybe<Scalars['Float']['output']>;
  peak: Scalars['Int']['output'];
  percentage: Scalars['Float']['output'];
  used: Scalars['Int']['output'];
  usedMB: Scalars['Float']['output'];
};

export type Message = Timestamps & {
  __typename?: 'Message';
  attachments?: Maybe<Array<Attachment>>;
  chat_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  estimate_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['ID']['output']>;
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this message has been auto-translated */
  isTranslated?: Maybe<Scalars['Boolean']['output']>;
  job_id?: Maybe<Scalars['ID']['output']>;
  recipient_account_id: Scalars['ID']['output'];
  senderAccountName?: Maybe<Scalars['String']['output']>;
  senderAvatarUrl?: Maybe<Scalars['String']['output']>;
  senderFirstName: Scalars['String']['output'];
  senderLastName: Scalars['String']['output'];
  sender_account_id: Scalars['ID']['output'];
  sender_user_id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  /** Locale the message was translated to (e.g., EN, ES) */
  translatedLocale?: Maybe<Scalars['String']['output']>;
  /** Translated text for recipients with a different locale than the sender */
  translatedText?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum MessagesSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type MobileAppVersion = {
  __typename?: 'MobileAppVersion';
  platform: MobilePlatform;
  version: Scalars['String']['output'];
};

/**
 * Supported mobile platforms for the application.
 * Used to track app versions and platform-specific features.
 */
export enum MobilePlatform {
  /** Google Android platform. */
  Android = 'ANDROID',
  /** Apple iOS platform (iPhone and iPad). */
  Ios = 'IOS',
}

/** Expected input to complete a mobile password reset */
export type MobileResetPasswordInput = {
  confirmNewPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** Scope of modification for recurring event instances */
export enum ModificationScope {
  /** Modify all instances in the series */
  All = 'ALL',
  /** Modify this instance and all future instances */
  ThisAndFuture = 'THIS_AND_FUTURE',
  /** Modify only this single instance */
  ThisOnly = 'THIS_ONLY',
}

export type ModifySubscriptionPlan = {
  __typename?: 'ModifySubscriptionPlan';
  account?: Maybe<ServiceProviderAccount>;
  message: Scalars['String']['output'];
};

export type ModifySubscriptionPlanInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  confirmationAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationNote?: InputMaybe<Scalars['String']['input']>;
  downgradeAction?: InputMaybe<AdminPlanDowngradeAction>;
  planCode: Scalars['String']['input'];
  seats?: InputMaybe<Scalars['Int']['input']>;
};

export type ModifySubscriptionPlanResponse = Error | ModifySubscriptionPlan;

export type Mutation = {
  __typename?: 'Mutation';
  /** Client-side: consume an invite magic-link token and flip the matching pending linkedServiceProviders entry to isPending=false (confirmed). */
  acceptClientInvite: AcceptClientInviteResponse;
  /**
   * Record a manual credit (top-up) against the AI billing ledger. Admin-only.
   * Use this after topping up the Anthropic account externally, so the
   * internal ledger matches reality and alerts reset.
   */
  addAIBillingCredit: AddAIBillingCreditResponse;
  /** Admin approve Connect application */
  adminApproveConnectApplication: AdminApproveConnectApplicationResponse;
  /** Admin decline Connect application */
  adminDeclineConnectApplication: AdminDeclineConnectApplicationResponse;
  /** Admin user login */
  adminLogin: AdminLoginResponse;
  /** Admin user logout */
  adminLogout: AdminLogoutResponse;
  /** Provision a dedicated phone number for an SP (Admin only) */
  adminProvisionDedicatedNumber: AdminProvisionDedicatedNumberResponse;
  /** Refresh admin access token */
  adminRefreshToken: AdminRefreshTokenResponse;
  /** Release a dedicated phone number from an SP (Admin only) */
  adminReleaseDedicatedNumber: AdminReleaseDedicatedNumberResponse;
  /** Reset an SP's custom IVR greeting to default (Admin only) */
  adminResetIvrGreeting: AdminResetIvrGreetingResponse;
  /** Complete password reset using token */
  adminResetPasswordWithToken: ResetPasswordWithTokenResponse;
  /** Archive a notification */
  archiveNotification: ArchiveNotificationResponse;
  /** Bulk delete service items from within the service provider admin. */
  bulkDeleteServiceItems: BulkDeleteServiceItemsResponse;
  /** Bulk update service provider fees (Admin only) */
  bulkUpdateSPFees: BulkUpdateSPFeesResponse;
  /** Bulk Update Service Items */
  bulkUpdateServiceItemsCSV: BulkUpdateServiceItemsCSVResponse;
  /** Cancel a running or queued QuickBooks import job for this account */
  cancelQuickBooksImport: CancelQuickBooksImportResponse;
  /** Cancel a QuickBooks setup: delete imported clients/service-items (skip those with downstream work) and fully disconnect from QuickBooks Online. */
  cancelQuickBooksSetup: CancelQuickBooksSetupResponse;
  /** Clean test db */
  cleanTestDB: CleanTestDBResponse;
  /** Convert an IVR callback lead (non-client caller) into a client account */
  convertIVRLeadToClient: ConvertIVRLeadToClientResponse;
  /** Create sample data for service provider account including default user. Returns 503 error if worker unavailable. */
  createAccountSampleData: CreateAccountSampleDataResponse;
  /** Create a new admin user */
  createAdminUser: CreateAdminUserResponse;
  createAppointment: CreateUpdateAppointmentResponse;
  /** Create an attachment. */
  createAttachment: CreateAttachmentResponse;
  /** Create a chat. */
  createChat: CreateChatResponse;
  /** Create a checklist. */
  createChecklist: CreateUpdateChecklistResponse;
  /** Create a checklist entry. */
  createChecklistEntry: CreateUpdateChecklistEntryResponse;
  /** Create a client account from within the service provider admin. */
  createClient: CreateClientResponse;
  /** Create a client account, user, and property in a single atomic transaction. All entities are created or none are. */
  createClientUserProperty: CreateClientUserPropertyResponse;
  /** Create a crew from within the service provider admin. */
  createCrew: CreateUpdateCrewResponse;
  /** Create an estimate from within the service provider admin. */
  createEstimate: CreateUpdateEstimateResponse;
  createEstimateFromAppointment: CreateEstimateFromAppointmentResponse;
  /** Create a feedback entry. */
  createFeedbackEntry: CreateUpdateFeedbackEntryResponse;
  /** Create a Group */
  createGroup: CreateUpdateGroupResponse;
  /** Create an invoice from within the service provider admin. */
  createInvoice: CreateUpdateInvoiceResponse;
  createInvoiceFromAppointment: CreateInvoiceFromAppointmentResponse;
  /** Create an invoice from a job from within the service provider admin. */
  createInvoiceFromJob: CreateUpdateInvoiceResponse;
  /** Create invoice payment session */
  createInvoicePaymentSession: CreateInvoicePaymentSessionResponse;
  /** Create a job from within the service provider admin. */
  createJob: CreateUpdateJobResponse;
  createJobFromAppointment: CreateJobFromAppointmentResponse;
  /** Convert an estimate to a job from within the service provider admin. */
  createJobFromEstimate: CreateUpdateJobResponse;
  /** Create a manufacturer */
  createManufacturer: CreateUpdateManufacturerResponse;
  /** Create a message. */
  createMessage: CreateUpdateMessageResponse;
  /** Create a note. */
  createNote: CreateUpdateNoteResponse;
  /** Create a payment for an invoice */
  createPayment: CreateUpdatePaymentResponse;
  /** Create a property. */
  createProperty: CreateUpdatePropertyResponse;
  /** Create a service item from within the service provider admin. */
  createServiceItem: CreateUpdateServiceItemResponse;
  /** Create a user from within service provider admin */
  createServiceProviderUser: CreateUpdateUserResponse;
  /** Create a tax rate. */
  createTaxRate: CreateUpdateTaxRateResponse;
  /** Create a timesheet. */
  createTimesheet: CreateUpdateTimesheetResponse;
  /** Create a timesheet entry. */
  createTimesheetEntry: CreateUpdateTimesheetEntryResponse;
  /** Create a vendor */
  createVendor: CreateUpdateVendorResponse;
  /** Delete only sample data created by createAccountSampleData (preserves other account data). Returns 503 error if worker unavailable. */
  deleteAccountSampleData: DeleteAccountSampleDataResponse;
  /** Delete an admin user */
  deleteAdminUser: DeleteAdminUserResponse;
  /** Force delete all account data - DANGEROUS OPERATION that removes all business data while preserving account settings and subscription data */
  deleteAllAccountData: DeleteAllAccountDataResponse;
  deleteAppointment: DeleteAppointmentResponse;
  /** Delete an attachment. */
  deleteAttachment: DeleteAttachmentResponse;
  /** Delete a checklist. */
  deleteChecklist: DeleteChecklistResponse;
  /** Delete a checklist entry. */
  deleteChecklistEntry: DeleteChecklistEntryResponse;
  /** Delete a client account from within the service provider admin or client admin. */
  deleteClientAccount: DeleteClientAccountResponse;
  /** Delete a crew from within the service provider admin. */
  deleteCrew: DeleteCrewResponse;
  /** Delete an estimate from within the service provider admin. */
  deleteEstimate: DeleteEstimateResponse;
  /** Delete a feedback entry. */
  deleteFeedbackEntry: DeleteFeedbackEntryResponse;
  /** Delete a Group */
  deleteGroup: DeleteGroupResponse;
  /** Soft-delete an IVR voicemail */
  deleteIVRVoicemail: DeleteIVRVoicemailResponse;
  /** Delete an invoice from within the service provider admin. */
  deleteInvoice: DeleteInvoiceResponse;
  /** Delete a job from within the service provider admin. */
  deleteJob: DeleteJobResponse;
  /** Delete a manufacturer */
  deleteManufacturer: DeleteManufacturerResponse;
  /** Delete a message. */
  deleteMessage: DeleteMessageResponse;
  /** Delete a note. */
  deleteNote: DeleteNoteResponse;
  /** Delete a notification */
  deleteNotification: DeleteNotificationResponse;
  /** Delete a payment */
  deletePayment: DeletePaymentResponse;
  /** Delete a property. */
  deleteProperty: DeletePropertyResponse;
  /** Delete a service item from within the service provider admin. */
  deleteServiceItem: DeleteServiceItemResponse;
  /** Delete a service provider account from within the service provider admin. */
  deleteServiceProviderAccount: DeleteServiceProviderAccountResponse;
  /** Delete a tax rate. */
  deleteTaxRate: DeleteTaxRateResponse;
  /** Delete timesheet entries by date. */
  deleteTimeSheetEntriesByDate: DeleteTimesheetEntriesByDateResponse;
  /** Delete a timesheet. */
  deleteTimesheet: DeleteTimesheetResponse;
  /** Delete a timesheet entry. */
  deleteTimesheetEntry: DeleteTimesheetEntryResponse;
  /** Delete a vendor */
  deleteVendor: DeleteVendorResponse;
  /** Disconnect from QuickBooks Online */
  disconnectQuickBooks: DisconnectQuickBooksResponse;
  /** Duplicate a checklist. */
  duplicateChecklist: DuplicateChecklistResponse;
  /** Duplicate an estimate from within the service provider admin. */
  duplicateEstimate: CreateUpdateEstimateResponse;
  /** Duplicate job with optional custom scheduled dates. */
  duplicateJob: CreateUpdateJobResponse;
  /** End user impersonation and return to admin mode */
  endImpersonation: EndImpersonationResponse;
  /** Enroll a service-provider account in the beta lifecycle after an agreement is signed (Admin only) */
  enrollBetaLifecycle: BetaLifecycleEnrollmentResponse;
  /** Authenticate using access link token */
  exchangeAccessLinkToken: ExchangeAccessLinkTokenResponse;
  /** Exchange a client update token for a scoped session to update profile data */
  exchangeClientUpdateToken: ExchangeClientUpdateTokenResponse;
  /** Exchange link token for access token */
  exchangeLinkToken?: Maybe<ExchangeLinkTokenResponse>;
  /** Authenticate using magic link token from notification and get redirect path */
  exchangeMagicLinkToken: ExchangeMagicLinkTokenResponse;
  /** Flush cache data with flexible scoping (single account, multiple accounts, all accounts, or admin cache) */
  flushCache: FlushCacheResponse;
  /** Flush geocoding cache to clear cached geocoding results (local env or admin only) */
  flushGeocodingCache: FlushGeocodingCacheResponse;
  /** Ignore a sync error */
  ignoreQuickBooksSyncItem: IgnoreQuickBooksSyncItemResponse;
  /** Impersonate a regular user (admin only) */
  impersonateUser: ImpersonateUserResponse;
  /** Import client accounts from CSV with billing info and properties */
  importClientsCSV: ImportClientsCSVResponse;
  /** Import client accounts from CSV as background job (upsert - inserts new, updates existing by email) */
  importClientsCSVJob: ImportClientsCSVJobResponse;
  /** Import Service Items */
  importServiceItemsCSV: ImportServiceItemsCSVResponse;
  /** Import Service Items as background job (upsert - inserts new, updates existing by SKU) */
  importServiceItemsCSVJob: ImportServiceItemsCSVJobResponse;
  /** Initiate OAuth flow with QuickBooks Online */
  initiateQuickBooksOAuth: InitiateQuickBooksOAuthResponse;
  /** Invalidate cache for a specific entity owned by the authenticated user */
  invalidateEntityCache: InvalidateEntityCacheResponse;
  /** Link a service provider to a client account using a client code */
  linkServiceProvider: LinkServiceProviderResponse;
  /** Link a WhatsApp number to the authenticated user (for WhatsApp channel access) */
  linkWhatsApp: LinkWhatsAppResponse;
  /** Mark all notifications as read */
  markAllNotificationsAsRead: MarkAllAsReadResponse;
  /** Mark an estimate as viewed by the client. */
  markEstimateAsViewed: MarkEstimateAsViewedResponse;
  /** Mark an IVR voicemail as listened */
  markIVRVoicemailListened: MarkIVRVoicemailListenedResponse;
  /** Mark notification as read */
  markNotificationAsRead: MarkAsReadResponse;
  /** Complete a mobile password reset without issuing an authenticated session */
  mobileResetPassword: ResetPasswordWithTokenResponse;
  modifySubscriptionPlan: ModifySubscriptionPlanResponse;
  /** Detect conflicts for a planned import without importing anything. Creates a PENDING_REVIEW job with CONFLICT sync logs the user can review and resolve. */
  prepareQuickBooksImport: PrepareQuickBooksImportResponse;
  /** Render selected notification templates for QA review */
  previewNotificationQa: NotificationQaPreviewResponse;
  /** Process invoice payment */
  processInvoicePayment: ProcessInvoicePaymentResponse;
  pushSyncAppointments: PushSyncAppointmentsResponse;
  /** Push-sync offline checklist changes to the server with conflict detection */
  pushSyncChecklists: PushSyncChecklistsResponse;
  /** Push-sync offline client account changes to the server with conflict detection */
  pushSyncClients: PushSyncClientsResponse;
  /** Push-sync offline crew changes to the server with per-record conflict detection */
  pushSyncCrews: PushSyncCrewsResponse;
  pushSyncEstimates: PushSyncEstimatesResponse;
  /** Push-sync offline group changes to the server with per-record conflict detection */
  pushSyncGroups: PushSyncGroupsResponse;
  pushSyncInvoices?: Maybe<PushSyncInvoicesResponse>;
  /** Push-sync offline job changes to the server with conflict detection */
  pushSyncJobs: PushSyncJobsResponse;
  pushSyncManufacturers: PushSyncManufacturersResponse;
  pushSyncPayments: PushSyncPaymentsResponse;
  pushSyncProperties?: Maybe<PushSyncPropertiesResponse>;
  pushSyncServiceItems?: Maybe<PushSyncServiceItemsResponse>;
  /** Push-sync offline TaxRate changes with durable conflict handling. */
  pushSyncTaxrates: PushSyncTaxratesResponse;
  pushSyncTimesheetEntries: PushSyncTimesheetEntriesResponse;
  pushSyncTimesheets: PushSyncTimesheetsResponse;
  pushSyncUsers: PushSyncUsersResponse;
  /** Push-sync offline vendor changes with per-record conflict detection */
  pushSyncVendors: PushSyncVendorsResponse;
  /** Refresh access token using a valid refresh token */
  refreshAccessToken: RefreshAccessTokenResponse;
  /** Refresh Connect account status */
  refreshConnectAccountStatus: RefreshConnectAccountStatusResponse;
  /** Re-run conflict detection on an existing PENDING_REVIEW import job, dropping any still-unresolved conflicts and replacing them with fresh results. */
  refreshQuickBooksImportPreview: RefreshQuickBooksImportPreviewResponse;
  /** Client-side: consume an invite magic-link token and remove the matching pending linkedServiceProviders entry (rejection). */
  rejectClientInvite: RejectClientInviteResponse;
  /** Remove an FCM device from push notifications */
  removeFCMDevice: RemoveFCMDeviceResponse;
  /** Remove the service item image. */
  removeServiceItemImage: RemoveServiceItemImageResponse;
  /** Remove the user's custom avatar and replace with default icon. */
  removeUserAvatar: RemoveUserAvatarResponse;
  /** Resend email verification to the current service provider user */
  resendEmailVerification: ResendEmailVerificationResponse;
  /** Reset admin user password */
  resetAdminUserPassword: ResetAdminUserPasswordResponse;
  /** Reset user password from sign-in page */
  resetUserPassword: ResetUserPasswordResponse;
  /** Resolve a QuickBooks sync conflict by choosing Keep DHS / Keep QBO / Skip */
  resolveQuickBooksConflict: ResolveQuickBooksConflictResponse;
  /** Retry a failed sync item */
  retryQuickBooksSyncItem: RetryQuickBooksSyncItemResponse;
  runBetaLifecycleForAccount: BetaLifecycleRunResponse;
  /** Enqueue a PENDING_REVIEW import job for execution. Resolved conflicts are honoured; remaining unresolved ones are skipped. */
  runQuickBooksImport: RunQuickBooksImportResponse;
  sendAppointment: SendAppointmentResponse;
  /** SP-side: send an invite (magic link email/SMS) to an existing client so they can approve linking this SP. Idempotent — resending refreshes the pending link and re-issues the magic link. */
  sendClientInvite: SendClientInviteResponse;
  /** Send an estimate from within the service provider admin. */
  sendEstimate: CreateUpdateEstimateResponse;
  /** Send an invoice from within the service provider admin. */
  sendInvoice: CreateUpdateInvoiceResponse;
  /** Send a job from within the service provider admin. */
  sendJob: CreateUpdateJobResponse;
  /** Send system maintenance notification to all users via SendGrid campaign (Admin only) */
  sendMaintenanceNotification: SendMaintenanceNotificationResponse;
  /** Queue a QA-marked notification for the supplied test recipients */
  sendNotificationQa: NotificationQaSendResponse;
  /** Manually send one onboarding email template to the current user */
  sendOnboardingEmailForCurrentUser: SendOnboardingEmailForCurrentUserResponse;
  /** Send a system announcement through the notification pipeline to all SP and CLIENT accounts (Admin only) */
  sendSystemAnnouncement: SendSystemAnnouncementResponse;
  /** Send typing indicator to a chat */
  sendTypingIndicator: SendTypingIndicatorResponse;
  /** Set the current user's onboarding day by adjusting the account trial start */
  setCurrentUserOnboardingDay: SetCurrentUserOnboardingDayResponse;
  /** Sign-in client from website */
  signInClient?: Maybe<SignInClientResponse>;
  /** Check a token for password reset */
  signInClientByToken?: Maybe<SignInClientResponse>;
  /** Sign in using Google - Client */
  signInGoogleClient?: Maybe<SignInClientResponse>;
  /** Sign in using Google - Service Provider */
  signInGoogleServiceProvider?: Maybe<SignInServiceProviderResponse>;
  /** Sign-in service provider from website */
  signInServiceProvider?: Maybe<SignInServiceProviderResponse>;
  /** Check a token for password reset */
  signInServiceProviderByToken?: Maybe<SignInServiceProviderResponse>;
  /** Sign-out client (deviceId for single device, logoutAllDevices for all devices) */
  signOutClient?: Maybe<SignOutClientResponse>;
  /** Sign-out service provider (deviceId for single device, logoutAllDevices for all devices) */
  signOutServiceProvider?: Maybe<SignOutServiceProviderResponse>;
  /** Create a client account from the website. */
  signUpClient: CreateClientExternalResponse;
  /** Sign-up a service provider from the website. */
  signUpServiceProvider: CreateServiceProviderResponse;
  /** Skip feedback for a job (client action). */
  skipJobFeedback: SkipJobFeedbackResponse;
  /** Snooze a notification */
  snoozeNotification: SnoozeNotificationResponse;
  /** Start Stripe Connect application process */
  startConnectApplication: StartConnectApplicationResponse;
  /** Start a timer for time tracking. */
  startTimer: StartTimerResponse;
  /** Stop any in-progress sample data creation or deletion job and clean up partial data. Returns 503 error if worker unavailable. */
  stopAccountSampleData: StopAccountSampleDataResponse;
  /** Stop a running timer for time tracking. */
  stopTimer: StopTimerResponse;
  /** Subscribe to beta updates mailing list (public endpoint, no authentication required) */
  subscribeMailingListBetaUpdates: SubscribeMailingListBetaUpdatesResponse;
  /** Stop an active timer and start a new timer for a job or appointment. */
  switchTimer: SwitchTimerResponse;
  /** Test Connect notification */
  testConnectNotification: TestConnectNotificationResponse;
  /** Test notification channels - creates test notification and sends to specified channels */
  testNotificationChannels: TestNotificationChannelsResponse;
  /** Manually trigger the learning cycle to analyze query history and promote frequently-used queries (local env or admin only) */
  triggerCacheLearningCycle: TriggerCacheLearningCycleResponse;
  /** Manually trigger cache prefresh to populate cache with global queries (local env or admin only) */
  triggerCachePrefresh: TriggerCachePrefreshResponse;
  /** Trigger first-time import from QuickBooks */
  triggerQuickBooksImport: TriggerQuickBooksImportResponse;
  /** Trigger sync of older items to QuickBooks */
  triggerQuickBooksSyncOlderItems: TriggerQuickBooksSyncOlderItemsResponse;
  /** Mark a known login device as trusted */
  trustKnownDevice: TrustKnownDeviceResponse;
  /** Unlink a service provider from a client account */
  unlinkServiceProvider: UnlinkServiceProviderResponse;
  /** Unlink WhatsApp number from the authenticated user */
  unlinkWhatsApp: UnlinkWhatsAppResponse;
  /** Unlock a locked admin user account */
  unlockAdminUser: UnlockAdminUserResponse;
  /** Update an existing admin user */
  updateAdminUser: UpdateAdminUserResponse;
  /** Update admin user password */
  updateAdminUserPassword: UpdateAdminUserPasswordResponse;
  updateAppointment: CreateUpdateAppointmentResponse;
  /** Record beta lifecycle trigger data for one enrolled service-provider account (Admin only) */
  updateBetaLifecycleEnrollment: BetaLifecycleEnrollmentResponse;
  /** Update a chat. */
  updateChat: UpdateChatResponse;
  /** Update a checklist. */
  updateChecklist: CreateUpdateChecklistResponse;
  /** Update a checklist entry. */
  updateChecklistEntry: CreateUpdateChecklistEntryResponse;
  /** Update the client account from service provider admin or client admin */
  updateClientAccount: UpdateClientAccountResponse;
  /** Update client account settings (CLIENT only) */
  updateClientAccountSettings: UpdateClientAccountSettingsResponse;
  /** Authenticated client/admin action to accept, decline, reopen, or block a client/service-provider relationship. */
  updateClientServiceProviderLinkState: UpdateClientServiceProviderLinkStateResponse;
  /** Update a client account, user, and/or property in a single atomic transaction. All updates succeed or all are rolled back. */
  updateClientUserProperty: UpdateClientUserPropertyResponse;
  /** Update Connect application status */
  updateConnectApplicationStatus: UpdateConnectApplicationStatusResponse;
  /** Update Connect fee configuration */
  updateConnectFeeConfiguration: UpdateConnectFeeConfigurationResponse;
  /** Update a crew from within the service provider admin. */
  updateCrew: CreateUpdateCrewResponse;
  /** Update an estimate from within the service provider admin. */
  updateEstimate: CreateUpdateEstimateResponse;
  /** Update FCM device information */
  updateFCMDevice: UpdateFCMDeviceResponse;
  /** Update a feedback entry. */
  updateFeedbackEntry: CreateUpdateFeedbackEntryResponse;
  /** Update global fee defaults that apply to new accounts (Admin only) */
  updateGlobalFeeDefaults: UpdateGlobalFeeDefaultsResponse;
  /** Update global beta-program settings for an authenticated administrator */
  updateGlobalSettings: UpdateGlobalSettingsResponse;
  /** Update a Group */
  updateGroup: CreateUpdateGroupResponse;
  /** Update an invoice from within the service provider admin. */
  updateInvoice: CreateUpdateInvoiceResponse;
  /** Update a job from within the service provider admin. */
  updateJob: CreateUpdateJobResponse;
  /** Update a manufacturer */
  updateManufacturer: CreateUpdateManufacturerResponse;
  /** Update a message. */
  updateMessage: CreateUpdateMessageResponse;
  /** Update minimum mobile app versions for iOS and Android (Admin only) */
  updateMinimumMobileAppVersions: UpdateMinimumMobileAppVersionsResponse;
  /** Update a note. */
  updateNote: CreateUpdateNoteResponse;
  /** Update user notification preferences */
  updateNotificationPreferences: UpdatePreferencesResponse;
  /** Update onboarding state for the authenticated user without broad entity invalidation. */
  updateOnboardingProgress: CreateUpdateUserResponse;
  /** Transfer or assign SP_OWNER role to another user (SP_OWNER or admin only) */
  updateOwner: UpdateOwnerResponse;
  /** Update a payment */
  updatePayment: CreateUpdatePaymentResponse;
  /** Update a property. */
  updateProperty: CreateUpdatePropertyResponse;
  /** Update QuickBooks chart of accounts mappings */
  updateQuickBooksAccountMappings: UpdateQuickBooksAccountMappingsResponse;
  /** Update QuickBooks sync settings */
  updateQuickBooksSyncSettings: UpdateQuickBooksSyncSettingsResponse;
  /** Update a service item from within the service provider admin. */
  updateServiceItem: CreateUpdateServiceItemResponse;
  /** Update a service provider account from within the service provider admin. */
  updateServiceProviderAccount: UpdateServiceProviderAccountResponse;
  /** Update service provider account settings (SP_ADMIN/SP_OWNER only) */
  updateServiceProviderAccountSettings: UpdateServiceProviderAccountSettingsResponse;
  /** Update a tax rate. */
  updateTaxRate: CreateUpdateTaxRateResponse;
  /** Update a timesheet. */
  updateTimesheet: CreateUpdateTimesheetResponse;
  /** Update a timesheet entry. */
  updateTimesheetEntry: CreateUpdateTimesheetEntryResponse;
  /** Update user information from client or service provider admin. `id` is optional if updating self. */
  updateUser: CreateUpdateUserResponse;
  /** Update the user's avatar. */
  updateUserAvatar: UpdateUserAvatarResponse;
  /** Update user password from client or service provider admin */
  updateUserPassword: UpdateUserPasswordResponse;
  /** Update current user settings */
  updateUserSettings: UpdateUserSettingsResponse;
  /** Update a vendor */
  updateVendor: CreateUpdateVendorResponse;
  /** Validate an FCM device token is still valid */
  validateFCMDeviceToken: ValidateFCMDeviceTokenResponse;
};

export type MutationacceptClientInviteArgs = {
  token: Scalars['String']['input'];
};

export type MutationaddAIBillingCreditArgs = {
  data: AddAIBillingCreditInput;
};

export type MutationadminApproveConnectApplicationArgs = {
  data: AdminApproveConnectApplicationInput;
};

export type MutationadminDeclineConnectApplicationArgs = {
  data: AdminDeclineConnectApplicationInput;
};

export type MutationadminLoginArgs = {
  data: AdminLoginInput;
};

export type MutationadminProvisionDedicatedNumberArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationadminRefreshTokenArgs = {
  data: AdminRefreshTokenInput;
};

export type MutationadminReleaseDedicatedNumberArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationadminResetIvrGreetingArgs = {
  accountId: Scalars['ID']['input'];
};

export type MutationadminResetPasswordWithTokenArgs = {
  data: ResetPasswordWithTokenInput;
};

export type MutationarchiveNotificationArgs = {
  data: ArchiveNotificationInput;
};

export type MutationbulkDeleteServiceItemsArgs = {
  data: BulkDeleteServiceItemsInput;
};

export type MutationbulkUpdateSPFeesArgs = {
  data: BulkFeeUpdateInput;
};

export type MutationbulkUpdateServiceItemsCSVArgs = {
  data: BulkUpdateServiceItemsCSVInput;
};

export type MutationconvertIVRLeadToClientArgs = {
  data: ConvertIVRLeadToClientInput;
};

export type MutationcreateAdminUserArgs = {
  data: CreateAdminUserInput;
};

export type MutationcreateAppointmentArgs = {
  data: CreateAppointmentInput;
};

export type MutationcreateAttachmentArgs = {
  data?: InputMaybe<CreateAttachmentInput>;
};

export type MutationcreateChatArgs = {
  data?: InputMaybe<CreateChatInput>;
};

export type MutationcreateChecklistArgs = {
  data?: InputMaybe<CreateChecklistInput>;
};

export type MutationcreateChecklistEntryArgs = {
  data?: InputMaybe<CreateChecklistEntryInput>;
};

export type MutationcreateClientArgs = {
  data?: InputMaybe<CreateClientInternalInput>;
};

export type MutationcreateClientUserPropertyArgs = {
  data: CreateClientUserPropertyInput;
};

export type MutationcreateCrewArgs = {
  data: CreateCrewInput;
};

export type MutationcreateEstimateArgs = {
  data?: InputMaybe<CreateEstimateInput>;
};

export type MutationcreateEstimateFromAppointmentArgs = {
  data: CreateEstimateFromAppointmentInput;
};

export type MutationcreateFeedbackEntryArgs = {
  data?: InputMaybe<CreateFeedbackEntryInput>;
};

export type MutationcreateGroupArgs = {
  data: CreateGroupInput;
};

export type MutationcreateInvoiceArgs = {
  data?: InputMaybe<CreateInvoiceInput>;
};

export type MutationcreateInvoiceFromAppointmentArgs = {
  data: CreateInvoiceFromAppointmentInput;
};

export type MutationcreateInvoiceFromJobArgs = {
  id: Scalars['ID']['input'];
};

export type MutationcreateInvoicePaymentSessionArgs = {
  cancelUrl: Scalars['String']['input'];
  invoiceId: Scalars['ID']['input'];
  successUrl: Scalars['String']['input'];
};

export type MutationcreateJobArgs = {
  data?: InputMaybe<CreateJobInput>;
};

export type MutationcreateJobFromAppointmentArgs = {
  data: CreateJobFromAppointmentInput;
};

export type MutationcreateJobFromEstimateArgs = {
  data?: InputMaybe<CreateJobFromEstimateInput>;
};

export type MutationcreateManufacturerArgs = {
  data: CreateManufacturerInput;
};

export type MutationcreateMessageArgs = {
  data?: InputMaybe<CreateMessageInput>;
};

export type MutationcreateNoteArgs = {
  data?: InputMaybe<CreateNoteInput>;
};

export type MutationcreatePaymentArgs = {
  data: CreatePaymentInput;
};

export type MutationcreatePropertyArgs = {
  data?: InputMaybe<CreatePropertyInput>;
};

export type MutationcreateServiceItemArgs = {
  data: CreateServiceItemInput;
};

export type MutationcreateServiceProviderUserArgs = {
  data?: InputMaybe<CreateUserInput>;
};

export type MutationcreateTaxRateArgs = {
  data?: InputMaybe<CreateTaxRateInput>;
};

export type MutationcreateTimesheetArgs = {
  data: CreateTimesheetInput;
};

export type MutationcreateTimesheetEntryArgs = {
  data?: InputMaybe<CreateTimesheetEntryInput>;
};

export type MutationcreateVendorArgs = {
  data: CreateVendorInput;
};

export type MutationdeleteAdminUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteAllAccountDataArgs = {
  data: DeleteAllAccountDataInput;
};

export type MutationdeleteAppointmentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteAttachmentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteChecklistArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteChecklistEntryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteClientAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteCrewArgs = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationdeleteEstimateArgs = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationdeleteFeedbackEntryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteGroupArgs = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationdeleteIVRVoicemailArgs = {
  data: DeleteIVRVoicemailInput;
};

export type MutationdeleteInvoiceArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteJobArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteManufacturerArgs = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationdeleteMessageArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteNoteArgs = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationdeleteNotificationArgs = {
  data: DeleteNotificationInput;
};

export type MutationdeletePaymentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeletePropertyArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteServiceItemArgs = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationdeleteServiceProviderAccountArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteTaxRateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteTimeSheetEntriesByDateArgs = {
  data?: InputMaybe<DeleteTimesheetEntriesByDateInput>;
};

export type MutationdeleteTimesheetArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteTimesheetEntryArgs = {
  id: Scalars['ID']['input'];
};

export type MutationdeleteVendorArgs = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationduplicateChecklistArgs = {
  id: Scalars['ID']['input'];
};

export type MutationduplicateEstimateArgs = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationduplicateJobArgs = {
  data: DuplicateJobInput;
};

export type MutationenrollBetaLifecycleArgs = {
  data: EnrollBetaLifecycleInput;
};

export type MutationexchangeAccessLinkTokenArgs = {
  token: Scalars['String']['input'];
};

export type MutationexchangeClientUpdateTokenArgs = {
  token: Scalars['String']['input'];
};

export type MutationexchangeLinkTokenArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};

export type MutationexchangeMagicLinkTokenArgs = {
  token: Scalars['String']['input'];
};

export type MutationflushCacheArgs = {
  account_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  includeAllAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  includeGlobalQueries?: InputMaybe<Scalars['Boolean']['input']>;
  includeHistory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationflushGeocodingCacheArgs = {
  includeInvalid?: InputMaybe<Scalars['Boolean']['input']>;
  includeValid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationignoreQuickBooksSyncItemArgs = {
  syncLogId: Scalars['ID']['input'];
};

export type MutationimpersonateUserArgs = {
  userId: Scalars['ID']['input'];
};

export type MutationimportClientsCSVArgs = {
  data: ImportClientsCSVInput;
};

export type MutationimportClientsCSVJobArgs = {
  data: ImportClientsCSVInput;
};

export type MutationimportServiceItemsCSVArgs = {
  data: ImportServiceItemsCSVInput;
};

export type MutationimportServiceItemsCSVJobArgs = {
  data: ImportServiceItemsCSVInput;
};

export type MutationinvalidateEntityCacheArgs = {
  entityId: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
};

export type MutationlinkServiceProviderArgs = {
  data: LinkServiceProviderInput;
};

export type MutationlinkWhatsAppArgs = {
  data: LinkWhatsAppInput;
};

export type MutationmarkAllNotificationsAsReadArgs = {
  data?: InputMaybe<MarkAllAsReadInput>;
};

export type MutationmarkEstimateAsViewedArgs = {
  data: MarkEstimateAsViewedInput;
};

export type MutationmarkIVRVoicemailListenedArgs = {
  data: MarkIVRVoicemailListenedInput;
};

export type MutationmarkNotificationAsReadArgs = {
  data: MarkAsReadInput;
};

export type MutationmobileResetPasswordArgs = {
  data: MobileResetPasswordInput;
};

export type MutationmodifySubscriptionPlanArgs = {
  input: ModifySubscriptionPlanInput;
};

export type MutationprepareQuickBooksImportArgs = {
  data: QuickBooksImportSettingsInput;
};

export type MutationpreviewNotificationQaArgs = {
  data: NotificationQaPreviewInput;
};

export type MutationprocessInvoicePaymentArgs = {
  sessionId: Scalars['String']['input'];
};

export type MutationpushSyncAppointmentsArgs = {
  data: PushSyncAppointmentsInput;
};

export type MutationpushSyncChecklistsArgs = {
  data: PushSyncChecklistsInput;
};

export type MutationpushSyncClientsArgs = {
  data: PushSyncClientsInput;
};

export type MutationpushSyncCrewsArgs = {
  data: PushSyncCrewsInput;
};

export type MutationpushSyncEstimatesArgs = {
  data: PushSyncEstimatesInput;
};

export type MutationpushSyncGroupsArgs = {
  data: PushSyncGroupsInput;
};

export type MutationpushSyncInvoicesArgs = {
  data: PushSyncInvoicesInput;
};

export type MutationpushSyncJobsArgs = {
  data: PushSyncJobsInput;
};

export type MutationpushSyncManufacturersArgs = {
  data: PushSyncManufacturersInput;
};

export type MutationpushSyncPaymentsArgs = {
  data: PushSyncPaymentsInput;
};

export type MutationpushSyncPropertiesArgs = {
  data: PushSyncPropertiesInput;
};

export type MutationpushSyncServiceItemsArgs = {
  data: PushSyncServiceItemsInput;
};

export type MutationpushSyncTaxratesArgs = {
  data: PushSyncTaxratesInput;
};

export type MutationpushSyncTimesheetEntriesArgs = {
  data: PushSyncTimesheetEntriesInput;
};

export type MutationpushSyncTimesheetsArgs = {
  data: PushSyncTimesheetsInput;
};

export type MutationpushSyncUsersArgs = {
  data: PushSyncUsersInput;
};

export type MutationpushSyncVendorsArgs = {
  data: PushSyncVendorsInput;
};

export type MutationrefreshAccessTokenArgs = {
  data: RefreshAccessTokenInput;
};

export type MutationrefreshQuickBooksImportPreviewArgs = {
  importJobId: Scalars['ID']['input'];
};

export type MutationrejectClientInviteArgs = {
  token: Scalars['String']['input'];
};

export type MutationremoveFCMDeviceArgs = {
  input: RemoveFCMDeviceInput;
};

export type MutationremoveServiceItemImageArgs = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationremoveUserAvatarArgs = {
  data?: InputMaybe<RemoveUserAvatarInput>;
};

export type MutationresetAdminUserPasswordArgs = {
  data: ResetAdminUserPasswordInput;
};

export type MutationresetUserPasswordArgs = {
  data?: InputMaybe<ResetUserPasswordInput>;
};

export type MutationresolveQuickBooksConflictArgs = {
  data: ResolveQuickBooksConflictInput;
};

export type MutationretryQuickBooksSyncItemArgs = {
  syncLogId: Scalars['ID']['input'];
};

export type MutationrunBetaLifecycleForAccountArgs = {
  data: RunBetaLifecycleInput;
};

export type MutationrunQuickBooksImportArgs = {
  importJobId: Scalars['ID']['input'];
};

export type MutationsendAppointmentArgs = {
  data: SendAppointmentInput;
};

export type MutationsendClientInviteArgs = {
  data: SendClientInviteInput;
};

export type MutationsendEstimateArgs = {
  data?: InputMaybe<SendEstimateInput>;
};

export type MutationsendInvoiceArgs = {
  data?: InputMaybe<SendInvoiceInput>;
};

export type MutationsendJobArgs = {
  data: SendJobInput;
};

export type MutationsendMaintenanceNotificationArgs = {
  data: SendMaintenanceNotificationInput;
};

export type MutationsendNotificationQaArgs = {
  data: NotificationQaSendInput;
};

export type MutationsendOnboardingEmailForCurrentUserArgs = {
  data: SendOnboardingEmailForCurrentUserInput;
};

export type MutationsendSystemAnnouncementArgs = {
  data: SendSystemAnnouncementInput;
};

export type MutationsendTypingIndicatorArgs = {
  data: SendTypingIndicatorInput;
};

export type MutationsetCurrentUserOnboardingDayArgs = {
  data: SetCurrentUserOnboardingDayInput;
};

export type MutationsignInClientArgs = {
  device?: InputMaybe<RegisterFCMDeviceInput>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationsignInClientByTokenArgs = {
  data?: InputMaybe<CheckResetTokenInput>;
};

export type MutationsignInGoogleClientArgs = {
  clientId: Scalars['String']['input'];
  credential: Scalars['String']['input'];
};

export type MutationsignInGoogleServiceProviderArgs = {
  clientId: Scalars['String']['input'];
  credential: Scalars['String']['input'];
};

export type MutationsignInServiceProviderArgs = {
  device?: InputMaybe<RegisterFCMDeviceInput>;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationsignInServiceProviderByTokenArgs = {
  data?: InputMaybe<CheckResetTokenInput>;
};

export type MutationsignOutClientArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  logoutAllDevices?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationsignOutServiceProviderArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  logoutAllDevices?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MutationsignUpClientArgs = {
  data?: InputMaybe<CreateClientInput>;
  device?: InputMaybe<RegisterFCMDeviceInput>;
};

export type MutationsignUpServiceProviderArgs = {
  data?: InputMaybe<CreateServiceProviderInput>;
  device?: InputMaybe<RegisterFCMDeviceInput>;
};

export type MutationskipJobFeedbackArgs = {
  data: SkipJobFeedbackInput;
};

export type MutationsnoozeNotificationArgs = {
  data: SnoozeNotificationInput;
};

export type MutationstartTimerArgs = {
  data: StartTimerInput;
};

export type MutationstopTimerArgs = {
  data: StopTimerInput;
};

export type MutationsubscribeMailingListBetaUpdatesArgs = {
  data: SubscribeMailingListBetaUpdatesInput;
};

export type MutationswitchTimerArgs = {
  data: SwitchTimerInput;
};

export type MutationtestConnectNotificationArgs = {
  alertType: Scalars['String']['input'];
};

export type MutationtestNotificationChannelsArgs = {
  data?: InputMaybe<TestNotificationChannelsInput>;
};

export type MutationtriggerQuickBooksImportArgs = {
  data: QuickBooksImportSettingsInput;
};

export type MutationtriggerQuickBooksSyncOlderItemsArgs = {
  data: QuickBooksSyncOlderItemsInput;
};

export type MutationtrustKnownDeviceArgs = {
  fingerprint: Scalars['String']['input'];
};

export type MutationunlinkServiceProviderArgs = {
  data: UnlinkServiceProviderInput;
};

export type MutationunlockAdminUserArgs = {
  id: Scalars['ID']['input'];
};

export type MutationupdateAdminUserArgs = {
  data: UpdateAdminUserInput;
};

export type MutationupdateAdminUserPasswordArgs = {
  data: UpdateAdminUserPasswordInput;
};

export type MutationupdateAppointmentArgs = {
  data: UpdateAppointmentInput;
};

export type MutationupdateBetaLifecycleEnrollmentArgs = {
  data: UpdateBetaLifecycleEnrollmentInput;
};

export type MutationupdateChatArgs = {
  data: UpdateChatInput;
};

export type MutationupdateChecklistArgs = {
  data?: InputMaybe<UpdateChecklistInput>;
};

export type MutationupdateChecklistEntryArgs = {
  data?: InputMaybe<UpdateChecklistEntryInput>;
};

export type MutationupdateClientAccountArgs = {
  data?: InputMaybe<UpdateClientAccountInput>;
};

export type MutationupdateClientAccountSettingsArgs = {
  data: UpdateClientAccountSettingsInput;
};

export type MutationupdateClientServiceProviderLinkStateArgs = {
  data: UpdateClientServiceProviderLinkStateInput;
};

export type MutationupdateClientUserPropertyArgs = {
  data: UpdateClientUserPropertyInput;
};

export type MutationupdateConnectApplicationStatusArgs = {
  status: SPStripeApplicationStatus;
};

export type MutationupdateConnectFeeConfigurationArgs = {
  feePercentage: Scalars['Float']['input'];
  fixedFeeAmount: Scalars['Float']['input'];
};

export type MutationupdateCrewArgs = {
  data: UpdateCrewInput;
};

export type MutationupdateEstimateArgs = {
  data?: InputMaybe<UpdateEstimateInput>;
};

export type MutationupdateFCMDeviceArgs = {
  input: UpdateFCMDeviceInput;
};

export type MutationupdateFeedbackEntryArgs = {
  data?: InputMaybe<UpdateFeedbackEntryInput>;
};

export type MutationupdateGlobalFeeDefaultsArgs = {
  data: GlobalFeeDefaultsInput;
};

export type MutationupdateGlobalSettingsArgs = {
  data: GlobalSettingsInput;
};

export type MutationupdateGroupArgs = {
  data: UpdateGroupInput;
};

export type MutationupdateInvoiceArgs = {
  data?: InputMaybe<UpdateInvoiceInput>;
};

export type MutationupdateJobArgs = {
  data?: InputMaybe<UpdateJobInput>;
};

export type MutationupdateManufacturerArgs = {
  data: UpdateManufacturerInput;
};

export type MutationupdateMessageArgs = {
  data?: InputMaybe<UpdateMessageInput>;
};

export type MutationupdateMinimumMobileAppVersionsArgs = {
  data: UpdateMinimumMobileAppVersionInput;
};

export type MutationupdateNoteArgs = {
  data?: InputMaybe<UpdateNoteInput>;
};

export type MutationupdateNotificationPreferencesArgs = {
  data: UpdatePreferencesInput;
};

export type MutationupdateOnboardingProgressArgs = {
  data: UpdateOnboardingProgressInput;
};

export type MutationupdateOwnerArgs = {
  data: UpdateOwnerInput;
};

export type MutationupdatePaymentArgs = {
  data: UpdatePaymentInput;
};

export type MutationupdatePropertyArgs = {
  data?: InputMaybe<UpdatePropertyInput>;
};

export type MutationupdateQuickBooksAccountMappingsArgs = {
  data: UpdateQuickBooksAccountMappingsInput;
};

export type MutationupdateQuickBooksSyncSettingsArgs = {
  data: UpdateQuickBooksSyncSettingsInput;
};

export type MutationupdateServiceItemArgs = {
  data: UpdateServiceItemInput;
};

export type MutationupdateServiceProviderAccountArgs = {
  data?: InputMaybe<UpdateServiceProviderAccountInput>;
};

export type MutationupdateServiceProviderAccountSettingsArgs = {
  data: UpdateServiceProviderAccountSettingsInput;
};

export type MutationupdateTaxRateArgs = {
  data?: InputMaybe<UpdateTaxRateInput>;
};

export type MutationupdateTimesheetArgs = {
  data: UpdateTimesheetInput;
};

export type MutationupdateTimesheetEntryArgs = {
  data?: InputMaybe<UpdateTimesheetEntryInput>;
};

export type MutationupdateUserArgs = {
  data?: InputMaybe<UpdateUserInput>;
};

export type MutationupdateUserAvatarArgs = {
  data?: InputMaybe<UpdateUserAvatarInput>;
};

export type MutationupdateUserPasswordArgs = {
  data?: InputMaybe<UpdateUserPasswordInput>;
};

export type MutationupdateUserSettingsArgs = {
  data: UserSettingsInput;
};

export type MutationupdateVendorArgs = {
  data: UpdateVendorInput;
};

export type MutationvalidateFCMDeviceTokenArgs = {
  input: ValidateFCMDeviceTokenInput;
};

export type Note = Timestamps & {
  __typename?: 'Note';
  account_id: Scalars['ID']['output'];
  appointment_id?: Maybe<Scalars['ID']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  client_account_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  creatorFullName: Scalars['String']['output'];
  creator_user_id: Scalars['ID']['output'];
  estimate_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['ID']['output']>;
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  job_id?: Maybe<Scalars['ID']['output']>;
  property_id?: Maybe<Scalars['ID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum NotesSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type Notification = Timestamps & {
  __typename?: 'Notification';
  /** Account this notification belongs to */
  accountId: Scalars['ID']['output'];
  /** Action button text */
  actionText?: Maybe<Scalars['String']['output']>;
  /** Action URL for notification */
  actionUrl?: Maybe<Scalars['String']['output']>;
  /** Notification body/message */
  body: Scalars['String']['output'];
  /** Category for grouping notifications */
  category: NotificationCategory;
  /** Delivery channels used */
  channels: Array<NotificationChannel>;
  createdAt: Scalars['Date']['output'];
  /** User who created this notification */
  createdBy?: Maybe<Scalars['ID']['output']>;
  /** Custom data payload */
  data?: Maybe<Scalars['JSON']['output']>;
  /** When notification was delivered */
  deliveredAt?: Maybe<Scalars['Date']['output']>;
  /** Delivery attempts */
  deliveryAttempts: Array<DeliveryAttempt>;
  /** Expiration time (TTL) */
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Whether this is a reminder */
  isReminder: Scalars['Boolean']['output'];
  /** Language/locale (en, es) */
  language: Scalars['String']['output'];
  /** Metadata for notification */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** Priority level */
  priority: NotificationPriority;
  /** When notification was read */
  readAt?: Maybe<Scalars['Date']['output']>;
  /** Recipient type */
  recipientType: RecipientType;
  /** Scheduled send time */
  scheduledFor?: Maybe<Scalars['Date']['output']>;
  /** Notification scope (user, account, role) */
  scope: NotificationScope;
  /** When notification was sent */
  sentAt?: Maybe<Scalars['Date']['output']>;
  /** Current status */
  status: NotificationStatus;
  /** Notification title */
  title: Scalars['String']['output'];
  /** Type of notification */
  type: NotificationType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** User this notification is for (null for account-wide) */
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum NotificationCategory {
  /** Feedback and reviews */
  CommunicationFeedback = 'COMMUNICATION_FEEDBACK',
  /** Messages and communication */
  CommunicationMessage = 'COMMUNICATION_MESSAGE',
  /** QuickBooks integration */
  IntegrationQuickbooks = 'INTEGRATION_QUICKBOOKS',
  /** Stripe Connect integration */
  IntegrationStripe = 'INTEGRATION_STRIPE',
  /** Onboarding and trial nudges (SendGrid ASM-managed unsubscribe) */
  MarketingOnboarding = 'MARKETING_ONBOARDING',
  /** Inventory and stock management */
  OperationalInventory = 'OPERATIONAL_INVENTORY',
  /** Team and crew management */
  OperationalTeam = 'OPERATIONAL_TEAM',
  /** Timesheet management */
  OperationalTimesheet = 'OPERATIONAL_TIMESHEET',
  /** SP broadcast to their clients (SP admin → linked clients) */
  SpAnnouncement = 'SP_ANNOUNCEMENT',
  /** Subscription and billing */
  SubscriptionBilling = 'SUBSCRIPTION_BILLING',
  /** System announcements (platform admin → all SP + CLIENT accounts) */
  SystemAnnouncement = 'SYSTEM_ANNOUNCEMENT',
  /** Appointment scheduling */
  TransactionalAppointment = 'TRANSACTIONAL_APPOINTMENT',
  /** Authentication and account management */
  TransactionalAuth = 'TRANSACTIONAL_AUTH',
  /** Estimate and quote management */
  TransactionalEstimate = 'TRANSACTIONAL_ESTIMATE',
  /** Financial transactions and payments */
  TransactionalFinancial = 'TRANSACTIONAL_FINANCIAL',
  /** Job lifecycle and management */
  TransactionalJob = 'TRANSACTIONAL_JOB',
}

export enum NotificationChannel {
  /** Browser push notification */
  Browser = 'BROWSER',
  /** Email notification */
  Email = 'EMAIL',
  /** Mobile push notification */
  Push = 'PUSH',
  /** SMS text message */
  Sms = 'SMS',
  /** In-app notification */
  Ui = 'UI',
  /** WhatsApp message notification */
  Whatsapp = 'WHATSAPP',
}

export type NotificationDeleted = {
  __typename?: 'NotificationDeleted';
  /** ID of deleted notification */
  notificationId: Scalars['ID']['output'];
};

export type NotificationFilter = {
  /** Filter by category */
  category?: InputMaybe<NotificationCategory>;
  /** Filter by channel */
  channel?: InputMaybe<NotificationChannel>;
  /** Filter by date from */
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by date to */
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by read/unread */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by priority */
  priority?: InputMaybe<NotificationPriority>;
  /** Filter by status */
  status?: InputMaybe<NotificationStatus>;
  /** Filter by notification type */
  type?: InputMaybe<NotificationType>;
};

/**
 * Methods for delivering notifications to users.
 * Determines how alerts and communications are sent.
 */
export enum NotificationMethod {
  /** Send notifications via both email and SMS. */
  Both = 'BOTH',
  /** Send notifications via email only. */
  Email = 'EMAIL',
  /** Send notifications via SMS text message only. */
  Sms = 'SMS',
}

export type NotificationPreferences = {
  __typename?: 'NotificationPreferences';
  /** Disabled notification types */
  disabledTypes: Array<NotificationType>;
  /** Enabled notification types */
  enabledTypes: Array<NotificationType>;
  /** Language preference */
  language: Scalars['String']['output'];
  /** Preferred channels */
  preferredChannels: Array<NotificationChannel>;
  /** Quiet hours end (24h format) */
  quietHoursEnd?: Maybe<Scalars['Int']['output']>;
  /** Quiet hours start (24h format) */
  quietHoursStart?: Maybe<Scalars['Int']['output']>;
  /** Timezone for quiet hours */
  timezone?: Maybe<Scalars['String']['output']>;
  /** User ID */
  userId: Scalars['ID']['output'];
};

export enum NotificationPriority {
  /** High priority notification */
  High = 'HIGH',
  /** Low priority notification */
  Low = 'LOW',
  /** Normal priority notification */
  Normal = 'NORMAL',
  /** Urgent priority notification */
  Urgent = 'URGENT',
}

export type NotificationPriorityCount = {
  __typename?: 'NotificationPriorityCount';
  high: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
  normal: Scalars['Int']['output'];
  urgent: Scalars['Int']['output'];
};

export type NotificationQaCatalog = {
  __typename?: 'NotificationQaCatalog';
  items: Array<NotificationQaCatalogItem>;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type NotificationQaCatalogItem = {
  __typename?: 'NotificationQaCatalogItem';
  channels: Array<NotificationChannel>;
  type: Scalars['String']['output'];
};

export type NotificationQaCatalogResponse = Error | NotificationQaCatalog;

export type NotificationQaPreview = {
  __typename?: 'NotificationQaPreview';
  channels: Array<NotificationQaPreviewChannel>;
  message: Scalars['String']['output'];
  type: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type NotificationQaPreviewChannel = {
  __typename?: 'NotificationQaPreviewChannel';
  body: Scalars['String']['output'];
  channel: NotificationChannel;
  html?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NotificationQaPreviewInput = {
  channels: Array<NotificationChannel>;
  language?: InputMaybe<Scalars['String']['input']>;
  recipientType?: RecipientType;
  type: Scalars['String']['input'];
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type NotificationQaPreviewResponse = Error | NotificationQaPreview;

export type NotificationQaSend = {
  __typename?: 'NotificationQaSend';
  channels: Array<NotificationChannel>;
  message: Scalars['String']['output'];
  notificationId: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

export type NotificationQaSendInput = {
  channels: Array<NotificationChannel>;
  language?: InputMaybe<Scalars['String']['input']>;
  recipientType?: RecipientType;
  recipients: Scalars['JSON']['input'];
  type: Scalars['String']['input'];
  variables?: InputMaybe<Scalars['JSON']['input']>;
};

export type NotificationQaSendResponse = Error | NotificationQaSend;

export type NotificationReceived = {
  __typename?: 'NotificationReceived';
  /** The new notification */
  notification: Notification;
};

export enum NotificationScope {
  /** Notification for account administrators */
  AccountAdmins = 'ACCOUNT_ADMINS',
  /** Notification for all account users */
  AccountAll = 'ACCOUNT_ALL',
  /** Notification for specific role */
  Role = 'ROLE',
  /** Notification for specific user */
  User = 'USER',
}

export enum NotificationSortBy {
  CreatedAt = 'CREATED_AT',
  Priority = 'PRIORITY',
  ReadAt = 'READ_AT',
  SentAt = 'SENT_AT',
  Type = 'TYPE',
}

export enum NotificationStatus {
  /** Notification archived */
  Archived = 'ARCHIVED',
  /** Notification delivered to recipient */
  Delivered = 'DELIVERED',
  /** Notification delivery failed */
  Failed = 'FAILED',
  /** Notification created, awaiting processing */
  Pending = 'PENDING',
  /** Notification queued for delivery */
  Queued = 'QUEUED',
  /** Notification read by recipient */
  Read = 'READ',
  /** Notification being sent */
  Sending = 'SENDING',
  /** Notification successfully sent */
  Sent = 'SENT',
}

/** Notification type for all system notifications */
export enum NotificationType {
  /** Alert announcement */
  AnnouncementAlert = 'ANNOUNCEMENT_ALERT',
  /** General announcement */
  AnnouncementGeneral = 'ANNOUNCEMENT_GENERAL',
  /** Maintenance announcement */
  AnnouncementMaintenance = 'ANNOUNCEMENT_MAINTENANCE',
  /** Appointment callback requested */
  AppointmentCallbackRequested = 'APPOINTMENT_CALLBACK_REQUESTED',
  /** Appointment cancelled */
  AppointmentCancelled = 'APPOINTMENT_CANCELLED',
  /** Appointment confirmed */
  AppointmentConfirmed = 'APPOINTMENT_CONFIRMED',
  /** Appointment reminder 1 day before */
  AppointmentReminder_1Day = 'APPOINTMENT_REMINDER_1DAY',
  /** Appointment reminder 1 hour before */
  AppointmentReminder_1Hour = 'APPOINTMENT_REMINDER_1HOUR',
  /** Appointment reminder 15 minutes before */
  AppointmentReminder_15Min = 'APPOINTMENT_REMINDER_15MIN',
  /** Custom appointment reminder */
  AppointmentReminderCustom = 'APPOINTMENT_REMINDER_CUSTOM',
  /** Appointment requested by existing client */
  AppointmentRequestedExistingClient = 'APPOINTMENT_REQUESTED_EXISTING_CLIENT',
  /** Appointment requested by new client */
  AppointmentRequestedNewClient = 'APPOINTMENT_REQUESTED_NEW_CLIENT',
  /** Appointment rescheduled */
  AppointmentRescheduled = 'APPOINTMENT_RESCHEDULED',
  /** Appointment scheduled */
  AppointmentScheduled = 'APPOINTMENT_SCHEDULED',
  /** Magic link access */
  AuthAccessLink = 'AUTH_ACCESS_LINK',
  /** Email verification required */
  AuthEmailVerification = 'AUTH_EMAIL_VERIFICATION',
  /** New device login detected */
  AuthNewDeviceLogin = 'AUTH_NEW_DEVICE_LOGIN',
  /** Password successfully changed */
  AuthPasswordChanged = 'AUTH_PASSWORD_CHANGED',
  /** Password reset request */
  AuthPasswordReset = 'AUTH_PASSWORD_RESET',
  /** Client signup confirmation */
  AuthSignupConfirmationClient = 'AUTH_SIGNUP_CONFIRMATION_CLIENT',
  /** Service provider signup confirmation */
  AuthSignupConfirmationSp = 'AUTH_SIGNUP_CONFIRMATION_SP',
  /** Team member invitation */
  AuthTeamInvitation = 'AUTH_TEAM_INVITATION',
  /** WhatsApp account access recorded */
  AuthWhatsappUnlock = 'AUTH_WHATSAPP_UNLOCK',
  /** Client accepted a service provider invite */
  ClientInviteAccepted = 'CLIENT_INVITE_ACCEPTED',
  /** Client declined a service provider invite */
  ClientInviteDeclined = 'CLIENT_INVITE_DECLINED',
  /** New client registered with provider */
  ClientNewWithProvider = 'CLIENT_NEW_WITH_PROVIDER',
  /** Client updated their own profile — SP receives notification of the change */
  ClientProfileUpdated = 'CLIENT_PROFILE_UPDATED',
  /** Client linked to service provider */
  ClientSpLinked = 'CLIENT_SP_LINKED',
  /** Client unlinked from service provider */
  ClientSpUnlinked = 'CLIENT_SP_UNLINKED',
  /** Welcome notification for SP-created client */
  ClientWelcomeSpCreated = 'CLIENT_WELCOME_SP_CREATED',
  /** Feedback received (legacy) */
  CommunicationFeedbackReceived = 'COMMUNICATION_FEEDBACK_RECEIVED',
  /** New message (legacy) */
  CommunicationNewMessage = 'COMMUNICATION_NEW_MESSAGE',
  /** Custom notification */
  Custom = 'CUSTOM',
  /** Estimate approved by client */
  EstimateApproved = 'ESTIMATE_APPROVED',
  /** Estimate changes requested */
  EstimateChangesRequested = 'ESTIMATE_CHANGES_REQUESTED',
  /** Estimate created */
  EstimateCreated = 'ESTIMATE_CREATED',
  /** Estimate expired */
  EstimateExpired = 'ESTIMATE_EXPIRED',
  /** Estimate rejected by client */
  EstimateRejected = 'ESTIMATE_REJECTED',
  /** Estimate sent to client */
  EstimateSent = 'ESTIMATE_SENT',
  /** Estimate viewed by client */
  EstimateViewed = 'ESTIMATE_VIEWED',
  /** Complaint filed */
  FeedbackComplaintFiled = 'FEEDBACK_COMPLAINT_FILED',
  /** Low rating received */
  FeedbackRatingLow = 'FEEDBACK_RATING_LOW',
  /** Feedback received */
  FeedbackReceived = 'FEEDBACK_RECEIVED',
  /** Feedback request sent */
  FeedbackRequest = 'FEEDBACK_REQUEST',
  /** Feedback response sent */
  FeedbackResponseSent = 'FEEDBACK_RESPONSE_SENT',
  /** Invoice created */
  FinancialInvoiceCreated = 'FINANCIAL_INVOICE_CREATED',
  /** Invoice payment due soon */
  FinancialInvoiceDueSoon = 'FINANCIAL_INVOICE_DUE_SOON',
  /** Invoice payment overdue */
  FinancialInvoiceOverdue = 'FINANCIAL_INVOICE_OVERDUE',
  /** Invoice paid */
  FinancialInvoicePaid = 'FINANCIAL_INVOICE_PAID',
  /** Invoice sent to client */
  FinancialInvoiceSent = 'FINANCIAL_INVOICE_SENT',
  /** Invoice viewed by client */
  FinancialInvoiceViewed = 'FINANCIAL_INVOICE_VIEWED',
  /** Payment confirmed */
  FinancialPaymentConfirmed = 'FINANCIAL_PAYMENT_CONFIRMED',
  /** Payment failed */
  FinancialPaymentFailed = 'FINANCIAL_PAYMENT_FAILED',
  /** Payment pending */
  FinancialPaymentPending = 'FINANCIAL_PAYMENT_PENDING',
  /** Payment received */
  FinancialPaymentReceived = 'FINANCIAL_PAYMENT_RECEIVED',
  /** Refund failed */
  FinancialRefundFailed = 'FINANCIAL_REFUND_FAILED',
  /** Refund processed */
  FinancialRefundProcessed = 'FINANCIAL_REFUND_PROCESSED',
  /** QuickBooks connected */
  IntegrationQuickbooksConnected = 'INTEGRATION_QUICKBOOKS_CONNECTED',
  /** QuickBooks connection lost */
  IntegrationQuickbooksConnectionLost = 'INTEGRATION_QUICKBOOKS_CONNECTION_LOST',
  /** QuickBooks disconnected */
  IntegrationQuickbooksDisconnected = 'INTEGRATION_QUICKBOOKS_DISCONNECTED',
  /** QuickBooks import completed */
  IntegrationQuickbooksImportComplete = 'INTEGRATION_QUICKBOOKS_IMPORT_COMPLETE',
  /** QuickBooks import failed */
  IntegrationQuickbooksImportFailed = 'INTEGRATION_QUICKBOOKS_IMPORT_FAILED',
  /** QuickBooks sync completed */
  IntegrationQuickbooksSyncComplete = 'INTEGRATION_QUICKBOOKS_SYNC_COMPLETE',
  /** QuickBooks sync conflict */
  IntegrationQuickbooksSyncConflict = 'INTEGRATION_QUICKBOOKS_SYNC_CONFLICT',
  /** QuickBooks sync failed */
  IntegrationQuickbooksSyncFailed = 'INTEGRATION_QUICKBOOKS_SYNC_FAILED',
  /** QuickBooks token expiring */
  IntegrationQuickbooksTokenExpiring = 'INTEGRATION_QUICKBOOKS_TOKEN_EXPIRING',
  /** Inventory low stock alert */
  InventoryLowStock = 'INVENTORY_LOW_STOCK',
  /** Inventory reorder needed */
  InventoryReorderNeeded = 'INVENTORY_REORDER_NEEDED',
  /** Inventory stock updated */
  InventoryStockUpdated = 'INVENTORY_STOCK_UPDATED',
  /** Invoice created (legacy) */
  InvoiceCreated = 'INVOICE_CREATED',
  /** Invoice overdue (legacy) */
  InvoiceOverdue = 'INVOICE_OVERDUE',
  /** Invoice paid (legacy) */
  InvoicePaid = 'INVOICE_PAID',
  /** Invoice sent (legacy) */
  InvoiceSent = 'INVOICE_SENT',
  /** Job assigned to crew */
  JobAssigned = 'JOB_ASSIGNED',
  /** Job canceled (legacy) */
  JobCanceled = 'JOB_CANCELED',
  /** Job cancelled */
  JobCancelled = 'JOB_CANCELLED',
  /** Job completed */
  JobCompleted = 'JOB_COMPLETED',
  /** Job confirmed */
  JobConfirmed = 'JOB_CONFIRMED',
  /** Job created */
  JobCreated = 'JOB_CREATED',
  /** Crew arrived at job */
  JobCrewArrived = 'JOB_CREW_ARRIVED',
  /** Crew en route to job */
  JobCrewEnRoute = 'JOB_CREW_EN_ROUTE',
  /** Public notes added to job */
  JobNotesAdded = 'JOB_NOTES_ADDED',
  /** Job paused */
  JobPaused = 'JOB_PAUSED',
  /** Photos added to job */
  JobPhotosAdded = 'JOB_PHOTOS_ADDED',
  /** Job reminder 1 day before */
  JobReminder_1Day = 'JOB_REMINDER_1DAY',
  /** Job reminder 1 hour before */
  JobReminder_1Hour = 'JOB_REMINDER_1HOUR',
  /** Job reminder 2 days before */
  JobReminder_2Days = 'JOB_REMINDER_2DAYS',
  /** Job reminder 15 minutes before */
  JobReminder_15Min = 'JOB_REMINDER_15MIN',
  /** Custom job reminder */
  JobReminderCustom = 'JOB_REMINDER_CUSTOM',
  /** Job rescheduled */
  JobRescheduled = 'JOB_RESCHEDULED',
  /** Job resumed */
  JobResumed = 'JOB_RESUMED',
  /** Job scheduled */
  JobScheduled = 'JOB_SCHEDULED',
  /** Job started */
  JobStarted = 'JOB_STARTED',
  /** Job details updated */
  JobUpdated = 'JOB_UPDATED',
  /** New message from client */
  MessagingNewFromClient = 'MESSAGING_NEW_FROM_CLIENT',
  /** New message from service provider */
  MessagingNewFromSp = 'MESSAGING_NEW_FROM_SP',
  /** Unread messages reminder */
  MessagingUnreadReminder = 'MESSAGING_UNREAD_REMINDER',
  /** New message (legacy) */
  NewMessage = 'NEW_MESSAGE',
  /** Onboarding-cron nudge — specific template selected via `templateKey` on the data payload */
  OnboardingNudge = 'ONBOARDING_NUDGE',
  /** CSV import completed */
  OperationalCsvImportComplete = 'OPERATIONAL_CSV_IMPORT_COMPLETE',
  /** Low stock alert (legacy) */
  OperationalLowStock = 'OPERATIONAL_LOW_STOCK',
  /** Timesheet approved (legacy) */
  OperationalTimesheetApproved = 'OPERATIONAL_TIMESHEET_APPROVED',
  /** Timesheet submitted (legacy) */
  OperationalTimesheetSubmitted = 'OPERATIONAL_TIMESHEET_SUBMITTED',
  /** User created (legacy) */
  OperationalUserCreated = 'OPERATIONAL_USER_CREATED',
  /** SP broadcast to clients */
  SpBroadcast = 'SP_BROADCAST',
  /** Stripe Connect access requested */
  StripeConnectAccessRequested = 'STRIPE_CONNECT_ACCESS_REQUESTED',
  /** Stripe Connect application approved */
  StripeConnectApplicationApproved = 'STRIPE_CONNECT_APPLICATION_APPROVED',
  /** Stripe Connect application declined */
  StripeConnectApplicationDeclined = 'STRIPE_CONNECT_APPLICATION_DECLINED',
  /** Stripe Connect application pending review */
  StripeConnectApplicationPending = 'STRIPE_CONNECT_APPLICATION_PENDING',
  /** Stripe Connect application submitted */
  StripeConnectApplicationSubmitted = 'STRIPE_CONNECT_APPLICATION_SUBMITTED',
  /** Subscription cancelled */
  SubscriptionCancelled = 'SUBSCRIPTION_CANCELLED',
  /** Subscription created */
  SubscriptionCreated = 'SUBSCRIPTION_CREATED',
  /** Subscription payment failed */
  SubscriptionPaymentFailed = 'SUBSCRIPTION_PAYMENT_FAILED',
  /** Subscription plan changed */
  SubscriptionPlanChanged = 'SUBSCRIPTION_PLAN_CHANGED',
  /** Subscription renewed */
  SubscriptionRenewed = 'SUBSCRIPTION_RENEWED',
  /** Subscription trial ending soon */
  SubscriptionTrialEnding = 'SUBSCRIPTION_TRIAL_ENDING',
  /** Team member added */
  TeamMemberAdded = 'TEAM_MEMBER_ADDED',
  /** Team member removed */
  TeamMemberRemoved = 'TEAM_MEMBER_REMOVED',
  /** Team member role changed */
  TeamRoleChanged = 'TEAM_ROLE_CHANGED',
  /** Team user created */
  TeamUserCreated = 'TEAM_USER_CREATED',
  /** Timesheet approved */
  TimesheetApproved = 'TIMESHEET_APPROVED',
  /** Timesheet overdue */
  TimesheetOverdue = 'TIMESHEET_OVERDUE',
  /** Timesheet rejected */
  TimesheetRejected = 'TIMESHEET_REJECTED',
  /** Timesheet submitted for approval */
  TimesheetSubmitted = 'TIMESHEET_SUBMITTED',
}

export type NotificationUpdated = {
  __typename?: 'NotificationUpdated';
  /** What changed */
  changes: Array<Scalars['String']['output']>;
  /** The updated notification */
  notification: Notification;
};

export type OnboardingEmailTemplate = {
  __typename?: 'OnboardingEmailTemplate';
  enabled: Scalars['Boolean']['output'];
  templateKey: Scalars['String']['output'];
};

/** Onboarding step type */
export type OnboardingStep = {
  __typename?: 'OnboardingStep';
  /** Dynamic action URL for the step based on current environment */
  actionUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['Date']['output']>;
  description: Scalars['String']['output'];
  descriptionKey: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  order: Scalars['Int']['output'];
  stepId: Scalars['String']['output'];
  title: Scalars['String']['output'];
  titleKey: Scalars['String']['output'];
};

/** Onboarding wizard state */
export enum OnboardingWizardState {
  /** Wizard is closed */
  Closed = 'CLOSED',
  /** Wizard is minimized but can be restored */
  Minimized = 'MINIMIZED',
  /** Wizard is fully visible */
  Open = 'OPEN',
}

/** Parameters to filter open work orders report data */
export type OpenWorkOrderReportFilter = {
  /** End date for work orders */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Start date for work orders */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type PDF = {
  __typename?: 'PDF';
  pdf: Scalars['String']['output'];
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage?: Maybe<Scalars['Int']['output']>;
  endIndex?: Maybe<Scalars['Int']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  nextPage?: Maybe<Scalars['Int']['output']>;
  prevPage?: Maybe<Scalars['Int']['output']>;
  startIndex?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
  totalRecords?: Maybe<Scalars['Int']['output']>;
  totalReturnedRecords?: Maybe<Scalars['Int']['output']>;
};

export type PaginationInput = {
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type Payment = Timestamps & {
  __typename?: 'Payment';
  account_id: Scalars['ID']['output'];
  amount: Scalars['Int']['output'];
  attachments?: Maybe<Array<Attachment>>;
  checkNumber?: Maybe<Scalars['String']['output']>;
  client_account_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  invoiceName?: Maybe<Scalars['String']['output']>;
  invoiceNumber: Scalars['String']['output'];
  invoice_id: Scalars['ID']['output'];
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  method: PaymentMethod;
  paymentNotes?: Maybe<Scalars['String']['output']>;
  processedByUser?: Maybe<User>;
  processed_by_user_id?: Maybe<Scalars['ID']['output']>;
  processorEnvironment?: Maybe<Scalars['String']['output']>;
  processorFee?: Maybe<Scalars['Int']['output']>;
  processorTransactionId?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  status: PaymentStatus;
  statusChangeReason?: Maybe<Scalars['String']['output']>;
  transactionDate: Scalars['Date']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum PaymentMethod {
  /** Payment made via bank transfer or ACH */
  BankTransfer = 'BANK_TRANSFER',
  /** Payment made with cash */
  Cash = 'CASH',
  /** Payment made with physical check */
  Check = 'CHECK',
  /** Payment made with credit or debit card */
  CreditCard = 'CREDIT_CARD',
  /** Payment made through alternative method */
  Other = 'OTHER',
  /** Payment processed through external payment processor */
  PaymentProcessor = 'PAYMENT_PROCESSOR',
}

/** Payment metrics */
export type PaymentMetrics = {
  __typename?: 'PaymentMetrics';
  /** Average payment value */
  averageValue: Scalars['Float']['output'];
  /** Total count of payments */
  count: Scalars['Int']['output'];
  /** Maximum payment value */
  maxValue?: Maybe<Scalars['Float']['output']>;
  /** Minimum payment value */
  minValue?: Maybe<Scalars['Float']['output']>;
  /** Status breakdown */
  statusBreakdown: Array<StatusCount>;
  /** Total payment value */
  totalValue: Scalars['Float']['output'];
};

export enum PaymentStatus {
  /** Payment has been successfully processed and completed */
  Completed = 'COMPLETED',
  /** Payment processing failed or was declined */
  Failed = 'FAILED',
  /** Payment is being processed and awaiting completion */
  Pending = 'PENDING',
  /** Payment has been refunded to the customer */
  Refunded = 'REFUNDED',
  /** Payment has been voided and cancelled */
  Voided = 'VOIDED',
}

export enum PaymentsSortBy {
  Amount = 'AMOUNT',
  CreatedAt = 'CREATED_AT',
  Method = 'METHOD',
  Status = 'STATUS',
  TransactionDate = 'TRANSACTION_DATE',
  UpdatedAt = 'UPDATED_AT',
}

/**
 * Stripe Connect pending requirements (admin-only visibility).
 * Captures the current state of Stripe's verification requirements.
 */
export type PendingRequirements = {
  __typename?: 'PendingRequirements';
  /** Requirements SP must fulfill now. */
  currentlyDue?: Maybe<Array<Scalars['String']['output']>>;
  /** Why the account is disabled (if applicable). */
  disabledReason?: Maybe<Scalars['String']['output']>;
  /** Future requirements that will eventually be due. */
  eventuallyDue?: Maybe<Array<Scalars['String']['output']>>;
  /** When requirements were last synced from Stripe. */
  lastUpdated?: Maybe<Scalars['Date']['output']>;
  /** Overdue requirements (more urgent). */
  pastDue?: Maybe<Array<Scalars['String']['output']>>;
  /** Submitted and awaiting Stripe verification. */
  pendingVerification?: Maybe<Array<Scalars['String']['output']>>;
};

/** Permission types for admin users */
export type Permission = {
  __typename?: 'Permission';
  /** Actions allowed on this resource */
  actions: Array<Scalars['String']['output']>;
  /** Resource this permission applies to */
  resource: Scalars['String']['output'];
};

export type PlanFeatures = {
  __typename?: 'PlanFeatures';
  crewsEnabled: Scalars['Boolean']['output'];
  maxSeats?: Maybe<Scalars['Int']['output']>;
  multiUser: Scalars['Boolean']['output'];
};

export type PlanMetadata = {
  __typename?: 'PlanMetadata';
  billingCycle: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  legacy: Scalars['Boolean']['output'];
  maxSeats?: Maybe<Scalars['Int']['output']>;
  minSeats?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  perSeat: Scalars['Boolean']['output'];
  planCode: Scalars['String']['output'];
  stripe_price_id: Scalars['String']['output'];
  stripe_product_id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  unitAmount: Scalars['Int']['output'];
  updatedAt: Scalars['String']['output'];
};

export type PrefreshAccountInfo = {
  __typename?: 'PrefreshAccountInfo';
  accountId: Scalars['String']['output'];
  accountType: Scalars['String']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  queriesPrerefreshed: Scalars['Int']['output'];
};

export type PrepareQuickBooksImport = {
  __typename?: 'PrepareQuickBooksImport';
  importJob: QuickBooksImportJob;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type PrepareQuickBooksImportResponse = Error | PrepareQuickBooksImport;

export type PreviewAdminSubscriptionPlanChange = {
  __typename?: 'PreviewAdminSubscriptionPlanChange';
  message: Scalars['String']['output'];
  preview: AdminSubscriptionPlanChangePreview;
};

export type PreviewAdminSubscriptionPlanChangeInput = {
  account_id: Scalars['ID']['input'];
  downgradeAction?: InputMaybe<AdminPlanDowngradeAction>;
  planCode: Scalars['String']['input'];
  seats?: InputMaybe<Scalars['Int']['input']>;
};

export type PreviewAdminSubscriptionPlanChangeResponse = Error | PreviewAdminSubscriptionPlanChange;

export type ProcessInvoicePayment = {
  __typename?: 'ProcessInvoicePayment';
  message: Scalars['String']['output'];
  payment: Payment;
  version: Scalars['String']['output'];
};

export type ProcessInvoicePaymentResponse = Error | ProcessInvoicePayment;

/** Common filter structure for all productivity reports */
export type ProductivityReportFilter = {
  /** Filter by specific crew IDs */
  crew_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date for filtering */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Start date for filtering */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by specific user IDs */
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Productivity statistics including time and utilization metrics */
export type ProductivityStats = {
  __typename?: 'ProductivityStats';
  /** Average completion time in hours */
  avgCompletionTimeHours: Scalars['Float']['output'];
  /** Job hours breakdown by type */
  jobHours: JobHours;
  /** Utilization percentage */
  utilizationPercentage: Scalars['Float']['output'];
};

export enum PropertiesSortBy {
  Address = 'ADDRESS',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
}

export type Property = Timestamps & {
  __typename?: 'Property';
  account_id?: Maybe<Scalars['ID']['output']>;
  address1: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  attachments?: Maybe<Array<Attachment>>;
  availability: Availability;
  city: Scalars['String']['output'];
  client_account_id?: Maybe<Scalars['ID']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  /** Geographic coordinates for the property address */
  geoCoordinates?: Maybe<GeoLatLng>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  /** Indicates if the property is in use and cannot be deleted (based on deletion rules) */
  isInUse: Scalars['Boolean']['output'];
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Note>>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  propertyType: propertyTypeEnum;
  /** Use drop down list of states. Send 2 character data, display full text. Ex: Send 'AL', display 'Alabama' https://www.drupal.org/node/332575 */
  state: Scalars['String']['output'];
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  zip: Scalars['String']['output'];
};

/** Property metrics */
export type PropertyMetrics = {
  __typename?: 'PropertyMetrics';
  /** Total count of properties */
  count: Scalars['Int']['output'];
  /** Breakdown by property type */
  typeBreakdown: Array<StatusCount>;
};

/** Filter for location-based job search */
export type ProximityFilter = {
  /** Center point latitude */
  latitude: Scalars['Float']['input'];
  /** Center point longitude */
  longitude: Scalars['Float']['input'];
  /** Search radius in miles */
  radiusMiles: Scalars['Float']['input'];
};

export type PublicInvoice = Timestamps & {
  __typename?: 'PublicInvoice';
  balanceDue?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type PublicInvoicePaymentInfo = {
  __typename?: 'PublicInvoicePaymentInfo';
  businessName: Scalars['String']['output'];
  canAcceptPayment: Scalars['Boolean']['output'];
  invoiceId: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  remainingBalance: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
};

export type PullSyncAppointments = {
  __typename?: 'PullSyncAppointments';
  appointments: Array<Appointment>;
  deletedAppointmentIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for pulling appointment sync data with cursor-based pagination. */
export type PullSyncAppointmentsInput = {
  /** Opaque cursor for resuming an interrupted sync. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Return records modified after this timestamp. Null for initial sync. */
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Records per page; default 50 and maximum 200. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncAppointmentsResponse = Error | PullSyncAppointments;

export type PullSyncChecklists = {
  __typename?: 'PullSyncChecklists';
  checklists: Array<Checklist>;
  /** IDs of checklists deleted since lastSyncedAt (empty on initial sync) */
  deletedChecklistIds: Array<Scalars['ID']['output']>;
  deletedIds: Array<Scalars['ID']['output']>;
  /** Whether there are more records to fetch */
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  /** Cursor for fetching the next batch (null if no more records) */
  nextCursor?: Maybe<Scalars['String']['output']>;
  records: Array<Checklist>;
  /** Server timestamp captured at start of sync - store for next delta sync */
  syncedAt: Scalars['Date']['output'];
  /** Total records matching the sync criteria */
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for pull-syncing checklists from the server to offline storage */
export type PullSyncChecklistsInput = {
  /** Opaque cursor for resuming an interrupted sync */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Return only records modified after this timestamp. Null for initial full sync. */
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Number of records per batch (default 50, max 200) */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncChecklistsResponse = Error | PullSyncChecklists;

export type PullSyncClients = {
  __typename?: 'PullSyncClients';
  clients: Array<ClientAccount>;
  /** IDs of client accounts deleted since lastSyncedAt (empty on initial sync) */
  deletedClientIds: Array<Scalars['ID']['output']>;
  /** Whether there are more records to fetch */
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  /** Cursor for fetching the next batch (null if no more records) */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Server timestamp captured at start of sync - store for next delta sync */
  syncedAt: Scalars['Date']['output'];
  /** Total records matching the sync criteria */
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for pulling client account sync data with cursor-based pagination. */
export type PullSyncClientsInput = {
  /** Opaque cursor for resuming an interrupted sync */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Return only records modified after this timestamp. Null for initial full sync. */
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Number of records per batch (default 50, max 200) */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncClientsResponse = Error | PullSyncClients;

export type PullSyncCrews = {
  __typename?: 'PullSyncCrews';
  crews: Array<Crew>;
  /** IDs of crews deleted since lastSyncedAt (empty on initial sync) */
  deletedCrewIds: Array<Scalars['ID']['output']>;
  /** Whether there are more records to fetch */
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  /** Cursor for fetching the next batch (null if no more records) */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Server timestamp captured at start of sync - store for next delta sync */
  syncedAt: Scalars['Date']['output'];
  /** Total records matching the sync criteria */
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for pull-syncing crews from the server to offline storage */
export type PullSyncCrewsInput = {
  /** Opaque cursor for resuming an interrupted sync */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Return only records modified after this timestamp. Null for initial full sync. */
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Number of records per batch (default 50, max 200) */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncCrewsResponse = Error | PullSyncCrews;

export type PullSyncEstimates = {
  __typename?: 'PullSyncEstimates';
  deletedIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  records: Array<Estimate>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for pulling estimate sync data with cursor-based pagination. */
export type PullSyncEstimatesInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Include recurring instances in results (default false - instances are hidden from normal listings) */
  includeRecurringInstances?: InputMaybe<Scalars['Boolean']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncEstimatesResponse = Error | PullSyncEstimates;

export type PullSyncGroups = {
  __typename?: 'PullSyncGroups';
  deletedGroupIds: Array<Scalars['ID']['output']>;
  groups: Array<Group>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type PullSyncGroupsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncGroupsResponse = Error | PullSyncGroups;

export type PullSyncInvoices = {
  __typename?: 'PullSyncInvoices';
  deletedIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  records: Array<Invoice>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type PullSyncInvoicesInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncInvoicesResponse = Error | PullSyncInvoices;

export type PullSyncJobs = {
  __typename?: 'PullSyncJobs';
  /** IDs of jobs deleted since lastSyncedAt (empty on initial sync) */
  deletedJobIds: Array<Scalars['ID']['output']>;
  /** Whether there are more records to fetch */
  hasMore: Scalars['Boolean']['output'];
  jobs: Array<Job>;
  message: Scalars['String']['output'];
  /** Cursor for fetching the next batch (null if no more records) */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /** Server timestamp captured at start of sync - store for next delta sync */
  syncedAt: Scalars['Date']['output'];
  /** Total records matching the sync criteria */
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for pull-syncing jobs from the server to offline storage */
export type PullSyncJobsInput = {
  /** Opaque cursor for resuming an interrupted sync */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Include recurring instances in results (default false - instances are hidden from normal listings) */
  includeRecurringInstances?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only records modified after this timestamp. Null for initial full sync. */
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Number of records per batch (default 50, max 200) */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncJobsResponse = Error | PullSyncJobs;

export type PullSyncManufacturers = {
  __typename?: 'PullSyncManufacturers';
  deletedIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  records: Array<Manufacturer>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for pulling Manufacturer sync data with cursor-based pagination. */
export type PullSyncManufacturersInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncManufacturersResponse = Error | PullSyncManufacturers;

export type PullSyncPayments = {
  __typename?: 'PullSyncPayments';
  deletedPaymentIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  records: Array<Payment>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for pulling account-scoped Payment changes with cursor pagination. */
export type PullSyncPaymentsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncPaymentsResponse = Error | PullSyncPayments;

export type PullSyncProperties = {
  __typename?: 'PullSyncProperties';
  deletedIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  records: Array<Property>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type PullSyncPropertiesInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncPropertiesResponse = Error | PullSyncProperties;

export type PullSyncServiceItems = {
  __typename?: 'PullSyncServiceItems';
  deletedIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  serviceItems: Array<ServiceItem>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for an incremental, account-scoped Service Item pull. */
export type PullSyncServiceItemsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncServiceItemsResponse = Error | PullSyncServiceItems;

/** Successful TaxRate pull-sync response. */
export type PullSyncTaxrates = {
  __typename?: 'PullSyncTaxrates';
  deletedIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  records: Array<TaxRate>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for pulling TaxRate sync data with cursor-based pagination. */
export type PullSyncTaxratesInput = {
  /** Opaque cursor for resuming an interrupted sync. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Return only records modified after this timestamp. Null for initial full sync. */
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  /** Number of records per batch (default 50, max 200). */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncTaxratesResponse = Error | PullSyncTaxrates;

export type PullSyncTimesheetEntries = {
  __typename?: 'PullSyncTimesheetEntries';
  deletedTimesheetEntryIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  syncedAt: Scalars['Date']['output'];
  timesheetEntries: Array<TimesheetEntry>;
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type PullSyncTimesheetEntriesInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncTimesheetEntriesResponse = Error | PullSyncTimesheetEntries;

export type PullSyncTimesheets = {
  __typename?: 'PullSyncTimesheets';
  deletedTimesheetIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  syncedAt: Scalars['Date']['output'];
  timesheets: Array<Timesheet>;
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type PullSyncTimesheetsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchTimesheetsFilter>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncTimesheetsResponse = Error | PullSyncTimesheets;

export type PullSyncUsers = {
  __typename?: 'PullSyncUsers';
  deletedUserIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  users: Array<SyncUserRecord>;
  version: Scalars['String']['output'];
};

export type PullSyncUsersInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncUsersResponse = Error | PullSyncUsers;

export type PullSyncVendors = {
  __typename?: 'PullSyncVendors';
  deletedIds: Array<Scalars['ID']['output']>;
  hasMore: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  records: Array<Vendor>;
  syncedAt: Scalars['Date']['output'];
  totalRecords: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

/** Input for pulling Vendor sync data with cursor-based pagination. */
export type PullSyncVendorsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  lastSyncedAt?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type PullSyncVendorsResponse = Error | PullSyncVendors;

export type PushSyncAppointments = {
  __typename?: 'PushSyncAppointments';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<SyncAppointmentChangeResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

/** Input for pushing appointment changes to the server. */
export type PushSyncAppointmentsInput = {
  changes: Array<SyncAppointmentChangeInput>;
};

export type PushSyncAppointmentsResponse = Error | PushSyncAppointments;

export type PushSyncChecklists = {
  __typename?: 'PushSyncChecklists';
  /** Count of conflicted changes requiring client resolution */
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  /** Results for each change in the batch */
  results: Array<SyncChecklistChangeResult>;
  /** Count of successfully applied changes */
  successCount: Scalars['Int']['output'];
  /** Server timestamp for reference */
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

/** Input for push-syncing offline checklist changes to the server */
export type PushSyncChecklistsInput = {
  /** Array of checklist changes to push */
  changes: Array<SyncChecklistChangeInput>;
};

export type PushSyncChecklistsResponse = Error | PushSyncChecklists;

export type PushSyncClients = {
  __typename?: 'PushSyncClients';
  /** Count of conflicted changes requiring client resolution */
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  /** Results for each change in the batch */
  results: Array<SyncClientChangeResult>;
  /** Count of successfully applied changes */
  successCount: Scalars['Int']['output'];
  /** Server timestamp for reference */
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

/** Input for push-syncing offline client account changes to the server. */
export type PushSyncClientsInput = {
  /** Array of client account changes to push (max 50 per batch) */
  changes: Array<SyncClientChangeInput>;
};

export type PushSyncClientsResponse = Error | PushSyncClients;

export type PushSyncCrews = {
  __typename?: 'PushSyncCrews';
  /** Count of conflicted changes requiring client resolution */
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  /** Results for each change in the batch */
  results: Array<SyncCrewChangeResult>;
  /** Count of successfully applied changes */
  successCount: Scalars['Int']['output'];
  /** Server timestamp for reference */
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

/** Input for push-syncing offline crew changes to the server */
export type PushSyncCrewsInput = {
  /** Array of crew changes to push */
  changes: Array<SyncCrewChangeInput>;
};

export type PushSyncCrewsResponse = Error | PushSyncCrews;

export type PushSyncEstimateResult = {
  __typename?: 'PushSyncEstimateResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  estimateTempId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverEstimate?: Maybe<Estimate>;
  serverId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
};

export type PushSyncEstimates = {
  __typename?: 'PushSyncEstimates';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<PushSyncEstimateResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type PushSyncEstimatesInput = {
  changes: Array<SyncEstimateChangeInput>;
};

export type PushSyncEstimatesResponse = Error | PushSyncEstimates;

export type PushSyncGroups = {
  __typename?: 'PushSyncGroups';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<SyncGroupChangeResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type PushSyncGroupsInput = {
  changes: Array<SyncGroupChangeInput>;
};

export type PushSyncGroupsResponse = Error | PushSyncGroups;

export type PushSyncInvoiceResult = {
  __typename?: 'PushSyncInvoiceResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  invoiceTempId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverId?: Maybe<Scalars['ID']['output']>;
  serverInvoice?: Maybe<Invoice>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
};

export type PushSyncInvoices = {
  __typename?: 'PushSyncInvoices';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<PushSyncInvoiceResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type PushSyncInvoicesInput = {
  changes: Array<SyncInvoiceChangeInput>;
};

export type PushSyncInvoicesResponse = Error | PushSyncInvoices;

export type PushSyncJobs = {
  __typename?: 'PushSyncJobs';
  /** Count of conflicted changes requiring client resolution */
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  /** Results for each change in the batch */
  results: Array<SyncJobChangeResult>;
  /** Count of successfully applied changes */
  successCount: Scalars['Int']['output'];
  /** Server timestamp for reference */
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type PushSyncJobsInput = {
  changes: Array<SyncJobChangeInput>;
};

export type PushSyncJobsResponse = Error | PushSyncJobs;

export type PushSyncManufacturers = {
  __typename?: 'PushSyncManufacturers';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<SyncManufacturerChangeResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

/** Input for push-syncing offline Manufacturer changes. */
export type PushSyncManufacturersInput = {
  changes: Array<SyncManufacturerChangeInput>;
};

export type PushSyncManufacturersResponse = Error | PushSyncManufacturers;

export type PushSyncPayments = {
  __typename?: 'PushSyncPayments';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<SyncPaymentChangeResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type PushSyncPaymentsInput = {
  changes: Array<SyncPaymentChangeInput>;
};

export type PushSyncPaymentsResponse = Error | PushSyncPayments;

export type PushSyncProperties = {
  __typename?: 'PushSyncProperties';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<PushSyncPropertyResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type PushSyncPropertiesInput = {
  changes: Array<SyncPropertyChangeInput>;
};

export type PushSyncPropertiesResponse = Error | PushSyncProperties;

export type PushSyncPropertyResult = {
  __typename?: 'PushSyncPropertyResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  propertyTempId?: Maybe<Scalars['ID']['output']>;
  serverId?: Maybe<Scalars['ID']['output']>;
  serverProperty?: Maybe<Property>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
};

export type PushSyncServiceItems = {
  __typename?: 'PushSyncServiceItems';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<SyncServiceItemChangeResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type PushSyncServiceItemsInput = {
  changes: Array<SyncServiceItemChangeInput>;
};

export type PushSyncServiceItemsResponse = Error | PushSyncServiceItems;

/** Successful TaxRate push-sync batch response. */
export type PushSyncTaxrates = {
  __typename?: 'PushSyncTaxrates';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<SyncTaxrateChangeResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

/** Input for push-syncing offline TaxRate changes. */
export type PushSyncTaxratesInput = {
  /** Array of TaxRate changes to push (max 50 per batch). */
  changes: Array<SyncTaxrateChangeInput>;
};

export type PushSyncTaxratesResponse = Error | PushSyncTaxrates;

export type PushSyncTimesheetEntries = {
  __typename?: 'PushSyncTimesheetEntries';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<SyncTimesheetEntryChangeResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type PushSyncTimesheetEntriesInput = {
  changes: Array<SyncTimesheetEntryChangeInput>;
};

export type PushSyncTimesheetEntriesResponse = Error | PushSyncTimesheetEntries;

export type PushSyncTimesheets = {
  __typename?: 'PushSyncTimesheets';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<SyncTimesheetChangeResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type PushSyncTimesheetsInput = {
  changes: Array<SyncTimesheetChangeInput>;
};

export type PushSyncTimesheetsResponse = Error | PushSyncTimesheets;

export type PushSyncUserResult = {
  __typename?: 'PushSyncUserResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverId?: Maybe<Scalars['ID']['output']>;
  serverUser?: Maybe<SyncUserRecord>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
  userTempId?: Maybe<Scalars['ID']['output']>;
};

export type PushSyncUsers = {
  __typename?: 'PushSyncUsers';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<PushSyncUserResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type PushSyncUsersInput = {
  changes: Array<SyncUserChangeInput>;
};

export type PushSyncUsersResponse = Error | PushSyncUsers;

export type PushSyncVendors = {
  __typename?: 'PushSyncVendors';
  conflictCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  results: Array<SyncVendorChangeResult>;
  successCount: Scalars['Int']['output'];
  syncedAt: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

/** Input for push-syncing offline Vendor changes. */
export type PushSyncVendorsInput = {
  changes: Array<SyncVendorChangeInput>;
};

export type PushSyncVendorsResponse = Error | PushSyncVendors;

export type Query = {
  __typename?: 'Query';
  /** Get all active devices for push notifications */
  activeDevices: FCMActiveDevicesResponse;
  /** Admin: Get client accounts with cross-account filtering support */
  adminGetClientAccounts?: Maybe<GetClientAccountsResponse>;
  /** Admin: Get service provider accounts with filtering support */
  adminGetServiceProviderAccounts?: Maybe<GetServiceProviderAccountsResponse>;
  /**
   * Process a natural language query through the AI framework.
   * The framework selects the appropriate tool and returns a formatted response.
   * Supports optional image transcription for text extraction or intelligent interpretation.
   */
  aiQuery: AIQueryResult;
  /** Calculate application fee for a given amount */
  calculateApplicationFee: CalculateApplicationFeeResponse;
  /** Calculate fee preview */
  calculateFeePreview?: Maybe<CalculateFeePreviewResponse>;
  /** Check admin password expiry status */
  checkAdminPasswordExpiry?: Maybe<CheckAdminPasswordExpiryResponse>;
  /** Get a specific device by ID */
  device: FCMDeviceResponse;
  /** Get device status information */
  deviceStatus: FCMDeviceStatusResponse;
  /** Get all devices for the current user */
  devices: FCMDeviceConnection;
  /** Export client accounts to CSV with billing info and properties */
  exportClientsCSV?: Maybe<ExportClientsCSVResponse>;
  /** Export service items to CSV */
  exportServiceItemsCSV?: Maybe<ExportServiceItemsCSVResponse>;
  /** Look up a CLIENT account by email or phone to decide whether to show a Send-Invite CTA instead of the bare 'User email already exists' error in createClient. SP-auth required. */
  findExistingClient: FindExistingClientResponse;
  /**
   * Get the current AI billing ledger state (singleton). Admin-only.
   * Returns the current balance, lifetime totals, thresholds, and alert level.
   */
  getAIBillingBalance: GetAIBillingBalanceResponse;
  /**
   * Get a paginated, newest-first list of AI billing transactions (credits,
   * usage, and adjustments). Admin-only.
   */
  getAIBillingLedger: GetAIBillingLedgerResponse;
  getAccountCacheDetails?: Maybe<GetAccountCacheDetailsResponse>;
  /** Get admin activity log with pagination */
  getAdminActivityLog?: Maybe<GetAdminActivityLogResponse>;
  /** Get admin audit logs (SUPER_ADMIN only) */
  getAdminAuditLogs?: Maybe<GetAdminAuditLogsResponse>;
  /** Get all available admin permissions */
  getAdminPermissions?: Maybe<GetAdminPermissionsResponse>;
  /** Get admin user information */
  getAdminUser?: Maybe<GetAdminUserResponse>;
  /** Get list of admin users with pagination and filtering */
  getAdminUsers?: Maybe<GetAdminUsersResponse>;
  /**
   * Discover available AI tools for the current user.
   * Tools are filtered based on user role and permissions.
   */
  getAiTools: GetAIToolsResult;
  /** Get the status and progress of a system announcement background job (SUPER_ADMIN only) */
  getAnnouncementJobStatus: GetAnnouncementJobStatusResponse;
  /** Get application fee history with pagination */
  getApplicationFeeHistory: GetApplicationFeeHistoryResponse;
  getAppointment: GetAppointmentResponse;
  getAppointments: GetAppointmentsResponse;
  /** Get attachment */
  getAttachment?: Maybe<GetAttachmentResponse>;
  /** Get attachments */
  getAttachments?: Maybe<GetAttachmentsResponse>;
  /** Get available (free) time slots for a crew on a given date, accounting for existing bookings */
  getAvailableSlots: GetAvailableSlotsResponse;
  /** Get background job status and details */
  getBackgroundJob: BackgroundJobsResponse;
  /** Get the beta lifecycle enrollment for one service-provider account (Admin only) */
  getBetaLifecycleEnrollment: BetaLifecycleEnrollmentResponse;
  getBillingHistory?: Maybe<GetBillingHistoryResponse>;
  /** Get comprehensive cache status with optional account-specific details. In local env: no auth required. In other envs: admin only. */
  getCacheStatus?: Maybe<GetCacheStatusResponse>;
  /** Get chat */
  getChat?: Maybe<GetChatResponse>;
  /** Get chats */
  getChats?: Maybe<GetChatsResponse>;
  /** Get a checklist by id */
  getChecklist?: Maybe<GetChecklistResponse>;
  /** Get checklist entries */
  getChecklistEntries?: Maybe<GetChecklistEntriesResponse>;
  /** Get checklist */
  getChecklistEntry?: Maybe<GetChecklistEntryResponse>;
  /** Get checklists */
  getChecklists?: Maybe<GetChecklistsResponse>;
  /** Get client account information for service provider */
  getClientAccount?: Maybe<GetClientAccountResponse>;
  /** Get client account settings (CLIENT only) */
  getClientAccountSettings: GetClientAccountSettingsResponse;
  /** Get all unique tags from client accounts */
  getClientAccountTags?: Maybe<GetClientAccountTagsResponse>;
  /** Get client accounts linked to logged in service provider account */
  getClientAccounts?: Maybe<GetClientAccountsResponse>;
  /** Preview a client invite magic-link token without consuming it. Public route used by the client portal invite screen. */
  getClientInvitePreview: ClientInvitePreviewResponse;
  /** Get sample CSV for client import */
  getClientSampleCSV?: Maybe<GetClientSampleCSVResponse>;
  /** Get detailed Connect application information for a specific account */
  getConnectApplicationDetails?: Maybe<GetConnectApplicationDetailsResponse>;
  /** Get summary of Connect applications by status */
  getConnectApplicationSummary?: Maybe<GetConnectApplicationSummaryResponse>;
  /** Get Connect onboarding status */
  getConnectOnboardingStatus: GetConnectOnboardingStatusResponse;
  /** Get Connect onboarding URL */
  getConnectOnboardingUrl?: Maybe<GetConnectOnboardingUrlResponse>;
  /** Get crew information from service provider admin */
  getCrew?: Maybe<GetCrewResponse>;
  /** Get crews linked to current logged in user's account */
  getCrews?: Maybe<GetCrewsResponse>;
  /** Get current admin user session information */
  getCurrentAdminUser?: Maybe<GetAdminUserSessionResponse>;
  /** Get the current user's materialized dashboard snapshot */
  getDashboard?: Maybe<GetDashboardResponse>;
  /** Get dashboard report with key business metrics */
  getDashboardReport?: Maybe<GetDashboardReportResponse>;
  /** Get weekly trend data (past 12 weeks) for dashboard sparkline charts */
  getDashboardTrend?: Maybe<GetDashboardTrendResponse>;
  /** Check if email provided in argument is in use by another user */
  getEmailInUse?: Maybe<GetEmailInUseResponse>;
  /** Get estimates */
  getEstimate?: Maybe<GetEstimateResponse>;
  getEstimatePDF?: Maybe<GetEstimatePDFResponse>;
  getEstimates?: Maybe<GetEstimatesResponse>;
  /** Get fee statistics */
  getFeeStatistics?: Maybe<GetFeeStatisticsResponse>;
  /** Get feedback entries */
  getFeedbackEntries?: Maybe<GetFeedbackEntriesResponse>;
  /** Get feedback entry */
  getFeedbackEntry?: Maybe<GetFeedbackEntryResponse>;
  /** Get global fee statistics across all Connect accounts */
  getGlobalFeeStatistics?: Maybe<GetGlobalFeeStatisticsResponse>;
  /** Get global beta-program settings for an authenticated administrator */
  getGlobalSettings?: Maybe<GetGlobalSettingsResponse>;
  /** Get group */
  getGroup?: Maybe<GetGroupResponse>;
  /** Get groups */
  getGroups?: Maybe<GetGroupsResponse>;
  /** Get health check */
  getHealth?: Maybe<GetHealthResponse>;
  /** Get IVR call logs for the authenticated service provider */
  getIVRCallLogs: GetIVRCallLogsResponse;
  /** Get IVR voicemails for the authenticated service provider */
  getIVRVoicemails: GetIVRVoicemailsResponse;
  /** Get invoices */
  getInvoice?: Maybe<GetInvoiceResponse>;
  getInvoicePDF?: Maybe<GetInvoicePDFResponse>;
  /** Get invoice payment information for Connect payments */
  getInvoicePaymentInfo?: Maybe<GetInvoicePaymentInfoResponse>;
  getInvoices?: Maybe<GetInvoicesResponse>;
  /** Get jobs */
  getJob?: Maybe<GetJobResponse>;
  /** Get estimated time of arrival for a job */
  getJobEnRouteETA?: Maybe<GetJobEnRouteETAResponse>;
  /** Get feedback status for a job (whether feedback exists or was skipped) */
  getJobFeedbackStatus?: Maybe<GetJobFeedbackStatusResponse>;
  getJobPDF?: Maybe<GetJobPDFResponse>;
  getJobs?: Maybe<GetJobsResponse>;
  /** Get list */
  getList?: Maybe<GetListsResponse>;
  /** Get unique cities and states from client properties and billing information */
  getLocations: GetLocationsResponse;
  /** Get manufacturer */
  getManufacturer?: Maybe<GetManufacturerResponse>;
  /** Get manufacturers */
  getManufacturers?: Maybe<GetManufacturersResponse>;
  /** Get messages */
  getMessages?: Maybe<GetMessagesResponse>;
  /** Get minimum mobile app versions for iOS and Android - no authentication required */
  getMinimumMobileAppVersions: GetMinimumMobileAppVersionsResponse;
  /** Get note */
  getNote?: Maybe<GetNoteResponse>;
  /** Get notes */
  getNotes?: Maybe<GetNotesResponse>;
  /** Get single notification by ID */
  getNotification: GetNotificationResponse;
  /** Get user notification preferences */
  getNotificationPreferences: GetNotificationPreferencesResponse;
  /** Get notification types and the channels available to the QA workspace */
  getNotificationQaCatalog: NotificationQaCatalogResponse;
  /** Get notification settings (account + user) */
  getNotificationSettings: GetNotificationSettingsResponse;
  /** Get list of notifications for current user */
  getNotifications: GetNotificationsResponse;
  getOfflineSyncClientParents?: Maybe<GetOfflineSyncClientParentsResponse>;
  /** List onboarding email templates available for QA manual send */
  getOnboardingEmailTemplates: GetOnboardingEmailTemplatesResponse;
  /** Get onboarding steps */
  getOnboardingSteps?: Maybe<GetOnboardingStepsResponse>;
  /** Check password strength of password provided in argument */
  getPasswordStrength?: Maybe<GetPasswordStrengthResponse>;
  /** Get payment */
  getPayment?: Maybe<GetPaymentResponse>;
  /** Get payments */
  getPayments?: Maybe<GetPaymentsResponse>;
  /** Get pending Connect applications for admin review */
  getPendingConnectApplications?: Maybe<GetPendingConnectApplicationsResponse>;
  /** Check if phone number provided in argument is in use by another user */
  getPhoneInUse?: Maybe<GetPhoneInUseResponse>;
  /** Get properties */
  getProperties?: Maybe<GetPropertiesResponse>;
  /** Get property */
  getProperty?: Maybe<GetPropertyResponse>;
  /** Get public invoice */
  getPublicInvoice?: Maybe<GetPublicInvoiceResponse>;
  /** Check if referral code is valid (public route) */
  getPublicReferralCodeIsValid?: Maybe<GetPublicReferralCodeIsValidResponse>;
  /** Get QBO chart of accounts for mapping dropdowns */
  getQBOAccounts: GetQBOAccountsResponse;
  /** Get QuickBooks connection status for the current account */
  getQuickBooksConnection: GetQuickBooksConnectionResponse;
  /** Get all conflict records for a PENDING_REVIEW import job, including their current resolution status */
  getQuickBooksImportConflicts: GetQuickBooksImportConflictsResponse;
  /** Get a specific QuickBooks import job by id */
  getQuickBooksImportJob: GetQuickBooksImportJobResponse;
  /** Get import preview counts from QuickBooks */
  getQuickBooksImportPreview: GetQuickBooksImportPreviewResponse;
  /** Get the latest QuickBooks import job for the current account (any state) */
  getQuickBooksLatestImportJob: GetQuickBooksImportJobResponse;
  /** Get detail for a single sync log entry */
  getQuickBooksSyncLogDetail: GetQuickBooksSyncLogDetailResponse;
  /** Get paginated sync activity logs with filters */
  getQuickBooksSyncLogs: GetQuickBooksSyncLogsResponse;
  /** Get QuickBooks sync settings for the current account */
  getQuickBooksSyncSettings: GetQuickBooksSyncSettingsResponse;
  /** Get absentee report for attendance monitoring */
  getReportDataAbsentee?: Maybe<GetReportDataAbsenteeResponse>;
  /** Calculate average job duration metrics, optionally filtered by crew */
  getReportDataAverageJobDuration?: Maybe<GetReportDataAverageJobDurationResponse>;
  /** Get comprehensive report data for all entities by account ID (admin only) */
  getReportDataByAccount?: Maybe<ReportDataByAccountResponse>;
  /** Get completed work orders report data */
  getReportDataCompletedWorkOrders?: Maybe<GetReportDataCompletedWorkOrdersResponse>;
  /** Get crewUser status report data with performance metrics */
  getReportDataCrewUserStatus?: Maybe<GetReportDataCrewUserStatusResponse>;
  /** Get crew user working hours report with audit trail data */
  getReportDataCrewUserWorkingHours?: Maybe<GetReportDataCrewUserWorkingHoursResponse>;
  /** Get customer complaints report data by crew lead */
  getReportDataCustomerComplaints?: Maybe<GetReportDataCustomerComplaintsResponse>;
  /** Get customer satisfaction report data by crew lead */
  getReportDataCustomerSatisfaction?: Maybe<GetReportDataCustomerSatisfactionResponse>;
  /** Calculate idle time percentage for crew utilization analysis */
  getReportDataIdleTime?: Maybe<GetReportDataIdleTimeResponse>;
  /** Get job productivity report with flexible crew vs user analysis */
  getReportDataJobProductivity?: Maybe<GetReportDataJobProductivityResponse>;
  /** Get open work orders report data */
  getReportDataOpenWorkOrders?: Maybe<GetReportDataOpenWorkOrdersResponse>;
  /** Calculate travel time between jobs for users or crews */
  getReportDataTravelTime?: Maybe<GetReportDataTravelTimeResponse>;
  /** Get work orders report data with filtering */
  getReportDataWorkOrders?: Maybe<GetReportDataWorkOrdersResponse>;
  /** Get working hours report with flexible crew vs user analysis */
  getReportDataWorkingHoursByGroup?: Maybe<GetReportDataWorkingHoursByGroupResponse>;
  /** Get service categories - Public API */
  getServiceCategories?: Maybe<GetServiceCategoriesResponse>;
  /** Get service item information from service provider or client admin */
  getServiceItem?: Maybe<GetServiceItemResponse>;
  /** Get sample CSV for service item import */
  getServiceItemSampleCSV?: Maybe<GetServiceItemSampleCSVResponse>;
  /** Get service item tags */
  getServiceItemTags?: Maybe<GetServiceItemTagsResponse>;
  /** Get service items linked to current logged in user's account */
  getServiceItems?: Maybe<GetServiceItemsResponse>;
  /** Get service provider account for client admin (admins can specify account_id) */
  getServiceProviderAccount?: Maybe<GetServiceProviderAccountResponse>;
  /** Get service provider account settings (SP_ADMIN/SP_OWNER only) */
  getServiceProviderAccountSettings: GetServiceProviderAccountSettingsResponse;
  /** Get service provider accounts for client admin */
  getServiceProviderAccounts?: Maybe<GetServiceProviderAccountsResponse>;
  /** Get service provider by code */
  getServiceProviderByClientCode?: Maybe<GetServiceProviderByClientCodeResponse>;
  /** Get service provider by IVR extension code (for IVR call routing) */
  getServiceProviderByExtensionCode?: Maybe<GetServiceProviderByExtensionCodeResponse>;
  /** Get service provider by referral code */
  getServiceProviderByReferralCode?: Maybe<GetServiceProviderByReferralCodeResponse>;
  /** Get single service provider public profile by ID - no authentication required */
  getServiceProviderPublicProfile?: Maybe<GetServiceProviderPublicProfileResponse>;
  /** Get service provider public profiles for public viewing - no authentication required */
  getServiceProviderPublicProfiles?: Maybe<GetServiceProviderPublicProfilesResponse>;
  /** Get user info for current session */
  getSessionUserInfo?: Maybe<GetUserSessionResponse>;
  /** Get setup status */
  getSetupStatus?: Maybe<GetSetupStatusResponse>;
  /** Check if SKU is already in use within the current account */
  getSkuInUse?: Maybe<GetSkuInUseResponse>;
  getStripeClientKey?: Maybe<GetStripeClientKeyResponse>;
  /** Get a single Subscription plan by its ID */
  getSubscriptionPlan: GetSubscriptionPlanResponse;
  /** Get available Subscription plans and their prices */
  getSubscriptionPlans: GetSubscriptionPlansResponse;
  getSubscriptionSubscriptionPlanChangeHistory?: Maybe<GetSubscriptionPlanChangeLogResponse>;
  /** Get tax rate */
  getTaxRate?: Maybe<GetTaxRateResponse>;
  /** Get tax rates */
  getTaxRates?: Maybe<GetTaxRatesResponse>;
  /** Get timesheet */
  getTimesheet?: Maybe<GetTimesheetResponse>;
  /** Get timesheet analytics */
  getTimesheetAnalytics?: Maybe<GetTimesheetAnalyticsResponse>;
  /** Get timesheet entries */
  getTimesheetEntries?: Maybe<GetTimesheetEntriesResponse>;
  /** Get timesheet entry */
  getTimesheetEntry?: Maybe<GetTimesheetEntryResponse>;
  /** Get timesheets */
  getTimesheets?: Maybe<GetTimesheetsResponse>;
  /** Get unavailable dates for account, crew and client */
  getUnavailableDates?: Maybe<GetUnavailableDatesResponse>;
  /** Get unread notification count */
  getUnreadCount: GetUnreadCountResponse;
  /** Get user information from service provider admin or client admin */
  getUser?: Maybe<GetUserResponse>;
  /** Get avatar for a user */
  getUserAvatar?: Maybe<GetUserAvatarResponse>;
  /** Get current user settings */
  getUserSettings: GetUserSettingsResponse;
  /** Get users linked to current logged in user's account */
  getUsers?: Maybe<GetUsersResponse>;
  /** Get vendor */
  getVendor?: Maybe<GetVendorResponse>;
  /** Get vendors */
  getVendors?: Maybe<GetVendorsResponse>;
  /** Get widget HTML by key */
  getWidgetHTML?: Maybe<GetWidgetHTMLResponse>;
  /** Check whether the current bearer-token session is valid and active */
  isCurrentSessionValid: Scalars['Boolean']['output'];
  /** Get known login devices for the current user */
  knownDevices: KnownDevicesResponse;
  /** Preview admin-triggered subscription plan impact before confirmation */
  previewAdminSubscriptionPlanChange: PreviewAdminSubscriptionPlanChangeResponse;
  pullSyncAppointments?: Maybe<PullSyncAppointmentsResponse>;
  /** Pull-sync checklists from the server for offline storage with cursor-based pagination and delta sync */
  pullSyncChecklists?: Maybe<PullSyncChecklistsResponse>;
  /** Pull-sync client accounts from the server for offline storage with cursor-based pagination and delta sync */
  pullSyncClients?: Maybe<PullSyncClientsResponse>;
  /** Pull-sync crews from the server for offline storage with cursor-based pagination and delta sync */
  pullSyncCrews?: Maybe<PullSyncCrewsResponse>;
  pullSyncEstimates?: Maybe<PullSyncEstimatesResponse>;
  /** Pull-sync groups from the server for offline storage with cursor-based pagination and delta sync */
  pullSyncGroups?: Maybe<PullSyncGroupsResponse>;
  pullSyncInvoices?: Maybe<PullSyncInvoicesResponse>;
  /** Pull-sync jobs from the server for offline storage with cursor-based pagination and delta sync */
  pullSyncJobs?: Maybe<PullSyncJobsResponse>;
  pullSyncManufacturers?: Maybe<PullSyncManufacturersResponse>;
  pullSyncPayments?: Maybe<PullSyncPaymentsResponse>;
  pullSyncProperties?: Maybe<PullSyncPropertiesResponse>;
  pullSyncServiceItems?: Maybe<PullSyncServiceItemsResponse>;
  /** Pull-sync TaxRates for offline storage with cursor-based pagination and delta sync. */
  pullSyncTaxrates?: Maybe<PullSyncTaxratesResponse>;
  pullSyncTimesheetEntries?: Maybe<PullSyncTimesheetEntriesResponse>;
  pullSyncTimesheets?: Maybe<PullSyncTimesheetsResponse>;
  pullSyncUsers?: Maybe<PullSyncUsersResponse>;
  /** Pull vendors from the server for offline storage with cursor-based pagination and delta sync */
  pullSyncVendors?: Maybe<PullSyncVendorsResponse>;
  /** Validate fee calculation */
  validateFeeCalculation?: Maybe<ValidateFeeCalculationResponse>;
  /** Validate invoice for payment */
  validateInvoiceForPayment?: Maybe<ValidateInvoiceForPaymentResponse>;
};

export type QueryadminGetClientAccountsArgs = {
  data?: InputMaybe<AdminSearchAccountsInput>;
};

export type QueryadminGetServiceProviderAccountsArgs = {
  data?: InputMaybe<AdminSearchAccountsInput>;
};

export type QueryaiQueryArgs = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<AIDevice>;
  images?: InputMaybe<Array<ImageInput>>;
  locale?: InputMaybe<Locale>;
  query: Scalars['String']['input'];
};

export type QuerycalculateApplicationFeeArgs = {
  amount: Scalars['Int']['input'];
};

export type QuerycalculateFeePreviewArgs = {
  data: CalculateFeePreviewInput;
};

export type QuerydeviceArgs = {
  deviceId: Scalars['String']['input'];
};

export type QuerydeviceStatusArgs = {
  deviceId: Scalars['String']['input'];
};

export type QuerydevicesArgs = {
  filter?: InputMaybe<DeviceFilter>;
  pagination?: InputMaybe<PaginationInput>;
};

export type QueryexportClientsCSVArgs = {
  data?: InputMaybe<ExportClientsCSVInput>;
};

export type QueryfindExistingClientArgs = {
  data: FindExistingClientInput;
};

export type QuerygetAIBillingLedgerArgs = {
  data?: InputMaybe<GetAIBillingLedgerInput>;
};

export type QuerygetAccountCacheDetailsArgs = {
  account_id: Scalars['String']['input'];
};

export type QuerygetAdminActivityLogArgs = {
  data?: InputMaybe<SearchAdminActivityLogInput>;
};

export type QuerygetAdminAuditLogsArgs = {
  filter?: InputMaybe<AdminAuditLogFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<AdminAuditLogSortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type QuerygetAdminUserArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetAdminUsersArgs = {
  data?: InputMaybe<SearchAdminUsersInput>;
};

export type QuerygetAnnouncementJobStatusArgs = {
  jobId: Scalars['ID']['input'];
};

export type QuerygetApplicationFeeHistoryArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type QuerygetAppointmentArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetAppointmentsArgs = {
  data?: InputMaybe<SearchAppointmentsInput>;
};

export type QuerygetAttachmentArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetAttachmentsArgs = {
  data?: InputMaybe<SearchAttachmentsInput>;
};

export type QuerygetAvailableSlotsArgs = {
  data: GetAvailableSlotsInput;
};

export type QuerygetBackgroundJobArgs = {
  backgroundJobId: Scalars['ID']['input'];
};

export type QuerygetBetaLifecycleEnrollmentArgs = {
  accountId: Scalars['ID']['input'];
};

export type QuerygetBillingHistoryArgs = {
  data?: InputMaybe<BillingHistoryInput>;
};

export type QuerygetCacheStatusArgs = {
  account_id?: InputMaybe<Scalars['String']['input']>;
};

export type QuerygetChatArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetChatsArgs = {
  data?: InputMaybe<SearchChatsInput>;
};

export type QuerygetChecklistArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetChecklistEntriesArgs = {
  data?: InputMaybe<SearchChecklistEntriesInput>;
};

export type QuerygetChecklistEntryArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetChecklistsArgs = {
  data?: InputMaybe<SearchChecklistsInput>;
};

export type QuerygetClientAccountArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerygetClientAccountsArgs = {
  data?: InputMaybe<SearchAccountsInput>;
};

export type QuerygetClientInvitePreviewArgs = {
  token: Scalars['String']['input'];
};

export type QuerygetConnectApplicationDetailsArgs = {
  accountId: Scalars['ID']['input'];
};

export type QuerygetConnectOnboardingUrlArgs = {
  data?: InputMaybe<GetConnectOnboardingUrlInput>;
};

export type QuerygetCrewArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetCrewsArgs = {
  data?: InputMaybe<SearchCrewsInput>;
};

export type QuerygetEmailInUseArgs = {
  email: Scalars['String']['input'];
};

export type QuerygetEstimateArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetEstimatePDFArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetEstimatesArgs = {
  data?: InputMaybe<SearchEstimatesInput>;
};

export type QuerygetFeeStatisticsArgs = {
  data?: InputMaybe<GetFeeStatisticsInput>;
};

export type QuerygetFeedbackEntriesArgs = {
  data?: InputMaybe<SearchFeedbackEntriesInput>;
};

export type QuerygetFeedbackEntryArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetGroupArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetGroupsArgs = {
  data?: InputMaybe<SearchGroupsInput>;
};

export type QuerygetIVRCallLogsArgs = {
  data?: InputMaybe<GetIVRCallLogsInput>;
};

export type QuerygetIVRVoicemailsArgs = {
  data?: InputMaybe<GetIVRVoicemailsInput>;
};

export type QuerygetInvoiceArgs = {
  account_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type QuerygetInvoicePDFArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetInvoicePaymentInfoArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type QuerygetInvoicesArgs = {
  data?: InputMaybe<SearchInvoicesInput>;
};

export type QuerygetJobArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetJobEnRouteETAArgs = {
  jobId: Scalars['ID']['input'];
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type QuerygetJobFeedbackStatusArgs = {
  job_id: Scalars['ID']['input'];
};

export type QuerygetJobPDFArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetJobsArgs = {
  data?: InputMaybe<SearchJobsInput>;
};

export type QuerygetListArgs = {
  cacheTimestamp?: InputMaybe<Scalars['Date']['input']>;
};

export type QuerygetLocationsArgs = {
  data?: InputMaybe<GetLocationsInput>;
};

export type QuerygetManufacturerArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetManufacturersArgs = {
  data?: InputMaybe<SearchManufacturersInput>;
};

export type QuerygetMessagesArgs = {
  data?: InputMaybe<SearchMessagesInput>;
};

export type QuerygetNoteArgs = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type QuerygetNotesArgs = {
  data?: InputMaybe<SearchNotesInput>;
};

export type QuerygetNotificationArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetNotificationsArgs = {
  data: GetNotificationsInput;
};

export type QuerygetOfflineSyncClientParentsArgs = {
  data: GetOfflineSyncClientParentsInput;
};

export type QuerygetPasswordStrengthArgs = {
  password: Scalars['String']['input'];
};

export type QuerygetPaymentArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetPaymentsArgs = {
  data?: InputMaybe<SearchPaymentsInput>;
};

export type QuerygetPendingConnectApplicationsArgs = {
  data?: InputMaybe<SearchConnectApplicationsInput>;
};

export type QuerygetPhoneInUseArgs = {
  phone: Scalars['String']['input'];
};

export type QuerygetPropertiesArgs = {
  data?: InputMaybe<SearchPropertiesInput>;
};

export type QuerygetPropertyArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetPublicInvoiceArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetPublicReferralCodeIsValidArgs = {
  referralCode: Scalars['String']['input'];
};

export type QuerygetQuickBooksImportConflictsArgs = {
  importJobId: Scalars['ID']['input'];
};

export type QuerygetQuickBooksImportJobArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetQuickBooksSyncLogDetailArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetQuickBooksSyncLogsArgs = {
  data: SearchQuickBooksSyncLogsInput;
};

export type QuerygetReportDataAbsenteeArgs = {
  data: SearchAbsenteeReportInput;
};

export type QuerygetReportDataAverageJobDurationArgs = {
  data: SearchAverageJobDurationReportInput;
};

export type QuerygetReportDataByAccountArgs = {
  filter: SearchReportDataByAccountInput;
};

export type QuerygetReportDataCompletedWorkOrdersArgs = {
  data: SearchCompletedWorkOrderReportInput;
};

export type QuerygetReportDataCrewUserStatusArgs = {
  data: SearchCrewUserStatusReportInput;
};

export type QuerygetReportDataCrewUserWorkingHoursArgs = {
  data: SearchCrewUserWorkingHoursInput;
};

export type QuerygetReportDataCustomerComplaintsArgs = {
  data: SearchFeedbackReportInput;
};

export type QuerygetReportDataCustomerSatisfactionArgs = {
  data: SearchFeedbackReportInput;
};

export type QuerygetReportDataIdleTimeArgs = {
  data: SearchIdleTimeReportInput;
};

export type QuerygetReportDataJobProductivityArgs = {
  data: SearchJobProductivityReportInput;
};

export type QuerygetReportDataOpenWorkOrdersArgs = {
  data: SearchOpenWorkOrderReportInput;
};

export type QuerygetReportDataTravelTimeArgs = {
  data: SearchTravelTimeReportInput;
};

export type QuerygetReportDataWorkOrdersArgs = {
  data: SearchWorkOrderReportInput;
};

export type QuerygetReportDataWorkingHoursByGroupArgs = {
  data: SearchWorkingHoursReportInput;
};

export type QuerygetServiceItemArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetServiceItemsArgs = {
  data?: InputMaybe<SearchServiceItemsInput>;
};

export type QuerygetServiceProviderAccountArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerygetServiceProviderAccountsArgs = {
  data?: InputMaybe<SearchAccountsInput>;
};

export type QuerygetServiceProviderByClientCodeArgs = {
  clientCode: Scalars['String']['input'];
};

export type QuerygetServiceProviderByExtensionCodeArgs = {
  extensionCode: Scalars['String']['input'];
};

export type QuerygetServiceProviderByReferralCodeArgs = {
  referralCode: Scalars['String']['input'];
};

export type QuerygetServiceProviderPublicProfileArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetServiceProviderPublicProfilesArgs = {
  data?: InputMaybe<SearchAccountsInput>;
};

export type QuerygetSkuInUseArgs = {
  sku: Scalars['String']['input'];
};

export type QuerygetSubscriptionPlanArgs = {
  planCode: Scalars['String']['input'];
};

export type QuerygetTaxRateArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetTaxRatesArgs = {
  data?: InputMaybe<SearchTaxRatesInput>;
};

export type QuerygetTimesheetArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetTimesheetEntriesArgs = {
  data?: InputMaybe<SearchTimesheetEntriesInput>;
};

export type QuerygetTimesheetEntryArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetTimesheetsArgs = {
  data?: InputMaybe<SearchTimesheetsInput>;
};

export type QuerygetUnavailableDatesArgs = {
  data?: InputMaybe<GetUnavailableDatesInput>;
};

export type QuerygetUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerygetUserAvatarArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuerygetUsersArgs = {
  data?: InputMaybe<SearchUsersInput>;
};

export type QuerygetVendorArgs = {
  id: Scalars['ID']['input'];
};

export type QuerygetVendorsArgs = {
  data?: InputMaybe<SearchVendorsInput>;
};

export type QuerygetWidgetHTMLArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};

export type QuerypreviewAdminSubscriptionPlanChangeArgs = {
  data: PreviewAdminSubscriptionPlanChangeInput;
};

export type QuerypullSyncAppointmentsArgs = {
  data?: InputMaybe<PullSyncAppointmentsInput>;
};

export type QuerypullSyncChecklistsArgs = {
  data?: InputMaybe<PullSyncChecklistsInput>;
};

export type QuerypullSyncClientsArgs = {
  data?: InputMaybe<PullSyncClientsInput>;
};

export type QuerypullSyncCrewsArgs = {
  data?: InputMaybe<PullSyncCrewsInput>;
};

export type QuerypullSyncEstimatesArgs = {
  data?: InputMaybe<PullSyncEstimatesInput>;
};

export type QuerypullSyncGroupsArgs = {
  data?: InputMaybe<PullSyncGroupsInput>;
};

export type QuerypullSyncInvoicesArgs = {
  data?: InputMaybe<PullSyncInvoicesInput>;
};

export type QuerypullSyncJobsArgs = {
  data?: InputMaybe<PullSyncJobsInput>;
};

export type QuerypullSyncManufacturersArgs = {
  data?: InputMaybe<PullSyncManufacturersInput>;
};

export type QuerypullSyncPaymentsArgs = {
  data?: InputMaybe<PullSyncPaymentsInput>;
};

export type QuerypullSyncPropertiesArgs = {
  data?: InputMaybe<PullSyncPropertiesInput>;
};

export type QuerypullSyncServiceItemsArgs = {
  data?: InputMaybe<PullSyncServiceItemsInput>;
};

export type QuerypullSyncTaxratesArgs = {
  data?: InputMaybe<PullSyncTaxratesInput>;
};

export type QuerypullSyncTimesheetEntriesArgs = {
  data?: InputMaybe<PullSyncTimesheetEntriesInput>;
};

export type QuerypullSyncTimesheetsArgs = {
  data?: InputMaybe<PullSyncTimesheetsInput>;
};

export type QuerypullSyncUsersArgs = {
  data?: InputMaybe<PullSyncUsersInput>;
};

export type QuerypullSyncVendorsArgs = {
  data?: InputMaybe<PullSyncVendorsInput>;
};

export type QueryvalidateFeeCalculationArgs = {
  data: ValidateFeeCalculationInput;
};

export type QueryvalidateInvoiceForPaymentArgs = {
  invoiceId: Scalars['ID']['input'];
};

export type QueryHistoryDetail = {
  __typename?: 'QueryHistoryDetail';
  executionTime?: Maybe<Scalars['Int']['output']>;
  hitCount: Scalars['Int']['output'];
  lastAccessed: Scalars['String']['output'];
  operationName: Scalars['String']['output'];
  responseSize?: Maybe<Scalars['Int']['output']>;
};

export type QueuedSystemAnnouncement = {
  __typename?: 'QueuedSystemAnnouncement';
  estimatedRecipients: Scalars['Int']['output'];
  jobId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type QuickBooksAccountInfo = {
  __typename?: 'QuickBooksAccountInfo';
  accountType?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickBooksChartOfAccounts = {
  __typename?: 'QuickBooksChartOfAccounts';
  paymentsAccountId?: Maybe<Scalars['String']['output']>;
  tipsAccountId?: Maybe<Scalars['String']['output']>;
};

export enum QuickBooksConflictResolutionAction {
  KeepDhs = 'KEEP_DHS',
  KeepQbo = 'KEEP_QBO',
  Skip = 'SKIP',
}

export enum QuickBooksConflictType {
  DuplicateDisplayName = 'DUPLICATE_DISPLAY_NAME',
  DuplicateEmail = 'DUPLICATE_EMAIL',
  DuplicateName = 'DUPLICATE_NAME',
  DuplicatePayment = 'DUPLICATE_PAYMENT',
  DuplicatePhone = 'DUPLICATE_PHONE',
  DuplicateSku = 'DUPLICATE_SKU',
}

export type QuickBooksConnectionInfo = Timestamps & {
  __typename?: 'QuickBooksConnectionInfo';
  account_id: Scalars['ID']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  connectedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  disconnectedAt?: Maybe<Scalars['Date']['output']>;
  environment: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastSyncAt?: Maybe<Scalars['Date']['output']>;
  realmId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type QuickBooksEntitySetting = {
  __typename?: 'QuickBooksEntitySetting';
  conflictResolution: Scalars['String']['output'];
  entityType: QuickBooksEntityType;
  lastSyncAt?: Maybe<Scalars['Date']['output']>;
  syncEnabled: Scalars['Boolean']['output'];
  syncRule?: Maybe<Scalars['String']['output']>;
  syncTrigger: Scalars['String']['output'];
};

export enum QuickBooksEntityType {
  Clients = 'CLIENTS',
  Estimates = 'ESTIMATES',
  Invoices = 'INVOICES',
  Payments = 'PAYMENTS',
  ServiceItems = 'SERVICE_ITEMS',
  Timesheets = 'TIMESHEETS',
}

/**
 * A single conflict record surfaced during the import prepare phase.
 * syncLogId can be passed directly to resolveQuickBooksConflict to resolve it.
 * conflictingDhsEntityId is absent for intra-QBO conflicts (two QBO records sharing
 * the same field value) — only SKIP is valid for those.
 */
export type QuickBooksImportConflict = {
  __typename?: 'QuickBooksImportConflict';
  conflictDetails?: Maybe<Scalars['JSON']['output']>;
  conflictType: QuickBooksConflictType;
  conflictingDhsEntityId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  entityName?: Maybe<Scalars['String']['output']>;
  entityType: QuickBooksEntityType;
  qboId: Scalars['String']['output'];
  resolution: QuickBooksSyncLogStatus;
  syncLogId: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type QuickBooksImportJob = Timestamps & {
  __typename?: 'QuickBooksImportJob';
  account_id: Scalars['ID']['output'];
  conflictCount: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  currentEntityType?: Maybe<QuickBooksEntityType>;
  entityTypes: Array<QuickBooksEntityType>;
  errorCount: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  processed: Scalars['Int']['output'];
  progressMessage?: Maybe<Scalars['String']['output']>;
  progressPercent: Scalars['Int']['output'];
  skippedCount: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['Date']['output']>;
  state: QuickBooksImportJobState;
  successCount: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum QuickBooksImportJobState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  DetectingConflicts = 'DETECTING_CONFLICTS',
  Failed = 'FAILED',
  PendingReview = 'PENDING_REVIEW',
  Queued = 'QUEUED',
  Running = 'RUNNING',
}

export type QuickBooksImportPreview = {
  __typename?: 'QuickBooksImportPreview';
  conflictCount: Scalars['Int']['output'];
  entityType: QuickBooksEntityType;
  samples: Array<QuickBooksImportSample>;
  totalCount: Scalars['Int']['output'];
};

export type QuickBooksImportSample = {
  __typename?: 'QuickBooksImportSample';
  conflict?: Maybe<QuickBooksImportSampleConflict>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickBooksImportSampleConflict = {
  __typename?: 'QuickBooksImportSampleConflict';
  conflictingDhsEntityId?: Maybe<Scalars['ID']['output']>;
  dhsValue?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  qboValue?: Maybe<Scalars['String']['output']>;
  type: QuickBooksConflictType;
};

export type QuickBooksImportSettingsInput = {
  importClients: Scalars['Boolean']['input'];
  importProducts: Scalars['Boolean']['input'];
};

export enum QuickBooksSyncAction {
  Create = 'CREATE',
  Delete = 'DELETE',
  Error = 'ERROR',
  Skip = 'SKIP',
  Update = 'UPDATE',
}

export enum QuickBooksSyncDirection {
  DhsToQbo = 'DHS_TO_QBO',
  QboToDhs = 'QBO_TO_DHS',
}

export type QuickBooksSyncLogEntry = Timestamps & {
  __typename?: 'QuickBooksSyncLogEntry';
  account_id: Scalars['ID']['output'];
  action: QuickBooksSyncAction;
  conflictDetails?: Maybe<Scalars['JSON']['output']>;
  conflictType?: Maybe<QuickBooksConflictType>;
  conflictingDhsEntityId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  details?: Maybe<Scalars['String']['output']>;
  dhs_entity_id?: Maybe<Scalars['ID']['output']>;
  direction?: Maybe<QuickBooksSyncDirection>;
  entityName?: Maybe<Scalars['String']['output']>;
  entityType: QuickBooksEntityType;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importJob_id?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  qbo_entity_id?: Maybe<Scalars['String']['output']>;
  status: QuickBooksSyncLogStatus;
  syncJobId?: Maybe<Scalars['String']['output']>;
  triggeredBy?: Maybe<QuickBooksSyncTriggeredBy>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type QuickBooksSyncLogFilterInput = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  entityType?: InputMaybe<QuickBooksEntityType>;
  status?: InputMaybe<QuickBooksSyncLogStatus>;
};

export enum QuickBooksSyncLogStatus {
  Conflict = 'CONFLICT',
  Failed = 'FAILED',
  Ignored = 'IGNORED',
  Partial = 'PARTIAL',
  ResolvedKeepDhs = 'RESOLVED_KEEP_DHS',
  ResolvedKeepQbo = 'RESOLVED_KEEP_QBO',
  ResolvedSkipped = 'RESOLVED_SKIPPED',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS',
}

export type QuickBooksSyncOlderItemsInput = {
  entityTypes: Array<QuickBooksEntityType>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
};

export type QuickBooksSyncSettingsInfo = {
  __typename?: 'QuickBooksSyncSettingsInfo';
  account_id: Scalars['ID']['output'];
  chartOfAccounts?: Maybe<QuickBooksChartOfAccounts>;
  entitySettings: Array<QuickBooksEntitySetting>;
  id: Scalars['ID']['output'];
  importCompletedAt?: Maybe<Scalars['Date']['output']>;
  importOnConnect?: Maybe<Scalars['Boolean']['output']>;
};

export enum QuickBooksSyncTriggeredBy {
  Import = 'IMPORT',
  Scheduler = 'SCHEDULER',
  User = 'USER',
  Webhook = 'WEBHOOK',
}

export type QuickTourState = {
  __typename?: 'QuickTourState';
  status: QuickTourStatus;
  tourId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum QuickTourStatus {
  Completed = 'COMPLETED',
  Skipped = 'SKIPPED',
}

export type QuickTourStatusInput = {
  status: QuickTourStatus;
  tourId: Scalars['String']['input'];
};

export type QuietHours = {
  __typename?: 'QuietHours';
  /** Whether quiet hours are enabled */
  enabled: Scalars['Boolean']['output'];
  /** End time in 24h format (e.g., '08:00') */
  end: Scalars['String']['output'];
  /** Start time in 24h format (e.g., '22:00') */
  start: Scalars['String']['output'];
  /** Timezone for quiet hours */
  timezone: Scalars['String']['output'];
};

export type QuietHoursInput = {
  /** Whether quiet hours are enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** End time in 24h format (e.g., '08:00') */
  end?: InputMaybe<Scalars['String']['input']>;
  /** Start time in 24h format (e.g., '22:00') */
  start?: InputMaybe<Scalars['String']['input']>;
  /** Timezone for quiet hours */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum RecipientType {
  /** Client recipient */
  Client = 'CLIENT',
  /** Service provider recipient */
  ServiceProvider = 'SERVICE_PROVIDER',
  /** System recipient */
  System = 'SYSTEM',
}

export type RecurringSchedule = {
  __typename?: 'RecurringSchedule';
  isRecurring?: Maybe<Scalars['Boolean']['output']>;
  recurringDaysOfWeekPreference?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  recurringFallSchedule?: Maybe<RecurringScheduleOptions>;
  recurringSpringSchedule?: Maybe<RecurringScheduleOptions>;
  recurringSummerSchedule?: Maybe<RecurringScheduleOptions>;
  recurringWinterSchedule?: Maybe<RecurringScheduleOptions>;
};

/** Expected input for a recurring schedule. */
export type RecurringScheduleInput = {
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  recurringDaysOfWeekPreference?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recurringFallSchedule?: InputMaybe<RecurringScheduleOptions>;
  recurringSpringSchedule?: InputMaybe<RecurringScheduleOptions>;
  recurringSummerSchedule?: InputMaybe<RecurringScheduleOptions>;
  recurringWinterSchedule?: InputMaybe<RecurringScheduleOptions>;
};

/** Options to set a recurring schedule for a job */
export enum RecurringScheduleOptions {
  None = 'NONE',
  Recurring_1Month = 'RECURRING_1_MONTH',
  Recurring_1Week = 'RECURRING_1_WEEK',
  Recurring_2Month = 'RECURRING_2_MONTH',
  Recurring_2Week = 'RECURRING_2_WEEK',
  Recurring_3Month = 'RECURRING_3_MONTH',
  Recurring_3Week = 'RECURRING_3_WEEK',
}

export type ReferralInfo = {
  __typename?: 'ReferralInfo';
  freeMonths: Scalars['Int']['output'];
  referralCode?: Maybe<Scalars['String']['output']>;
  referralsTotal: Scalars['Int']['output'];
  referredBy?: Maybe<Scalars['String']['output']>;
};

/** Success response for refreshing an access token */
export type RefreshAccessToken = {
  __typename?: 'RefreshAccessToken';
  /** New access token with updated expiration */
  accessToken: Scalars['String']['output'];
  /** Success message */
  message: Scalars['String']['output'];
  /** Refresh token (Phase 1: unchanged; future phases will rotate) */
  refreshToken: Scalars['String']['output'];
  /** User information associated with the tokens */
  user: User;
  /** API version */
  version: Scalars['String']['output'];
};

/** Expected input to refresh access token */
export type RefreshAccessTokenInput = {
  /** JWT refresh token from login response */
  refreshToken: Scalars['String']['input'];
};

/** Response union for refresh access token operation */
export type RefreshAccessTokenResponse = Error | RefreshAccessToken;

export type RefreshConnectAccountStatus = {
  __typename?: 'RefreshConnectAccountStatus';
  message: Scalars['String']['output'];
  status: ConnectStatus;
  updated: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

export type RefreshConnectAccountStatusResponse = Error | RefreshConnectAccountStatus;

export type RefreshQuickBooksImportPreview = {
  __typename?: 'RefreshQuickBooksImportPreview';
  importJob: QuickBooksImportJob;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type RefreshQuickBooksImportPreviewResponse = Error | RefreshQuickBooksImportPreview;

export type RefundPayment = {
  __typename?: 'RefundPayment';
  message: Scalars['String']['output'];
};

/** Expected input to refund a payment */
export type RefundPaymentInput = {
  amount: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  statusChangeReason: Scalars['String']['input'];
};

export type RefundPaymentResponse = Error | RefundPayment;

/**
 * Input for registering a new FCM device for push notifications.
 * This mutation can be called during login/signup before JWT is issued,
 * using email to identify the user.
 */
export type RegisterFCMDeviceInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  platform: DevicePlatform;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type RejectClientInvite = {
  __typename?: 'RejectClientInvite';
  message: Scalars['String']['output'];
  serviceProviderName?: Maybe<Scalars['String']['output']>;
};

export type RejectClientInviteResponse = Error | RejectClientInvite;

/** Input for removing an FCM device */
export type RemoveFCMDeviceInput = {
  deviceId: Scalars['String']['input'];
};

/** Response for removing an FCM device */
export type RemoveFCMDeviceResponse = DeviceRemoval | Error;

export type RemoveServiceItemImage = {
  __typename?: 'RemoveServiceItemImage';
  message: Scalars['String']['output'];
  serviceItem: ServiceItem;
  version: Scalars['String']['output'];
};

export type RemoveServiceItemImageResponse = Error | RemoveServiceItemImage;

export type RemoveUserAvatar = {
  __typename?: 'RemoveUserAvatar';
  avatarUrl: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Expected input to remove a user's avatar */
export type RemoveUserAvatarInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type RemoveUserAvatarResponse = Error | RemoveUserAvatar;

/** Comprehensive report data for an account */
export type ReportDataByAccount = {
  __typename?: 'ReportDataByAccount';
  /** Account ID for this report */
  account_id: Scalars['ID']['output'];
  /** Aggregated statistics */
  aggregates: AggregatesData;
  /** Date range for this report */
  dateRange?: Maybe<DateRange>;
  /** All entity data */
  entities: EntitiesData;
  /** Standard message for the response */
  message: Scalars['String']['output'];
  /** API version */
  version: Scalars['String']['output'];
};

export type ReportDataByAccountResponse = Error | ReportDataByAccount;

/** Date range input for report filtering */
export type ReportDateRangeInput = {
  /** End date for the report range */
  endDate: Scalars['Date']['input'];
  /** Start date for the report range */
  startDate: Scalars['Date']['input'];
};

/** Aggregation level control for flexible crew vs user analysis */
export enum ReportGroupType {
  /** Crew-level aggregated metrics */
  Crew = 'CREW',
  /** Both crew and individual user breakdowns (hierarchical) */
  CrewUser = 'CREW_USER',
  /** Individual user metrics */
  User = 'USER',
}

export type RequestConnectPermission = {
  __typename?: 'RequestConnectPermission';
  alertSent: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  status: ConnectStatus;
  version: Scalars['String']['output'];
};

export type ResendEmailVerification = {
  __typename?: 'ResendEmailVerification';
  message: Scalars['String']['output'];
  sent: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

export type ResendEmailVerificationResponse = Error | ResendEmailVerification;

export type ResetAdminUserPassword = {
  __typename?: 'ResetAdminUserPassword';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to reset admin user password */
export type ResetAdminUserPasswordInput = {
  email: Scalars['String']['input'];
};

export type ResetAdminUserPasswordResponse = Error | ResetAdminUserPassword;

export type ResetPasswordWithToken = {
  __typename?: 'ResetPasswordWithToken';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to complete password reset with token */
export type ResetPasswordWithTokenInput = {
  confirmNewPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type ResetPasswordWithTokenResponse = Error | ResetPasswordWithToken;

export type ResetUserPassword = {
  __typename?: 'ResetUserPassword';
  message: Scalars['String']['output'];
};

/** Expected input to reset a user's password */
export type ResetUserPasswordInput = {
  email: Scalars['String']['input'];
};

export type ResetUserPasswordResponse = Error | ResetUserPassword;

export type ResolveQuickBooksConflict = {
  __typename?: 'ResolveQuickBooksConflict';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type ResolveQuickBooksConflictInput = {
  resolution: QuickBooksConflictResolutionAction;
  /** Any sync-log id from the conflict cluster for a given QBO entity. The resolver applies the resolution to all conflict logs sharing the same (account, entityType, qbo_entity_id). */
  syncLogId: Scalars['ID']['input'];
};

export type ResolveQuickBooksConflictResponse = Error | ResolveQuickBooksConflict;

export type RetryQuickBooksSyncItem = {
  __typename?: 'RetryQuickBooksSyncItem';
  message: Scalars['String']['output'];
  updatedStatus?: Maybe<QuickBooksSyncLogStatus>;
  version: Scalars['String']['output'];
};

export type RetryQuickBooksSyncItemResponse = Error | RetryQuickBooksSyncItem;

/** ENUM for available User roles */
export enum Role {
  /** Client user with customer-level access and permissions */
  Client = 'CLIENT',
  /** Service Provider Administrator with full system access */
  SpAdmin = 'SP_ADMIN',
  /** Service Provider Crew member with field worker permissions */
  SpCrew = 'SP_CREW',
  /** Service Provider Owner with supreme system access and billing control */
  SpOwner = 'SP_OWNER',
  /** Service Provider Support staff with management permissions */
  SpSupport = 'SP_SUPPORT',
}

export type RunBetaLifecycleInput = {
  accountId: Scalars['ID']['input'];
  asOf: Scalars['Date']['input'];
};

export type RunQuickBooksImport = {
  __typename?: 'RunQuickBooksImport';
  importJob: QuickBooksImportJob;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type RunQuickBooksImportResponse = Error | RunQuickBooksImport;

/**
 * Status of Service Provider's Stripe Connect application process.
 * Tracks the progress from initial inquiry through final approval or decline.
 */
export enum SPStripeApplicationStatus {
  /** Stripe needs additional information (e.g., identity verification). */
  ActionRequired = 'ACTION_REQUIRED',
  /** Application has been submitted to Stripe. */
  Applied = 'APPLIED',
  /** Application has been approved and account is active. */
  Approved = 'APPROVED',
  /** Application has been declined by Stripe. */
  Declined = 'DECLINED',
  /** System error - Stripe account exists in DB but not in Stripe, or other error. */
  Error = 'ERROR',
  /** Service provider has made an inquiry about Stripe Connect. */
  Inquiry = 'INQUIRY',
  /** No application has been started - initial state. */
  None = 'NONE',
  /** Application is pending - onboarding form not yet completed. */
  Pending = 'PENDING',
  /** Permission has been granted to proceed with application. */
  Permission = 'PERMISSION',
  /** Application submitted and Stripe is verifying - no SP action needed. */
  UnderReview = 'UNDER_REVIEW',
}

export type SampleDataCreationResult = {
  __typename?: 'SampleDataCreationResult';
  appointments: Scalars['Int']['output'];
  attachments: Scalars['Int']['output'];
  chats: Scalars['Int']['output'];
  checklistEntries: Scalars['Int']['output'];
  checklists: Scalars['Int']['output'];
  clientAccounts: Scalars['Int']['output'];
  crews: Scalars['Int']['output'];
  estimates: Scalars['Int']['output'];
  groups: Scalars['Int']['output'];
  invoices: Scalars['Int']['output'];
  jobs: Scalars['Int']['output'];
  manufacturers: Scalars['Int']['output'];
  messages: Scalars['Int']['output'];
  notes: Scalars['Int']['output'];
  payments: Scalars['Int']['output'];
  properties: Scalars['Int']['output'];
  serviceItems: Scalars['Int']['output'];
  taxRates: Scalars['Int']['output'];
  timesheetEntries: Scalars['Int']['output'];
  timesheets: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
  vendors: Scalars['Int']['output'];
};

export type SampleDataDeletionSummary = {
  __typename?: 'SampleDataDeletionSummary';
  /** Number of sample attachments deleted */
  attachmentsDeleted: Scalars['Int']['output'];
  /** Number of sample chats deleted */
  chatsDeleted: Scalars['Int']['output'];
  /** Number of sample checklists deleted */
  checklistsDeleted: Scalars['Int']['output'];
  /** Number of sample client accounts deleted */
  clientAccountsDeleted: Scalars['Int']['output'];
  /** Timestamp when deletion was completed */
  completedAt: Scalars['Date']['output'];
  /** Number of sample crews deleted */
  crewsDeleted: Scalars['Int']['output'];
  /** Total deletion time in milliseconds */
  deletionTimeMs: Scalars['Int']['output'];
  /** Number of sample estimates deleted */
  estimatesDeleted: Scalars['Int']['output'];
  /** Number of sample groups deleted */
  groupsDeleted: Scalars['Int']['output'];
  /** Number of sample invoices deleted */
  invoicesDeleted: Scalars['Int']['output'];
  /** Number of sample jobs deleted */
  jobsDeleted: Scalars['Int']['output'];
  /** Number of sample manufacturers deleted */
  manufacturersDeleted: Scalars['Int']['output'];
  /** Number of sample notes deleted */
  notesDeleted: Scalars['Int']['output'];
  /** Number of sample payments deleted */
  paymentsDeleted: Scalars['Int']['output'];
  /** Number of sample products deleted */
  productsDeleted: Scalars['Int']['output'];
  /** Number of sample properties deleted */
  propertiesDeleted: Scalars['Int']['output'];
  /** Number of sample service items deleted */
  serviceItemsDeleted: Scalars['Int']['output'];
  /** Number of sample tax rates deleted */
  taxRatesDeleted: Scalars['Int']['output'];
  /** Number of sample timesheets deleted */
  timesheetsDeleted: Scalars['Int']['output'];
  /** Number of sample users deleted */
  usersDeleted: Scalars['Int']['output'];
  /** Number of sample vendors deleted */
  vendorsDeleted: Scalars['Int']['output'];
};

export type ScheduleConflictJob = {
  __typename?: 'ScheduleConflictJob';
  job_id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scheduledStartDatetime: Scalars['Date']['output'];
  scheduledStopDatetime: Scalars['Date']['output'];
  status: JobStatus;
};

export type SchedulerViewSettings = {
  __typename?: 'SchedulerViewSettings';
  customDateRange?: Maybe<CustomDateRange>;
  view?: Maybe<SchedulerViewType>;
};

export type SchedulerViewSettingsInput = {
  customDateRange?: InputMaybe<CustomDateRangeInput>;
  view?: InputMaybe<SchedulerViewType>;
};

export enum SchedulerViewType {
  Custom = 'CUSTOM',
  Day = 'DAY',
  List = 'LIST',
  Month = 'MONTH',
  Week = 'WEEK',
}

/** Parameters to search absentee reports */
export type SearchAbsenteeReportInput = {
  /** Filter for absentee reports */
  filter?: InputMaybe<ProductivityReportFilter>;
  /** Search by keyword to match user names, job names, or descriptions */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Records per page for pagination */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number for pagination */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order (high to low) */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Search filter for accounts */
export type SearchAccountsFilter = {
  /** Filter by service provider availability for a date range (checks only account availability, not crew availability) */
  availabilityDateRange?: InputMaybe<DateRangeInput>;
  /** Filter by billing info cities (returns accounts matching any of the provided cities) */
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by billing info city (deprecated: use cities array instead) */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Search by IDs */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter by archived status */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by pending link status (true = invite sent but not yet accepted, false = accepted/active link) */
  isPending?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter client/service-provider relationships by explicit link state */
  linkStates?: InputMaybe<Array<ClientServiceProviderLinkState>>;
  propertyType?: InputMaybe<propertyTypeEnum>;
  /** Filter by one or more service categories */
  serviceCategories?: InputMaybe<Array<InputMaybe<ServiceCategory>>>;
  /** Filter by billing info state (deprecated: use states array instead) */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Filter by billing info states (returns accounts matching any of the provided state codes) */
  states?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by tags (returns accounts matching any of the provided tags) */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Parameters to search accounts */
export type SearchAccountsInput = {
  /** Filter by specific id */
  filter?: InputMaybe<SearchAccountsFilter>;
  /** Search by keyword to match file name. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** TODO remove me */
  propertyType?: InputMaybe<propertyTypeEnum>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<AccountsSortBy>;
};

/** Expected input for admin activity log search */
export type SearchAdminActivityLogInput = {
  /** Filter by action */
  action?: InputMaybe<Scalars['String']['input']>;
  /** Filter by admin user ID */
  adminUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by date range */
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by resource ID */
  resourceId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by resource type */
  resourceType?: InputMaybe<Scalars['String']['input']>;
};

/** Search filter for admin users */
export type SearchAdminUsersFilter = {
  /** Search by active status */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by locked status */
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by date range for last login */
  lastLoginFrom?: InputMaybe<Scalars['Date']['input']>;
  lastLoginTo?: InputMaybe<Scalars['Date']['input']>;
  /** Search by specific permission IDs */
  permissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search by roles */
  roles?: InputMaybe<Array<AdminRole>>;
};

/** Parameters to search admin users */
export type SearchAdminUsersInput = {
  /** Search by filter */
  filter?: InputMaybe<SearchAdminUsersFilter>;
  /** Search by keyword to match email, first name, or last name */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<AdminUsersSortBy>;
};

/** Search filter for appointments */
export type SearchAppointmentsFilter = {
  /** Search by account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by appointment ids */
  appointment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter by callback appointments */
  callback?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by client_account_id */
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by crew_id */
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by archived status */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by priority */
  priority?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by property_id */
  property_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by scheduled date range */
  scheduledStartDateFrom?: InputMaybe<Scalars['Date']['input']>;
  scheduledStartDateTo?: InputMaybe<Scalars['Date']['input']>;
  /** Search by status */
  statuses?: InputMaybe<Array<InputMaybe<AppointmentStatus>>>;
};

/** Parameters to search appointments */
export type SearchAppointmentsInput = {
  /** Filter */
  filter?: InputMaybe<SearchAppointmentsFilter>;
  /** Search by keyword to match name or description */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<AppointmentsSortBy>;
};

/** Search filter for attachments */
export type SearchAttachmentsFilter = {
  /** Search by account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by appointment_id */
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple appointment IDs for batch loading */
  appointment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Multiple ids */
  attachment_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search by client_account_id */
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by estimate_id */
  estimate_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple estimate IDs for batch loading */
  estimate_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by invoice_id */
  invoice_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple invoice IDs for batch loading */
  invoice_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by isInternal */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by job_id */
  job_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple job IDs for batch loading */
  job_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by message_id */
  message_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by note_id */
  note_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by property_id */
  property_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by service_item_id */
  service_item_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by type */
  type?: InputMaybe<AttachmentType>;
};

/** Parameters to search attachments */
export type SearchAttachmentsInput = {
  /** Filter by specific id */
  filter?: InputMaybe<SearchAttachmentsFilter>;
  /** Search by keyword to match file name. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<AttachmentsSortBy>;
};

/** Parameters to search average job duration reports */
export type SearchAverageJobDurationReportInput = {
  /** Filter for average job duration reports */
  filter?: InputMaybe<AverageJobDurationReportFilter>;
  /** Search by keyword to match crew names */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Records per page for pagination */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number for pagination */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order (high to low) */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Search filter for filter */
export type SearchChatsFilter = {
  /** Search by account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by appointment_id */
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple appointment IDs for batch loading */
  appointment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by chatTypes (array of ChatType) */
  chatTypes?: InputMaybe<Array<ChatType>>;
  /** Search by client_account_id */
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by estimate_id */
  estimate_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple estimate IDs for batch loading */
  estimate_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by invoice_id */
  invoice_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple invoice IDs for batch loading */
  invoice_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** By isArchived */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by isArchivedClientAccount (client-specific archive status) */
  isArchivedClientAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by isArchivedServiceProviderAccount (service provider-specific archive status) */
  isArchivedServiceProviderAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to show only chats with at least one message (when true) */
  isWithMessages?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by job_id */
  job_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple job IDs for batch loading */
  job_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Parameters to search chats */
export type SearchChatsInput = {
  /** Filter */
  filter?: InputMaybe<SearchChatsFilter>;
  /** Search by keyword to match name or description. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<ChatsSortBy>;
};

/** Search filter for checklistEntries */
export type SearchChecklistEntriesFilter = {
  /** Search by checklist id */
  checklist_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Parameters to search checklistEntries */
export type SearchChecklistEntriesInput = {
  /** Filter by specific id */
  filter?: InputMaybe<SearchChecklistEntriesFilter>;
  /** Search by keyword to match check list title. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<ChecklistEntriesSortBy>;
};

/** Parameters to search checklists */
export type SearchChecklistsInput = {
  /** Filter by archived status */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by keyword to match name or description. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<ChecklistsSortBy>;
};

/** Parameters to search completed work order reports */
export type SearchCompletedWorkOrderReportInput = {
  /** Filter for completed work order reports */
  filter?: InputMaybe<CompletedWorkOrderReportFilter>;
  /** Search by keyword to match job name or description */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for searching Connect applications */
export type SearchConnectApplicationsInput = {
  /** Search by keyword to match business name, email */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Records per page */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  maxProcessingTime?: InputMaybe<Scalars['Float']['input']>;
  /** Filter by processing time range (in hours) */
  minProcessingTime?: InputMaybe<Scalars['Float']['input']>;
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<ConnectApplicationSortBy>;
  /** Filter by application status */
  status?: InputMaybe<SPStripeApplicationStatus>;
  /** Filter by applications submitted after this date */
  submittedAfter?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by applications submitted before this date */
  submittedBefore?: InputMaybe<Scalars['Date']['input']>;
};

/** Parameters to search crewUser status reports */
export type SearchCrewUserStatusReportInput = {
  /** Filter for crewUser status reports */
  filter?: InputMaybe<CrewUserStatusReportFilter>;
  /** Search by keyword to match crewUser name, role, or status */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for crew user working hours search */
export type SearchCrewUserWorkingHoursInput = {
  /** Filter criteria for the working hours report */
  filter: CrewUserWorkingHoursFilter;
  /** Records per page for pagination */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number for pagination */
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Filter for crew search */
export type SearchCrewsFilter = {
  /** Filter by account ID */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Multiple crew ids */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by crew being assigned to an estimate, job, or other entity. */
  isInUse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by crew currently having a schedule conflict. */
  isScheduleConflict?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by specific user IDs - returns crews containing any of these users */
  user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Parameters to search crews */
export type SearchCrewsInput = {
  /** Filter criteria for crew search */
  filter?: InputMaybe<SearchCrewsFilter>;
  /** Search by keyword to match name or description. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<CrewsSortBy>;
};

/** Search filter for estimates */
export type SearchEstimatesFilter = {
  /** Search by account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by appointment_id */
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by client_account_id */
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by crew_id */
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by array of crew_ids */
  crew_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Include recurring instances in results (default false - instances are hidden from normal listings) */
  includeRecurringInstances?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by archived status */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by recurring template status (true = templates only, false = instances/regular estimates only) */
  isRecurringTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by job_id */
  job_id?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by parent estimate template ID (get all instances of a recurring template) */
  parent_estimate_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by property_id */
  property_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by array of property_ids */
  property_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by estimate status */
  status?: InputMaybe<Array<EstimateStatus>>;
};

/** Parameters to search estimates */
export type SearchEstimatesInput = {
  /** Filter */
  filter?: InputMaybe<SearchEstimatesFilter>;
  /** Search by keyword to match name or description. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<EstimatesSortBy>;
};

/** Search filter for feedback entries */
export type SearchFeedbackEntriesFilter = {
  /** Search by crew_id */
  crew_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search by crew_lead_user_id */
  crew_lead_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search by isComplaint */
  isComplaint?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by job_id */
  job_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search by rating */
  ratings?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Search by reviewed_by_user_id */
  reviewed_by_user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search by status */
  statuses?: InputMaybe<Array<FeedbackEntryStatus>>;
  /** Search by type */
  types?: InputMaybe<Array<FeedbackEntryType>>;
};

/** Parameters to search feedback entries */
export type SearchFeedbackEntriesInput = {
  /** Filter by specific criteria */
  filter?: InputMaybe<SearchFeedbackEntriesFilter>;
  /** Search by keyword to match description */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Items per page */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<FeedbackEntriesSortBy>;
};

/** Parameters to search feedback reports */
export type SearchFeedbackReportInput = {
  /** Filter for feedback reports */
  filter?: InputMaybe<FeedbackReportFilter>;
  /** Search by keyword to match crew lead name, description, or job details */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Search filter for groups */
export type SearchGroupsFilter = {
  /** Search by account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Include archived groups */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by service_item_ids */
  service_item_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Parameters to search groups */
export type SearchGroupsInput = {
  /** Filters for group */
  filter?: InputMaybe<SearchGroupsFilter>;
  /** Search by keyword to match group code, name or description */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<GroupsSortBy>;
};

/** Parameters to search idle time reports */
export type SearchIdleTimeReportInput = {
  /** Filter for idle time reports */
  filter?: InputMaybe<IdleTimeReportFilter>;
  /** Search by keyword to match user names or roles */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Records per page for pagination */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number for pagination */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order (high to low) */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Search filter for invoices */
export type SearchInvoicesFilter = {
  /** Account ID for admin access */
  account_id?: InputMaybe<Scalars['String']['input']>;
  /** Search by appointment_id */
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by client_account_id */
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by crew id */
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by crew ids */
  crew_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  endDueDate?: InputMaybe<Scalars['Date']['input']>;
  endIssueDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search by past due */
  isPastDue?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by job_id */
  job_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by job_ids */
  job_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by property_id */
  property_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by array of property_ids */
  property_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by due date */
  startDueDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search by issue date */
  startIssueDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search by invoice status */
  status?: InputMaybe<Array<InvoiceStatus>>;
};

/** Parameters to search invoices */
export type SearchInvoicesInput = {
  /** Filter */
  filter?: InputMaybe<SearchInvoicesFilter>;
  /** Search by keyword to match invoice name, invoice number, job name, client company name, client user names, or service item details. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<InvoicesSortBy>;
};

/** Parameters to search job productivity reports */
export type SearchJobProductivityReportInput = {
  /** Filter for job productivity reports */
  filter?: InputMaybe<ProductivityReportFilter>;
  /** Aggregation level - controls crew vs user analysis */
  groupBy: ReportGroupType;
  /** Search by keyword to match user names, crew names, or job details */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Records per page for pagination */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number for pagination */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order (high to low) */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time period grouping for trend analysis */
  timePeriod?: InputMaybe<TimePeriodType>;
};

/** Search filter for jobs */
export type SearchJobsFilter = {
  /** Search by account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by appointment_id */
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by client_account_id */
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by crew id */
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by crew ids */
  crew_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Include recurring instances in results (default false - instances are hidden from normal listings) */
  includeRecurringInstances?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by recurring template status (true = templates only, false = instances/regular jobs only) */
  isRecurringTemplate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by job ids */
  job_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter by parent job template ID (get all instances of a recurring template) */
  parent_job_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by property_id */
  property_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by array of property_ids */
  property_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Filter jobs by proximity to a location */
  proximity?: InputMaybe<ProximityFilter>;
  /** Search by scheduled start date */
  scheduledStartDatetime?: InputMaybe<Scalars['Date']['input']>;
  /** Search by scheduled stop date */
  scheduledStopDatetime?: InputMaybe<Scalars['Date']['input']>;
  /** Search by job statuses */
  statuses?: InputMaybe<Array<InputMaybe<JobStatus>>>;
};

/** Parameters to search jobs */
export type SearchJobsInput = {
  /** Filter */
  filter?: InputMaybe<SearchJobsFilter>;
  /** Search by keyword to match name or description. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<JobsSortBy>;
};

/** Search filter for manufacturers */
export type SearchManufacturersFilter = {
  /** Search by account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Include inactive manufacturers */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Parameters to search manufacturers */
export type SearchManufacturersInput = {
  /** Filters for manufacturer */
  filter?: InputMaybe<SearchManufacturersFilter>;
  /** Search by keyword to match manufacturer name or company */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<ManufacturersSortBy>;
};

/** Search filter for filter */
export type SearchMessagesFilter = {
  /** Search by appointment_id */
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple appointment IDs for batch loading */
  appointment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by chat_id */
  chat_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by client_account_id */
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by estimate_id */
  estimate_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple estimate IDs for batch loading */
  estimate_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by invoice_id */
  invoice_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple invoice IDs for batch loading */
  invoice_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by isArchived */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by isInternal */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by job_id */
  job_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple job IDs for batch loading */
  job_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Parameters to search messages */
export type SearchMessagesInput = {
  /** Filter */
  filter?: InputMaybe<SearchMessagesFilter>;
  /** Search by keyword to match name or description. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<MessagesSortBy>;
};

/** Search filter for notes */
export type SearchNotesFilter = {
  /** Search by account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by appointment_id */
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple appointment IDs for batch loading */
  appointment_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by client_account_id */
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by estimate_id */
  estimate_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple estimate IDs for batch loading */
  estimate_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by invoice_id */
  invoice_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple invoice IDs for batch loading */
  invoice_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by isInternal */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by job_id */
  job_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple job IDs for batch loading */
  job_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by property_id */
  property_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Parameters to search notes */
export type SearchNotesInput = {
  /** Filter by specific id */
  filter?: InputMaybe<SearchNotesFilter>;
  /** Search by keyword to match file name. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<NotesSortBy>;
};

/** Parameters to search open work order reports */
export type SearchOpenWorkOrderReportInput = {
  /** Filter for open work order reports */
  filter?: InputMaybe<OpenWorkOrderReportFilter>;
  /** Search by keyword to match job name or description */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Search filter for payments */
export type SearchPaymentsFilter = {
  /** Admin-only: specify account_id to query payments for specific account */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endTransactionDate?: InputMaybe<Scalars['Date']['input']>;
  invoice_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple invoice_ids for batch loading */
  invoice_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  method?: InputMaybe<PaymentMethod>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startTransactionDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<PaymentStatus>;
};

/** Expected input to search payments */
export type SearchPaymentsInput = {
  filter?: InputMaybe<SearchPaymentsFilter>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<PaymentsSortBy>;
};

/** Search filter for properties */
export type SearchPropertiesFilter = {
  /** Search by account_id / client_account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Searh by type */
  type?: InputMaybe<propertyTypeEnum>;
};

/** Parameters to search properties */
export type SearchPropertiesInput = {
  /** Filter by specific id */
  filter?: InputMaybe<SearchPropertiesFilter>;
  /** Search by keyword to match file name. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<PropertiesSortBy>;
};

export type SearchQuickBooksSyncLogsInput = {
  filter?: InputMaybe<QuickBooksSyncLogFilterInput>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Parameters to search report data by account */
export type SearchReportDataByAccountInput = {
  /** Account ID to filter data by */
  account_id: Scalars['ID']['input'];
  /** If true, ignore date range and return all records. If false or omitted, default to records from last 30 days */
  allRecords?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional date range for filtering (if not provided and allRecords is false, defaults to last 30 days) */
  dateRange?: InputMaybe<ReportDateRangeInput>;
};

/** Parameters to search reports */
export type SearchReportInput = {
  /** Filter for feedback reports */
  feedbackFilter?: InputMaybe<FeedbackReportFilter>;
  /** Search by keyword to match crew lead name, description, or job details */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for work order reports */
  workOrderFilter?: InputMaybe<WorkOrderReportFilter>;
};

/** Search filter for properties */
export type SearchServiceItemsFilter = {
  /** Search by account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by group_id */
  group_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple group_ids (returns all service items from these groups with no duplicates) */
  group_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search by isArchived */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by isShowNewService */
  isShowNewService?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by isShowOnlineBooking */
  isShowOnlineBooking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by isTaxable */
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by manufacturer_id */
  manufacturer_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by service item IDs */
  service_item_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search by type */
  type?: InputMaybe<ServiceItemType>;
  /** Search by unitOfMeasure */
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
  /** Search by vendor_id */
  vendor_id?: InputMaybe<Scalars['ID']['input']>;
};

/** Parameters to search crews */
export type SearchServiceItemsInput = {
  /** Filters */
  filter?: InputMaybe<SearchServiceItemsFilter>;
  /** Search by keyword to match sku, name or description. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<ServiceItemsSortBy>;
};

/** Parameters to search taxRates */
export type SearchTaxRatesInput = {
  /** Search by keyword to match file name. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<TaxRatesSortBy>;
};

/** Search filter for timesheetEntries */
export type SearchTimesheetEntriesFilter = {
  /** Search by appointment_id */
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by approved_by_user_id */
  approved_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by end time */
  endTime?: InputMaybe<Scalars['Date']['input']>;
  /** Filter for entries with no end time (null or not set) */
  hasNoEndTime?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter for entries not linked to any timesheet (timesheet_id is null) */
  hasNoTimesheet?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by job_id - For backwards compat */
  job_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple job ids */
  job_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by start time */
  startTime?: InputMaybe<Scalars['Date']['input']>;
  /** Search by timesheet_id */
  timesheet_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by type */
  types?: InputMaybe<Array<TimesheetEntryType>>;
  /** Search by user_id - For backwards compat */
  user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by multiple user ids */
  user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Parameters to search timesheetEntries */
export type SearchTimesheetEntriesInput = {
  /** Optional timezone override for display purposes (e.g., HR viewing different location) */
  displayTimezone?: InputMaybe<Scalars['String']['input']>;
  /** Filter by specific id */
  filter?: InputMaybe<SearchTimesheetEntriesFilter>;
  /** Search by keyword to match file name. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<TimesheetEntriesSortBy>;
};

/** Search filter for timesheets */
export type SearchTimesheetsFilter = {
  /** Filter by account ID */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by approved_by_user_id */
  approved_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** End date */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search by rejected_by_user_id */
  rejected_by_user_id?: InputMaybe<Scalars['ID']['input']>;
  /** Start date */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Search by status */
  statuses?: InputMaybe<Array<TimesheetStatus>>;
  /** Search by user_id */
  user_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** Parameters to search timesheets */
export type SearchTimesheetsInput = {
  /** Optional timezone override for display purposes (e.g., HR viewing different location) */
  displayTimezone?: InputMaybe<Scalars['String']['input']>;
  /** Filter by specific id */
  filter?: InputMaybe<SearchTimesheetsFilter>;
  /** Search by keyword to match description. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<TimesheetsSortBy>;
};

/** Parameters to search travel time reports */
export type SearchTravelTimeReportInput = {
  /** Filter for travel time reports */
  filter?: InputMaybe<TravelTimeReportFilter>;
  /** Search by keyword to match user or crew names */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Records per page for pagination */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number for pagination */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order (high to low) */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Search filter for users */
export type SearchUsersFilter = {
  /** Optional account id to specify users.  Either the logged in account users or the SP's client's user(s) */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional crew id to specify users. */
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  /** Search by ids */
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Search by isDisabled */
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by role */
  roles?: InputMaybe<Array<Role>>;
};

/** Parameters to search users */
export type SearchUsersInput = {
  /** Search by filter */
  filter?: InputMaybe<SearchUsersFilter>;
  /** Search by keyword to match email, first name, last name, or phone number. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<UsersSortBy>;
};

/** Search filter for vendors */
export type SearchVendorsFilter = {
  /** Search by account_id */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Include archived vendors */
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Parameters to search vendors */
export type SearchVendorsInput = {
  /** Filters for vendor */
  filter?: InputMaybe<SearchVendorsFilter>;
  /** Search by keyword to match vendor name or company */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sort by field */
  sortBy?: InputMaybe<VendorsSortBy>;
};

/** Parameters to search work order reports */
export type SearchWorkOrderReportInput = {
  /** Filter for work order reports */
  filter?: InputMaybe<WorkOrderReportFilter>;
  /** Search by keyword to match job name or description */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** limitPerPage */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Parameters to search working hours reports */
export type SearchWorkingHoursReportInput = {
  /** Filter for working hours reports */
  filter?: InputMaybe<ProductivityReportFilter>;
  /** Aggregation level - controls crew vs user analysis */
  groupBy: ReportGroupType;
  /** Search by keyword to match user names, crew names, or descriptions */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Records per page for pagination */
  limitPerPage?: InputMaybe<Scalars['Int']['input']>;
  /** Page number for pagination */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Reverse sort order (high to low) */
  reverseSort?: InputMaybe<Scalars['Boolean']['input']>;
  /** Time period grouping for trend analysis */
  timePeriod?: InputMaybe<TimePeriodType>;
};

export type SendAppointment = {
  __typename?: 'SendAppointment';
  appointment: Appointment;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to send an appointment via SMS or EMAIL. */
export type SendAppointmentInput = {
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Override recipient email (if client has no email on file). Saved to client automatically. */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  /** Override recipient phone (if client has no phone on file). Saved to client automatically. */
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  smsText?: InputMaybe<Scalars['String']['input']>;
};

export type SendAppointmentResponse = Error | SendAppointment;

export type SendClientInvite = {
  __typename?: 'SendClientInvite';
  createdAt?: Maybe<Scalars['String']['output']>;
  existingClient: ExistingClientInfo;
  /** True if the email/SMS invite was dispatched */
  magicLinkSent: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type SendClientInviteInput = {
  /** The id of the existing CLIENT account to invite */
  existingClientAccountId: Scalars['ID']['input'];
  /** Invite mode — drives which email template is used */
  mode?: InputMaybe<ClientInviteMode>;
  /** Required when mode is INVITE_AND_VIEW */
  recordId?: InputMaybe<Scalars['ID']['input']>;
  /** Required when mode is INVITE_AND_VIEW */
  recordType?: InputMaybe<ClientInviteRecordType>;
};

export type SendClientInviteResponse = Error | SendClientInvite;

export type SendEstimate = {
  __typename?: 'SendEstimate';
  estimate: Estimate;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to send an estimate via SMS or EMAIL. */
export type SendEstimateInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  commentToClient?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Override recipient email (if client has no email on file). Saved to client automatically. */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  /** Override recipient phone (if client has no phone on file). Saved to client automatically. */
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  smsText?: InputMaybe<Scalars['String']['input']>;
};

export type SendInvoice = {
  __typename?: 'SendInvoice';
  invoice: Invoice;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to send an invoice via SMS or EMAIL. */
export type SendInvoiceInput = {
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Override recipient email (if client has no email on file). Saved to client automatically. */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  /** Override recipient phone (if client has no phone on file). Saved to client automatically. */
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  smsText?: InputMaybe<Scalars['String']['input']>;
};

export type SendJob = {
  __typename?: 'SendJob';
  job: Job;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to send a job via SMS or EMAIL. */
export type SendJobInput = {
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Override recipient email (if client has no email on file). Saved to client automatically. */
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  /** Override recipient phone (if client has no phone on file). Saved to client automatically. */
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  sendCopy?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  smsText?: InputMaybe<Scalars['String']['input']>;
};

export type SendJobResponse = Error | SendJob;

export type SendMaintenanceNotification = {
  __typename?: 'SendMaintenanceNotification';
  campaignId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  sentToLists: Array<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

/** Expected input to send system maintenance notification */
export type SendMaintenanceNotificationInput = {
  message: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SendMaintenanceNotificationResponse = Error | SendMaintenanceNotification;

export type SendOnboardingEmailForCurrentUser = {
  __typename?: 'SendOnboardingEmailForCurrentUser';
  accountId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  messageId?: Maybe<Scalars['String']['output']>;
  originalTo?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  templateKey: Scalars['String']['output'];
  to: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

export type SendOnboardingEmailForCurrentUserInput = {
  templateKey: Scalars['String']['input'];
};

export type SendOnboardingEmailForCurrentUserResponse = Error | SendOnboardingEmailForCurrentUser;

/** Input for sending a system announcement to all SP and CLIENT accounts */
export type SendSystemAnnouncementInput = {
  /** Optional call-to-action button label — GENERAL and ALERT types */
  actionText?: InputMaybe<Scalars['String']['input']>;
  /** Optional call-to-action URL — GENERAL and ALERT types */
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  /** Comma-separated list of affected services — MAINTENANCE type only */
  affectedServices?: InputMaybe<Scalars['String']['input']>;
  /** Maintenance window end time (ISO 8601) — MAINTENANCE type only */
  maintenanceEnd?: InputMaybe<Scalars['String']['input']>;
  /** Maintenance window start time (ISO 8601) — MAINTENANCE type only */
  maintenanceStart?: InputMaybe<Scalars['String']['input']>;
  /** Main message body */
  message: Scalars['String']['input'];
  /** Email subject and notification title */
  subject: Scalars['String']['input'];
  /** Announcement type — controls template, priority, and email layout */
  type: SystemAnnouncementType;
};

export type SendSystemAnnouncementResponse = Error | QueuedSystemAnnouncement;

export type SendTypingIndicator = {
  __typename?: 'SendTypingIndicator';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

/** Input to send a typing indicator */
export type SendTypingIndicatorInput = {
  /** Chat ID where typing is occurring */
  chatId: Scalars['ID']['input'];
  /** Whether typing indicator is internal */
  isInternal?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether user is currently typing */
  isTyping: Scalars['Boolean']['input'];
};

export type SendTypingIndicatorResponse = Error | SendTypingIndicator;

export enum ServiceCategory {
  ApplianceRepair = 'APPLIANCE_REPAIR',
  AutoDetailing = 'AUTO_DETAILING',
  Carpentry = 'CARPENTRY',
  CarpetCleaning = 'CARPET_CLEANING',
  ChimneySweepServices = 'CHIMNEY_SWEEP_SERVICES',
  Concrete = 'CONCRETE',
  DemolitionContractor = 'DEMOLITION_CONTRACTOR',
  DogWalking = 'DOG_WALKING',
  Drywall = 'DRYWALL',
  Electrical = 'ELECTRICAL',
  ElevatorServices = 'ELEVATOR_SERVICES',
  Excavation = 'EXCAVATION',
  FenceServices = 'FENCE_SERVICES',
  Flooring = 'FLOORING',
  GarageDoorServices = 'GARAGE_DOOR_SERVICES',
  GeneralContracting = 'GENERAL_CONTRACTING',
  Handyman = 'HANDYMAN',
  Hvac = 'HVAC',
  InstallationServices = 'INSTALLATION_SERVICES',
  InHomeElderlyCare = 'IN_HOME_ELDERLY_CARE',
  IrrigationServices = 'IRRIGATION_SERVICES',
  JanitorialCleaning = 'JANITORIAL_CLEANING',
  JunkRemoval = 'JUNK_REMOVAL',
  Landscaping = 'LANDSCAPING',
  LawnCare = 'LAWN_CARE',
  LocksmithServices = 'LOCKSMITH_SERVICES',
  MechanicalContracting = 'MECHANICAL_CONTRACTING',
  MoversMovingServices = 'MOVERS_MOVING_SERVICES',
  Painting = 'PAINTING',
  Paving = 'PAVING',
  PestControl = 'PEST_CONTROL',
  Plumbing = 'PLUMBING',
  PoolAndSpaServices = 'POOL_AND_SPA_SERVICES',
  PooperScooper = 'POOPER_SCOOPER',
  PressurePowerWashing = 'PRESSURE_POWER_WASHING',
  PropertyMaintenance = 'PROPERTY_MAINTENANCE',
  Remodeling = 'REMODELING',
  Restoration = 'RESTORATION',
  Roofing = 'ROOFING',
  SecuritySystems = 'SECURITY_SYSTEMS',
  SnowRemoval = 'SNOW_REMOVAL',
  Tiling = 'TILING',
  TreeCare = 'TREE_CARE',
  WellWaterServices = 'WELL_WATER_SERVICES',
  WindowCleaning = 'WINDOW_CLEANING',
  WindowTreatment = 'WINDOW_TREATMENT',
}

/** Represents a service item, including inventory, vendor, and manufacturer details. */
export type ServiceItem = IServiceItem &
  Timestamps & {
    __typename?: 'ServiceItem';
    /** ID of the account that owns this service item. */
    account_id: Scalars['ID']['output'];
    /** Additional data or notes (ADT) for the service item. */
    adt?: Maybe<Scalars['String']['output']>;
    /** Attachments related to the service item (e.g., images, documents). */
    attachments?: Maybe<Array<Attachment>>;
    /** Quantity of the service item available for use. */
    availableQty: Scalars['Int']['output'];
    /** ID of the checklist associated with this service item, if any. */
    checklist_id?: Maybe<Scalars['ID']['output']>;
    /** Color of the service item, if applicable. */
    color?: Maybe<Scalars['String']['output']>;
    /** Date when the service item was created. */
    createdAt: Scalars['Date']['output'];
    /** Description of the service item. */
    description?: Maybe<Scalars['String']['output']>;
    /** Groups this service item belongs to. */
    groups?: Maybe<Array<GroupMinimum>>;
    /** Unique identifier for the service item. */
    id: Scalars['ID']['output'];
    /** Indicates if the service item is archived. */
    isArchived: Scalars['Boolean']['output'];
    /** Indicates if the service item is currently in use. */
    isInUse: Scalars['Boolean']['output'];
    /** Indicates if inventory tracking is disabled for this MATERIAL item (e.g., for consumables like bolts, screws). */
    isInventoryDisabled: Scalars['Boolean']['output'];
    /** Indicates if the record was created via Quick Add. */
    isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates if the service item is shown as a new service. */
    isShowNewService: Scalars['Boolean']['output'];
    /** Indicates if the service item is available for online booking. */
    isShowOnlineBooking: Scalars['Boolean']['output'];
    /** Indicates if the service item is taxable. */
    isTaxable: Scalars['Boolean']['output'];
    /** Location of the service item in inventory or warehouse. */
    location?: Maybe<Scalars['String']['output']>;
    /** Manufacturer entity associated with this service item. */
    manufacturer?: Maybe<Manufacturer>;
    /** Manufacturer's model number for the service item. */
    manufacturerModelNumber?: Maybe<Scalars['String']['output']>;
    /** ID of the manufacturer of this service item, if any. */
    manufacturer_id?: Maybe<Scalars['ID']['output']>;
    /** Name of the service item. */
    name: Scalars['String']['output'];
    /** URL of the service item image. */
    photoUrl?: Maybe<Scalars['String']['output']>;
    /** Current quantity of the service item on hand. */
    quantityOnHand: Scalars['Int']['output'];
    /** Reorder level for the service item. */
    reorderLevel: Scalars['Int']['output'];
    /** Quantity of the service item reserved in estimates. */
    reservedInEstimates: Scalars['Int']['output'];
    /** Quantity of the service item reserved in jobs. */
    reservedInJobs: Scalars['Int']['output'];
    /** Size of the service item, if applicable. */
    size?: Maybe<Scalars['String']['output']>;
    /** Stock keeping unit (SKU) for the service item. */
    sku: Scalars['String']['output'];
    /** Tags associated with the service item. */
    tags?: Maybe<Array<Scalars['String']['output']>>;
    /** Type of the service item (labor or material). */
    type: ServiceItemType;
    /** Unit cost of the service item in cents. */
    unitCost: Scalars['Float']['output'];
    /** Unit of measure for the service item (e.g., EACH, BOX, GALLON). */
    unitOfMeasure?: Maybe<UnitOfMeasure>;
    /** Unit retail price of the service item in cents. */
    unitRetailPrice: Scalars['Float']['output'];
    /** Universal Product Code (UPC) for the service item. */
    upc?: Maybe<Scalars['String']['output']>;
    /** Date when the service item was last updated. */
    updatedAt?: Maybe<Scalars['Date']['output']>;
    /** Vendor entity associated with this service item. */
    vendor?: Maybe<Vendor>;
    /** Vendor-specific SKU for the service item. */
    vendorSku?: Maybe<Scalars['String']['output']>;
    /** ID of the vendor supplying this service item, if any. */
    vendor_id?: Maybe<Scalars['ID']['output']>;
  };

/** Mapping of CSV columns to service item fields */
export type ServiceItemCSVColumnMapping = {
  /** Column name or index for ADT */
  adt?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for color */
  color?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Is Archived */
  isArchived?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for isShowNewService */
  isShowNewService?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for isShowOnlineBooking */
  isShowOnlineBooking?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for isTaxable */
  isTaxable?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for location */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for manufacturer model number */
  manufacturerModelNumber?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for name */
  name: Scalars['String']['input'];
  /** Column name or index for quantity on hand */
  quantityOnHand?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for reorder level */
  reorderLevel?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for size */
  size?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for SKU */
  sku: Scalars['String']['input'];
  /** Column name or index for tags (comma-separated) */
  tags?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for type (LABOR/MATERIAL) */
  type: Scalars['String']['input'];
  /** Column name or index for unit cost */
  unitCost: Scalars['String']['input'];
  /** Column name or index for unit of measure */
  unitOfMeasure?: InputMaybe<Scalars['String']['input']>;
  /** Column name or index for unit retail price */
  unitRetailPrice: Scalars['String']['input'];
  /** Column name or index for vendor SKU */
  vendorSku?: InputMaybe<Scalars['String']['input']>;
};

/** Service item metrics */
export type ServiceItemMetrics = {
  __typename?: 'ServiceItemMetrics';
  /** Category breakdown */
  categoryBreakdown: Array<StatusCount>;
  /** Total count of service items */
  count: Scalars['Int']['output'];
  /** Number of labor items */
  laborItemsCount: Scalars['Int']['output'];
  /** Number of material items */
  materialItemsCount: Scalars['Int']['output'];
  /** Total inventory value */
  totalInventoryValue: Scalars['Float']['output'];
  /** Type breakdown (MATERIAL vs LABOR) */
  typeBreakdown: Array<StatusCount>;
};

/** The type of service item, either LABOR or MATERIAL. */
export enum ServiceItemType {
  /** Labor service item. */
  Labor = 'LABOR',
  /** Material service item. */
  Material = 'MATERIAL',
}

/** ENUM for sortBy field */
export enum ServiceItemsSortBy {
  /** Sort by created date. */
  CreatedAt = 'CREATED_AT',
  /** Sort by name. */
  Name = 'NAME',
  /** Sort by SKU. */
  Sku = 'SKU',
  /** Sort by type. */
  Type = 'TYPE',
  /** Sort by unit cost. */
  UnitCost = 'UNIT_COST',
  /** Sort by unit retail price. */
  UnitRetailPrice = 'UNIT_RETAIL_PRICE',
  /** Sort by updated date. */
  UpdatedAt = 'UPDATED_AT',
}

export type ServiceProviderAccount = Account &
  Timestamps & {
    __typename?: 'ServiceProviderAccount';
    accountType: AccountType;
    availability: Availability;
    betaProgram?: Maybe<BetaProgram>;
    billingDisabled?: Maybe<Scalars['Boolean']['output']>;
    billingInfo?: Maybe<BillingInfo>;
    businessType?: Maybe<Scalars['String']['output']>;
    checklists?: Maybe<Array<Checklist>>;
    clientCode?: Maybe<Scalars['String']['output']>;
    clientEmail?: Maybe<Scalars['String']['output']>;
    clientPhone?: Maybe<Scalars['String']['output']>;
    companyEmail?: Maybe<Scalars['String']['output']>;
    companyName?: Maybe<Scalars['String']['output']>;
    companyPhone?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['Date']['output'];
    currentSubscriptionPlanCode?: Maybe<Scalars['String']['output']>;
    dedicatedPhoneNumber?: Maybe<Scalars['String']['output']>;
    defaultCrewId?: Maybe<Scalars['ID']['output']>;
    /** True if sample data has been created for this account via createAccountSampleData mutation */
    hasSampleData?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['ID']['output'];
    isArchived: Scalars['Boolean']['output'];
    ivrExtensionCode?: Maybe<Scalars['String']['output']>;
    lastPaymentAttempt?: Maybe<Scalars['Date']['output']>;
    paymentFailureCount?: Maybe<Scalars['Int']['output']>;
    planFeatures?: Maybe<PlanFeatures>;
    referralInfo: ReferralInfo;
    seats?: Maybe<Scalars['Int']['output']>;
    serviceCategories?: Maybe<Array<ServiceCategory>>;
    settings?: Maybe<ServiceProviderSettings>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    stripeDefaultPaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeIsLiveMode?: Maybe<Scalars['Boolean']['output']>;
    stripeLastPaymentIntentId?: Maybe<Scalars['String']['output']>;
    stripeLastPaymentMethod?: Maybe<Scalars['String']['output']>;
    stripeSubscriptionPlanId?: Maybe<Scalars['String']['output']>;
    stripeSubscriptionPlanStatus?: Maybe<SubscriptionStatus>;
    taxRates?: Maybe<Array<TaxRate>>;
    timeZone: Scalars['String']['output'];
    trialDaysRemaining?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['Date']['output'];
    users?: Maybe<Array<User>>;
    website?: Maybe<Scalars['String']['output']>;
  };

export type ServiceProviderAccountClientView = Account &
  Timestamps & {
    __typename?: 'ServiceProviderAccountClientView';
    appointmentCount?: Maybe<Scalars['Int']['output']>;
    availability: Availability;
    betaProgram?: Maybe<BetaProgram>;
    billingDisabled?: Maybe<Scalars['Boolean']['output']>;
    billingInfo?: Maybe<BillingInfo>;
    businessType?: Maybe<Scalars['String']['output']>;
    clientCode?: Maybe<Scalars['String']['output']>;
    clientEmail?: Maybe<Scalars['String']['output']>;
    clientLink?: Maybe<LinkedServiceProviderAccount>;
    clientPhone?: Maybe<Scalars['String']['output']>;
    companyEmail?: Maybe<Scalars['String']['output']>;
    companyName?: Maybe<Scalars['String']['output']>;
    companyPhone?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['Date']['output'];
    currentSubscriptionPlanCode?: Maybe<Scalars['String']['output']>;
    estimateCount?: Maybe<Scalars['Int']['output']>;
    id: Scalars['ID']['output'];
    invoiceCount?: Maybe<Scalars['Int']['output']>;
    isArchived: Scalars['Boolean']['output'];
    jobCount?: Maybe<Scalars['Int']['output']>;
    lastPaymentAttempt?: Maybe<Scalars['Date']['output']>;
    paymentFailureCount?: Maybe<Scalars['Int']['output']>;
    referralInfo: ReferralInfo;
    seats?: Maybe<Scalars['Int']['output']>;
    serviceCategories?: Maybe<Array<ServiceCategory>>;
    settings?: Maybe<ServiceProviderSettings>;
    stripeCustomerId?: Maybe<Scalars['String']['output']>;
    stripeDefaultPaymentMethodId?: Maybe<Scalars['String']['output']>;
    stripeIsLiveMode?: Maybe<Scalars['Boolean']['output']>;
    stripeLastPaymentIntentId?: Maybe<Scalars['String']['output']>;
    stripeLastPaymentMethod?: Maybe<Scalars['String']['output']>;
    stripeSubscriptionPlanId?: Maybe<Scalars['String']['output']>;
    stripeSubscriptionPlanStatus?: Maybe<SubscriptionStatus>;
    timeZone: Scalars['String']['output'];
    trialDaysRemaining?: Maybe<Scalars['Int']['output']>;
    updatedAt: Scalars['Date']['output'];
    users?: Maybe<Array<UserClientView>>;
    website?: Maybe<Scalars['String']['output']>;
  };

export type ServiceProviderPublicProfile = {
  __typename?: 'ServiceProviderPublicProfile';
  availability: Availability;
  billingInfo?: Maybe<BillingInfo>;
  businessType?: Maybe<Scalars['String']['output']>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientPhone?: Maybe<Scalars['String']['output']>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived: Scalars['Boolean']['output'];
  serviceCategories?: Maybe<Array<ServiceCategory>>;
  timeZone: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type ServiceProviderSettings = {
  __typename?: 'ServiceProviderSettings';
  /** When enabled, crew members can log time on any job in the system, not just jobs assigned to them */
  allowCrewTimeLogOnAnyJob?: Maybe<Scalars['Boolean']['output']>;
  appointmentIdCounter?: Maybe<Scalars['Int']['output']>;
  /** When enabled, new timesheet entries are automatically linked to a DRAFT timesheet for the same week */
  automaticTimesheetLinking?: Maybe<Scalars['Boolean']['output']>;
  clientPaymentDisclaimerText?: Maybe<Scalars['String']['output']>;
  clientPaymentDisclaimerUseDefault?: Maybe<Scalars['Boolean']['output']>;
  doNotShareInformation?: Maybe<Scalars['Boolean']['output']>;
  estimateIdCounter?: Maybe<Scalars['Int']['output']>;
  invitationLinkExistingUser?: Maybe<Scalars['String']['output']>;
  invitationLinkNewUser?: Maybe<Scalars['String']['output']>;
  invoiceNumberCounter?: Maybe<Scalars['Int']['output']>;
  isDisplayZelleMessage?: Maybe<Scalars['Boolean']['output']>;
  /** Phone number for emergency call transfer (caller presses 5) */
  ivrEmergencyPhone?: Maybe<Scalars['String']['output']>;
  /** Whether the IVR system is enabled for this account */
  ivrEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** URL for custom recorded greeting in Azure Blob storage */
  ivrGreetingUrl?: Maybe<Scalars['String']['output']>;
  /** IVR mode: FULL for appointment CRUD + callback, CALLBACK_ONLY for callback requests only */
  ivrMode?: Maybe<Scalars['String']['output']>;
  jobIdCounter?: Maybe<Scalars['Int']['output']>;
  maxJobsPerDay?: Maybe<Scalars['Int']['output']>;
  notificationCrewEnRouteEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationCrewEnRouteText?: Maybe<Scalars['String']['output']>;
  notificationCrewJobPausedEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationCrewJobPausedText?: Maybe<Scalars['String']['output']>;
  notificationCrewJobStartedEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationCrewJobStartedText?: Maybe<Scalars['String']['output']>;
  notificationDepositPaymentReminders?: Maybe<
    Array<ServiceProviderSettingsNotificationDepositPaymentReminder>
  >;
  notificationEstimateReadyEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationEstimateReadyText?: Maybe<Scalars['String']['output']>;
  notificationJobCancelledEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationJobCancelledText?: Maybe<Scalars['String']['output']>;
  notificationJobReminders?: Maybe<Array<ServiceProviderSettingsNotificationJobReminder>>;
  notificationJobScheduledEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationJobScheduledText?: Maybe<Scalars['String']['output']>;
  notificationMarketing?: Maybe<Scalars['Boolean']['output']>;
  stripeConnectSettings?: Maybe<StripeConnectSettings>;
  zelleMessage?: Maybe<Scalars['String']['output']>;
};

export type ServiceProviderSettingsNotificationDepositPaymentReminder = {
  __typename?: 'ServiceProviderSettingsNotificationDepositPaymentReminder';
  confirmText?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  timeInAdvance?: Maybe<Scalars['Int']['output']>;
};

export type ServiceProviderSettingsNotificationDepositPaymentReminderInput = {
  confirmText?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  timeInAdvance?: InputMaybe<Scalars['Int']['input']>;
};

export type ServiceProviderSettingsNotificationJobReminder = {
  __typename?: 'ServiceProviderSettingsNotificationJobReminder';
  confirmText?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  timeInAdvance?: Maybe<Scalars['Int']['output']>;
};

export type ServiceProviderSettingsNotificationJobReminderInput = {
  confirmText?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  timeInAdvance?: InputMaybe<Scalars['Int']['input']>;
};

export type SetCurrentUserOnboardingDay = {
  __typename?: 'SetCurrentUserOnboardingDay';
  accountId: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  onboardingDay: Scalars['Int']['output'];
  trialStartedAt: Scalars['Date']['output'];
  userId: Scalars['ID']['output'];
  version: Scalars['String']['output'];
};

export type SetCurrentUserOnboardingDayInput = {
  day: Scalars['Int']['input'];
};

export type SetCurrentUserOnboardingDayResponse = Error | SetCurrentUserOnboardingDay;

export type SetupStatus = {
  __typename?: 'SetupStatus';
  isClientAdded: Scalars['Boolean']['output'];
  isCrewAdded: Scalars['Boolean']['output'];
  isServiceItemAdded: Scalars['Boolean']['output'];
  isUserAdded: Scalars['Boolean']['output'];
};

export type SignInClient = {
  __typename?: 'SignInClient';
  accessToken: Scalars['String']['output'];
  account: ClientAccount;
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

export type SignInClientResponse = Error | SignInClient;

export type SignInServiceProvider = {
  __typename?: 'SignInServiceProvider';
  accessToken: Scalars['String']['output'];
  account: ServiceProviderAccount;
  message: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

export type SignInServiceProviderResponse = Error | SignInServiceProvider;

export type SignOutClient = {
  __typename?: 'SignOutClient';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type SignOutClientResponse = Error | SignOutClient;

export type SignOutServiceProvider = {
  __typename?: 'SignOutServiceProvider';
  message: Scalars['String']['output'];
};

export type SignOutServiceProviderResponse = Error | SignOutServiceProvider;

export enum SignatureFontStyle {
  Classic = 'CLASSIC',
  Handwritten = 'HANDWRITTEN',
  Modern = 'MODERN',
  Script = 'SCRIPT',
}

export type SkipJobFeedback = {
  __typename?: 'SkipJobFeedback';
  job: Job;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Input to skip feedback for a job */
export type SkipJobFeedbackInput = {
  /** The job ID to skip feedback for */
  job_id: Scalars['ID']['input'];
};

export type SkipJobFeedbackResponse = Error | SkipJobFeedback;

export type SkippedAccountInfo = {
  __typename?: 'SkippedAccountInfo';
  accountId: Scalars['String']['output'];
  accountType?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
};

export type SkippedItem = {
  __typename?: 'SkippedItem';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  referencedIn: Array<Scalars['String']['output']>;
  sku: Scalars['String']['output'];
};

/** SMS and WhatsApp delivery preference for notifications */
export enum SmsWhatsAppPreference {
  Both = 'BOTH',
  SmsOnly = 'SMS_ONLY',
  WhatsappOnly = 'WHATSAPP_ONLY',
}

export type SnoozeNotification = {
  __typename?: 'SnoozeNotification';
  message: Scalars['String']['output'];
  notification: Notification;
  snoozedUntil: Scalars['Date']['output'];
  version: Scalars['String']['output'];
};

export type SnoozeNotificationInput = {
  /** Notification ID to snooze */
  notificationId: Scalars['ID']['input'];
  /** How long to snooze (minutes) */
  snoozeDuration: Scalars['Int']['input'];
};

export type SnoozeNotificationResponse = Error | SnoozeNotification;

/** Sort order */
export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export type StartConnectApplication = {
  __typename?: 'StartConnectApplication';
  message: Scalars['String']['output'];
  onboardingUrl: Scalars['String']['output'];
  stripeAccountId: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type StartConnectApplicationResponse = Error | StartConnectApplication;

export type StartTimer = {
  __typename?: 'StartTimer';
  message: Scalars['String']['output'];
  timesheetEntry: TimesheetEntry;
  version: Scalars['String']['output'];
};

/** Expected input to start a timer. */
export type StartTimerInput = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
  timesheet_id?: InputMaybe<Scalars['ID']['input']>;
  type: TimesheetEntryType;
};

export type StartTimerResponse = Error | StartTimer;

/** Status count for entities that have status fields */
export type StatusCount = {
  __typename?: 'StatusCount';
  /** Number of entities with this status */
  count: Scalars['Int']['output'];
  /** The status value */
  status: Scalars['String']['output'];
};

export type StopAccountSampleData = {
  __typename?: 'StopAccountSampleData';
  abortedJobType?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

export type StopAccountSampleDataResponse = Error | StopAccountSampleData;

export type StopTimer = {
  __typename?: 'StopTimer';
  message: Scalars['String']['output'];
  timesheetEntry: TimesheetEntry;
  version: Scalars['String']['output'];
};

/** Expected input to stop a timer. */
export type StopTimerInput = {
  timesheetEntry_id: Scalars['ID']['input'];
};

export type StopTimerResponse = Error | StopTimer;

export type StripeConnectSettings = {
  __typename?: 'StripeConnectSettings';
  adminNotes?: Maybe<Scalars['String']['output']>;
  applicationDate?: Maybe<Scalars['Date']['output']>;
  applicationFee?: Maybe<LegacyApplicationFee>;
  applicationResponseDate?: Maybe<Scalars['Date']['output']>;
  applicationStatus?: Maybe<SPStripeApplicationStatus>;
  customFeeConfiguration?: Maybe<CustomFeeConfiguration>;
  declineReason?: Maybe<Scalars['String']['output']>;
  lastStatusUpdate?: Maybe<Scalars['Date']['output']>;
  /** Pending requirements from Stripe (admin-only visibility). */
  pendingRequirements?: Maybe<PendingRequirements>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
};

export type StripeConnectSettingsInput = {
  adminNotes?: InputMaybe<Scalars['String']['input']>;
  applicationDate?: InputMaybe<Scalars['Date']['input']>;
  applicationFee?: InputMaybe<LegacyApplicationFeeInput>;
  applicationResponseDate?: InputMaybe<Scalars['Date']['input']>;
  applicationStatus?: InputMaybe<SPStripeApplicationStatus>;
  customFeeConfiguration?: InputMaybe<CustomFeeConfigurationInput>;
  declineReason?: InputMaybe<Scalars['String']['input']>;
  lastStatusUpdate?: InputMaybe<Scalars['Date']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type StripePrice = {
  __typename?: 'StripePrice';
  amount: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SubscribeMailingListBetaUpdates = {
  __typename?: 'SubscribeMailingListBetaUpdates';
  listId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  subscription: BetaUpdatesMailingListSubscription;
  version: Scalars['String']['output'];
};

export type SubscribeMailingListBetaUpdatesInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  interest: BetaUpdatesMailingListInterest;
  lastName: Scalars['String']['input'];
};

export type SubscribeMailingListBetaUpdatesResponse = Error | SubscribeMailingListBetaUpdates;

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribe to new messages in a chat */
  chatMessageSent?: Maybe<ChatMessageEvent>;
  /** Subscribe to chat list updates for an account */
  chatUpdated?: Maybe<ChatUpdateEvent>;
  /** Subscribe to materialized dashboard snapshot updates for the current user */
  dashboardSnapshotUpdated?: Maybe<DashboardSnapshotUpdated>;
  /** Subscribe to notification deletions */
  notificationDeleted: NotificationDeleted;
  /** Subscribe to new notifications for current user */
  notificationReceived: NotificationReceived;
  /** Subscribe to notification updates */
  notificationUpdated: NotificationUpdated;
  syncAppointmentsChanged: SyncAppointmentsChangedEvent;
  /** Subscribe to checklist changes for offline sync - replaces polling pullSyncChecklists for real-time notifications */
  syncChecklistsChanged: SyncChecklistsChangedEvent;
  /** Subscribe to client account changes for offline sync - replaces polling pullSyncClients for real-time notifications */
  syncClientsChanged: SyncClientsChangedEvent;
  /** Subscribe to crew changes for offline sync - replaces polling pullSyncCrews for real-time notifications */
  syncCrewsChanged: SyncCrewsChangedEvent;
  syncEstimatesChanged: SyncEstimatesChangedEvent;
  syncGroupsChanged: SyncGroupsChangedEvent;
  syncInvoicesChanged: SyncInvoicesChangedEvent;
  /** Subscribe to job changes for offline sync - replaces polling pullSyncJobs for real-time notifications */
  syncJobsChanged: SyncJobsChangedEvent;
  /** Subscribe to account-scoped Manufacturer offline-sync refresh hints. */
  syncManufacturersChanged: SyncManufacturersChangedEvent;
  syncPaymentsChanged: SyncPaymentsChangedEvent;
  syncPropertiesChanged: SyncPropertiesChangedEvent;
  syncServiceItemsChanged: SyncServiceItemsChangedEvent;
  /** Subscribe to account-scoped TaxRate offline-sync refresh hints. */
  syncTaxratesChanged: SyncTaxratesChangedEvent;
  syncUsersChanged: SyncUsersChangedEvent;
  /** Subscribe to account-scoped Vendor offline-sync refresh hints. */
  syncVendorsChanged: SyncVendorsChangedEvent;
  /** Subscribe to typing indicators in a chat */
  userTyping?: Maybe<TypingEvent>;
};

export type SubscriptionchatMessageSentArgs = {
  chatId: Scalars['ID']['input'];
};

export type SubscriptionchatUpdatedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptiondashboardSnapshotUpdatedArgs = {
  userId: Scalars['ID']['input'];
};

export type SubscriptionsyncAppointmentsChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncChecklistsChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncClientsChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncCrewsChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncEstimatesChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncGroupsChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncInvoicesChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncJobsChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncManufacturersChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncPaymentsChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncPropertiesChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncServiceItemsChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncTaxratesChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncUsersChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionsyncVendorsChangedArgs = {
  accountId: Scalars['ID']['input'];
};

export type SubscriptionuserTypingArgs = {
  chatId: Scalars['ID']['input'];
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<PlanFeatures>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  planCode?: Maybe<Scalars['String']['output']>;
  prices: Array<StripePrice>;
};

export type SubscriptionPlanChangeHistory = {
  __typename?: 'SubscriptionPlanChangeHistory';
  account_id: Scalars['ID']['output'];
  chargeDetails?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  newPlan?: Maybe<Scalars['String']['output']>;
  newStatus?: Maybe<Scalars['String']['output']>;
  planCode?: Maybe<Scalars['String']['output']>;
  previousPlan?: Maybe<Scalars['String']['output']>;
  previousStatus?: Maybe<Scalars['String']['output']>;
  priceAtChange?: Maybe<Scalars['Int']['output']>;
  prorationDetails?: Maybe<Scalars['String']['output']>;
  refundDetails?: Maybe<Scalars['String']['output']>;
  stripe_event_id?: Maybe<Scalars['String']['output']>;
  stripe_transaction_id?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
  usersAdded?: Maybe<Scalars['Int']['output']>;
  usersRemoved?: Maybe<Scalars['Int']['output']>;
};

/** ENUM for Stripe subscription statuses */
export enum SubscriptionStatus {
  Active = 'active',
  Canceled = 'canceled',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  PastDue = 'past_due',
  Paused = 'paused',
  Trialing = 'trialing',
  Unpaid = 'unpaid',
}

export type SuccessfulClientImport = {
  __typename?: 'SuccessfulClientImport';
  /** Company name */
  companyName?: Maybe<Scalars['String']['output']>;
  /** Client email */
  email: Scalars['String']['output'];
  /** Client account ID */
  id: Scalars['ID']['output'];
  /** Number of properties created for this client */
  propertiesCreated: Scalars['Int']['output'];
  /** Number of properties updated for this client */
  propertiesUpdated: Scalars['Int']['output'];
  /** Row number in CSV */
  row: Scalars['Int']['output'];
};

export type SuccessfulDelete = {
  __typename?: 'SuccessfulDelete';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sku: Scalars['String']['output'];
};

export type SuccessfulImport = {
  __typename?: 'SuccessfulImport';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  row: Scalars['Int']['output'];
  sku: Scalars['String']['output'];
};

export type SuggestedAction = {
  __typename?: 'SuggestedAction';
  /** Action identifier for handling */
  action: Scalars['String']['output'];
  /** Display label for the action */
  label: Scalars['String']['output'];
  /** Optional parameters for the action */
  params?: Maybe<Scalars['JSON']['output']>;
};

export type SwitchTimer = {
  __typename?: 'SwitchTimer';
  message: Scalars['String']['output'];
  startedTimesheetEntry: TimesheetEntry;
  stoppedTimesheetEntry: TimesheetEntry;
  version: Scalars['String']['output'];
};

/** Expected input to stop an active timer and start a new timer for a job or appointment. */
export type SwitchTimerInput = {
  /** The appointment ID for the new timer (required if no job_id). */
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional description for the new timer entry. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The job ID for the new timer (required if no appointment_id). */
  job_id?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the currently running timesheet entry to stop. */
  timesheetEntry_id: Scalars['ID']['input'];
  /** The type of the new timer entry. */
  type: TimesheetEntryType;
};

export type SwitchTimerResponse = Error | SwitchTimer;

/** A durable appointment change from an offline device. */
export type SyncAppointmentChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  clientTempId?: InputMaybe<Scalars['String']['input']>;
  create?: InputMaybe<CreateAppointmentInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateAppointmentInput>;
};

export type SyncAppointmentChangeResult = {
  __typename?: 'SyncAppointmentChangeResult';
  clientTempId?: Maybe<Scalars['String']['output']>;
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverAppointment?: Maybe<Appointment>;
  serverId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
};

/** Refresh hint emitted after a committed appointment sync mutation. */
export type SyncAppointmentsChangedEvent = {
  __typename?: 'SyncAppointmentsChangedEvent';
  accountId: Scalars['ID']['output'];
  appointmentIds: Array<Scalars['ID']['output']>;
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
};

/** Type of change that occurred for sync notifications */
export enum SyncChangeType {
  Created = 'CREATED',
  Deleted = 'DELETED',
  Updated = 'UPDATED',
}

/** A single checklist change record from the client */
export type SyncChecklistChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  /** The complete updated checklist data (entries included) */
  checklist?: InputMaybe<UpdateChecklistInput>;
  checklistTempId?: InputMaybe<Scalars['String']['input']>;
  /** Client's last known updatedAt for this record (for conflict detection) */
  clientUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateChecklistInput>;
  dependsOnOperationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  /** The checklist ID being modified */
  id?: InputMaybe<Scalars['ID']['input']>;
  operation?: InputMaybe<SyncOperationType>;
  operationId?: InputMaybe<Scalars['ID']['input']>;
  update?: InputMaybe<UpdateChecklistInput>;
};

/** Result for a single checklist sync operation */
export type SyncChecklistChangeResult = {
  __typename?: 'SyncChecklistChangeResult';
  checklistTempId?: Maybe<Scalars['String']['output']>;
  /** The checklist ID */
  checklist_id: Scalars['ID']['output'];
  /** Conflict reason if success is false */
  conflictReason?: Maybe<Scalars['String']['output']>;
  /** Classification of the conflict (reuses the SyncConflictType enum defined for jobs) */
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation?: Maybe<SyncOperationType>;
  operationId?: Maybe<Scalars['ID']['output']>;
  /** The server version of the checklist (returned on both success and conflict) */
  serverChecklist?: Maybe<Checklist>;
  serverId?: Maybe<Scalars['ID']['output']>;
  /** Whether this change was successfully applied */
  success: Scalars['Boolean']['output'];
  syncedAt?: Maybe<Scalars['Date']['output']>;
};

/** Event payload when checklists are created, updated, or deleted */
export type SyncChecklistsChangedEvent = {
  __typename?: 'SyncChecklistsChangedEvent';
  /** The account ID that owns the checklists */
  accountId: Scalars['ID']['output'];
  /** Type of change that occurred (reuses the SyncChangeType enum defined for jobs) */
  changeType: SyncChangeType;
  /** Server timestamp when the change occurred */
  changedAt: Scalars['Date']['output'];
  /** The checklist IDs that were affected */
  checklistIds: Array<Scalars['ID']['output']>;
};

/** A single durable Client aggregate change from an offline device. */
export type SyncClientChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  clientTempId?: InputMaybe<Scalars['String']['input']>;
  create?: InputMaybe<CreateClientUserPropertyInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateClientUserPropertyInput>;
};

/** Result for a single client account sync operation */
export type SyncClientChangeResult = {
  __typename?: 'SyncClientChangeResult';
  clientTempId?: Maybe<Scalars['String']['output']>;
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverClient?: Maybe<ClientAccount>;
  serverId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
};

/** Event payload when client accounts are created, updated, or deleted */
export type SyncClientsChangedEvent = {
  __typename?: 'SyncClientsChangedEvent';
  /** The SP account ID that owns the client relationships */
  accountId: Scalars['ID']['output'];
  /** Type of change that occurred */
  changeType: SyncChangeType;
  /** Server timestamp when the change occurred */
  changedAt: Scalars['Date']['output'];
  /** The client account IDs that were affected */
  clientIds: Array<Scalars['ID']['output']>;
};

export enum SyncConflictType {
  /** The requested record was already deleted; destructive side effects were not repeated */
  AlreadyDeleted = 'ALREADY_DELETED',
  /** A create operation conflicts with an existing record */
  CreateDuplicate = 'CREATE_DUPLICATE',
  /** Record not found (may have been deleted) */
  NotFound = 'NOT_FOUND',
  /** A required parent or dependent operation does not exist or has not completed */
  ParentNotFound = 'PARENT_NOT_FOUND',
  /** Record was deleted on server */
  ServerDeleted = 'SERVER_DELETED',
  /** Record was modified on server after client's last sync */
  ServerModified = 'SERVER_MODIFIED',
  /** Validation error in client data */
  ValidationError = 'VALIDATION_ERROR',
}

/** A single durable Crew aggregate change from an offline device */
export type SyncCrewChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateCrewInput>;
  crewTempId?: InputMaybe<Scalars['String']['input']>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateCrewInput>;
};

/** Result for a single durable Crew sync operation */
export type SyncCrewChangeResult = {
  __typename?: 'SyncCrewChangeResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  crewTempId?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverCrew?: Maybe<Crew>;
  serverId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
};

/** Event payload when crews are created, updated, or deleted */
export type SyncCrewsChangedEvent = {
  __typename?: 'SyncCrewsChangedEvent';
  /** The account ID that owns the crews */
  accountId: Scalars['ID']['output'];
  /** Type of change that occurred */
  changeType: SyncChangeType;
  /** Server timestamp when the change occurred */
  changedAt: Scalars['Date']['output'];
  /** The crew IDs that were affected */
  crewIds: Array<Scalars['ID']['output']>;
};

export type SyncEstimateChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateEstimateInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  estimateTempId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateEstimateInput>;
};

export type SyncEstimatesChangedEvent = {
  __typename?: 'SyncEstimatesChangedEvent';
  accountId: Scalars['ID']['output'];
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
  estimateIds: Array<Scalars['ID']['output']>;
};

export type SyncGroupChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateGroupInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  groupTempId?: InputMaybe<Scalars['String']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateGroupInput>;
};

export type SyncGroupChangeResult = {
  __typename?: 'SyncGroupChangeResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  groupTempId?: Maybe<Scalars['String']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverGroup?: Maybe<Group>;
  serverId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
};

export type SyncGroupsChangedEvent = {
  __typename?: 'SyncGroupsChangedEvent';
  accountId: Scalars['ID']['output'];
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
  groupIds: Array<Scalars['ID']['output']>;
};

export type SyncInvoiceChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateInvoiceInput>;
  dependsOnOperationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  invoiceTempId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateInvoiceInput>;
};

export type SyncInvoicesChangedEvent = {
  __typename?: 'SyncInvoicesChangedEvent';
  accountId: Scalars['ID']['output'];
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
  invoiceIds: Array<Scalars['ID']['output']>;
};

export type SyncJobChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateJobInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  jobTempId?: InputMaybe<Scalars['String']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateJobInput>;
};

/** Result for a single job sync operation */
export type SyncJobChangeResult = {
  __typename?: 'SyncJobChangeResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  jobTempId?: Maybe<Scalars['String']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverId?: Maybe<Scalars['ID']['output']>;
  serverJob?: Maybe<Job>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
};

/** Event payload when jobs are created, updated, or deleted */
export type SyncJobsChangedEvent = {
  __typename?: 'SyncJobsChangedEvent';
  /** The account ID that owns the jobs */
  accountId: Scalars['ID']['output'];
  /** Type of change that occurred */
  changeType: SyncChangeType;
  /** Server timestamp when the change occurred */
  changedAt: Scalars['Date']['output'];
  /** The job IDs that were affected */
  jobIds: Array<Scalars['ID']['output']>;
};

/** A single durable Manufacturer change from an offline device. */
export type SyncManufacturerChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateManufacturerInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  temporaryId?: InputMaybe<Scalars['String']['input']>;
  update?: InputMaybe<UpdateManufacturerInput>;
};

export type SyncManufacturerChangeResult = {
  __typename?: 'SyncManufacturerChangeResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverId?: Maybe<Scalars['ID']['output']>;
  serverManufacturer?: Maybe<Manufacturer>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
  temporaryId?: Maybe<Scalars['String']['output']>;
};

/** Event payload when Manufacturers are created, updated, or deleted. */
export type SyncManufacturersChangedEvent = {
  __typename?: 'SyncManufacturersChangedEvent';
  accountId: Scalars['ID']['output'];
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
  manufacturerIds: Array<Scalars['ID']['output']>;
};

/** Durable offline mutation operation. */
export enum SyncOperationType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE',
}

export type SyncPaymentChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreatePaymentInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  paymentTempId?: InputMaybe<Scalars['String']['input']>;
  update?: InputMaybe<UpdatePaymentInput>;
};

export type SyncPaymentChangeResult = {
  __typename?: 'SyncPaymentChangeResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  paymentTempId?: Maybe<Scalars['String']['output']>;
  serverId?: Maybe<Scalars['ID']['output']>;
  serverPayment?: Maybe<Payment>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
};

export type SyncPaymentsChangedEvent = {
  __typename?: 'SyncPaymentsChangedEvent';
  accountId: Scalars['ID']['output'];
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
  paymentIds: Array<Scalars['ID']['output']>;
};

export type SyncPropertiesChangedEvent = {
  __typename?: 'SyncPropertiesChangedEvent';
  accountId: Scalars['ID']['output'];
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
  propertyIds: Array<Scalars['ID']['output']>;
};

export type SyncPropertyChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreatePropertyInput>;
  dependsOnOperationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  propertyTempId?: InputMaybe<Scalars['ID']['input']>;
  update?: InputMaybe<UpdatePropertyInput>;
};

/** One durable Service Item operation. CREATE uses serviceItemTempId and create; UPDATE/DELETE use entityId. */
export type SyncServiceItemChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateServiceItemInput>;
  dependsOnOperationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  serviceItemTempId?: InputMaybe<Scalars['ID']['input']>;
  update?: InputMaybe<UpdateServiceItemInput>;
};

export type SyncServiceItemChangeResult = {
  __typename?: 'SyncServiceItemChangeResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverId?: Maybe<Scalars['ID']['output']>;
  serverServiceItem?: Maybe<ServiceItem>;
  serviceItemTempId?: Maybe<Scalars['ID']['output']>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
};

export type SyncServiceItemsChangedEvent = {
  __typename?: 'SyncServiceItemsChangedEvent';
  accountId: Scalars['ID']['output'];
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
  serviceItemIds: Array<Scalars['ID']['output']>;
};

/** A single durable TaxRate change from an offline device. */
export type SyncTaxrateChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateTaxRateInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  temporaryId?: InputMaybe<Scalars['String']['input']>;
  update?: InputMaybe<UpdateTaxRateInput>;
};

/** Result for a single TaxRate sync operation. */
export type SyncTaxrateChangeResult = {
  __typename?: 'SyncTaxrateChangeResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverId?: Maybe<Scalars['ID']['output']>;
  serverTaxRate?: Maybe<TaxRate>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
  temporaryId?: Maybe<Scalars['String']['output']>;
};

/** Event payload when TaxRates are created, updated, or deleted. */
export type SyncTaxratesChangedEvent = {
  __typename?: 'SyncTaxratesChangedEvent';
  /** The Service Provider account that owns the TaxRates. */
  accountId: Scalars['ID']['output'];
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
  taxRateIds: Array<Scalars['ID']['output']>;
};

export type SyncTimesheetChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateTimesheetInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  timesheetTempId?: InputMaybe<Scalars['ID']['input']>;
  update?: InputMaybe<UpdateTimesheetInput>;
};

export type SyncTimesheetChangeResult = {
  __typename?: 'SyncTimesheetChangeResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverId?: Maybe<Scalars['ID']['output']>;
  serverTimesheet?: Maybe<Timesheet>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
  timesheetTempId?: Maybe<Scalars['ID']['output']>;
};

/** One idempotent offline Timesheet Entry change. */
export type SyncTimesheetEntryChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateTimesheetEntryInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  timesheetEntryTempId?: InputMaybe<Scalars['ID']['input']>;
  update?: InputMaybe<UpdateTimesheetEntryInput>;
};

export type SyncTimesheetEntryChangeResult = {
  __typename?: 'SyncTimesheetEntryChangeResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverId?: Maybe<Scalars['ID']['output']>;
  serverTimesheetEntry?: Maybe<TimesheetEntry>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
  timesheetEntryTempId?: Maybe<Scalars['ID']['output']>;
};

export type SyncUserChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateUserInput>;
  dependsOnOperationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  update?: InputMaybe<UpdateUserInput>;
  userTempId?: InputMaybe<Scalars['ID']['input']>;
};

export type SyncUserRecord = {
  __typename?: 'SyncUserRecord';
  account_id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  crewIds: Array<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  locale?: Maybe<Locale>;
  phone?: Maybe<Scalars['String']['output']>;
  role: Role;
  timeZone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type SyncUsersChangedEvent = {
  __typename?: 'SyncUsersChangedEvent';
  accountId: Scalars['ID']['output'];
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
  userIds: Array<Scalars['ID']['output']>;
};

/** A single durable Vendor change from an offline device. */
export type SyncVendorChangeInput = {
  baseUpdatedAt?: InputMaybe<Scalars['Date']['input']>;
  create?: InputMaybe<CreateVendorInput>;
  dependsOnOperationIds: Array<Scalars['ID']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['input'];
  temporaryId?: InputMaybe<Scalars['String']['input']>;
  update?: InputMaybe<UpdateVendorInput>;
};

export type SyncVendorChangeResult = {
  __typename?: 'SyncVendorChangeResult';
  conflictReason?: Maybe<Scalars['String']['output']>;
  conflictType?: Maybe<SyncConflictType>;
  entityId?: Maybe<Scalars['ID']['output']>;
  operation: SyncOperationType;
  operationId: Scalars['ID']['output'];
  serverId?: Maybe<Scalars['ID']['output']>;
  serverVendor?: Maybe<Vendor>;
  success: Scalars['Boolean']['output'];
  syncedAt: Scalars['Date']['output'];
  temporaryId?: Maybe<Scalars['String']['output']>;
};

/** Event payload when Vendors are created, updated, or deleted. */
export type SyncVendorsChangedEvent = {
  __typename?: 'SyncVendorsChangedEvent';
  accountId: Scalars['ID']['output'];
  changeType: SyncChangeType;
  changedAt: Scalars['Date']['output'];
  vendorIds: Array<Scalars['ID']['output']>;
};

/** Announcement type for system-wide notifications */
export enum SystemAnnouncementType {
  Alert = 'ALERT',
  General = 'GENERAL',
  Maintenance = 'MAINTENANCE',
}

export type TaxRate = Timestamps & {
  __typename?: 'TaxRate';
  account_id: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  groupIds?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  rate: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum TaxRatesSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type TestConnectNotification = {
  __typename?: 'TestConnectNotification';
  alertId?: Maybe<Scalars['ID']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
  version: Scalars['String']['output'];
};

export type TestConnectNotificationResponse = Error | TestConnectNotification;

export type TestNotificationChannels = {
  __typename?: 'TestNotificationChannels';
  message: Scalars['String']['output'];
  notification: Notification;
  version: Scalars['String']['output'];
};

export type TestNotificationChannelsInput = {
  /** Channels to test (defaults to [UI, EMAIL, PUSH] if not provided) */
  channels?: InputMaybe<Array<NotificationChannel>>;
};

export type TestNotificationChannelsResponse = Error | TestNotificationChannels;

/** Time period breakdown for trend analysis */
export type TimePeriodBreakdown = {
  __typename?: 'TimePeriodBreakdown';
  /** Average completion time for this period */
  avgCompletionTime: Scalars['Float']['output'];
  /** Number of completed jobs in this period */
  completedJobs: Scalars['Int']['output'];
  /** Time period identifier (e.g., '2024-01-15', '2024-W03', '2024-01') */
  period: Scalars['String']['output'];
  /** Total hours worked in this period */
  totalHours: Scalars['Float']['output'];
};

/** Time period grouping options for trend analysis */
export enum TimePeriodType {
  /** Group by individual days */
  Daily = 'DAILY',
  /** Group by months */
  Monthly = 'MONTHLY',
  /** Group by weeks */
  Weekly = 'WEEKLY',
}

export type Timesheet = Timestamps & {
  __typename?: 'Timesheet';
  account_id: Scalars['ID']['output'];
  approvedAt?: Maybe<Scalars['Date']['output']>;
  approved_by_user_id?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  employee_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  overtimeHours?: Maybe<Scalars['Float']['output']>;
  regularHours?: Maybe<Scalars['Float']['output']>;
  rejectedAt?: Maybe<Scalars['Date']['output']>;
  rejected_by_user_id?: Maybe<Scalars['ID']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: TimesheetStatus;
  submissions?: Maybe<Array<TimesheetSubmission>>;
  timesheetDate?: Maybe<Scalars['Date']['output']>;
  timesheetEntries?: Maybe<Array<TimesheetEntry>>;
  totalEnRouteHours?: Maybe<Scalars['Int']['output']>;
  totalHours?: Maybe<Scalars['Float']['output']>;
  totalJobPrepHours?: Maybe<Scalars['Int']['output']>;
  totalOfficeHours?: Maybe<Scalars['Int']['output']>;
  totalWorkHours?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userAvatarUrl?: Maybe<Scalars['String']['output']>;
  userCrews?: Maybe<Array<TimesheetUserCrew>>;
  userFullName: Scalars['String']['output'];
  user_id: Scalars['ID']['output'];
  weekEndDate?: Maybe<Scalars['String']['output']>;
  weekStartDate?: Maybe<Scalars['String']['output']>;
};

export type TimesheetAnalytics = {
  __typename?: 'TimesheetAnalytics';
  totalEnRouteHours?: Maybe<Scalars['Int']['output']>;
  totalEnRouteHoursCurrentWeek?: Maybe<Scalars['Int']['output']>;
  totalEnRouteHoursPreviousWeek?: Maybe<Scalars['Int']['output']>;
  totalHours?: Maybe<Scalars['Int']['output']>;
  totalHoursCurrentWeek?: Maybe<Scalars['Int']['output']>;
  totalHoursPreviousWeek?: Maybe<Scalars['Int']['output']>;
  totalJobPrepHours?: Maybe<Scalars['Int']['output']>;
  totalJobPrepHoursCurrentWeek?: Maybe<Scalars['Int']['output']>;
  totalJobPrepHoursPreviousWeek?: Maybe<Scalars['Int']['output']>;
  totalOfficeHours?: Maybe<Scalars['Int']['output']>;
  totalOfficeHoursCurrentWeek?: Maybe<Scalars['Int']['output']>;
  totalOfficeHoursPreviousWeek?: Maybe<Scalars['Int']['output']>;
  totalWorkHours?: Maybe<Scalars['Int']['output']>;
  totalWorkHoursCurrentWeek?: Maybe<Scalars['Int']['output']>;
  totalWorkHoursPreviousWeek?: Maybe<Scalars['Int']['output']>;
};

export enum TimesheetEntriesSortBy {
  CreatedAt = 'CREATED_AT',
  EndTime = 'END_TIME',
  StartTime = 'START_TIME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
}

export type TimesheetEntry = Timestamps & {
  __typename?: 'TimesheetEntry';
  /**
   * Computed field: startTime converted to account's timezone.
   * Calculated dynamically via field resolver (Phase 5).
   * Not stored in database.
   */
  accountStartTime: Scalars['Date']['output'];
  /**
   * Computed field: endTime converted to account's timezone.
   * Calculated dynamically via field resolver (Phase 5).
   * Nullable because timer may still be running (endTime null).
   * Not stored in database.
   */
  accountStopTime?: Maybe<Scalars['Date']['output']>;
  account_id: Scalars['ID']['output'];
  appointmentTitle?: Maybe<Scalars['String']['output']>;
  appointment_id?: Maybe<Scalars['ID']['output']>;
  approved_by_user_id?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Date']['output'];
  /** Full name of the user who created this entry on behalf of another user. */
  createdByUserFullName?: Maybe<Scalars['String']['output']>;
  /** The user who created this entry on behalf of another user (set when an admin/manager creates time for a crew member). */
  created_by_user_id?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isMerged?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  job_id?: Maybe<Scalars['ID']['output']>;
  startTime: Scalars['Date']['output'];
  timesheet_id?: Maybe<Scalars['ID']['output']>;
  type: TimesheetEntryType;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userAvatarUrl?: Maybe<Scalars['String']['output']>;
  userFullName?: Maybe<Scalars['String']['output']>;
  user_id: Scalars['ID']['output'];
};

export enum TimesheetEntryType {
  /** Time spent traveling to a job. */
  EnRoute = 'EN_ROUTE',
  /** Time spent preparing for job work */
  JobPrepTime = 'JOB_PREP_TIME',
  /** Time spent actively working on a job */
  JobTime = 'JOB_TIME',
  /** Any timesheet time not spent on a job. */
  OfficeTime = 'OFFICE_TIME',
}

/** Timesheet metrics */
export type TimesheetMetrics = {
  __typename?: 'TimesheetMetrics';
  /** Average hours per entry */
  averageHours: Scalars['Float']['output'];
  /** Total count of timesheet entries */
  count: Scalars['Int']['output'];
  /** Total hours logged */
  totalHours: Scalars['Float']['output'];
};

export type TimesheetStats = {
  __typename?: 'TimesheetStats';
  completeEntriesCount: Scalars['Int']['output'];
  incompleteEntriesCount: Scalars['Int']['output'];
  totalCompletedHours: Scalars['Int']['output'];
  totalCompletedMinutes: Scalars['Int']['output'];
};

export enum TimesheetStatus {
  /** Timesheet has been approved. */
  Approved = 'APPROVED',
  /** Timesheet is in draft status. */
  Draft = 'DRAFT',
  /** Timesheet is pending approval. */
  Pending = 'PENDING',
  /** Timesheet has been rejected. */
  Rejected = 'REJECTED',
}

export type TimesheetSubmission = {
  __typename?: 'TimesheetSubmission';
  status?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['Date']['output']>;
  submittedBy?: Maybe<Scalars['ID']['output']>;
};

export type TimesheetUserCrew = {
  __typename?: 'TimesheetUserCrew';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export enum TimesheetsSortBy {
  CreatedAt = 'CREATED_AT',
  Status = 'STATUS',
  TimesheetDate = 'TIMESHEET_DATE',
  UpdatedAt = 'UPDATED_AT',
}

export type Timestamps = {
  createdAt: Scalars['Date']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Parameters to filter travel time report data */
export type TravelTimeReportFilter = {
  /** Filter by specific crew IDs */
  crew_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** End date for timesheet entries */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by specific job IDs */
  job_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Start date for timesheet entries */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by specific user IDs */
  user_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Travel time metrics for crew/user efficiency analysis */
export type TravelTimeReportItem = {
  __typename?: 'TravelTimeReportItem';
  /** Average travel time per job in hours */
  averageTravelTimePerJobHours: Scalars['Int']['output'];
  /** Average travel time per job in minutes (remainder) */
  averageTravelTimePerJobMinutes: Scalars['Int']['output'];
  /** Crew object (null for user-level report) */
  crew?: Maybe<Crew>;
  /** Crew name (null for user-level report) */
  crewName?: Maybe<Scalars['String']['output']>;
  /** Crew ID (null for user-level report) */
  crew_id?: Maybe<Scalars['ID']['output']>;
  /** Total number of travel entries */
  totalTravelEntries: Scalars['Int']['output'];
  /** Total travel time in hours */
  totalTravelTimeHours: Scalars['Int']['output'];
  /** Total travel time in minutes (remainder) */
  totalTravelTimeMinutes: Scalars['Int']['output'];
  /** Number of unique jobs traveled to */
  uniqueJobsCount: Scalars['Int']['output'];
  /** User object (null for crew-level report) */
  user?: Maybe<User>;
  /** User full name (null for crew-level report) */
  userFullName?: Maybe<Scalars['String']['output']>;
  /** User ID (null for crew-level report) */
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type TriggerCacheLearningCycle = {
  __typename?: 'TriggerCacheLearningCycle';
  executionTime: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  queriesAnalyzed: Scalars['Int']['output'];
  queriesPromoted: Scalars['Int']['output'];
  timestamp: Scalars['String']['output'];
};

export type TriggerCacheLearningCycleResponse = Error | TriggerCacheLearningCycle;

export type TriggerCachePrefresh = {
  __typename?: 'TriggerCachePrefresh';
  jobId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  queueName: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type TriggerCachePrefreshResponse = Error | TriggerCachePrefresh;

export type TriggerQuickBooksImport = {
  __typename?: 'TriggerQuickBooksImport';
  importJob?: Maybe<QuickBooksImportJob>;
  message: Scalars['String']['output'];
  syncJobId?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type TriggerQuickBooksImportResponse = Error | TriggerQuickBooksImport;

export type TriggerQuickBooksSyncOlderItems = {
  __typename?: 'TriggerQuickBooksSyncOlderItems';
  message: Scalars['String']['output'];
  syncJobId?: Maybe<Scalars['String']['output']>;
  version: Scalars['String']['output'];
};

export type TriggerQuickBooksSyncOlderItemsResponse = Error | TriggerQuickBooksSyncOlderItems;

export type TrustKnownDevice = {
  __typename?: 'TrustKnownDevice';
  device: KnownDevice;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Response for trusting a known login device */
export type TrustKnownDeviceResponse = Error | TrustKnownDevice;

export type TypingEvent = Error | TypingIndicatorEvent;

export type TypingIndicator = {
  __typename?: 'TypingIndicator';
  chatId: Scalars['ID']['output'];
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  isTyping: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
};

export type TypingIndicatorEvent = {
  __typename?: 'TypingIndicatorEvent';
  /** Typing indicator data */
  typingIndicator: TypingIndicator;
};

/** Unit of measure for service items, such as EACH, BOX, GALLON, etc. */
export enum UnitOfMeasure {
  /** Box as a unit of measure. */
  Box = 'BOX',
  /** Case as a unit of measure. */
  Case = 'CASE',
  /** Cubic centimeter as a unit of measure. */
  CubicCentimeter = 'CUBIC_CENTIMETER',
  /** Cubic meter as a unit of measure. */
  CubicMeter = 'CUBIC_METER',
  /** Cubic millimeter as a unit of measure. */
  CubicMillimeter = 'CUBIC_MILLIMETER',
  /** Cup as a unit of measure. */
  Cup = 'CUP',
  /** Dozen as a unit of measure. */
  Dozen = 'DOZEN',
  /** Each individual item. */
  Each = 'EACH',
  /** Feet as a unit of measure. */
  Feet = 'FEET',
  /** Gallon as a unit of measure. */
  Gallon = 'GALLON',
  /** Inch as a unit of measure. */
  Inch = 'INCH',
  /** Liter as a unit of measure. */
  Liter = 'LITER',
  /** Milliliter as a unit of measure. */
  Milliliter = 'MILLILITER',
  /** Ounce as a unit of measure. */
  Ounce = 'OUNCE',
  /** Pint as a unit of measure. */
  Pint = 'PINT',
  /** Pound as a unit of measure. */
  Pound = 'POUND',
  /** Quart as a unit of measure. */
  Quart = 'QUART',
  /** Yard as a unit of measure. */
  Yard = 'YARD',
}

export type UnlinkServiceProvider = {
  __typename?: 'UnlinkServiceProvider';
  isLinked: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Input for unlinking a service provider from a client account using service provider account ID */
export type UnlinkServiceProviderInput = {
  serviceProviderAccountId: Scalars['ID']['input'];
};

export type UnlinkServiceProviderResponse = Error | UnlinkServiceProvider;

/** Response when a WhatsApp number is successfully unlinked */
export type UnlinkWhatsApp = {
  __typename?: 'UnlinkWhatsApp';
  message: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

export type UnlinkWhatsAppResponse = Error | UnlinkWhatsApp;

export type UnlockAdminUser = {
  __typename?: 'UnlockAdminUser';
  adminUser: AdminUser;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type UnlockAdminUserResponse = Error | UnlockAdminUser;

export type UpdateAdminUser = {
  __typename?: 'UpdateAdminUser';
  adminUser: AdminUser;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to update an admin user */
export type UpdateAdminUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Specific permission IDs to grant */
  permissionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<AdminRole>;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAdminUserPassword = {
  __typename?: 'UpdateAdminUserPassword';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to update admin user password */
export type UpdateAdminUserPasswordInput = {
  confirmNewPassword: Scalars['String']['input'];
  currentPassword: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  newPassword: Scalars['String']['input'];
};

export type UpdateAdminUserPasswordResponse = Error | UpdateAdminUserPassword;

export type UpdateAdminUserResponse = Error | UpdateAdminUser;

/** Expected input to update an appointment */
export type UpdateAppointmentInput = {
  alternateBillingInfo?: InputMaybe<BillingInfoInput>;
  bill_to_client_account_id?: InputMaybe<Scalars['ID']['input']>;
  callback?: InputMaybe<Scalars['Boolean']['input']>;
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  job_id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  priority?: InputMaybe<Scalars['Boolean']['input']>;
  property_id?: InputMaybe<Scalars['ID']['input']>;
  scheduledStartDatetime?: InputMaybe<Scalars['Date']['input']>;
  scheduledStopDatetime?: InputMaybe<Scalars['Date']['input']>;
  serviceItems?: InputMaybe<Array<AppointmentServiceItemInput>>;
  status?: InputMaybe<AppointmentStatus>;
  taxRate?: InputMaybe<Scalars['Float']['input']>;
  taxRateName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBetaLifecycleEnrollmentInput = {
  accountId: Scalars['ID']['input'];
  checklistCompletedCount?: InputMaybe<Scalars['Int']['input']>;
  convertedAt?: InputMaybe<Scalars['Date']['input']>;
  lastActiveAt?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChat = {
  __typename?: 'UpdateChat';
  chat: Chat;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to update a chat. */
export type UpdateChatInput = {
  /** Chat ID to update */
  id: Scalars['ID']['input'];
  /** Whether to mark chat as archived (role-specific: CLIENT updates isArchivedClientAccount, SP updates isArchivedServiceProviderAccount) */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update client-specific archive status directly */
  isArchivedClientAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update service provider-specific archive status directly */
  isArchivedServiceProviderAccount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to mark chat as read (true) or unread (false) */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateChatResponse = Error | UpdateChat;

export type UpdateChecklistEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDescriptionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChecklistInput = {
  checklistEntries?: InputMaybe<Array<UpdateChecklistEntryInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateChecklistSavedEntryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  isDescriptionRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isNew?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateChecklistSavedInput = {
  checklistEntries?: InputMaybe<Array<UpdateChecklistSavedEntryInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientAccount = {
  __typename?: 'UpdateClientAccount';
  account: ClientAccount;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input to update a client account from service provider or client admin */
export type UpdateClientAccountInput = {
  availability?: InputMaybe<AvailabilityInput>;
  billingInfo?: InputMaybe<BillingInfoInput>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  settings?: InputMaybe<UpdateClientAccountSettingsInput>;
  /** Tags for organizing and searching client accounts */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientAccountResponse = Error | UpdateClientAccount;

export type UpdateClientAccountSettings = {
  __typename?: 'UpdateClientAccountSettings';
  message: Scalars['String']['output'];
  settings: ClientSettings;
  version: Scalars['String']['output'];
};

/** Settings for a client account */
export type UpdateClientAccountSettingsInput = {
  dashboardAdvancedView?: InputMaybe<Scalars['Boolean']['input']>;
  doNotShareInformation?: InputMaybe<Scalars['Boolean']['input']>;
  notificationAnnoucements?: InputMaybe<Scalars['Boolean']['input']>;
  notificationChatMessages?: InputMaybe<Scalars['Boolean']['input']>;
  notificationJobReminders?: InputMaybe<Scalars['Boolean']['input']>;
  notificationJobStatus?: InputMaybe<Scalars['Boolean']['input']>;
  notificationMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  notificationMethod?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientAccountSettingsResponse = Error | UpdateClientAccountSettings;

export type UpdateClientServiceProviderLinkState = {
  __typename?: 'UpdateClientServiceProviderLinkState';
  clientAccountId: Scalars['ID']['output'];
  linkState: ClientServiceProviderLinkState;
  message: Scalars['String']['output'];
  serviceProviderAccountId: Scalars['ID']['output'];
};

export type UpdateClientServiceProviderLinkStateInput = {
  /** Client account to update. Required for admin users; ignored for CLIENT users. */
  clientAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Next state for the relationship */
  linkState: ClientServiceProviderLinkState;
  /** Optional admin note stored in invite history */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Service provider relationship to update */
  serviceProviderAccountId: Scalars['ID']['input'];
};

export type UpdateClientServiceProviderLinkStateResponse =
  | Error
  | UpdateClientServiceProviderLinkState;

export type UpdateClientUserProperty = {
  __typename?: 'UpdateClientUserProperty';
  account?: Maybe<ClientAccount>;
  message: Scalars['String']['output'];
  property?: Maybe<Property>;
  user?: Maybe<User>;
  version: Scalars['String']['output'];
};

/** Account fields for transactional update */
export type UpdateClientUserPropertyAccountInput = {
  /** File attachments tied to the client account */
  attachments?: InputMaybe<Array<InputMaybe<LinkAttachmentInput>>>;
  /** Client account availability */
  availability?: InputMaybe<AvailabilityInput>;
  /** Billing information */
  billingInfo?: InputMaybe<BillingInfoInput>;
  /** Company name */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** Client email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Client account ID (required) */
  id: Scalars['ID']['input'];
  /** Archived status */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mark as quick add (incomplete record) */
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  /** Client account settings */
  settings?: InputMaybe<UpdateClientAccountSettingsInput>;
  /** Tags */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Time zone */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Website URL */
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a client account, user, and/or property in a single transaction */
export type UpdateClientUserPropertyInput = {
  /** Client account fields to update */
  account?: InputMaybe<UpdateClientUserPropertyAccountInput>;
  /** Property fields to update */
  property?: InputMaybe<UpdateClientUserPropertyPropertyInput>;
  /** User fields to update */
  user?: InputMaybe<UpdateClientUserPropertyUserInput>;
};

/** Property fields for transactional update */
export type UpdateClientUserPropertyPropertyInput = {
  /** Address line 1 */
  address1?: InputMaybe<Scalars['String']['input']>;
  /** Address line 2 */
  address2?: InputMaybe<Scalars['String']['input']>;
  /** Property availability */
  availability?: InputMaybe<AvailabilityInput>;
  /** Base64 encoded property image (jpg or png) */
  base64Image?: InputMaybe<Scalars['String']['input']>;
  /** City */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Contact email */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Contact name */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Contact phone */
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  /** Country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Property ID (required) */
  id: Scalars['ID']['input'];
  /** Mark as quick add (incomplete property) */
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  /** Property name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** File attachments tied to the property */
  propertyAttachments?: InputMaybe<Array<InputMaybe<LinkAttachmentInput>>>;
  /** Free-text note attached to the property */
  propertyNote?: InputMaybe<Scalars['String']['input']>;
  /** Property type */
  propertyType?: InputMaybe<propertyTypeEnum>;
  /** State (2-character code) */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Time zone */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Zip code */
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientUserPropertyResponse = Error | UpdateClientUserProperty;

/** User fields for transactional update */
export type UpdateClientUserPropertyUserInput = {
  /** Email address */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User ID (required) */
  id: Scalars['ID']['input'];
  /** Last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Time zone */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConnectApplicationStatus = {
  __typename?: 'UpdateConnectApplicationStatus';
  message: Scalars['String']['output'];
  status: ConnectStatus;
  version: Scalars['String']['output'];
};

export type UpdateConnectApplicationStatusResponse = Error | UpdateConnectApplicationStatus;

export type UpdateConnectFeeConfiguration = {
  __typename?: 'UpdateConnectFeeConfiguration';
  feeConfiguration: ApplicationFeeConfig;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type UpdateConnectFeeConfigurationResponse = Error | UpdateConnectFeeConfiguration;

/** Expected input to update a crew.  Note, when updating a crew, the users array should contain all users that should be in the crew.  If a user is not in the array, they will be removed from the crew.  If a user is in the array, they will be added to the crew. If there is no user in the array with `isCrewLead` set to true, an error will be returned. */
export type UpdateCrewInput = {
  availability?: InputMaybe<AvailabilityInput>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** IANA timezone identifier for the crew (e.g., America/Los_Angeles, America/New_York) */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<CrewUserInput>>;
};

/** Expected input to update a estimate.  Note, when updating a estimate, the serviceItems field all service items that should be in the estimate.  If a user is not in the array, they will be removed from the estimate.  If a user is in the array, they will be added to the estimate. If there is no service item in the array, an array will be returned. */
export type UpdateEstimateInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  alternateBillingInfo?: InputMaybe<BillingInfoInput>;
  availability?: InputMaybe<AvailabilityInput>;
  bill_to_client_account_id?: InputMaybe<Scalars['ID']['input']>;
  /** Client message posted to the Estimate chat when requesting changes or rejecting an estimate */
  changeRequestNotes?: InputMaybe<Scalars['String']['input']>;
  checklist_id?: InputMaybe<Scalars['ID']['input']>;
  clientApprovedSignatureImageBase64?: InputMaybe<Scalars['String']['input']>;
  clientApprovedSignatureTimestamp?: InputMaybe<Scalars['Date']['input']>;
  client_account_id?: InputMaybe<Scalars['ID']['input']>;
  commentToClient?: InputMaybe<Scalars['String']['input']>;
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  estimatedHours?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  isResetChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  /** When removing recurring, keep completed/approved instances as standalone (default: true) */
  keepCompletedInstances?: InputMaybe<Scalars['Boolean']['input']>;
  /** Scope of modification when updating a recurring instance (default: THIS_ONLY) */
  modificationScope?: InputMaybe<ModificationScope>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Set to null to detach this instance from its recurring series (EXDATE always added to parent) */
  parent_estimate_id?: InputMaybe<Scalars['ID']['input']>;
  property_id?: InputMaybe<Scalars['ID']['input']>;
  recurringSchedule?: InputMaybe<RecurringScheduleInput>;
  serviceItems?: InputMaybe<Array<EstimateServiceItemInput>>;
  skipAccountHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<EstimateStatus>;
  taxRate?: InputMaybe<Scalars['Int']['input']>;
  taxRateName?: InputMaybe<Scalars['String']['input']>;
  /** Optional date after which a sent estimate is no longer valid */
  validUntil?: InputMaybe<Scalars['Date']['input']>;
};

/** Input for updating FCM device information */
export type UpdateFCMDeviceInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  deviceId: Scalars['String']['input'];
  deviceModel?: InputMaybe<Scalars['String']['input']>;
  deviceName?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  osVersion?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** Response for updating an FCM device */
export type UpdateFCMDeviceResponse = DeviceUpdate | Error;

export type UpdateFeedbackEntryInput = {
  complaintDescription?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isComplaint?: InputMaybe<Scalars['Boolean']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  resolution_notes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<FeedbackEntryStatus>;
  type?: InputMaybe<FeedbackEntryType>;
};

export type UpdateGlobalFeeDefaults = {
  __typename?: 'UpdateGlobalFeeDefaults';
  /** Number of accounts that will be affected by this change */
  affectedAccounts: Scalars['Int']['output'];
  feeDefaults: GlobalFeeDefaults;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type UpdateGlobalFeeDefaultsResponse = Error | UpdateGlobalFeeDefaults;

export type UpdateGlobalSettings = {
  __typename?: 'UpdateGlobalSettings';
  message: Scalars['String']['output'];
  settings: GlobalSettings;
  version: Scalars['String']['output'];
};

export type UpdateGlobalSettingsResponse = Error | UpdateGlobalSettings;

export type UpdateGroupInput = {
  /** Account ID for admin users (optional, ignored for regular users) */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  groupCode?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  service_item_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Expected input to update a invoice.  Note, when updating a invoice, the serviceItems field all service items that should be in the invoice.  If a user is not in the array, they will be removed from the invoice.  If a user is in the array, they will be added to the invoice. If there is no service item in the array, an array will be returned. */
export type UpdateInvoiceInput = {
  clientMessage?: InputMaybe<Scalars['String']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  dueDate?: InputMaybe<Scalars['Date']['input']>;
  dueDateTerms?: InputMaybe<DueDateTerms>;
  dueDateType?: InputMaybe<DueDateTerms>;
  id?: InputMaybe<Scalars['ID']['input']>;
  issueDate?: InputMaybe<Scalars['Date']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  serviceItems?: InputMaybe<Array<InvoiceServiceItemInput>>;
  status?: InputMaybe<InvoiceStatus>;
  taxRate?: InputMaybe<Scalars['Int']['input']>;
  taxRateName?: InputMaybe<Scalars['String']['input']>;
};

/** Expected input to update a job.  Note, when updating a job, the serviceItems field all service items that should be in the job.  If a user is not in the array, they will be removed from the job.  If a user is in the array, they will be added to the job. If there is no service item in the array, an array will be returned. */
export type UpdateJobInput = {
  alternateBillingInfo?: InputMaybe<BillingInfoInput>;
  availability?: InputMaybe<AvailabilityInput>;
  bill_to_client_account_id?: InputMaybe<Scalars['ID']['input']>;
  checklist?: InputMaybe<UpdateChecklistSavedInput>;
  checklist_id?: InputMaybe<Scalars['ID']['input']>;
  crew_id?: InputMaybe<Scalars['ID']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  discount?: InputMaybe<Scalars['Int']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  emailText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  isResetChecklist?: InputMaybe<Scalars['Boolean']['input']>;
  jobdHours?: InputMaybe<Scalars['Float']['input']>;
  /** When removing recurring, keep completed/in-progress instances as standalone (default: true) */
  keepCompletedInstances?: InputMaybe<Scalars['Boolean']['input']>;
  /** Scope of modification when updating a recurring instance (default: THIS_ONLY) */
  modificationScope?: InputMaybe<ModificationScope>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set to null to detach this instance from its recurring series (EXDATE always added to parent) */
  parent_job_id?: InputMaybe<Scalars['ID']['input']>;
  property_id?: InputMaybe<Scalars['ID']['input']>;
  recurringSchedule?: InputMaybe<RecurringScheduleInput>;
  scheduledStartDatetime?: InputMaybe<Scalars['Date']['input']>;
  scheduledStopDatetime?: InputMaybe<Scalars['Date']['input']>;
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
  serviceItems?: InputMaybe<Array<JobServiceItemInput>>;
  skipAccountHolidays?: InputMaybe<Scalars['Boolean']['input']>;
  smsText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobStatus>;
  taxRate?: InputMaybe<Scalars['Int']['input']>;
  taxRateName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateManufacturerInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Account ID for admin users (optional, ignored for regular users) */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  primaryContactEmail?: InputMaybe<Scalars['String']['input']>;
  primaryContactName?: InputMaybe<Scalars['String']['input']>;
  primaryContactPhone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  supportEmail?: InputMaybe<Scalars['String']['input']>;
  supportPhone?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Expected input to update a message. isArchived only */
export type UpdateMessageInput = {
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateMinimumMobileAppVersionInput = {
  android?: InputMaybe<Scalars['String']['input']>;
  ios?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMinimumMobileAppVersions = {
  __typename?: 'UpdateMinimumMobileAppVersions';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
  versions: Array<MobileAppVersion>;
};

export type UpdateMinimumMobileAppVersionsResponse = Error | UpdateMinimumMobileAppVersions;

export type UpdateNoteInput = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** Onboarding-only updates for the authenticated user */
export type UpdateOnboardingProgressInput = {
  isWelcomeScreenClosed?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingMobileTourComplete?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingWizardState?: InputMaybe<OnboardingWizardState>;
  quickToursDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  resetOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  setQuickTourStatus?: InputMaybe<QuickTourStatusInput>;
  updateOnboardingStep?: InputMaybe<UpdateOnboardingStep>;
};

/** Input for updating a specific onboarding step */
export type UpdateOnboardingStep = {
  isCompleted: Scalars['Boolean']['input'];
  stepId: Scalars['String']['input'];
};

export type UpdateOwner = {
  __typename?: 'UpdateOwner';
  message: Scalars['String']['output'];
  user: User;
  version: Scalars['String']['output'];
};

/** Expected input to transfer or assign SP_OWNER role to another user (SP_OWNER or admin only) */
export type UpdateOwnerInput = {
  /** User ID to assign owner role to (must not be the current user) */
  userId: Scalars['ID']['input'];
};

export type UpdateOwnerResponse = Error | UpdateOwner;

/** Expected input to update a payment */
export type UpdatePaymentInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  attachments?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<PaymentMethod>;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  processorFee?: InputMaybe<Scalars['Int']['input']>;
  processorTransactionId?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PaymentStatus>;
  transactionDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdatePreferences = {
  __typename?: 'UpdatePreferences';
  message: Scalars['String']['output'];
  preferences: NotificationPreferences;
  version: Scalars['String']['output'];
};

export type UpdatePreferencesInput = {
  /** Notification types to disable */
  disableTypes?: InputMaybe<Array<NotificationType>>;
  /** Notification types to enable */
  enableTypes?: InputMaybe<Array<NotificationType>>;
  /** Language preference */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Preferred delivery channels */
  preferredChannels?: InputMaybe<Array<NotificationChannel>>;
  /** Quiet hours end (0-23) */
  quietHoursEnd?: InputMaybe<Scalars['Int']['input']>;
  /** Quiet hours start (0-23) */
  quietHoursStart?: InputMaybe<Scalars['Int']['input']>;
  /** Timezone */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePreferencesResponse = Error | UpdatePreferences;

export type UpdatePropertyInput = {
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  availability?: InputMaybe<AvailabilityInput>;
  base64Image?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<propertyTypeEnum>;
  /** Use drop down list of states. Send 2 character data, display full text. Ex: Send 'AL', display 'Alabama' https://www.drupal.org/node/332575 */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuickBooksAccountMappings = {
  __typename?: 'UpdateQuickBooksAccountMappings';
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type UpdateQuickBooksAccountMappingsInput = {
  paymentsAccountId?: InputMaybe<Scalars['String']['input']>;
  tipsAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuickBooksAccountMappingsResponse = Error | UpdateQuickBooksAccountMappings;

export type UpdateQuickBooksEntitySettingInput = {
  conflictResolution?: InputMaybe<Scalars['String']['input']>;
  entityType: QuickBooksEntityType;
  syncEnabled: Scalars['Boolean']['input'];
  syncRule?: InputMaybe<Scalars['String']['input']>;
  syncTrigger: Scalars['String']['input'];
};

export type UpdateQuickBooksSyncSettings = {
  __typename?: 'UpdateQuickBooksSyncSettings';
  message: Scalars['String']['output'];
  syncSettings?: Maybe<QuickBooksSyncSettingsInfo>;
  version: Scalars['String']['output'];
};

export type UpdateQuickBooksSyncSettingsInput = {
  entitySettings: Array<UpdateQuickBooksEntitySettingInput>;
};

export type UpdateQuickBooksSyncSettingsResponse = Error | UpdateQuickBooksSyncSettings;

/** Expected input to update a service item. */
export type UpdateServiceItemInput = {
  adt?: InputMaybe<Scalars['String']['input']>;
  /** Base64 encoded image data for the service item. */
  base64Image?: InputMaybe<Scalars['String']['input']>;
  checklist_id?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isInventoryDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  isShowNewService?: InputMaybe<Scalars['Boolean']['input']>;
  isShowOnlineBooking?: InputMaybe<Scalars['Boolean']['input']>;
  isTaxable?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  manufacturerModelNumber?: InputMaybe<Scalars['String']['input']>;
  manufacturer_id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  quantityOnHand?: InputMaybe<Scalars['Int']['input']>;
  reorderLevel?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<ServiceItemType>;
  unitCost?: InputMaybe<Scalars['Float']['input']>;
  unitOfMeasure?: InputMaybe<UnitOfMeasure>;
  unitRetailPrice?: InputMaybe<Scalars['Float']['input']>;
  upc?: InputMaybe<Scalars['String']['input']>;
  vendorSku?: InputMaybe<Scalars['String']['input']>;
  vendor_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateServiceProviderAccount = {
  __typename?: 'UpdateServiceProviderAccount';
  account: ServiceProviderAccount;
  message: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** Expected input for updated a service provider account from within service provider admin */
export type UpdateServiceProviderAccountInput = {
  availability?: InputMaybe<AvailabilityInput>;
  betaProgram?: InputMaybe<BetaProgramInput>;
  /** Disable all billing features for test accounts (STWI internal use only) */
  billingDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  billingInfo?: InputMaybe<BillingInfoInput>;
  businessType?: InputMaybe<Scalars['String']['input']>;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** Account ID to update (required for admin users, ignored for regular users) */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 5-digit IVR extension code (10000-99999) */
  ivrExtensionCode?: InputMaybe<Scalars['String']['input']>;
  /** Stripe payment method ID to set as default for the account */
  paymentMethodId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The plan code to change to (PlanMetadata.planCode) */
  planCode?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  /** Number of seats for team plans */
  seats?: InputMaybe<Scalars['Int']['input']>;
  serviceCategories?: InputMaybe<Array<ServiceCategory>>;
  settings?: InputMaybe<UpdateServiceProviderAccountSettingsInput>;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceProviderAccountResponse = Error | UpdateServiceProviderAccount;

export type UpdateServiceProviderAccountSettings = {
  __typename?: 'UpdateServiceProviderAccountSettings';
  message: Scalars['String']['output'];
  settings: ServiceProviderSettings;
  version: Scalars['String']['output'];
};

/** Settings for a service provider account */
export type UpdateServiceProviderAccountSettingsInput = {
  /** When enabled, crew members can log time on any job in the system, not just jobs assigned to them */
  allowCrewTimeLogOnAnyJob?: InputMaybe<Scalars['Boolean']['input']>;
  /** When enabled, new timesheet entries are automatically linked to a DRAFT timesheet for the same week */
  automaticTimesheetLinking?: InputMaybe<Scalars['Boolean']['input']>;
  clientPaymentDisclaimerText?: InputMaybe<Scalars['String']['input']>;
  clientPaymentDisclaimerUseDefault?: InputMaybe<Scalars['Boolean']['input']>;
  doNotShareInformation?: InputMaybe<Scalars['Boolean']['input']>;
  invitationLinkExistingUser?: InputMaybe<Scalars['String']['input']>;
  invitationLinkNewUser?: InputMaybe<Scalars['String']['input']>;
  invoiceNumberCounter?: InputMaybe<Scalars['Int']['input']>;
  isDisplayZelleMessage?: InputMaybe<Scalars['Boolean']['input']>;
  /** Phone number for emergency call transfer (caller presses 5) */
  ivrEmergencyPhone?: InputMaybe<Scalars['String']['input']>;
  /** Whether the IVR system is enabled for this account */
  ivrEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** IVR mode: FULL or CALLBACK_ONLY */
  ivrMode?: InputMaybe<Scalars['String']['input']>;
  maxJobsPerDay?: InputMaybe<Scalars['Int']['input']>;
  notificationCrewEnRouteEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationCrewEnRouteText?: InputMaybe<Scalars['String']['input']>;
  notificationCrewJobPausedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationCrewJobPausedText?: InputMaybe<Scalars['String']['input']>;
  notificationCrewJobStartedEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationCrewJobStartedText?: InputMaybe<Scalars['String']['input']>;
  notificationDepositPaymentReminders?: InputMaybe<
    Array<ServiceProviderSettingsNotificationDepositPaymentReminderInput>
  >;
  notificationEstimateReadyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationEstimateReadyText?: InputMaybe<Scalars['String']['input']>;
  notificationJobCancelledEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationJobCancelledText?: InputMaybe<Scalars['String']['input']>;
  notificationJobReminders?: InputMaybe<Array<ServiceProviderSettingsNotificationJobReminderInput>>;
  notificationJobScheduledEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationJobScheduledText?: InputMaybe<Scalars['String']['input']>;
  notificationMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  stripeConnectSettings?: InputMaybe<StripeConnectSettingsInput>;
  zelleMessage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateServiceProviderAccountSettingsResponse =
  | Error
  | UpdateServiceProviderAccountSettings;

export type UpdateTaxRateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTimesheetEntryInput = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  job_id?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['Date']['input']>;
  timesheet_id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TimesheetEntryType>;
};

export type UpdateTimesheetInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<TimesheetStatus>;
  timesheetDate?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateUserAvatar = {
  __typename?: 'UpdateUserAvatar';
  avatarUrl: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Expected input to update a user's avatar */
export type UpdateUserAvatarInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  avatarBase64Image: Scalars['String']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserAvatarResponse = Error | UpdateUserAvatar;

/** Expected input to update a user from service provider or client admin - does not include password */
export type UpdateUserInput = {
  account_id?: InputMaybe<Scalars['ID']['input']>;
  analyticsConsent?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates whether the user consented to receive SMS notifications */
  isSMSConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Onboarding related fields */
  isWelcomeScreenClosed?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Locale>;
  /** Update user location for ETA calculations */
  location?: InputMaybe<LocationInput>;
  /** Update mobile tour onboarding completion status */
  onboardingMobileTourComplete?: InputMaybe<Scalars['Boolean']['input']>;
  onboardingWizardState?: InputMaybe<OnboardingWizardState>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Disable automatic Quick Tour starts for this user */
  quickToursDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reset onboarding steps */
  resetOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Role>;
  /** Idempotently add or update one Quick Tour outcome by tour id */
  setQuickTourStatus?: InputMaybe<QuickTourStatusInput>;
  /** Update user settings */
  settings?: InputMaybe<UserSettingsInput>;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone?: InputMaybe<Scalars['String']['input']>;
  /** Update specific onboarding step completion status */
  updateOnboardingStep?: InputMaybe<UpdateOnboardingStep>;
};

export type UpdateUserPassword = {
  __typename?: 'UpdateUserPassword';
  message: Scalars['String']['output'];
};

/** Expected input to create or update a user's password */
export type UpdateUserPasswordInput = {
  confirmNewPassword: Scalars['String']['input'];
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isReset?: InputMaybe<Scalars['Boolean']['input']>;
  isSetPassword?: InputMaybe<Scalars['Boolean']['input']>;
  newPassword: Scalars['String']['input'];
};

export type UpdateUserPasswordResponse = Error | UpdateUserPassword;

export type UpdateUserSettings = {
  __typename?: 'UpdateUserSettings';
  message: Scalars['String']['output'];
  settings: UserSettings;
  version: Scalars['String']['output'];
};

export type UpdateUserSettingsResponse = Error | UpdateUserSettings;

export type UpdateVendorInput = {
  /** Account ID for admin users (optional, ignored for regular users) */
  account_id?: InputMaybe<Scalars['ID']['input']>;
  address1?: InputMaybe<Scalars['String']['input']>;
  address2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  contactBusinessPhone?: InputMaybe<Scalars['String']['input']>;
  contactCellPhone?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPosition?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isQuickAdd?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type User = IUser &
  Timestamps & {
    __typename?: 'User';
    account_id: Scalars['ID']['output'];
    /** URL to user avatar */
    avatarUrl?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['Date']['output'];
    crews?: Maybe<Array<Maybe<CrewList>>>;
    /** Current GPS latitude for ETA calculations */
    currentLatitude?: Maybe<Scalars['Float']['output']>;
    /** Current GPS longitude for ETA calculations */
    currentLongitude?: Maybe<Scalars['Float']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    /** List of registered FCM devices for push notifications */
    deviceTokens?: Maybe<Array<Device>>;
    /** Email address (optional for draft client users created without email) */
    email?: Maybe<Scalars['String']['output']>;
    firstName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    /** Check if user is disabled */
    isDisabled: Scalars['Boolean']['output'];
    /** Check if email is confirmed */
    isEmailConfirmed: Scalars['Boolean']['output'];
    /** Check if user is in use within a crew or other entity and cannot be deleted. */
    isInUse: Scalars['Boolean']['output'];
    /** Indicates if all required onboarding steps are completed */
    isOnboardingComplete: Scalars['Boolean']['output'];
    /** Indicates if the record was created via Quick Add */
    isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates whether the user consented to receive SMS notifications */
    isSMSConsent?: Maybe<Scalars['Boolean']['output']>;
    /** Onboarding related fields */
    isWelcomeScreenClosed: Scalars['Boolean']['output'];
    /** Timestamp of last location update */
    lastLocationUpdate?: Maybe<Scalars['Date']['output']>;
    lastName: Scalars['String']['output'];
    lastOnboardingInteraction?: Maybe<Scalars['Date']['output']>;
    locale?: Maybe<Locale>;
    /** Indicates if the mobile tour onboarding has been completed */
    onboardingMobileTourComplete: Scalars['Boolean']['output'];
    onboardingSteps: Array<OnboardingStep>;
    onboardingWizardState: OnboardingWizardState;
    /** Phone number (optional for draft client users created without phone) */
    phone?: Maybe<Scalars['String']['output']>;
    /** Per-tour Quick Tour outcomes used to suppress repeat auto-starts */
    quickTours: Array<QuickTourState>;
    /** Disable automatic Quick Tour starts for this user */
    quickToursDisabled: Scalars['Boolean']['output'];
    role: Role;
    /** User settings and preferences */
    settings?: Maybe<UserSettings>;
    /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
    timeZone: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['Date']['output']>;
    /** Verified WhatsApp number linked from the DHS app (E.164 format) */
    whatsappNumber?: Maybe<Scalars['String']['output']>;
  };

export type UserClientView = IUser &
  Timestamps & {
    __typename?: 'UserClientView';
    account_id: Scalars['ID']['output'];
    /** URL to user avatar */
    avatarUrl?: Maybe<Scalars['String']['output']>;
    createdAt: Scalars['Date']['output'];
    /** Current GPS latitude for ETA calculations */
    currentLatitude?: Maybe<Scalars['Float']['output']>;
    /** Current GPS longitude for ETA calculations */
    currentLongitude?: Maybe<Scalars['Float']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    /** Email address (optional for draft client users created without email) */
    email?: Maybe<Scalars['String']['output']>;
    firstName: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    /** Check if user is disabled */
    isDisabled: Scalars['Boolean']['output'];
    /** Check if email is confirmed */
    isEmailConfirmed: Scalars['Boolean']['output'];
    /** Check if user is in use within a crew or other entity and cannot be deleted. */
    isInUse: Scalars['Boolean']['output'];
    /** Indicates if all required onboarding steps are completed */
    isOnboardingComplete: Scalars['Boolean']['output'];
    /** Indicates if the record was created via Quick Add */
    isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates whether the user consented to receive SMS notifications */
    isSMSConsent?: Maybe<Scalars['Boolean']['output']>;
    /** Onboarding related fields */
    isWelcomeScreenClosed: Scalars['Boolean']['output'];
    /** Timestamp of last location update */
    lastLocationUpdate?: Maybe<Scalars['Date']['output']>;
    lastName: Scalars['String']['output'];
    lastOnboardingInteraction?: Maybe<Scalars['Date']['output']>;
    locale?: Maybe<Locale>;
    /** Indicates if the mobile tour onboarding has been completed */
    onboardingMobileTourComplete: Scalars['Boolean']['output'];
    onboardingSteps: Array<OnboardingStep>;
    onboardingWizardState: OnboardingWizardState;
    /** Phone number (optional for draft client users created without phone) */
    phone?: Maybe<Scalars['String']['output']>;
    /** Per-tour Quick Tour outcomes used to suppress repeat auto-starts */
    quickTours: Array<QuickTourState>;
    /** Disable automatic Quick Tour starts for this user */
    quickToursDisabled: Scalars['Boolean']['output'];
    role: Role;
    /** User settings and preferences */
    settings?: Maybe<UserSettings>;
    /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
    timeZone: Scalars['String']['output'];
    updatedAt?: Maybe<Scalars['Date']['output']>;
    /** Verified WhatsApp number linked from the DHS app (E.164 format) */
    whatsappNumber?: Maybe<Scalars['String']['output']>;
  };

/** User metrics */
export type UserMetrics = {
  __typename?: 'UserMetrics';
  /** Number of active users */
  activeCount: Scalars['Int']['output'];
  /** Total count of users */
  count: Scalars['Int']['output'];
  /** Number of disabled users */
  disabledCount: Scalars['Int']['output'];
  /** Status breakdown */
  statusBreakdown: Array<StatusCount>;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  /** Per-category channel settings (overrides global channels) */
  categorySettings: Array<CategoryChannelSettings>;
  /** Global enabled notification channels (fallback for unconfigured categories) */
  channels: Array<NotificationChannel>;
  /** Do not disturb mode */
  doNotDisturb?: Maybe<DoNotDisturb>;
  /** List of muted notification types */
  mutedTypes: Array<Scalars['String']['output']>;
  /** Preferred language override (if different from user.locale) */
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  /** Quiet hours configuration */
  quietHours?: Maybe<QuietHours>;
  /** SMS/WhatsApp delivery preference */
  smsWhatsAppPreference?: Maybe<SmsWhatsAppPreference>;
};

export type UserNotificationSettingsInput = {
  /** Per-category channel settings */
  categorySettings?: InputMaybe<Array<CategoryChannelSettingsInput>>;
  /** Enabled notification channels */
  channels?: InputMaybe<Array<NotificationChannel>>;
  /** Do not disturb mode */
  doNotDisturb?: InputMaybe<DoNotDisturbInput>;
  /** List of muted notification types */
  mutedTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Preferred language override */
  preferredLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Quiet hours configuration */
  quietHours?: InputMaybe<QuietHoursInput>;
  /** SMS/WhatsApp delivery preference */
  smsWhatsAppPreference?: InputMaybe<SmsWhatsAppPreference>;
};

/**
 * Permissions that can be granted to users for accessing user data.
 * Controls the scope of user information that can be read or accessed.
 */
export enum UserPermission {
  /** Permission to read any user's information within the system (admin-level access). */
  ReadAnyUser = 'READ_ANY_USER',
  /** Permission to read only the user's own information (self-access). */
  ReadOwnUser = 'READ_OWN_USER',
  /** Permission to read super user or system administrator information (elevated access). */
  ReadSuperUser = 'READ_SUPER_USER',
}

export type UserSession = Timestamps & {
  __typename?: 'UserSession';
  account_id: Scalars['ID']['output'];
  /** URL to user avatar */
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  crews?: Maybe<Array<Maybe<CrewList>>>;
  /** Current GPS latitude for ETA calculations */
  currentLatitude?: Maybe<Scalars['Float']['output']>;
  /** Current GPS longitude for ETA calculations */
  currentLongitude?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Email address (optional for draft client users created without email) */
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Check if user is disabled */
  isDisabled: Scalars['Boolean']['output'];
  /** Check if email is confirmed */
  isEmailConfirmed: Scalars['Boolean']['output'];
  /** Check if user is in use within a crew or other entity and cannot be deleted. */
  isInUse: Scalars['Boolean']['output'];
  /** Indicates if all required onboarding steps are completed */
  isOnboardingComplete: Scalars['Boolean']['output'];
  /** Indicates whether the user consented to receive SMS notifications */
  isSMSConsent?: Maybe<Scalars['Boolean']['output']>;
  /** Check if timer is running */
  isTimerRunning: Scalars['Boolean']['output'];
  /** Onboarding related fields */
  isWelcomeScreenClosed: Scalars['Boolean']['output'];
  /** Timestamp of last location update */
  lastLocationUpdate?: Maybe<Scalars['Date']['output']>;
  lastName: Scalars['String']['output'];
  lastOnboardingInteraction?: Maybe<Scalars['Date']['output']>;
  locale?: Maybe<Locale>;
  /** Indicates if the mobile tour onboarding has been completed */
  onboardingMobileTourComplete: Scalars['Boolean']['output'];
  onboardingSteps: Array<OnboardingStep>;
  onboardingWizardState: OnboardingWizardState;
  /** Phone number (optional for draft client users created without phone) */
  phone?: Maybe<Scalars['String']['output']>;
  /** Per-tour Quick Tour outcomes used to suppress repeat auto-starts */
  quickTours: Array<QuickTourState>;
  /** Disable automatic Quick Tour starts for this user */
  quickToursDisabled: Scalars['Boolean']['output'];
  role: Role;
  /** User settings and preferences */
  settings?: Maybe<UserSettings>;
  /** Use drop down list of iana data. Ex: America/Los_Angeles https://www.iana.org/time-zones */
  timeZone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Verified WhatsApp number linked from the DHS app (E.164 format) */
  whatsappNumber?: Maybe<Scalars['String']['output']>;
};

export type UserSettings = {
  __typename?: 'UserSettings';
  /** Override account-level automatic timesheet linking. null = use account default */
  automaticTimesheetLinking?: Maybe<Scalars['Boolean']['output']>;
  dashboardSettings?: Maybe<DashboardSettings>;
  notifications?: Maybe<UserNotificationSettings>;
  signatureFontStyle?: Maybe<SignatureFontStyle>;
  standaloneSchedulerView?: Maybe<SchedulerViewSettings>;
};

export type UserSettingsInput = {
  /** Override account-level automatic timesheet linking. null = use account default */
  automaticTimesheetLinking?: InputMaybe<Scalars['Boolean']['input']>;
  dashboardSettings?: InputMaybe<DashboardSettingsInput>;
  notifications?: InputMaybe<UserNotificationSettingsInput>;
  signatureFontStyle?: InputMaybe<SignatureFontStyle>;
  standaloneSchedulerView?: InputMaybe<SchedulerViewSettingsInput>;
};

/**
 * Available sorting options for user lists and queries.
 * Determines the field by which user results are ordered.
 */
export enum UsersSortBy {
  /** Sort users by creation date. */
  CreatedAt = 'CREATED_AT',
  /** Sort users alphabetically by email address. */
  Email = 'EMAIL',
  /** Sort users alphabetically by first name. */
  FirstName = 'FIRST_NAME',
  /** Sort users by their role (SP_ADMIN, SP_SUPPORT, SP_CREW, CLIENT). */
  Role = 'ROLE',
  /** Sort users by last update date. */
  UpdatedAt = 'UPDATED_AT',
}

/** Input for validating FCM device token */
export type ValidateFCMDeviceTokenInput = {
  deviceId: Scalars['String']['input'];
  fcmToken: Scalars['String']['input'];
};

/** Response for validating an FCM device token */
export type ValidateFCMDeviceTokenResponse = DeviceTokenValidationResult | Error;

export type ValidateFeeCalculation = {
  __typename?: 'ValidateFeeCalculation';
  message: Scalars['String']['output'];
  validation: FeeValidation;
  version: Scalars['String']['output'];
};

export type ValidateFeeCalculationInput = {
  paymentId: Scalars['ID']['input'];
};

export type ValidateFeeCalculationResponse = Error | ValidateFeeCalculation;

export type ValidateInvoiceForPayment = {
  __typename?: 'ValidateInvoiceForPayment';
  isValid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  reasons?: Maybe<Array<Scalars['String']['output']>>;
  version: Scalars['String']['output'];
};

export type ValidateInvoiceForPaymentResponse = Error | ValidateInvoiceForPayment;

export type ValidatePublicInvoiceForPayment = {
  __typename?: 'ValidatePublicInvoiceForPayment';
  isValid: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  reasons?: Maybe<Array<Scalars['String']['output']>>;
  version: Scalars['String']['output'];
};

export type ValidatePublicInvoiceForPaymentResponse = Error | ValidatePublicInvoiceForPayment;

export type Vendor = Timestamps & {
  __typename?: 'Vendor';
  account_id: Scalars['ID']['output'];
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  contactBusinessPhone?: Maybe<Scalars['String']['output']>;
  contactCellPhone?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPosition?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the record was created via Quick Add */
  isQuickAdd?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Date']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export enum VendorsSortBy {
  CreatedAt = 'CREATED_AT',
  UpdatedAt = 'UPDATED_AT',
}

export type VoidPayment = {
  __typename?: 'VoidPayment';
  message: Scalars['String']['output'];
};

/** Expected input to void a payment */
export type VoidPaymentInput = {
  id: Scalars['ID']['input'];
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  statusChangeReason: Scalars['String']['input'];
};

export type VoidPaymentResponse = Error | VoidPayment;

/** Parameters to filter work order report data */
export type WorkOrderReportFilter = {
  /** End date for work orders */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by priority status */
  isPriority?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start date for work orders */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by job statuses */
  statuses?: InputMaybe<Array<JobStatus>>;
};

/** Parameters to filter work orders report data */
export type WorkOrdersReportFilter = {
  /** End date for work orders */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Start date for work orders */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filter by job statuses */
  statuses?: InputMaybe<Array<JobStatus>>;
};

/** Working hours breakdown for idle time calculation */
export type WorkingHours = {
  __typename?: 'WorkingHours';
  /** Hours spent en route */
  enRouteTime: Scalars['Float']['output'];
  /** Hours spent on job preparation */
  jobPrepTime: Scalars['Float']['output'];
  /** Hours spent on job work */
  jobTime: Scalars['Float']['output'];
  /** Total working hours */
  total: Scalars['Float']['output'];
};

/** Working hours for a specific time period */
export type WorkingHoursPeriod = {
  __typename?: 'WorkingHoursPeriod';
  /** Number of days worked in this period */
  daysWorked: Scalars['Int']['output'];
  /** Hours breakdown by type for this period */
  hoursBreakdown: HoursBreakdown;
  /** Time period identifier */
  period: Scalars['String']['output'];
  /** Total hours for this period */
  totalHours: Scalars['Float']['output'];
};

/** Flexible response item that adapts to crew vs user grouping for working hours */
export type WorkingHoursReportItem = {
  __typename?: 'WorkingHoursReportItem';
  /** Crew object - populated when type = 'CREW' */
  crew?: Maybe<Crew>;
  /** Hours breakdown by type */
  hoursBreakdown: HoursBreakdown;
  /** Entity ID - user_id or crew_id depending on groupBy */
  id: Scalars['ID']['output'];
  /** Member breakdown - populated when groupBy = 'CREW_USER' */
  memberBreakdown?: Maybe<Array<WorkingHoursReportItem>>;
  /** Entity name - userFullName or crew name */
  name: Scalars['String']['output'];
  /** Time period breakdown for trend analysis */
  timePeriodBreakdown: Array<WorkingHoursPeriod>;
  /** Total logged hours */
  totalLoggedHours: Scalars['Float']['output'];
  /** Entity type - 'USER' or 'CREW' */
  type: Scalars['String']['output'];
  /** User object - populated when type = 'USER' */
  user?: Maybe<User>;
};

export type id = {
  id: Scalars['ID']['input'];
};

/**
 * Types of properties that can be managed in the system.
 * Determines the category and handling of property-specific features.
 */
export enum propertyTypeEnum {
  /** Commercial property such as offices, retail stores, warehouses, or business facilities. */
  Commercial = 'COMMERCIAL',
  /** Residential property such as houses, apartments, condos, or other dwelling places. */
  Residential = 'RESIDENTIAL',
  /** Service provider location such as company headquarters, storage facilities, or operational bases. */
  SpLocation = 'SP_LOCATION',
}
